/**
 * Copyright (C) Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

/**
 * Atacama
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 * You can find the template which this was generated from in the atacama-codegen package
 */

export const ATACAMA_VERSION: string = '0.1';

/**
 * @export
 * @interface AcceptInvitationToPracticeRequestDTO
 */
export interface AcceptInvitationToPracticeRequestDTO {
  /**
   * @description Invited provider's new password
   * @type {string}
   * @memberof AcceptInvitationToPracticeRequestDTO
   */
  password: string;
  /**
   * @description Invited provider's account id
   * @type {string}
   * @memberof AcceptInvitationToPracticeRequestDTO
   */
  accountId: string;
  /**
   * @description Invited provider's newAccountToken generated when they were invited
   * @type {string}
   * @memberof AcceptInvitationToPracticeRequestDTO
   */
  token: string;
}

/**
 * @export
 * @interface AcceptInvitationToPracticeResponseDTO
 */
export interface AcceptInvitationToPracticeResponseDTO {
  /**
   * @description providerId for the created provider account
   * @type {string}
   * @memberof AcceptInvitationToPracticeResponseDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface AcceptPracticeTosRequestDTO
 */
export interface AcceptPracticeTosRequestDTO {
  /**
   * @type {PracticeTypeDTO}
   * @memberof AcceptPracticeTosRequestDTO
   */
  practiceType: PracticeTypeDTO;
  /**
   * @type {string}
   * @memberof AcceptPracticeTosRequestDTO
   */
  practiceId: string;
  /**
   * @description The User Agreements Being Signed
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof AcceptPracticeTosRequestDTO
   */
  userAgreementVersions: Array<UserAgreementVersionDTO>;
  /**
   * @description The legal name of the person signing
   * @type {string}
   * @memberof AcceptPracticeTosRequestDTO
   */
  signatory: string;
  /**
   * @type {string}
   * @memberof AcceptPracticeTosRequestDTO
   */
  email: string;
}

/**
 * @export
 * @interface AcceptReferralRequestDTO
 */
export interface AcceptReferralRequestDTO {
  /**
   * @type {string}
   * @memberof AcceptReferralRequestDTO
   */
  referralId: string;
}

/**
 * @export
 * @interface AcceptTosForPatientRequestDTO
 */
export interface AcceptTosForPatientRequestDTO {
  /**
   * @type {string}
   * @memberof AcceptTosForPatientRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface AcceptTosForPracticeRequestDTO
 */
export interface AcceptTosForPracticeRequestDTO {
  /**
   * @description Practice Id for the practice you're accepting the TOS for
   * @type {string}
   * @memberof AcceptTosForPracticeRequestDTO
   */
  practiceId: string;
  /**
   * @description Provider Id for the provider accepting the TOS for the practice
   * @type {string}
   * @memberof AcceptTosForPracticeRequestDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface AcceptUserAgreementVersionsRequestDTO
 */
export interface AcceptUserAgreementVersionsRequestDTO {
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof AcceptUserAgreementVersionsRequestDTO
   */
  userAgreementVersions: Array<UserAgreementVersionDTO>;
}

/**
 * @export
 * @interface AcceptedInsurancePlanDTO
 */
export interface AcceptedInsurancePlanDTO {
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanDTO
   */
  insurancePlanId: string;
  /**
   * @type {boolean}
   * @memberof AcceptedInsurancePlanDTO
   */
  isActive: boolean;
  /**
   * @type {boolean}
   * @memberof AcceptedInsurancePlanDTO
   */
  isTeleSupported?: boolean;
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanDTO
   */
  pauseFromDate?: string;
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanDTO
   */
  pauseUntilDate?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum AccountStateDTO {
  Active = 'Active',
  CreatedButNotActivated = 'Created But Not Activated',
  Inactive = 'Inactive'
}

/**
 * @export
 * @interface AcknowledgeHighRiskAssessmentRequestDTO
 */
export interface AcknowledgeHighRiskAssessmentRequestDTO {
  /**
   * @type {string}
   * @memberof AcknowledgeHighRiskAssessmentRequestDTO
   */
  assessmentResultId: string;
}

/**
 * @export
 * @interface AcknowledgeNotificationRequestDTO
 */
export interface AcknowledgeNotificationRequestDTO {
  /**
   * @type {string}
   * @memberof AcknowledgeNotificationRequestDTO
   */
  notificationId: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ActionTypeDTO {
  Redirect = 'Redirect',
  Continue = 'Continue'
}

/**
 * @export
 * @interface ActivateMatchListRequestDTO
 */
export interface ActivateMatchListRequestDTO {
  /**
   * @type {string}
   * @memberof ActivateMatchListRequestDTO
   */
  patientId: string;
  /**
   * @type {boolean}
   * @memberof ActivateMatchListRequestDTO
   */
  isAutolaunched: boolean;
  /**
   * @type {EditMatchListRequestMatchListDTO}
   * @memberof ActivateMatchListRequestDTO
   */
  matchList: EditMatchListRequestMatchListDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ActivationChannelDTO {
  EHRDirect = 'EHR Direct',
  EHRHL7 = 'EHR_HL7',
  RecommendedPatient = 'Recommended Patient',
  ReactivePatient = 'Reactive Patient',
  CurbsideWorkaround = 'Curbside Workaround',
  ManuallyAddedRecommendedPatient = 'Manually Added Recommended Patient',
  PatientSelfReferral = 'Patient Self Referral',
  CMAPI = 'CM API',
  PCPAPI = 'PCP API',
  FullPanelPatient = 'Full Panel Patient',
  PostAssessment = 'Post Assessment'
}

/**
 * @export
 * @interface AddAccountToIdpDTO
 */
export interface AddAccountToIdpDTO {
  /**
   * @type {string}
   * @memberof AddAccountToIdpDTO
   */
  accountId: string;
  /**
   * @type {string}
   * @memberof AddAccountToIdpDTO
   */
  nameId: string;
  /**
   * @type {string}
   * @memberof AddAccountToIdpDTO
   */
  idpId: string;
}

/**
 * @export
 * @interface AddBhpToPracticeRequestDTO
 */
export interface AddBhpToPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof AddBhpToPracticeRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof AddBhpToPracticeRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof AddBhpToPracticeRequestDTO
   */
  emailAddress: string;
  /**
   * @type {string}
   * @memberof AddBhpToPracticeRequestDTO
   */
  practiceId: string;
  /**
   * @type {Array<BhPracticeRoleDTO>}
   * @memberof AddBhpToPracticeRequestDTO
   */
  practiceRoles: Array<BhPracticeRoleDTO>;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof AddBhpToPracticeRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @type {boolean}
   * @memberof AddBhpToPracticeRequestDTO
   */
  isExternalBhp?: boolean;
  /**
   * @type {string}
   * @memberof AddBhpToPracticeRequestDTO
   */
  npi?: string;
}

/**
 * @export
 * @interface AddBhpToPracticeResponseDTO
 */
export interface AddBhpToPracticeResponseDTO {
  /**
   * @type {string}
   * @memberof AddBhpToPracticeResponseDTO
   */
  bhpId: string;
}

/**
 * @export
 * @interface AddCareEventExternalIdRequestDTO
 */
export interface AddCareEventExternalIdRequestDTO {
  /**
   * @type {string}
   * @memberof AddCareEventExternalIdRequestDTO
   */
  careEventId: string;
  /**
   * @type {CareEventExternalIdDTO}
   * @memberof AddCareEventExternalIdRequestDTO
   */
  externalId: CareEventExternalIdDTO;
}

/**
 * @export
 * @interface AddCaseManagerToGroupRequestDTO
 */
export interface AddCaseManagerToGroupRequestDTO {
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  phoneNumber: string;
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  emailAddress: string;
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  faxNumber?: string;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  groupId: string;
  /**
   * @type {GroupCaseManagerProfilePermissionsDTO}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  profilePermissions: GroupCaseManagerProfilePermissionsDTO;
  /**
   * @type {boolean}
   * @memberof AddCaseManagerToGroupRequestDTO
   */
  requiresTwoFactorAuthentication?: boolean;
}

/**
 * @export
 * @interface AddCaseManagerToGroupResponseDTO
 */
export interface AddCaseManagerToGroupResponseDTO {
  /**
   * @type {string}
   * @memberof AddCaseManagerToGroupResponseDTO
   */
  caseManagerId: string;
}

/**
 * @export
 * @interface AddExistingPcpToPracticeRequestDTO
 */
export interface AddExistingPcpToPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof AddExistingPcpToPracticeRequestDTO
   */
  practiceId: string;
  /**
   * @type {string}
   * @memberof AddExistingPcpToPracticeRequestDTO
   */
  pcpId: string;
}

/**
 * @export
 * @interface AddLocationAddressDTO
 */
export interface AddLocationAddressDTO {
  /**
   * @type {string}
   * @memberof AddLocationAddressDTO
   */
  city: string;
  /**
   * @type {string}
   * @memberof AddLocationAddressDTO
   */
  postalCode: string;
  /**
   * @type {StateDTO}
   * @memberof AddLocationAddressDTO
   */
  state: StateDTO;
  /**
   * @type {string}
   * @memberof AddLocationAddressDTO
   */
  streetAddress: string;
  /**
   * @type {string}
   * @memberof AddLocationAddressDTO
   */
  streetAddressLineTwo?: string;
}

/**
 * @export
 * @interface AddLocationToPracticeDTO
 */
export interface AddLocationToPracticeDTO {
  /**
   * @type {string}
   * @memberof AddLocationToPracticeDTO
   */
  practiceId: string;
  /**
   * @type {string}
   * @memberof AddLocationToPracticeDTO
   */
  name?: string;
  /**
   * @type {AddLocationAddressDTO}
   * @memberof AddLocationToPracticeDTO
   */
  address: AddLocationAddressDTO;
}

/**
 * @export
 * @interface AddPatientExternalIdRequestDTO
 */
export interface AddPatientExternalIdRequestDTO {
  /**
   * @type {string}
   * @memberof AddPatientExternalIdRequestDTO
   */
  patientId: string;
  /**
   * @type {PatientExternalIdDTO}
   * @memberof AddPatientExternalIdRequestDTO
   */
  externalId: PatientExternalIdDTO;
}

/**
 * @export
 * @interface AddPatientToSystemEmrRequestDTO
 */
export interface AddPatientToSystemEmrRequestDTO {
  /**
   * @type {string}
   * @memberof AddPatientToSystemEmrRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof AddPatientToSystemEmrRequestDTO
   */
  systemId: string;
}

/**
 * @export
 * @interface AddPcpToPracticeRequestDTO
 */
export interface AddPcpToPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  npi?: string;
  /**
   * @type {boolean}
   * @memberof AddPcpToPracticeRequestDTO
   */
  skipNpiValidation?: boolean;
  /**
   * @type {boolean}
   * @memberof AddPcpToPracticeRequestDTO
   */
  isHeadlessProvider?: boolean;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof AddPcpToPracticeRequestDTO
   */
  pcpPracticeTitle: PcpPracticeTitleDTO;
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  phoneNumber: string;
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  emailAddress: string;
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  faxNumber?: string;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof AddPcpToPracticeRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @type {string}
   * @memberof AddPcpToPracticeRequestDTO
   */
  practiceId: string;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof AddPcpToPracticeRequestDTO
   */
  pcpProfilePermissions: ProviderProfilePermissionsDTO;
  /**
   * @type {boolean}
   * @memberof AddPcpToPracticeRequestDTO
   */
  isExternalPcp?: boolean;
}

/**
 * @export
 * @interface AddPcpToPracticeResponseDTO
 */
export interface AddPcpToPracticeResponseDTO {
  /**
   * @type {string}
   * @memberof AddPcpToPracticeResponseDTO
   */
  pcpId: string;
}

/**
 * @export
 * @interface AddProviderExternalIdRequestDTO
 */
export interface AddProviderExternalIdRequestDTO {
  /**
   * @type {string}
   * @memberof AddProviderExternalIdRequestDTO
   */
  providerId: string;
  /**
   * @type {ProviderExternalIdDTO}
   * @memberof AddProviderExternalIdRequestDTO
   */
  externalId: ProviderExternalIdDTO;
}

/**
 * @export
 * @interface AddressDTO
 */
export interface AddressDTO {
  /**
   * @type {string}
   * @memberof AddressDTO
   */
  city?: string;
  /**
   * @type {string}
   * @memberof AddressDTO
   */
  postalCode?: string;
  /**
   * @type {StateDTO}
   * @memberof AddressDTO
   */
  state?: StateDTO;
  /**
   * @type {string}
   * @memberof AddressDTO
   */
  streetAddress?: string;
  /**
   * @type {string}
   * @memberof AddressDTO
   */
  streetAddressLineTwo?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum AddressTypeDTO {
  Home = 'Home',
  Work = 'Work',
  Other = 'Other'
}

/**
 * @export
 * @interface AdminDTO
 */
export interface AdminDTO {
  /**
   * @type {string}
   * @memberof AdminDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof AdminDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof AdminDTO
   */
  email?: string;
  /**
   * @type {string}
   * @memberof AdminDTO
   */
  id?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum AppointmentCanceledReasonDTO {
  BhpCanceled = 'Bhp Canceled',
  PatientScheduleConflict = 'Patient Schedule Conflict',
  PatientPersonalIssue = 'Patient Personal Issue',
  PatientRejectedBhp = 'Patient Rejected Bhp',
  PatientDeclinedQuartetServices = 'Patient Declined Quartet Services',
  Other = 'Other'
}

/**
 * @export
 * @interface AppointmentDTO
 */
export interface AppointmentDTO {
  /**
   * @description The id of this appointment
   * @type {string}
   * @memberof AppointmentDTO
   */
  id: string;
  /**
   * @description The id of this appointment's patient
   * @type {string}
   * @memberof AppointmentDTO
   */
  patientId: string;
  /**
   * @description The id for this appointment's provider
   * @type {string}
   * @memberof AppointmentDTO
   */
  providerId: string;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof AppointmentDTO
   */
  setting?: AppointmentSettingDTO;
  /**
   * @description The id of this appointment's location
   * @type {string}
   * @memberof AppointmentDTO
   */
  locationId?: string;
  /**
   * @description The date and time of this appointment
   * @type {string}
   * @memberof AppointmentDTO
   */
  date: string;
  /**
   * @type {AppointmentStatusDTO}
   * @memberof AppointmentDTO
   */
  status: AppointmentStatusDTO;
}

/**
 * @export
 * @interface AppointmentDetailDTO
 */
export interface AppointmentDetailDTO {
  /**
   * @description The id of this appointment
   * @type {string}
   * @memberof AppointmentDetailDTO
   */
  id: string;
  /**
   * @type {AppointmentDetailPatientDTO}
   * @memberof AppointmentDetailDTO
   */
  patient: AppointmentDetailPatientDTO;
  /**
   * @type {DisplayProviderDTO}
   * @memberof AppointmentDetailDTO
   */
  provider: DisplayProviderDTO;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof AppointmentDetailDTO
   */
  setting?: AppointmentSettingDTO;
  /**
   * @type {LocationResponseDTO}
   * @memberof AppointmentDetailDTO
   */
  location?: LocationResponseDTO;
  /**
   * @type {AppointmentDetailReferralDTO}
   * @memberof AppointmentDetailDTO
   */
  referral: AppointmentDetailReferralDTO;
  /**
   * @description The date and time of this appointment
   * @type {string}
   * @memberof AppointmentDetailDTO
   */
  date: string;
  /**
   * @type {AppointmentStatusDTO}
   * @memberof AppointmentDetailDTO
   */
  status: AppointmentStatusDTO;
  /**
   * @type {Array<AppointmentDetailNotesDTO>}
   * @memberof AppointmentDetailDTO
   */
  notes?: Array<AppointmentDetailNotesDTO>;
}

/**
 * @export
 * @interface AppointmentDetailNotesDTO
 */
export interface AppointmentDetailNotesDTO {
  /**
   * @type {string}
   * @memberof AppointmentDetailNotesDTO
   */
  date: string;
  /**
   * @type {string}
   * @memberof AppointmentDetailNotesDTO
   */
  text: string;
}

/**
 * @export
 * @interface AppointmentDetailPatientDTO
 */
export interface AppointmentDetailPatientDTO {
  /**
   * @description The id of this appointment's patient
   * @type {string}
   * @memberof AppointmentDetailPatientDTO
   */
  id: string;
}

/**
 * @export
 * @interface AppointmentDetailReferralDTO
 */
export interface AppointmentDetailReferralDTO {
  /**
   * @description The referral associated with this appointment
   * @type {string}
   * @memberof AppointmentDetailReferralDTO
   */
  id: string;
}

/**
 * @export
 * @interface AppointmentDetailsForReferralDTO
 */
export interface AppointmentDetailsForReferralDTO {
  /**
   * @type {string}
   * @memberof AppointmentDetailsForReferralDTO
   */
  appointmentId?: string;
  /**
   * @type {string}
   * @memberof AppointmentDetailsForReferralDTO
   */
  patientAppointmentRecordId?: string;
  /**
   * @type {string}
   * @memberof AppointmentDetailsForReferralDTO
   */
  date: string;
  /**
   * @type {AppointmentStatusDTO}
   * @memberof AppointmentDetailsForReferralDTO
   */
  status: AppointmentStatusDTO;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof AppointmentDetailsForReferralDTO
   */
  setting?: AppointmentSettingDTO;
  /**
   * @type {LocationDTO}
   * @memberof AppointmentDetailsForReferralDTO
   */
  location?: LocationDTO;
  /**
   * @type {string}
   * @memberof AppointmentDetailsForReferralDTO
   */
  practiceName?: string;
  /**
   * @type {string}
   * @memberof AppointmentDetailsForReferralDTO
   */
  bhpFullName?: string;
  /**
   * @type {AppointmentNotAttendedReasonDTO}
   * @memberof AppointmentDetailsForReferralDTO
   */
  notAttendedReason?: AppointmentNotAttendedReasonDTO;
  /**
   * @type {boolean}
   * @memberof AppointmentDetailsForReferralDTO
   */
  requiresFeedback: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum AppointmentMissedReasonDTO {
  ScheduleConflict = 'Patient Schedule Conflict',
  Forgot = 'Patient Forgot',
  RejectedBhp = 'Patient Rejected Bhp',
  DeclinedQuartetServices = 'Patient Declined Quartet Services'
}

/**
 * @export
 * @interface AppointmentNotAttendedReasonDTO
 */
export interface AppointmentNotAttendedReasonDTO {
  /**
   * @type {AppointmentCanceledReasonDTO}
   * @memberof AppointmentNotAttendedReasonDTO
   */
  canceledReason?: AppointmentCanceledReasonDTO;
  /**
   * @type {string}
   * @memberof AppointmentNotAttendedReasonDTO
   */
  freeTextCanceledReason?: string;
  /**
   * @type {AppointmentMissedReasonDTO}
   * @memberof AppointmentNotAttendedReasonDTO
   */
  missedReason?: AppointmentMissedReasonDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum AppointmentSettingDTO {
  AtLocation = 'At Location',
  Tele = 'Tele'
}

/**
 * @export
 * @enum {string}
 */
export enum AppointmentStatusDTO {
  Attended = 'Attended',
  Canceled = 'Canceled',
  Missed = 'Missed',
  Scheduled = 'Scheduled'
}

/**
 * @export
 * @interface AppointmentsResponseDTO
 */
export interface AppointmentsResponseDTO {
  /**
   * @type {Array<AppointmentDetailDTO>}
   * @memberof AppointmentsResponseDTO
   */
  appointments: Array<AppointmentDetailDTO>;
  /**
   * @type {PageDTO}
   * @memberof AppointmentsResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface AssessRecommendedPatientsRequestDTO
 */
export interface AssessRecommendedPatientsRequestDTO {
  /**
   * @type {string}
   * @memberof AssessRecommendedPatientsRequestDTO
   */
  practiceId?: string;
  /**
   * @type {Array<string>}
   * @memberof AssessRecommendedPatientsRequestDTO
   */
  recommendationIds: Array<string>;
}

/**
 * @export
 * @interface AssessmentAnswerDTO
 */
export interface AssessmentAnswerDTO {
  /**
   * @type {string}
   * @memberof AssessmentAnswerDTO
   */
  text?: string;
  /**
   * @type {number}
   * @memberof AssessmentAnswerDTO
   */
  value?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum AssessmentCompletingUserTypeDTO {
  PROVIDER = 'PROVIDER',
  CASEMANAGER = 'CASE MANAGER',
  PATIENT = 'PATIENT',
  QHADMIN = 'QH ADMIN'
}

/**
 * @export
 * @interface AssessmentInfoDTO
 */
export interface AssessmentInfoDTO {
  /**
   * @type {AssessmentTypeDTO}
   * @memberof AssessmentInfoDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @type {string}
   * @memberof AssessmentInfoDTO
   */
  lastCreated?: string;
  /**
   * @type {ProviderNameDTO}
   * @memberof AssessmentInfoDTO
   */
  lastCreatedBy?: ProviderNameDTO;
  /**
   * @type {string}
   * @memberof AssessmentInfoDTO
   */
  lastCompleted?: string;
}

/**
 * @export
 * @interface AssessmentModuleAnswerDTO
 */
export interface AssessmentModuleAnswerDTO {
  /**
   * @type {string}
   * @memberof AssessmentModuleAnswerDTO
   */
  id?: string;
  /**
   * @description Response for a given question in text form
   * @type {string}
   * @memberof AssessmentModuleAnswerDTO
   */
  text?: string;
  /**
   * @description corresponding numerical value for a response of this kind
   * @type {number}
   * @memberof AssessmentModuleAnswerDTO
   */
  value?: number;
}

/**
 * @export
 * @interface AssessmentModuleQuestionDTO
 */
export interface AssessmentModuleQuestionDTO {
  /**
   * @type {string}
   * @memberof AssessmentModuleQuestionDTO
   */
  id: string;
  /**
   * @description Reference to a question
   * @type {AssessmentQuestionDTO}
   * @memberof AssessmentModuleQuestionDTO
   */
  question: AssessmentQuestionDTO;
  /**
   * @description Indicates what position this question should be placed in for this module
   * @type {number}
   * @memberof AssessmentModuleQuestionDTO
   */
  position: number;
}

/**
 * @export
 * @interface AssessmentModuleResultV2DTO
 */
export interface AssessmentModuleResultV2DTO {
  /**
   * @type {AssessmentModuleTypeDTO}
   * @memberof AssessmentModuleResultV2DTO
   */
  assessmentModuleType: AssessmentModuleTypeDTO;
  /**
   * @description raw total for this module as calculated by the scoring function
   * @type {number}
   * @memberof AssessmentModuleResultV2DTO
   */
  rawScore: number;
  /**
   * @description textual label that corresponds to this score
   * @type {ScoreLabelDTO}
   * @memberof AssessmentModuleResultV2DTO
   */
  scoreLabel: ScoreLabelDTO;
  /**
   * @type {Array<AssessmentModuleAnswerDTO>}
   * @memberof AssessmentModuleResultV2DTO
   */
  assessmentAnswers: Array<AssessmentModuleAnswerDTO>;
  /**
   * @description Indicates whether the Assessment Module Result is clinically positive
   * @type {boolean}
   * @memberof AssessmentModuleResultV2DTO
   */
  isPositive: boolean;
  /**
   * @description Indicates whether the Assessment Module Result is clinically urgent
   * @type {boolean}
   * @memberof AssessmentModuleResultV2DTO
   */
  isUrgent: boolean;
  /**
   * @type {Array<AssessmentModuleUrgencyReasonDTO>}
   * @memberof AssessmentModuleResultV2DTO
   */
  urgentReasons?: Array<AssessmentModuleUrgencyReasonDTO>;
}

/**
 * @export
 * @enum {string}
 */
export enum AssessmentModuleTypeDTO {
  AdaptedNIDA = 'Adapted NIDA',
  ASRM = 'ASRM',
  AUDITC2 = 'AUDITC2',
  CAFAS = 'CAFAS',
  CATS = 'CATS',
  CFARSPsychosocial = 'CFARS Psychosocial',
  CFARSRisk = 'CFARS Risk',
  CoMorbid = 'Co morbid',
  ClinicianRatedDimensionsOfPsychosisSymptomSeverity = 'Clinician-Rated Dimensions of Psychosis Symptom Severity',
  CORE10 = 'CORE-10',
  CRAFFT21 = 'CRAFFT 2.1',
  Diagnostic = 'Diagnostic',
  DLA20 = 'DLA-20',
  FARSPsychosocial = 'FARS Psychosocial',
  FARSRisk = 'FARS Risk',
  GAD2 = 'GAD-2',
  GAD7 = 'GAD-7',
  MADRSS = 'MADRS-S',
  NIDATAPS = 'NIDA TAPS',
  PatientHealthQuestion = 'Patient Health Question',
  PECFAS = 'PECFAS',
  CPSS = 'CPSS',
  PHQ2 = 'PHQ-2',
  PHQ8 = 'PHQ-8',
  PHQ9 = 'PHQ-9',
  PTSD = 'PTSD',
  PROMISAdultAnger = 'PROMIS Adult Anger',
  PROMISAdultAnxiety = 'PROMIS Adult Anxiety',
  PROMISAdultDepression = 'PROMIS Adult Depression',
  PROMISChildAnxiety = 'PROMIS Child Anxiety',
  PROMISChildDepression = 'PROMIS Child Depression',
  PROMISChildAnger = 'PROMIS Child Anger',
  SCARED = 'SCARED',
  SMFQ = 'SMFQ',
  Vanderbilt = 'Vanderbilt',
  WHODAS = 'WHODAS',
  WHO5 = 'WHO-5',
  YMRS = 'YMRS',
  GAT = 'GAT',
  AUDIT = 'AUDIT',
  ChronicHealthQuestionnaire = 'Chronic Health Questionnaire',
  ComprehensivePart1 = 'Comprehensive - Part 1',
  ComprehensivePart2 = 'Comprehensive - Part 2',
  Inefficiency = 'Inefficiency',
  SEMCD6 = 'SEMCD-6',
  WarmUp = 'Warm Up'
}

/**
 * @export
 * @enum {string}
 */
export enum AssessmentModuleUrgencyReasonDTO {
  SuicidalResponse = 'Suicidal Response',
  ScoreThresholdReached = 'Score Threshold Reached'
}

/**
 * @export
 * @interface AssessmentModuleWithAnswersDTO
 */
export interface AssessmentModuleWithAnswersDTO {
  /**
   * @type {AssessmentModuleTypeDTO}
   * @memberof AssessmentModuleWithAnswersDTO
   */
  moduleType: AssessmentModuleTypeDTO;
  /**
   * @type {Array<AssessmentAnswerDTO>}
   * @memberof AssessmentModuleWithAnswersDTO
   */
  answers: Array<AssessmentAnswerDTO>;
}

/**
 * @export
 * @interface AssessmentQuestionDTO
 */
export interface AssessmentQuestionDTO {
  /**
   * @type {string}
   * @memberof AssessmentQuestionDTO
   */
  id?: string;
  /**
   * @description Question being asked
   * @type {string}
   * @memberof AssessmentQuestionDTO
   */
  text: string;
  /**
   * @description Boolean that indicates if the answer to this question is free text
   * @type {boolean}
   * @memberof AssessmentQuestionDTO
   */
  isFreeResponse?: boolean;
}

/**
 * @export
 * @interface AssessmentQuestionResponseDTO
 */
export interface AssessmentQuestionResponseDTO {
  /**
   * @type {string}
   * @memberof AssessmentQuestionResponseDTO
   */
  questionId: string;
  /**
   * @type {string}
   * @memberof AssessmentQuestionResponseDTO
   */
  answerId: string;
}

/**
 * @export
 * @interface AssessmentResultDTO
 */
export interface AssessmentResultDTO {
  /**
   * @description Indicates whether or not the patient consented to this assessment
   * @type {boolean}
   * @memberof AssessmentResultDTO
   */
  hasConsented: boolean;
  /**
   * @type {string}
   * @memberof AssessmentResultDTO
   */
  id: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof AssessmentResultDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @description Id of the patient who took this assessment
   * @type {string}
   * @memberof AssessmentResultDTO
   */
  patientId: string;
  /**
   * @description results from each module in the assessment
   * @type {Array<AssessmentModuleResultV2DTO>}
   * @memberof AssessmentResultDTO
   */
  moduleResultsV2: Array<AssessmentModuleResultV2DTO>;
  /**
   * @description State of this result set
   * @type {AssessmentStateDTO}
   * @memberof AssessmentResultDTO
   */
  state: AssessmentStateDTO;
  /**
   * @description Indicates if the results require urgent attention for patient
   * @type {boolean}
   * @memberof AssessmentResultDTO
   */
  isUrgent?: boolean;
  /**
   * @description Assessments that are scored positive are presented to PCP users
   * @type {boolean}
   * @memberof AssessmentResultDTO
   */
  isPositive?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum AssessmentStateDTO {
  Created = 'Created',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Expired = 'Expired'
}

/**
 * @export
 * @enum {string}
 */
export enum AssessmentTypeDTO {
  AUDITC2Assessment = 'AUDITC2 Assessment',
  ASRM = 'ASRM',
  BipolarSelfAssessment = 'Bipolar Self-Assessment',
  CAFASAssessment = 'CAFAS Assessment',
  CATSAssessment = 'CATS Assessment',
  CFARSAssessment = 'CFARS Assessment',
  CORE10Assessment = 'CORE-10 Assessment',
  CPSSAssessment = 'CPSS Assessment',
  CRAFFT21Assessment = 'CRAFFT 2.1 Assessment',
  DLA20Assessment = 'DLA-20 Assessment',
  FARSAssessment = 'FARS Assessment',
  MADRSS = 'MADRS-S',
  NIDATAPSAssessment = 'NIDA TAPS Assessment',
  PECFASAssessment = 'PECFAS Assessment',
  PTSDAssessment = 'PTSD Assessment',
  PROMISAdultDepressionAssessment = 'PROMIS Adult Depression Assessment',
  PROMISAdultAnxietyAssessment = 'PROMIS Adult Anxiety Assessment',
  PROMISAdultAngerAssessment = 'PROMIS Adult Anger Assessment',
  PROMISChildAnxietyAssessment = 'PROMIS Child Anxiety Assessment',
  PROMISChildDepressionAssessment = 'PROMIS Child Depression Assessment',
  PROMISChildAngerAssessment = 'PROMIS Child Anger Assessment',
  PsychosisAssessment = 'Psychosis Assessment',
  SCAREDAssessment = 'SCARED Assessment',
  SCREENERWITHLOGICV3 = 'SCREENER_WITH_LOGIC_V3',
  SCREENERWITHLOGICV4 = 'SCREENER_WITH_LOGIC_V4',
  SMFQSelfReportedAssessment = 'SMFQ Self Reported Assessment',
  SMFQParentReportedAssessment = 'SMFQ Parent Reported Assessment',
  VanderbiltAssessment = 'Vanderbilt Assessment',
  WHODASAssessment = 'WHODAS Assessment',
  WHO5Assessment = 'WHO-5 Assessment',
  YMRSAssessment = 'YMRS Assessment',
  GAT = 'GAT',
  AUDIT = 'AUDIT',
  COMPREHENSIVE = 'COMPREHENSIVE',
  GAD2 = 'GAD-2',
  GAD7 = 'GAD-7',
  PHQ2 = 'PHQ-2',
  PHQ9 = 'PHQ-9',
  SCREENERWITHLOGICV1 = 'SCREENER_WITH_LOGIC_V1',
  SCREENERWITHLOGICV2 = 'SCREENER_WITH_LOGIC_V2'
}

/**
 * @export
 * @interface AssignCareNavigatorToPatientRequestDTO
 */
export interface AssignCareNavigatorToPatientRequestDTO {
  /**
   * @type {string}
   * @memberof AssignCareNavigatorToPatientRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof AssignCareNavigatorToPatientRequestDTO
   */
  careNavigatorEmailAddress: string;
}

/**
 * @export
 * @interface AssignedCaseManagerDTO
 */
export interface AssignedCaseManagerDTO {
  /**
   * @type {string}
   * @memberof AssignedCaseManagerDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof AssignedCaseManagerDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof AssignedCaseManagerDTO
   */
  lastName?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof AssignedCaseManagerDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {Array<DisplayCaseManagerGroupDTO>}
   * @memberof AssignedCaseManagerDTO
   */
  groups?: Array<DisplayCaseManagerGroupDTO>;
}

/**
 * @export
 * @enum {string}
 */
export enum AtacamaErrorCodeDTO {
  AccountAlreadyActiveError = 'account_already_active_error',
  AssessmentValidationError = 'assessment_validation_error',
  IllegalArgumentError = 'illegal_argument_error',
  MissingRequestIdHeaderError = 'missing_request_id_header_error',
  MissingAccountIdHeaderError = 'missing_account_id_header_error',
  AuthenticationError = 'authentication_error',
  AuthenticationErrorUserLocked = 'authentication_error_user_locked',
  AuthorizationError = 'authorization_error',
  ExpiredAccountPasswordTokenError = 'expired_account_password_token_error',
  InvalidAccountPasswordTokenError = 'invalid_account_password_token_error',
  ExpiredTwoFactorAuthCodeError = 'expired_two_factor_auth_code_error',
  InvalidTwoFactorAuthCodeError = 'invalid_two_factor_auth_code_error',
  NotFoundError = 'not_found_error',
  AlreadyExistsError = 'already_exists_error',
  InternalServerError = 'internal_server_error',
  IllegalStateError = 'illegal_state_error',
  TooManyConcurrentSessionsError = 'too_many_concurrent_sessions_error',
  AccountInactiveError = 'account_inactive_error',
  AccountAwaitingActivationError = 'account_awaiting_activation_error',
  EntityLocked = 'entity_locked',
  ImpersonationLoginMissingReason = 'impersonation_login_missing_reason',
  NotImplemented = 'not_implemented',
  RequestNotProcessed = 'request_not_processed',
  RestrictedUserRole = 'restricted_user_role',
  PracticeAdminRequirementError = 'practice_admin_requirement_error',
  MissingRequiredProperty = 'missing_required_property',
  InvalidEmail = 'invalid_email',
  InvalidPassword = 'invalid_password',
  MinimumAgeError = 'minimum_age_error',
  InvalidAccountUserLinkageError = 'invalid_account_user_linkage_error',
  InvalidSingleSignOnOperation = 'invalid_single_sign_on_operation',
  SingleSignOnAuthenticationError = 'single_sign_on_authentication_error',
  UnreachablePhoneNumber = 'unreachable_phone_number',
  RecipientNotSubscribedToSms = 'recipient_not_subscribed_to_sms',
  UnsupportedCountryCodeForSms = 'unsupported_country_code_for_sms',
  PediatricPatientError = 'pediatric_patient_error',
  ActivationChannelError = 'activation_channel_error'
}

/**
 * @export
 * @interface AtacamaErrorDTO
 */
export interface AtacamaErrorDTO {
  /**
   * @description An Atacama-specific error code for the error that occurred
   * @type {AtacamaErrorCodeDTO}
   * @memberof AtacamaErrorDTO
   */
  code: AtacamaErrorCodeDTO;
  /**
   * @description A human-readable description of the error, not intended to be shown to end users
   * @type {string}
   * @memberof AtacamaErrorDTO
   */
  message: string;
}

/**
 * @export
 * @enum {string}
 */
export enum AudienceTypeDTO {
  PatientAudience = 'Patient Audience',
  FullPanelAudience = 'Full Panel Audience',
  RegulatedInsuranceAudience = 'Regulated Insurance Audience'
}

/**
 * @export
 * @enum {string}
 */
export enum AuthenticationResultDTO {
  LOGINSUCCESSFUL = 'LOGIN_SUCCESSFUL',
  REQUIRESTWOFACTORAUTH = 'REQUIRES_TWO_FACTOR_AUTH',
  IMPERSONATIONLOGINSUCCESSFUL = 'IMPERSONATION_LOGIN_SUCCESSFUL'
}

/**
 * @export
 * @interface BaseExternalIdDTO
 */
export interface BaseExternalIdDTO {
  /**
   * @type {string}
   * @memberof BaseExternalIdDTO
   */
  externalId?: string;
  /**
   * @type {string}
   * @memberof BaseExternalIdDTO
   */
  healthSystemId?: string;
}

/**
 * @export
 * @interface BaseInsurancePolicyDTO
 */
export interface BaseInsurancePolicyDTO {
  /**
   * @type {string}
   * @memberof BaseInsurancePolicyDTO
   */
  insurancePlanId: string;
  /**
   * @type {string}
   * @memberof BaseInsurancePolicyDTO
   */
  memberId: string;
  /**
   * @type {string}
   * @memberof BaseInsurancePolicyDTO
   */
  groupId?: string;
}

/**
 * @export
 * @interface BasicPatientDemographicsDTO
 */
export interface BasicPatientDemographicsDTO {
  /**
   * @type {Array<string>}
   * @memberof BasicPatientDemographicsDTO
   */
  insuranceMemberIds?: Array<string>;
  /**
   * @type {string}
   * @memberof BasicPatientDemographicsDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof BasicPatientDemographicsDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof BasicPatientDemographicsDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof BasicPatientDemographicsDTO
   */
  dateOfBirth: string;
  /**
   * @type {Array<string>}
   * @memberof BasicPatientDemographicsDTO
   */
  zipCodes: Array<string>;
  /**
   * @type {string}
   * @memberof BasicPatientDemographicsDTO
   */
  primaryPhoneNumber?: string;
  /**
   * @type {string}
   * @memberof BasicPatientDemographicsDTO
   */
  primaryEmail?: string;
}

/**
 * @export
 * @interface BasicPcpDemographicsDTO
 */
export interface BasicPcpDemographicsDTO {
  /**
   * @type {string}
   * @memberof BasicPcpDemographicsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof BasicPcpDemographicsDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof BasicPcpDemographicsDTO
   */
  dateOfBirth?: string;
  /**
   * @type {string}
   * @memberof BasicPcpDemographicsDTO
   */
  npi?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum BhPracticeRoleDTO {
  Admin = 'Practice Admin',
  Provider = 'Practice Provider'
}

/**
 * @export
 * @enum {string}
 */
export enum BhProviderTypeDTO {
  AAC = 'AAC',
  AMFT = 'AMFT',
  APN = 'APN',
  ASW = 'ASW',
  ArtTherapist = 'Art Therapist',
  CA = 'CA',
  CAC = 'CAC',
  CC = 'CC',
  CDAC = 'CDAC',
  CSAC = 'CSAC',
  CaseManager = 'Case Manager',
  CentralIntake = 'Central Intake',
  CertifiedPeerSpecialist = 'Certified Peer Specialist',
  ClinicalSocialWorkTherapist = 'Clinical Social Work Therapist',
  Counselor = 'Counselor',
  CounselorIntern = 'Counselor Intern',
  Curbside = 'Curbside',
  DrugAlcoholCounselor = 'Drug Alcohol Counselor',
  LAC = 'LAC',
  LASW = 'LASW',
  LCADAC = 'LCADAC',
  LCMHCA = 'LCMHCA',
  LCMHC = 'LCMHC',
  LCPC = 'LCPC',
  LCSW = 'LCSW',
  LCSWA = 'LCSWA',
  LEP = 'LEP',
  LICSW = 'LICSW',
  LMFT = 'LMFT',
  LMFTA = 'LMFTA',
  LMHC = 'LMHC',
  LMHCA = 'LMHCA',
  LMSW = 'LMSW',
  LPC = 'LPC',
  LPCIntern = 'LPC Intern',
  LPCA = 'LPCA',
  LPCC = 'LPCC',
  LPCS = 'LPCS',
  LSW = 'LSW',
  LSWAA = 'LSWAA',
  LSWAIC = 'LSWAIC',
  LicensedPastoralCounselor = 'Licensed Pastoral Counselor',
  LimitedLicensedPsychologist = 'Limited Licensed Psychologist',
  MAC = 'MAC',
  MFTCandidateDoctoral = 'MFT Candidate - Doctoral',
  MFTCandidateMasters = 'MFT Candidate - Masters',
  MFTI = 'MFT-I',
  MHR = 'MHR',
  NCAAC = 'NCAAC',
  NCACI = 'NCAC I',
  NCACII = 'NCAC II',
  NCPRSS = 'NCPRSS',
  NCSE = 'NCSE',
  NDS = 'NDS',
  NursePractitioner = 'Nurse Practitioner',
  Other = 'Other',
  PCCI = 'PCCI',
  PLPC = 'PLPC',
  PastoralCounselor = 'Pastoral Counselor',
  PhysicianAssistant = 'Physician Assistant',
  PsychiatricNursePractitioner = 'Psychiatric Nurse Practitioner',
  Psychiatrist = 'Psychiatrist',
  PsychologicalAssociate = 'Psychological Associate',
  Psychologist = 'Psychologist',
  RSW = 'RSW'
}

/**
 * @export
 * @interface BhpDTO
 */
export interface BhpDTO {
  /**
   * @type {Array<AcceptedInsurancePlanDTO>}
   * @memberof BhpDTO
   */
  acceptedInsurancePlans?: Array<AcceptedInsurancePlanDTO>;
  /**
   * @type {Array<string>}
   * @memberof BhpDTO
   */
  associatedPractices?: Array<string>;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof BhpDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof BhpDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @type {Array<EmailDTO>}
   * @memberof BhpDTO
   */
  emails: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof BhpDTO
   */
  firstName?: string;
  /**
   * @type {GenderDTO}
   * @memberof BhpDTO
   */
  gender?: GenderDTO;
  /**
   * @type {string}
   * @memberof BhpDTO
   */
  id: string;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof BhpDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {string}
   * @memberof BhpDTO
   */
  lastName?: string;
  /**
   * @type {LicenseDTO}
   * @memberof BhpDTO
   */
  license?: LicenseDTO;
  /**
   * @type {Array<LicenseDTO>}
   * @memberof BhpDTO
   */
  licenses?: Array<LicenseDTO>;
  /**
   * @type {Array<string>}
   * @memberof BhpDTO
   */
  locations?: Array<string>;
  /**
   * @type {string}
   * @memberof BhpDTO
   */
  npi?: string;
  /**
   * @type {number}
   * @memberof BhpDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {number}
   * @memberof BhpDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof BhpDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {Array<BhPracticeRoleDTO>}
   * @memberof BhpDTO
   */
  practiceRoles: Array<BhPracticeRoleDTO>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof BhpDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<ProviderStatusInQuartetDTO>}
   * @memberof BhpDTO
   */
  providerStatusInQuartet?: Array<ProviderStatusInQuartetDTO>;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof BhpDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof BhpDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof BhpDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {boolean}
   * @memberof BhpDTO
   */
  isQHVerified?: boolean;
  /**
   * @type {string}
   * @memberof BhpDTO
   */
  tin?: string;
  /**
   * @description flag to determine if this provider is allowed to recveive referrals
   * @type {boolean}
   * @memberof BhpDTO
   */
  canReceiveReferrals?: boolean;
  /**
   * @type {BhpTypeDTO}
   * @memberof BhpDTO
   */
  type?: BhpTypeDTO;
  /**
   * @type {boolean}
   * @memberof BhpDTO
   */
  isUsingSupervisorsNpi?: boolean;
  /**
   * @type {RaceEthnicityDTO}
   * @memberof BhpDTO
   */
  raceEthnicity?: RaceEthnicityDTO;
}

/**
 * @export
 * @interface BhpDashboardAppointmentDTO
 */
export interface BhpDashboardAppointmentDTO {
  /**
   * @type {string}
   * @memberof BhpDashboardAppointmentDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof BhpDashboardAppointmentDTO
   */
  date?: string;
}

/**
 * @export
 * @interface BhpDashboardPatientDTO
 */
export interface BhpDashboardPatientDTO {
  /**
   * @type {string}
   * @memberof BhpDashboardPatientDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof BhpDashboardPatientDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof BhpDashboardPatientDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof BhpDashboardPatientDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof BhpDashboardPatientDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<string>}
   * @memberof BhpDashboardPatientDTO
   */
  providerIds: Array<string>;
  /**
   * @type {boolean}
   * @memberof BhpDashboardPatientDTO
   */
  isBcncVbcPatient?: boolean;
}

/**
 * @export
 * @interface BhpDashboardProviderDTO
 */
export interface BhpDashboardProviderDTO {
  /**
   * @type {string}
   * @memberof BhpDashboardProviderDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof BhpDashboardProviderDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof BhpDashboardProviderDTO
   */
  lastName?: string;
}

/**
 * @export
 * @interface BhpDetailsForMatchedPracticeDTO
 */
export interface BhpDetailsForMatchedPracticeDTO {
  /**
   * @type {string}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  id: string;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {Array<ProviderMatchAcceptedInsurancePlanDTO>}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  acceptedInsurancePlans?: Array<ProviderMatchAcceptedInsurancePlanDTO>;
  /**
   * @type {Array<string>}
   * @memberof BhpDetailsForMatchedPracticeDTO
   */
  locations?: Array<string>;
}

/**
 * @export
 * @interface BhpDetailsForPatientDTO
 */
export interface BhpDetailsForPatientDTO {
  /**
   * @type {string}
   * @memberof BhpDetailsForPatientDTO
   */
  bhpId: string;
  /**
   * @type {string}
   * @memberof BhpDetailsForPatientDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof BhpDetailsForPatientDTO
   */
  lastName: string;
  /**
   * @type {GenderDTO}
   * @memberof BhpDetailsForPatientDTO
   */
  gender?: GenderDTO;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof BhpDetailsForPatientDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {string}
   * @memberof BhpDetailsForPatientDTO
   */
  practiceId?: string;
  /**
   * @type {string}
   * @memberof BhpDetailsForPatientDTO
   */
  practiceName?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof BhpDetailsForPatientDTO
   */
  practicePhoneNumbers?: Array<PhoneNumberDTO>;
}

/**
 * @export
 * @interface BhpForPracticeResponseDTO
 */
export interface BhpForPracticeResponseDTO {
  /**
   * @type {Array<AcceptedInsurancePlanDTO>}
   * @memberof BhpForPracticeResponseDTO
   */
  acceptedInsurancePlans?: Array<AcceptedInsurancePlanDTO>;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof BhpForPracticeResponseDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<EmailDTO>}
   * @memberof BhpForPracticeResponseDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof BhpForPracticeResponseDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof BhpForPracticeResponseDTO
   */
  id: string;
  /**
   * @type {boolean}
   * @memberof BhpForPracticeResponseDTO
   */
  isQHVerified?: boolean;
  /**
   * @type {string}
   * @memberof BhpForPracticeResponseDTO
   */
  lastName: string;
  /**
   * @type {Array<BhPracticeRoleDTO>}
   * @memberof BhpForPracticeResponseDTO
   */
  practiceRoles?: Array<BhPracticeRoleDTO>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof BhpForPracticeResponseDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<ProviderStatusInQuartetDTO>}
   * @memberof BhpForPracticeResponseDTO
   */
  providerStatusInQuartet: Array<ProviderStatusInQuartetDTO>;
  /**
   * @type {ProviderTypeDTO}
   * @memberof BhpForPracticeResponseDTO
   */
  type: ProviderTypeDTO;
}

/**
 * @export
 * @interface BhpPatientTimelineTaskBaseDTO
 */
export interface BhpPatientTimelineTaskBaseDTO {
  /**
   * @type {string}
   * @memberof BhpPatientTimelineTaskBaseDTO
   */
  dueDate?: string;
  /**
   * @type {string}
   * @memberof BhpPatientTimelineTaskBaseDTO
   */
  completionDate?: string;
}

/**
 * @export
 * @interface BhpPracticeSmartMatchPreferencesDTO
 */
export interface BhpPracticeSmartMatchPreferencesDTO {
  /**
   * @type {boolean}
   * @memberof BhpPracticeSmartMatchPreferencesDTO
   */
  requiresHealthSystemReferrals?: boolean;
  /**
   * @type {boolean}
   * @memberof BhpPracticeSmartMatchPreferencesDTO
   */
  isExcludedFromAutolaunch?: boolean;
}

/**
 * @export
 * @interface BhpProfileResponseDTO
 */
export interface BhpProfileResponseDTO {
  /**
   * @type {BhpDTO}
   * @memberof BhpProfileResponseDTO
   */
  bhp: BhpDTO;
}

/**
 * @export
 * @interface BhpSmartMatchPreferencesDTO
 */
export interface BhpSmartMatchPreferencesDTO {
  /**
   * @type {boolean}
   * @memberof BhpSmartMatchPreferencesDTO
   */
  includeInSmartMatch?: boolean;
  /**
   * @type {string}
   * @memberof BhpSmartMatchPreferencesDTO
   */
  pauseMatchesFrom?: string;
  /**
   * @type {string}
   * @memberof BhpSmartMatchPreferencesDTO
   */
  pauseMatchesUntil?: string;
}

/**
 * @export
 * @interface BhpTaskBaseDTO
 */
export interface BhpTaskBaseDTO {
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof BhpTaskBaseDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof BhpTaskBaseDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof BhpTaskBaseDTO
   */
  providerLastName: string;
}

/**
 * @export
 * @interface BhpTaskResponseDTO
 */
export interface BhpTaskResponseDTO {
  /**
   * @type {Array<PendingReferralDTO>}
   * @memberof BhpTaskResponseDTO
   */
  pendingReferrals?: Array<PendingReferralDTO>;
  /**
   * @type {Array<AppointmentNeedingUpdateDTO>}
   * @memberof BhpTaskResponseDTO
   */
  appointmentsNeedingUpdate?: Array<AppointmentNeedingUpdateDTO>;
  /**
   * @type {Array<ReferralNeedingContactDTO>}
   * @memberof BhpTaskResponseDTO
   */
  referralsNeedingContact?: Array<ReferralNeedingContactDTO>;
  /**
   * @type {Array<PatientNeedingUpdateDTO>}
   * @memberof BhpTaskResponseDTO
   */
  patientsNeedingUpdate?: Array<PatientNeedingUpdateDTO>;
  /**
   * @type {Array<VbcBaselineAssessmentDTO>}
   * @memberof BhpTaskResponseDTO
   */
  vbcBaselineAssessment?: Array<VbcBaselineAssessmentDTO>;
  /**
   * @type {Array<VbcFollowupAssessmentDTO>}
   * @memberof BhpTaskResponseDTO
   */
  vbcFollowupAssessment?: Array<VbcFollowupAssessmentDTO>;
  /**
   * @type {Array<HighRiskAssessmentDTO>}
   * @memberof BhpTaskResponseDTO
   */
  highRiskAssessment?: Array<HighRiskAssessmentDTO>;
}

/**
 * @export
 * @interface BhpTeleSettingsDTO
 */
export interface BhpTeleSettingsDTO {
  /**
   * @type {boolean}
   * @memberof BhpTeleSettingsDTO
   */
  isSupported?: boolean;
  /**
   * @type {boolean}
   * @memberof BhpTeleSettingsDTO
   */
  isInitialInPersonRequired?: boolean;
  /**
   * @type {string}
   * @memberof BhpTeleSettingsDTO
   */
  exclusionaryCriteria?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum BhpTypeDTO {
  BHP = 'BHP',
  BHADMIN = 'BH_ADMIN'
}

/**
 * @export
 * @interface BhpsForPracticeResponseDTO
 */
export interface BhpsForPracticeResponseDTO {
  /**
   * @description The collection of BHP's in a practice
   * @type {Array<BhpForPracticeResponseDTO>}
   * @memberof BhpsForPracticeResponseDTO
   */
  bhps: Array<BhpForPracticeResponseDTO>;
}

/**
 * @export
 * @interface CancelPatientRematchRequestRequestDTO
 */
export interface CancelPatientRematchRequestRequestDTO {
  /**
   * @type {string}
   * @memberof CancelPatientRematchRequestRequestDTO
   */
  patientRematchRequestId: string;
}

/**
 * @export
 * @interface CareEventDTO
 */
export interface CareEventDTO {
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  appointmentId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  assessmentResultId?: string;
  /**
   * @type {ContactOutcomeDTO}
   * @memberof CareEventDTO
   */
  contactOutcome?: ContactOutcomeDTO;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  creatingProviderId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  creatingCaseManagerId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  creatingAdminId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  creatingPatientId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  curbsideId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  date: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  followupDate?: string;
  /**
   * @type {boolean}
   * @memberof CareEventDTO
   */
  isUrgent: boolean;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  note?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  progressUpdateId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  providerId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  caseManagerId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  id: string;
  /**
   * @type {CareEventTypeDTO}
   * @memberof CareEventDTO
   */
  type: CareEventTypeDTO;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  careTeamId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  referralId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  crisisReferralId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  patientRematchRequestId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  patientContactInfoRequestId?: string;
  /**
   * @type {string}
   * @memberof CareEventDTO
   */
  patientIntakeId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum CareEventExternalIdTypeDTO {
  Encounter = 'Encounter',
  Location = 'Location',
  SendingFacility = 'Sending Facility',
  OrderId = 'Order Id'
}

/**
 * @export
 * @enum {string}
 */
export enum CareEventTypeDTO {
  AppointmentAttended = 'Appointment Attended',
  AppointmentCanceled = 'Appointment Canceled',
  AppointmentMissed = 'Appointment Missed',
  AppointmentRescheduled = 'Appointment Rescheduled',
  AppointmentScheduled = 'Appointment Scheduled',
  AssessmentCanceled = 'Assessment Canceled',
  AssessmentCompleted = 'Assessment Completed',
  AssessmentCreated = 'Assessment Created',
  AssessmentExpired = 'Assessment Expired',
  AssessmentUpdated = 'Assessment Updated',
  HighRiskAssessmentAcknowledged = 'High Risk Assessment Acknowledged',
  BHPInitialProgressUpdate = 'BHP Initial Progress Update',
  BHPLegacyProgressUpdate = 'BHP Legacy Progress Update',
  BHPStructuredProgressUpdate = 'BHP Structured Progress Update',
  CaseManagerJoinedCareTeam = 'Case Manager Joined Care Team',
  CaseManagerLeftCareTeam = 'Case Manager Left Care Team',
  CaseManagerProgressUpdate = 'Case Manager Progress Update',
  CCBTCompleted = 'CCBT Completed',
  CCBTCreated = 'CCBT Created',
  ContactLogCreated = 'Contact Log Created',
  CrisisReferralCreated = 'Crisis Referral Created',
  CrisisReferralResolved = 'Crisis Referral Resolved',
  CurbsideCanceled = 'Curbside Canceled',
  CurbsideCompleted = 'Curbside Completed',
  CurbsideCreated = 'Curbside Created',
  CurbsideInProgress = 'Curbside In Progress',
  DeclinedReferral = 'Declined Referral',
  FullPanelPatientCreated = 'Full Panel Patient Created',
  LegacyCurbsideCreated = 'Legacy Curbside Created',
  OptedIn = 'Opted In',
  ProviderAcceptedReferral = 'Provider Accepted Referral',
  ProviderJoinedCareTeam = 'Provider Joined Care Team',
  ProviderLeftCareTeam = 'Provider Left Care Team',
  PatientContactInformationUpdateRequested = 'Patient Contact Information Update Requested',
  PatientContactInformationUpdated = 'Patient Contact Information Updated',
  PatientIntakeCompleted = 'Patient Intake Completed',
  PatientRematchRequested = 'Patient Rematch Requested',
  PatientRematchUpdated = 'Patient Rematch Updated',
  PatientRematchCompleted = 'Patient Rematch Completed',
  PatientRematchCanceled = 'Patient Rematch Canceled',
  PatientDeclinedCare = 'Patient Declined Care',
  PatientDeclinedExternallyInCare = 'Patient Declined Externally In Care',
  PatientDeferred = 'Patient Deferred',
  PatientDuplicate = 'Patient Duplicate',
  PatientOutOfScope = 'Patient Out Of Scope',
  PatientReactivated = 'Patient Reactivated',
  PatientReassignedPractice = 'Patient Reassigned Practice',
  PatientReferredOutside = 'Patient Referred Outside',
  PatientUnreachable = 'Patient Unreachable',
  PendingOptIn = 'Pending Opt In',
  PendingPatientIntakeCompletion = 'Pending Patient Intake Completion',
  PendingSelfServiceProviderSelection = 'Pending Self Service Provider Selection',
  PCPProgressUpdate = 'PCP Progress Update',
  PracticeFollowingUp = 'Practice Following Up',
  ProgressUpdateEdited = 'Progress Update Edited',
  QuartetDeclined = 'Quartet Declined',
  QuartetProgressUpdate = 'Quartet Progress Update',
  ReassignedReferral = 'Reassigned Referral',
  ReferralCreated = 'Referral Created',
  ReferralExpired = 'Referral Expired',
  ReferredIntoQuartet = 'Referred Into Quartet',
  ReferredIntoVirtualClinic = 'Referred Into Virtual Clinic',
  SelfServiceProviderSelected = 'Self Service Provider Selected',
  SubmittedAsRecommendedPatient = 'Submitted as Recommended Patient',
  NoSelfServiceProviderSelected = 'No Self Service Provider Selected'
}

/**
 * @export
 * @interface CareEventsDTO
 */
export interface CareEventsDTO {
  /**
   * @type {Array<CareEventDTO>}
   * @memberof CareEventsDTO
   */
  careEvents: Array<CareEventDTO>;
  /**
   * @type {PageDTO}
   * @memberof CareEventsDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface CareEventsForPatientTimelineResponseDTO
 */
export interface CareEventsForPatientTimelineResponseDTO {
  /**
   * @type {PatientDTO}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  patient?: PatientDTO;
  /**
   * @description The care events for patient timeline
   * @type {Array<CareEventDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  careEvents: Array<CareEventDTO>;
  /**
   * @description The assessment results for care events on the patient timeline
   * @type {Array<AssessmentResultWithCompletingInfoDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  assessmentResults?: Array<AssessmentResultWithCompletingInfoDTO>;
  /**
   * @description The appointments for care events on the patient timeline
   * @type {Array<AppointmentDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  appointments?: Array<AppointmentDTO>;
  /**
   * @type {Array<LocationDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  appointmentLocations?: Array<LocationDTO>;
  /**
   * @description The curbsides for care events on the patient timeline
   * @type {Array<CurbsideDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  curbsides?: Array<CurbsideDTO>;
  /**
   * @description The progress updates for care events on the patient timeline
   * @type {Array<ProgressUpdateDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  progressUpdates?: Array<ProgressUpdateDTO>;
  /**
   * @description The providers and creatingProviders associated with the care events on the patient timeline
   * @type {Array<ProviderDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  providers?: Array<ProviderDTO>;
  /**
   * @description The provider notifications associated with the care events on the patient timeline
   * @type {Array<NotificationForTimelineDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  notifications?: Array<NotificationForTimelineDTO>;
  /**
   * @description The case manager notifications associated with the care events on the patient timeline
   * @type {Array<NotificationForTimelineDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  caseManagerNotifications?: Array<NotificationForTimelineDTO>;
  /**
   * @description The referrals linked to the care events
   * @type {Array<ReferralDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  referrals?: Array<ReferralDTO>;
  /**
   * @description The creatingCaseManagers associated with the care events on the patient timeline
   * @type {Array<CaseManagerDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  caseManagers?: Array<CaseManagerDTO>;
  /**
   * @description The creatingAdmins associated with the care events on the patient timeline
   * @type {Array<AdminDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  admins?: Array<AdminDTO>;
  /**
   * @description The contact info requests associated with the care events on the patient timeline
   * @type {Array<PatientContactInfoRequestDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  patientContactInfoRequests?: Array<PatientContactInfoRequestDTO>;
  /**
   * @description The crisis referrals for care events on the patient timeline
   * @type {Array<CrisisReferralDTO>}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  crisisReferrals?: Array<CrisisReferralDTO>;
  /**
   * @type {PageDTO}
   * @memberof CareEventsForPatientTimelineResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface CareEventsResponseDTO
 */
export interface CareEventsResponseDTO {
  /**
   * @description The collection of care event entities
   * @type {Array<CareEventDTO>}
   * @memberof CareEventsResponseDTO
   */
  careEvents: Array<CareEventDTO>;
  /**
   * @description Providers and creating providers of the care events
   * @type {Array<ProviderDTO>}
   * @memberof CareEventsResponseDTO
   */
  providers?: Array<ProviderDTO>;
  /**
   * @description Creating case managers of the care events
   * @type {Array<CaseManagerDTO>}
   * @memberof CareEventsResponseDTO
   */
  caseManagers?: Array<CaseManagerDTO>;
  /**
   * @description Creating QH admins of the care events
   * @type {Array<AdminDTO>}
   * @memberof CareEventsResponseDTO
   */
  admins?: Array<AdminDTO>;
  /**
   * @description Progress updates associated with the care events
   * @type {Array<ProgressUpdateDTO>}
   * @memberof CareEventsResponseDTO
   */
  progressUpdates?: Array<ProgressUpdateDTO>;
}

/**
 * @export
 * @interface CareEventsWithMetadataResponseDTO
 */
export interface CareEventsWithMetadataResponseDTO {
  /**
   * @type {Array<CareEventWithMetadataDTO>}
   * @memberof CareEventsWithMetadataResponseDTO
   */
  careEvents: Array<CareEventWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof CareEventsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface CareTeamCaseManagerDTO
 */
export interface CareTeamCaseManagerDTO {
  /**
   * @type {string}
   * @memberof CareTeamCaseManagerDTO
   */
  caseManagerId?: string;
  /**
   * @type {CareTeamMemberStatusDTO}
   * @memberof CareTeamCaseManagerDTO
   */
  status?: CareTeamMemberStatusDTO;
}

/**
 * @export
 * @interface CareTeamDTO
 */
export interface CareTeamDTO {
  /**
   * @type {Array<CareTeamMemberDTO>}
   * @memberof CareTeamDTO
   */
  careTeamMembers?: Array<CareTeamMemberDTO>;
  /**
   * @type {Array<CareTeamCaseManagerDTO>}
   * @memberof CareTeamDTO
   */
  caseManagers?: Array<CareTeamCaseManagerDTO>;
  /**
   * @type {Array<CareTeamPcpDTO>}
   * @memberof CareTeamDTO
   */
  pcps?: Array<CareTeamPcpDTO>;
  /**
   * @type {string}
   * @memberof CareTeamDTO
   */
  patientId?: string;
  /**
   * @type {string}
   * @memberof CareTeamDTO
   */
  id?: string;
}

/**
 * @export
 * @interface CareTeamMemberDTO
 */
export interface CareTeamMemberDTO {
  /**
   * @type {string}
   * @memberof CareTeamMemberDTO
   */
  providerId?: string;
  /**
   * @type {CareTeamRoleDTO}
   * @memberof CareTeamMemberDTO
   */
  role?: CareTeamRoleDTO;
  /**
   * @type {CareTeamMemberStatusDTO}
   * @memberof CareTeamMemberDTO
   */
  status?: CareTeamMemberStatusDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum CareTeamMemberStatusDTO {
  Active = 'Active',
  Inactive = 'Inactive'
}

/**
 * @export
 * @interface CareTeamPcpDTO
 */
export interface CareTeamPcpDTO {
  /**
   * @type {string}
   * @memberof CareTeamPcpDTO
   */
  providerId?: string;
  /**
   * @type {string}
   * @memberof CareTeamPcpDTO
   */
  practiceId?: string;
  /**
   * @type {CareTeamMemberStatusDTO}
   * @memberof CareTeamPcpDTO
   */
  status?: CareTeamMemberStatusDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum CareTeamRoleDTO {
  PrimaryCarePhysician = 'Primary Care Physician',
  BehavioralHealthProvider = 'Behavioral Health Provider'
}

/**
 * @export
 * @interface CareTeamsWithMetadataResponseDTO
 */
export interface CareTeamsWithMetadataResponseDTO {
  /**
   * @type {Array<CareTeamWithMetadataDTO>}
   * @memberof CareTeamsWithMetadataResponseDTO
   */
  careTeams: Array<CareTeamWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof CareTeamsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface CaseManagerDTO
 */
export interface CaseManagerDTO {
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof CaseManagerDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof CaseManagerDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerDTO
   */
  firstName?: string;
  /**
   * @type {GenderDTO}
   * @memberof CaseManagerDTO
   */
  gender?: GenderDTO;
  /**
   * @type {string}
   * @memberof CaseManagerDTO
   */
  lastName?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof CaseManagerDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {Array<string>}
   * @memberof CaseManagerDTO
   */
  practices?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CaseManagerDTO
   */
  groupIds?: Array<string>;
  /**
   * @type {string}
   * @memberof CaseManagerDTO
   */
  id?: string;
  /**
   * @type {Array<CaseManagerStatusInQuartetDTO>}
   * @memberof CaseManagerDTO
   */
  statusInQuartet?: Array<CaseManagerStatusInQuartetDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerDTO
   */
  suffix?: string;
  /**
   * @type {ProviderProfilePermissionsForAdminDTO}
   * @memberof CaseManagerDTO
   */
  caseManagerProfilePermissions?: ProviderProfilePermissionsForAdminDTO;
}

/**
 * @export
 * @interface CaseManagerDashboardResponseDTO
 */
export interface CaseManagerDashboardResponseDTO {
  /**
   * @type {PageDTO}
   * @memberof CaseManagerDashboardResponseDTO
   */
  page: PageDTO;
  /**
   * @type {Array<CaseManagerDashboardResponsePatientDTO>}
   * @memberof CaseManagerDashboardResponseDTO
   */
  patients: Array<CaseManagerDashboardResponsePatientDTO>;
}

/**
 * @export
 * @interface CaseManagerDashboardResponsePatientDTO
 */
export interface CaseManagerDashboardResponsePatientDTO {
  /**
   * @type {string}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {DisplayCaseManagerDTO}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  caseManager?: DisplayCaseManagerDTO;
  /**
   * @type {DisplayCareEventDTO}
   * @memberof CaseManagerDashboardResponsePatientDTO
   */
  latestCareEvent?: DisplayCareEventDTO;
}

/**
 * @export
 * @interface CaseManagerForGroupResponseDTO
 */
export interface CaseManagerForGroupResponseDTO {
  /**
   * @type {Array<CaseManagerStateDTO>}
   * @memberof CaseManagerForGroupResponseDTO
   */
  states?: Array<CaseManagerStateDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerForGroupResponseDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof CaseManagerForGroupResponseDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof CaseManagerForGroupResponseDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof CaseManagerForGroupResponseDTO
   */
  primaryEmail?: string;
  /**
   * @type {GroupCaseManagerProfilePermissionsDTO}
   * @memberof CaseManagerForGroupResponseDTO
   */
  profilePermissions?: GroupCaseManagerProfilePermissionsDTO;
  /**
   * @type {boolean}
   * @memberof CaseManagerForGroupResponseDTO
   */
  isAccountActive?: boolean;
}

/**
 * @export
 * @interface CaseManagerProfileDTO
 */
export interface CaseManagerProfileDTO {
  /**
   * @type {string}
   * @memberof CaseManagerProfileDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof CaseManagerProfileDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof CaseManagerProfileDTO
   */
  lastName?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof CaseManagerProfileDTO
   */
  emails: Array<EmailDTO>;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof CaseManagerProfileDTO
   */
  phoneNumbers: Array<PhoneNumberDTO>;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof CaseManagerProfileDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @type {Array<string>}
   * @memberof CaseManagerProfileDTO
   */
  groupIds: Array<string>;
  /**
   * @type {Array<CaseManagerStatusInQuartetDTO>}
   * @memberof CaseManagerProfileDTO
   */
  statusInQuartet: Array<CaseManagerStatusInQuartetDTO>;
  /**
   * @type {GroupCaseManagerProfilePermissionsDTO}
   * @memberof CaseManagerProfileDTO
   */
  profilePermissions: GroupCaseManagerProfilePermissionsDTO;
}

/**
 * @export
 * @interface CaseManagerProfileResponseDTO
 */
export interface CaseManagerProfileResponseDTO {
  /**
   * @type {CaseManagerProfileDTO}
   * @memberof CaseManagerProfileResponseDTO
   */
  caseManager: CaseManagerProfileDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum CaseManagerStateDTO {
  Deactivated = 'Deactivated',
  CompletedRegistration = 'Completed Registration'
}

/**
 * @export
 * @interface CaseManagerStatusInQuartetDTO
 */
export interface CaseManagerStatusInQuartetDTO {
  /**
   * @type {string}
   * @memberof CaseManagerStatusInQuartetDTO
   */
  date: string;
  /**
   * @type {CaseManagerStateDTO}
   * @memberof CaseManagerStatusInQuartetDTO
   */
  state: CaseManagerStateDTO;
}

/**
 * @export
 * @interface CaseManagerUserDataDTO
 */
export interface CaseManagerUserDataDTO {
  /**
   * @type {string}
   * @memberof CaseManagerUserDataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof CaseManagerUserDataDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof CaseManagerUserDataDTO
   */
  lastName?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof CaseManagerUserDataDTO
   */
  emails: Array<EmailDTO>;
  /**
   * @type {Array<DisplayPracticeDTO>}
   * @memberof CaseManagerUserDataDTO
   */
  followingPractices: Array<DisplayPracticeDTO>;
  /**
   * @type {Array<HealthSystemDTO>}
   * @memberof CaseManagerUserDataDTO
   */
  dashboardHealthSystems: Array<HealthSystemDTO>;
  /**
   * @type {Array<DisplayCaseManagerGroupDTO>}
   * @memberof CaseManagerUserDataDTO
   */
  groups: Array<DisplayCaseManagerGroupDTO>;
  /**
   * @type {number}
   * @memberof CaseManagerUserDataDTO
   */
  minimumReactiveReferralAge: number;
  /**
   * @type {number}
   * @memberof CaseManagerUserDataDTO
   */
  minimumCurbsideAge: number;
  /**
   * @type {number}
   * @memberof CaseManagerUserDataDTO
   */
  minimumPediatricAge?: number;
  /**
   * @type {number}
   * @memberof CaseManagerUserDataDTO
   */
  maximumPediatricAge?: number;
}

/**
 * @export
 * @interface CaseManagersForGroupResponseDTO
 */
export interface CaseManagersForGroupResponseDTO {
  /**
   * @description The collection of case managers in a group
   * @type {Array<CaseManagerForGroupResponseDTO>}
   * @memberof CaseManagersForGroupResponseDTO
   */
  caseManagers: Array<CaseManagerForGroupResponseDTO>;
}

/**
 * @export
 * @interface CaseManagersWithMetadataResponseDTO
 */
export interface CaseManagersWithMetadataResponseDTO {
  /**
   * @type {Array<CaseManagerWithMetadataDTO>}
   * @memberof CaseManagersWithMetadataResponseDTO
   */
  caseManagers: Array<CaseManagerWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof CaseManagersWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum CcbtProgramAssessmentTypeDTO {
  GAD7 = 'GAD7',
  PHQ9 = 'PHQ9',
  SPIN = 'SPIN'
}

/**
 * @export
 * @interface CcbtProgramDTO
 */
export interface CcbtProgramDTO {
  /**
   * @type {string}
   * @memberof CcbtProgramDTO
   */
  patientId: string;
  /**
   * @type {CcbtProgramVendorDTO}
   * @memberof CcbtProgramDTO
   */
  vendor: CcbtProgramVendorDTO;
  /**
   * @type {CcbtProgramTypeDTO}
   * @memberof CcbtProgramDTO
   */
  programType: CcbtProgramTypeDTO;
  /**
   * @type {CcbtProgramAssessmentTypeDTO}
   * @memberof CcbtProgramDTO
   */
  assessmentType: CcbtProgramAssessmentTypeDTO;
  /**
   * @type {string}
   * @memberof CcbtProgramDTO
   */
  registrationDate: string;
  /**
   * @type {number}
   * @memberof CcbtProgramDTO
   */
  initialScore: number;
  /**
   * @description If the program has been completed, the date and time of completion
   * @type {string}
   * @memberof CcbtProgramDTO
   */
  completionDate?: string;
  /**
   * @description If the program has been completed, the patient's final score
   * @type {number}
   * @memberof CcbtProgramDTO
   */
  finalScore?: number;
  /**
   * @type {string}
   * @memberof CcbtProgramDTO
   */
  externalId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum CcbtProgramTypeDTO {
  GeneralizedAnxiety = 'Generalized Anxiety',
  SocialAnxiety = 'Social Anxiety',
  Depression = 'Depression',
  SpaceForPositiveBodyImage = 'Space for Positive Body Image',
  SpaceForResilience = 'Space for Resilience',
  SpaceFromAnxiety = 'Space from Anxiety',
  SpaceFromDepression = 'Space from Depression',
  SpaceInChronicPainFromDepressionAndAnxiety = 'Space in Chronic Pain from Depression and Anxiety',
  SpaceFromStress = 'Space from Stress',
  SpaceFromDepressionAndAnxiety = 'Space from Depression and Anxiety',
  Stress = 'Stress',
  Sleep = 'Sleep',
  WorkEngagementAndProductivity = 'Work Engagement and Productivity',
  WorkLifeBalance = 'Work-Life Balance',
  Anger = 'Anger',
  Work = 'Work',
  Marriage = 'Marriage',
  MarriageOrIntimateRelationship = 'Marriage or Intimate Relationship'
}

/**
 * @export
 * @enum {string}
 */
export enum CcbtProgramVendorDTO {
  Joyable = 'Joyable',
  SilverCloud = 'SilverCloud',
  WayForward = 'WayForward'
}

/**
 * @export
 * @enum {string}
 */
export enum ClaimsEventTypeDTO {
  InpatientAdmission = 'Inpatient admission',
  ERVisit = 'ER visit',
  MentalHealthProviderVisit = 'Mental health provider visit',
  PrimaryCareProviderVisit = 'Primary care provider visit',
  OtherProviderVisit = 'Other provider visit',
  OutpatientSurgeryVisit = 'Outpatient surgery visit',
  OutpatientObservationVisit = 'Outpatient Observation Visit',
  OutpatientEMVisit = 'Outpatient EM Visit',
  ProviderVisit = 'Provider Visit',
  ConsultVisit = 'Consult Visit',
  OutpatientOtherVisit = 'Outpatient Other Visit',
  OtherVisit = 'Other Visit',
  LabDiagnosticsVisit = 'Lab Diagnostics Visit',
  AdultDayCareVisit = 'Adult Day Care Visit',
  SubacuteInpatientAdmission = 'Subacute Inpatient Admission',
  AcuteMaternityInpatientAdmission = 'Acute Maternity Inpatient Admission',
  AcuteInpatientAdmission = 'Acute Inpatient Admission',
  OutpatientEmergencyRoomVisit = 'Outpatient Emergency Room Visit',
  CriticalCareVisit = 'Critical Care Visit',
  ProfProcedure = 'Prof Procedure',
  ProfTreatment = 'Prof Treatment',
  ProfImaging = 'Prof Imaging',
  ProfOther = 'Prof Other',
  HomeHealth = 'Home Health',
  UnknownVisitType = 'Unknown Visit Type'
}

/**
 * @export
 * @enum {string}
 */
export enum ClientEngagementLevelDTO {
  VeryEngaged = 'Very Engaged',
  Engaged = 'Engaged',
  Neutral = 'Neutral',
  Disengaged = 'Disengaged',
  VeryDisengaged = 'Very Disengaged'
}

/**
 * @export
 * @enum {string}
 */
export enum CommunicationPreferenceDTO {
  SMS = 'Receive SMS',
  Email = 'Receive Email'
}

/**
 * @export
 * @interface CommunicationPreferencesDTO
 */
export interface CommunicationPreferencesDTO {
  /**
   * @type {boolean}
   * @memberof CommunicationPreferencesDTO
   */
  isSubscribedToEmail: boolean;
  /**
   * @type {boolean}
   * @memberof CommunicationPreferencesDTO
   */
  isSubscribedToSms: boolean;
}

/**
 * @export
 * @interface CompleteCcbtProgramRequestDTO
 */
export interface CompleteCcbtProgramRequestDTO {
  /**
   * @type {string}
   * @memberof CompleteCcbtProgramRequestDTO
   */
  ccbtProgramId: string;
  /**
   * @type {string}
   * @memberof CompleteCcbtProgramRequestDTO
   */
  completionDate: string;
  /**
   * @type {number}
   * @memberof CompleteCcbtProgramRequestDTO
   */
  finalScore: number;
}

/**
 * @export
 * @interface CompleteDigitalIntakeRequestDTO
 */
export interface CompleteDigitalIntakeRequestDTO {
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  address: AddressDTO;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  gender: GenderDTO;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  lastName: string;
  /**
   * @description If known, the ID of the patient
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  patientId?: string;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  patientPreferences: PatientPreferencesDTO;
  /**
   * @description The patient's preferred service format
   * @type {TeleservicesPreferenceDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @description The patient's preferred MHP gender
   * @type {GenderDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The patient's preferred MHP language
   * @type {LanguageDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description Patient's phone numbers (must be exactly one where isPrimary = true)
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  preferredName?: string;
  /**
   * @type {CreateSelfReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  primaryInsurancePolicy: CreateSelfReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @type {CreateSelfReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  secondaryInsurancePolicy?: CreateSelfReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @description Patient's suffix, if any
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  suffix?: string;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description The edited note to put on the care event
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  careEventNote: string;
  /**
   * @type {string}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  referralReason: string;
  /**
   * @description The service type patient is requesting
   * @type {PatientServiceTypeDTO}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  serviceType?: PatientServiceTypeDTO;
  /**
   * @description The patient's primary and additional concerns
   * @type {Array<PatientConcernDTO>}
   * @memberof CompleteDigitalIntakeRequestDTO
   */
  patientConcerns?: Array<PatientConcernDTO>;
}

/**
 * @export
 * @interface CompletePatientRegistrationRequestDTO
 */
export interface CompletePatientRegistrationRequestDTO {
  /**
   * @description The ID of the patient attepmting to register
   * @type {string}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  patientId: string;
  /**
   * @description The primary email of the patient attepmting to register
   * @type {string}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  emailAddress: string;
  /**
   * @type {PatientReferralChannelDTO}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  referralChannel: PatientReferralChannelDTO;
  /**
   * @description The primary phone number of the patient attepmting to register
   * @type {string}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  phoneNumber: string;
  /**
   * @type {string}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  password: string;
  /**
   * @type {boolean}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  smsConsent: boolean;
  /**
   * @type {boolean}
   * @memberof CompletePatientRegistrationRequestDTO
   */
  emailConsent: boolean;
}

/**
 * @export
 * @interface CompletedAssessmentDetailsDTO
 */
export interface CompletedAssessmentDetailsDTO {
  /**
   * @type {AssessmentTypeDTO}
   * @memberof CompletedAssessmentDetailsDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @type {string}
   * @memberof CompletedAssessmentDetailsDTO
   */
  completedAt: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ConditionDTO {
  ADHD = 'ADHD',
  ADHDADD = 'ADHD/ADD',
  AcademicUnderachievement = 'Academic Underachievement',
  Addiction = 'Addiction',
  Adjustment = 'Adjustment',
  Adoption = 'Adoption',
  AlcoholAbuse = 'Alcohol Abuse',
  Alzheimers = "Alzheimer's",
  AngerManagement = 'Anger Management',
  AntisocialPersonality = 'Antisocial Personality',
  Anxiety = 'Anxiety',
  AspergersSyndrome = "Asperger's Syndrome",
  Autism = 'Autism',
  AutismEvaluation = 'Autism Evaluation',
  BehavioralIssues = 'Behavioral Issues',
  BereavementGrief = 'Bereavement/Grief',
  BipolarDisorder = 'Bipolar Disorder',
  BisexualIssues = 'Bisexual Issues',
  BodyImage = 'Body Image',
  BorderlinePersonality = 'Borderline Personality',
  CareerCounseling = 'Career Counseling',
  ChildAdolescent = 'Child Adolescent',
  ChronicImpulsivity = 'Chronic Impulsivity',
  ChronicPain = 'Chronic Pain',
  ChronicRelapse = 'Chronic Relapse',
  Codependency = 'Codependency',
  ControlIssues = 'Control Issues',
  CopingSkills = 'Coping Skills',
  CopingWithAMedicalIssue = 'Coping with a medical issue',
  Dementia = 'Dementia',
  Depression = 'Depression',
  DevelopmentalDisorders = 'Developmental Disorders',
  DissociativeDisorders = 'Dissociative Disorders',
  Divorce = 'Divorce',
  DomesticAbuse = 'Domestic Abuse',
  DomesticViolence = 'Domestic Violence',
  DrugAbuse = 'Drug Abuse',
  DualDiagnosis = 'Dual Diagnosis',
  EatingDisorders = 'Eating Disorders',
  ElderlyPersonsDisorders = 'Elderly Persons Disorders',
  EmotionalDisturbance = 'Emotional Disturbance',
  Entitlement = 'Entitlement',
  FamilyConflict = 'Family Conflict',
  FirstRespondersMilitaryVeterans = 'First Responders / Military / Veterans',
  Gambling = 'Gambling',
  GayIssues = 'Gay Issues',
  Grief = 'Grief',
  HistoryOfSuicideIdeationAttempts = 'History of Suicide Ideation / Attempts',
  ImpulseControlDisorders = 'Impulse Control Disorders',
  Infertility = 'Infertility',
  Infidelity = 'Infidelity',
  IntellectualDisability = 'Intellectual Disability',
  InternetAddiction = 'Internet Addiction',
  Isolation = 'Isolation',
  LearningDisabilities = 'Learning Disabilities',
  LesbianIssues = 'Lesbian Issues',
  LGBTQ = 'LGBTQ',
  LifeCoaching = 'Life Coaching',
  Manipulation = 'Manipulation',
  MaritalPremarital = 'Marital Premarital',
  MedicalDetox = 'Medical Detox',
  MedicalDocumentation = 'Medical Documentation',
  MedicalIssues = 'Medical Issues',
  MedicationAssistedTreatmentMAT = 'Medication Assisted Treatment (MAT)',
  MedicationEvaluation = 'Medication Evaluation',
  MedicationManagement = 'Medication Management',
  MensIssues = 'Mens Issues',
  MoodDisorders = 'Mood Disorders',
  NarcissisticPersonality = 'Narcissistic Personality',
  OCD = 'OCD',
  Obesity = 'Obesity',
  OppositionalDefiance = 'Oppositional Defiance',
  Other = 'Other',
  OtherNeuropsychEvaluation = 'Other Neuropsych Evaluation',
  OtherIssues = 'Other Issues',
  PTSD = 'PTSD',
  Paranoia = 'Paranoia',
  Parenting = 'Parenting',
  PeerRelationships = 'Peer Relationships',
  PersonalityDisorders = 'Personality Disorders',
  Phobia = 'Phobia',
  PostpartumDepression = 'Postpartum Depression',
  Pregnancy = 'Pregnancy',
  Prenatal = 'Prenatal',
  Postpartum = 'Postpartum',
  PregnancyPrenatalPostpartum = 'Pregnancy Prenatal Postpartum',
  Psychosis = 'Psychosis',
  RecoveryHistoryOfAddiction = 'Recovery / History of Addiction',
  RelationshipIssues = 'Relationship Issues',
  SAD = 'SAD',
  Schizophrenia = 'Schizophrenia',
  SelfEsteem = 'Self Esteem',
  SelfHarming = 'Self Harming',
  SexTherapy = 'Sex Therapy',
  SexualAbuse = 'Sexual Abuse',
  SexualAddiction = 'Sexual Addiction',
  SexualCompulsiveBehaviors = 'Sexual Compulsive Behaviors',
  ShoppingAddiction = 'Shopping Addiction',
  SleepOrInsomnia = 'Sleep or Insomnia',
  SmokingCessation = 'Smoking Cessation',
  Somatization = 'Somatization',
  Spirituality = 'Spirituality',
  Stress = 'Stress',
  StimulantUse = 'Stimulant Use',
  SubstanceAbuse = 'Substance Abuse',
  SuicidalIdeation = 'Suicidal Ideation',
  TeenViolence = 'Teen Violence',
  TestingAndEvaluation = 'Testing and Evaluation',
  ThinkingDisorders = 'Thinking Disorders',
  TransgenderIdentity = 'Transgender Identity',
  Trauma = 'Trauma',
  TraumaticBrainInjury = 'Traumatic Brain Injury',
  VideoGameAddiction = 'Video Game Addiction',
  WeightLoss = 'Weight Loss',
  WomensIssues = 'Womens Issues'
}

/**
 * @export
 * @enum {string}
 */
export enum ContactOutcomeDTO {
  SentEmail = 'Sent Email',
  NoAnswer = 'No Answer',
  Other = 'Other',
  Voicemail = 'Voicemail',
  ReceivedEmail = 'Received Email',
  ContactedAppointmentScheduled = 'Contacted Appointment Scheduled',
  ContactedNoAppointmentScheduled = 'Contacted No Appointment Scheduled'
}

/**
 * @export
 * @enum {string}
 */
export enum CoordinationOfBenefitsOrderDTO {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
  Inactive = 'Inactive',
  EntityDetectedPrimary = 'Entity Detected Primary'
}

/**
 * @export
 * @interface CreateBhpAndPracticeRequestDTO
 */
export interface CreateBhpAndPracticeRequestDTO {
  /**
   * @type {CreateBhpDTO}
   * @memberof CreateBhpAndPracticeRequestDTO
   */
  bhp: CreateBhpDTO;
  /**
   * @type {CreatePracticeDTO}
   * @memberof CreateBhpAndPracticeRequestDTO
   */
  practice: CreatePracticeDTO;
  /**
   * @description Indices of practice locations to give the provider (0-indexed)
   * @type {Array<number>}
   * @memberof CreateBhpAndPracticeRequestDTO
   */
  providerLocationIndices: Array<number>;
  /**
   * @type {Array<BhPracticeRoleDTO>}
   * @memberof CreateBhpAndPracticeRequestDTO
   */
  practiceRoles: Array<BhPracticeRoleDTO>;
}

/**
 * @export
 * @interface CreateBhpAndPracticeResponseDTO
 */
export interface CreateBhpAndPracticeResponseDTO {
  /**
   * @type {BhpDTO}
   * @memberof CreateBhpAndPracticeResponseDTO
   */
  bhp: BhpDTO;
  /**
   * @type {PracticeDTO}
   * @memberof CreateBhpAndPracticeResponseDTO
   */
  practice: PracticeDTO;
  /**
   * @type {Array<BhPracticeRoleDTO>}
   * @memberof CreateBhpAndPracticeResponseDTO
   */
  bhPracticeRoles: Array<BhPracticeRoleDTO>;
}

/**
 * @description Core data describing a Bhp.
 * @export
 * @interface CreateBhpDTO
 */
export interface CreateBhpDTO {
  /**
   * @description The provider's first name.
   * @type {string}
   * @memberof CreateBhpDTO
   */
  firstName: string;
  /**
   * @description The provider's last name.
   * @type {string}
   * @memberof CreateBhpDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof CreateBhpDTO
   */
  suffix?: string;
  /**
   * @type {GenderDTO}
   * @memberof CreateBhpDTO
   */
  gender?: GenderDTO;
  /**
   * @type {ProviderTypeDTO}
   * @memberof CreateBhpDTO
   */
  type: ProviderTypeDTO;
  /**
   * @type {string}
   * @memberof CreateBhpDTO
   */
  npi?: string;
  /**
   * @type {boolean}
   * @memberof CreateBhpDTO
   */
  isUsingSupervisorsNpi?: boolean;
  /**
   * @description A primary phone number at which the provider can be reached.
   * @type {string}
   * @memberof CreateBhpDTO
   */
  primaryPhoneNumber?: string;
  /**
   * @description The provider's primary email address.
   * @type {string}
   * @memberof CreateBhpDTO
   */
  emailAddress: string;
  /**
   * @type {LicenseDTO}
   * @memberof CreateBhpDTO
   */
  license?: LicenseDTO;
  /**
   * @type {Array<LicenseDTO>}
   * @memberof CreateBhpDTO
   */
  licenses?: Array<LicenseDTO>;
  /**
   * @description A fax number that the provider can receive documents on.
   * @type {string}
   * @memberof CreateBhpDTO
   */
  faxNumber?: string;
  /**
   * @type {Array<AcceptedInsurancePlanDTO>}
   * @memberof CreateBhpDTO
   */
  acceptedInsurancePlans?: Array<AcceptedInsurancePlanDTO>;
  /**
   * @type {Array<string>}
   * @memberof CreateBhpDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof CreateBhpDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof CreateBhpDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof CreateBhpDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {number}
   * @memberof CreateBhpDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {number}
   * @memberof CreateBhpDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {string}
   * @memberof CreateBhpDTO
   */
  tin?: string;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof CreateBhpDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof CreateBhpDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof CreateBhpDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {string}
   * @memberof CreateBhpDTO
   */
  password: string;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof CreateBhpDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof CreateBhpDTO
   */
  userAgreementVersions?: Array<UserAgreementVersionDTO>;
  /**
   * @type {RaceEthnicityDTO}
   * @memberof CreateBhpDTO
   */
  raceEthnicity?: RaceEthnicityDTO;
}

/**
 * @export
 * @interface CreateCareEventWithExternalCaseIdRequestDTO
 */
export interface CreateCareEventWithExternalCaseIdRequestDTO {
  /**
   * @description The ID for the to patient to be linked in the care event
   * @type {string}
   * @memberof CreateCareEventWithExternalCaseIdRequestDTO
   */
  patientId: string;
  /**
   * @description The ID of the external case to link to the care event
   * @type {string}
   * @memberof CreateCareEventWithExternalCaseIdRequestDTO
   */
  externalCaseId: string;
  /**
   * @description A note to save on the care event
   * @type {string}
   * @memberof CreateCareEventWithExternalCaseIdRequestDTO
   */
  note?: string;
  /**
   * @description An optional date override used for backfilling
   * @type {string}
   * @memberof CreateCareEventWithExternalCaseIdRequestDTO
   */
  dateOverride?: string;
}

/**
 * @export
 * @interface CreateCaseManagerAndGroupRequestDTO
 */
export interface CreateCaseManagerAndGroupRequestDTO {
  /**
   * @type {CreateGroupCaseManagerRequestDTO}
   * @memberof CreateCaseManagerAndGroupRequestDTO
   */
  caseManager: CreateGroupCaseManagerRequestDTO;
  /**
   * @type {CreateGroupCaseManagerGroupRequestDTO}
   * @memberof CreateCaseManagerAndGroupRequestDTO
   */
  group: CreateGroupCaseManagerGroupRequestDTO;
}

/**
 * @export
 * @interface CreateCaseManagerAndGroupResponseDTO
 */
export interface CreateCaseManagerAndGroupResponseDTO {
  /**
   * @type {string}
   * @memberof CreateCaseManagerAndGroupResponseDTO
   */
  caseManagerId: string;
  /**
   * @type {string}
   * @memberof CreateCaseManagerAndGroupResponseDTO
   */
  groupId: string;
}

/**
 * @export
 * @interface CreateCaseManagerRequestDTO
 */
export interface CreateCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof CreateCaseManagerRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof CreateCaseManagerRequestDTO
   */
  lastName: string;
  /**
   * @type {Array<string>}
   * @memberof CreateCaseManagerRequestDTO
   */
  emails: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreateCaseManagerRequestDTO
   */
  phoneNumbers: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreateCaseManagerRequestDTO
   */
  healthSystemIds: Array<string>;
  /**
   * @type {GenderDTO}
   * @memberof CreateCaseManagerRequestDTO
   */
  gender?: GenderDTO;
  /**
   * @type {boolean}
   * @memberof CreateCaseManagerRequestDTO
   */
  requiresTwoFactorAuthentication?: boolean;
}

/**
 * @export
 * @interface CreateCaseManagerResponseDTO
 */
export interface CreateCaseManagerResponseDTO {
  /**
   * @type {string}
   * @memberof CreateCaseManagerResponseDTO
   */
  caseManagerId: string;
}

/**
 * @export
 * @interface CreateContactLogDTO
 */
export interface CreateContactLogDTO {
  /**
   * @description The provider that reached out
   * @type {string}
   * @memberof CreateContactLogDTO
   */
  providerId: string;
  /**
   * @description The relevant referral being contacted
   * @type {string}
   * @memberof CreateContactLogDTO
   */
  referralId: string;
  /**
   * @type {ContactOutcomeDTO}
   * @memberof CreateContactLogDTO
   */
  contactOutcome: ContactOutcomeDTO;
  /**
   * @description An additional note about the contact
   * @type {string}
   * @memberof CreateContactLogDTO
   */
  note?: string;
  /**
   * @description A date to try again or follow up on this contact
   * @type {string}
   * @memberof CreateContactLogDTO
   */
  followupDate?: string;
}

/**
 * @export
 * @interface CreateCurbsideForPatientRequestDTO
 */
export interface CreateCurbsideForPatientRequestDTO {
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  patientDateOfBirth: string;
  /**
   * @type {GenderDTO}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  patientGender: GenderDTO;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  patientZipCode: string;
  /**
   * @description The id of the practice from which the patient is being referred
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  practiceId?: string;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  pcpPhoneNumber: string;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  pcpAvailability: string;
  /**
   * @type {string}
   * @memberof CreateCurbsideForPatientRequestDTO
   */
  reasonForConsult: string;
}

/**
 * @export
 * @interface CreateExternalCurbsideRequestDTO
 */
export interface CreateExternalCurbsideRequestDTO {
  /**
   * @type {Array<CareEventExternalIdDTO>}
   * @memberof CreateExternalCurbsideRequestDTO
   */
  careEventExternalIds?: Array<CareEventExternalIdDTO>;
  /**
   * @type {string}
   * @memberof CreateExternalCurbsideRequestDTO
   */
  healthSystemId: string;
  /**
   * @type {EmrCurbsideDTO}
   * @memberof CreateExternalCurbsideRequestDTO
   */
  curbside: EmrCurbsideDTO;
  /**
   * @type {ExternalReferralPatientDTO}
   * @memberof CreateExternalCurbsideRequestDTO
   */
  patient: ExternalReferralPatientDTO;
  /**
   * @type {ExternalReferralPcpDTO}
   * @memberof CreateExternalCurbsideRequestDTO
   */
  pcp: ExternalReferralPcpDTO;
}

/**
 * @export
 * @interface CreateExternalReferralInsurancePolicyDTO
 */
export interface CreateExternalReferralInsurancePolicyDTO {
  /**
   * @description Member Id for the patient insurance policy that is supposed to be associated with this alias.
   * @type {string}
   * @memberof CreateExternalReferralInsurancePolicyDTO
   */
  insuranceMemberId: string;
  /**
   * @description Priority for the patient insurance policy that is supposed to be associated with this alias.
   * @type {CoordinationOfBenefitsOrderDTO}
   * @memberof CreateExternalReferralInsurancePolicyDTO
   */
  order: CoordinationOfBenefitsOrderDTO;
  /**
   * @type {CreateExternalReferralRequestInsuranceAliasDTO}
   * @memberof CreateExternalReferralInsurancePolicyDTO
   */
  insuranceAlias: CreateExternalReferralRequestInsuranceAliasDTO;
}

/**
 * @export
 * @interface CreateExternalReferralRequestDTO
 */
export interface CreateExternalReferralRequestDTO {
  /**
   * @description A flag which specifies that this patient is in crisis. If not provided, we default to false
   * @type {boolean}
   * @memberof CreateExternalReferralRequestDTO
   */
  isCrisisPatient?: boolean;
  /**
   * @type {string}
   * @memberof CreateExternalReferralRequestDTO
   */
  healthSystemId: string;
  /**
   * @type {ExternalReferralPatientDTO}
   * @memberof CreateExternalReferralRequestDTO
   */
  patient: ExternalReferralPatientDTO;
  /**
   * @type {ExternalReferralPcpDTO}
   * @memberof CreateExternalReferralRequestDTO
   */
  pcp: ExternalReferralPcpDTO;
  /**
   * @description The required note explaining the reason for referral.
   * @type {string}
   * @memberof CreateExternalReferralRequestDTO
   */
  referralReason: string;
  /**
   * @type {Array<CareEventExternalIdDTO>}
   * @memberof CreateExternalReferralRequestDTO
   */
  careEventExternalIds?: Array<CareEventExternalIdDTO>;
  /**
   * @type {string}
   * @memberof CreateExternalReferralRequestDTO
   */
  invitationCode?: string;
}

/**
 * @export
 * @interface CreateExternalReferralRequestInsuranceAliasDTO
 */
export interface CreateExternalReferralRequestInsuranceAliasDTO {
  /**
   * @type {string}
   * @memberof CreateExternalReferralRequestInsuranceAliasDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof CreateExternalReferralRequestInsuranceAliasDTO
   */
  healthSystemId: string;
}

/**
 * @export
 * @interface CreateExternalReferralResponseDTO
 */
export interface CreateExternalReferralResponseDTO {
  /**
   * @description The event ID of the patient's referral
   * @type {string}
   * @memberof CreateExternalReferralResponseDTO
   */
  careEventId: string;
  /**
   * @description Quartet's patient ID
   * @type {string}
   * @memberof CreateExternalReferralResponseDTO
   */
  patientId: string;
  /**
   * @description The HL7 compliant patient external ID
   * @type {string}
   * @memberof CreateExternalReferralResponseDTO
   */
  patientHl7Id?: string;
  /**
   * @description Quartet's provider ID
   * @type {string}
   * @memberof CreateExternalReferralResponseDTO
   */
  referringProviderId: string;
  /**
   * @type {string}
   * @memberof CreateExternalReferralResponseDTO
   */
  createdAt: string;
  /**
   * @description Patient's primary insurance plan Quartet ID
   * @type {string}
   * @memberof CreateExternalReferralResponseDTO
   */
  insurancePlanId?: string;
}

/**
 * @export
 * @interface CreateFullPanelPatientRequestDTO
 */
export interface CreateFullPanelPatientRequestDTO {
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  dateOfBirth: string;
  /**
   * @type {GenderDTO}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  gender: GenderDTO;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  zipCode: string;
  /**
   * @type {boolean}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  smsConsent: boolean;
  /**
   * @type {Array<PhoneTypeAndNumberDTO>}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  phoneNumbers?: Array<PhoneTypeAndNumberDTO>;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  email?: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  insurancePlanId: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  insuranceMemberId: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  bhpId: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  creatingBhpId?: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  appointmentDate?: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  appointmentLocationId?: string;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  appointmentSetting?: AppointmentSettingDTO;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  mrn?: string;
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientRequestDTO
   */
  sourceHash?: string;
}

/**
 * @export
 * @interface CreateFullPanelPatientResponseDTO
 */
export interface CreateFullPanelPatientResponseDTO {
  /**
   * @type {string}
   * @memberof CreateFullPanelPatientResponseDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface CreateGroupCaseManagerGroupRequestDTO
 */
export interface CreateGroupCaseManagerGroupRequestDTO {
  /**
   * @type {string}
   * @memberof CreateGroupCaseManagerGroupRequestDTO
   */
  name: string;
  /**
   * @type {AddressDTO}
   * @memberof CreateGroupCaseManagerGroupRequestDTO
   */
  address?: AddressDTO;
  /**
   * @type {StateDTO}
   * @memberof CreateGroupCaseManagerGroupRequestDTO
   */
  state?: StateDTO;
}

/**
 * @export
 * @interface CreateGroupCaseManagerRequestDTO
 */
export interface CreateGroupCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof CreateGroupCaseManagerRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof CreateGroupCaseManagerRequestDTO
   */
  lastName: string;
  /**
   * @type {Array<string>}
   * @memberof CreateGroupCaseManagerRequestDTO
   */
  emails: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreateGroupCaseManagerRequestDTO
   */
  phoneNumbers: Array<string>;
  /**
   * @type {GenderDTO}
   * @memberof CreateGroupCaseManagerRequestDTO
   */
  gender?: GenderDTO;
  /**
   * @type {boolean}
   * @memberof CreateGroupCaseManagerRequestDTO
   */
  requiresTwoFactorAuthentication?: boolean;
}

/**
 * @export
 * @interface CreateHealthSystemBhpPartnershipRuleDTO
 */
export interface CreateHealthSystemBhpPartnershipRuleDTO {
  /**
   * @type {Array<string>}
   * @memberof CreateHealthSystemBhpPartnershipRuleDTO
   */
  healthSystemIds: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreateHealthSystemBhpPartnershipRuleDTO
   */
  bhpPracticeIds: Array<string>;
}

/**
 * @export
 * @interface CreateHealthSystemRequestDTO
 */
export interface CreateHealthSystemRequestDTO {
  /**
   * @type {string}
   * @memberof CreateHealthSystemRequestDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof CreateHealthSystemRequestDTO
   */
  parentHealthSystemId?: string;
  /**
   * @type {AddressDTO}
   * @memberof CreateHealthSystemRequestDTO
   */
  address?: AddressDTO;
}

/**
 * @export
 * @interface CreateHealthSystemResponseDTO
 */
export interface CreateHealthSystemResponseDTO {
  /**
   * @type {HealthSystemDTO}
   * @memberof CreateHealthSystemResponseDTO
   */
  healthSystem?: HealthSystemDTO;
}

/**
 * @export
 * @interface CreateInactiveProgressUpdateRequestDTO
 */
export interface CreateInactiveProgressUpdateRequestDTO {
  /**
   * @description author's provider id
   * @type {string}
   * @memberof CreateInactiveProgressUpdateRequestDTO
   */
  authorId: string;
  /**
   * @description progress update inactive reason
   * @type {InactiveReasonDTO}
   * @memberof CreateInactiveProgressUpdateRequestDTO
   */
  inactiveReason: InactiveReasonDTO;
  /**
   * @description note
   * @type {string}
   * @memberof CreateInactiveProgressUpdateRequestDTO
   */
  note?: string;
  /**
   * @description patient id
   * @type {string}
   * @memberof CreateInactiveProgressUpdateRequestDTO
   */
  patientId: string;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof CreateInactiveProgressUpdateRequestDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
}

/**
 * @export
 * @interface CreateInsurancePlanAliasRequestDTO
 */
export interface CreateInsurancePlanAliasRequestDTO {
  /**
   * @type {string}
   * @memberof CreateInsurancePlanAliasRequestDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof CreateInsurancePlanAliasRequestDTO
   */
  healthSystemId: string;
  /**
   * @type {string}
   * @memberof CreateInsurancePlanAliasRequestDTO
   */
  insurancePlanId: string;
}

/**
 * @export
 * @interface CreateInsurancePlanAliasResponseDTO
 */
export interface CreateInsurancePlanAliasResponseDTO {
  /**
   * @type {string}
   * @memberof CreateInsurancePlanAliasResponseDTO
   */
  id: string;
}

/**
 * @export
 * @interface CreateInsurancePlanBhpPracticePartnershipRuleDTO
 */
export interface CreateInsurancePlanBhpPracticePartnershipRuleDTO {
  /**
   * @type {Array<string>}
   * @memberof CreateInsurancePlanBhpPracticePartnershipRuleDTO
   */
  insurancePlanIds: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreateInsurancePlanBhpPracticePartnershipRuleDTO
   */
  bhpPracticeIds: Array<string>;
}

/**
 * @export
 * @interface CreateInsurancePlanHealthSystemPartnershipRuleDTO
 */
export interface CreateInsurancePlanHealthSystemPartnershipRuleDTO {
  /**
   * @type {Array<string>}
   * @memberof CreateInsurancePlanHealthSystemPartnershipRuleDTO
   */
  insurancePlanIds: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreateInsurancePlanHealthSystemPartnershipRuleDTO
   */
  healthSystemIds: Array<string>;
}

/**
 * @export
 * @interface CreateInsurancePlanRequestDTO
 */
export interface CreateInsurancePlanRequestDTO {
  /**
   * @type {string}
   * @memberof CreateInsurancePlanRequestDTO
   */
  carrier: string;
  /**
   * @type {string}
   * @memberof CreateInsurancePlanRequestDTO
   */
  mbho?: string;
  /**
   * @type {InsuranceCategoryDTO}
   * @memberof CreateInsurancePlanRequestDTO
   */
  category: InsuranceCategoryDTO;
  /**
   * @type {InsurancePlanTypeDTO}
   * @memberof CreateInsurancePlanRequestDTO
   */
  type?: InsurancePlanTypeDTO;
  /**
   * @type {StateDTO}
   * @memberof CreateInsurancePlanRequestDTO
   */
  state: StateDTO;
  /**
   * @type {Array<string>}
   * @memberof CreateInsurancePlanRequestDTO
   */
  aliases?: Array<string>;
  /**
   * @type {boolean}
   * @memberof CreateInsurancePlanRequestDTO
   */
  isActive?: boolean;
  /**
   * @type {boolean}
   * @memberof CreateInsurancePlanRequestDTO
   */
  isCountyRestricted?: boolean;
}

/**
 * @export
 * @interface CreateInsurancePlanResponseDTO
 */
export interface CreateInsurancePlanResponseDTO {
  /**
   * @type {InsurancePlanDTO}
   * @memberof CreateInsurancePlanResponseDTO
   */
  insurancePlan?: InsurancePlanDTO;
}

/**
 * @export
 * @interface CreateIntraHealthSystemRuleDTO
 */
export interface CreateIntraHealthSystemRuleDTO {
  /**
   * @type {Array<string>}
   * @memberof CreateIntraHealthSystemRuleDTO
   */
  healthSystemIds: Array<string>;
}

/**
 * @export
 * @interface CreateKeepMePostedPatientRequestDTO
 */
export interface CreateKeepMePostedPatientRequestDTO {
  /**
   * @description The patient's postal code
   * @type {string}
   * @memberof CreateKeepMePostedPatientRequestDTO
   */
  postalCode: string;
  /**
   * @type {PatientReferralChannelDTO}
   * @memberof CreateKeepMePostedPatientRequestDTO
   */
  patientReferralChannel: PatientReferralChannelDTO;
  /**
   * @description The patient's first name
   * @type {string}
   * @memberof CreateKeepMePostedPatientRequestDTO
   */
  firstName: string;
  /**
   * @description The patient's last name
   * @type {string}
   * @memberof CreateKeepMePostedPatientRequestDTO
   */
  lastName: string;
  /**
   * @description The patient's email address
   * @type {string}
   * @memberof CreateKeepMePostedPatientRequestDTO
   */
  emailAddress: string;
  /**
   * @description If the patient has opted in for future Quartet research
   * @type {boolean}
   * @memberof CreateKeepMePostedPatientRequestDTO
   */
  isOptedInForResearch: boolean;
}

/**
 * @export
 * @interface CreateKeepMePostedPatientResponseDTO
 */
export interface CreateKeepMePostedPatientResponseDTO {
  /**
   * @description The new patient's id
   * @type {string}
   * @memberof CreateKeepMePostedPatientResponseDTO
   */
  patientId: string;
}

/**
 * @description The data required to create a new location.
 * @export
 * @interface CreateLocationDTO
 */
export interface CreateLocationDTO {
  /**
   * @type {AddressDTO}
   * @memberof CreateLocationDTO
   */
  address?: AddressDTO;
  /**
   * @type {string}
   * @memberof CreateLocationDTO
   */
  name?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof CreateLocationDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {string}
   * @memberof CreateLocationDTO
   */
  tin?: string;
  /**
   * @type {string}
   * @memberof CreateLocationDTO
   */
  tinRemitAddress?: string;
}

/**
 * @export
 * @interface CreateMarketConfigurationRequestDTO
 */
export interface CreateMarketConfigurationRequestDTO {
  /**
   * @type {MarketConfigurationDTO}
   * @memberof CreateMarketConfigurationRequestDTO
   */
  marketConfiguration: MarketConfigurationDTO;
}

/**
 * @export
 * @interface CreateMatchListRequestDTO
 */
export interface CreateMatchListRequestDTO {
  /**
   * @type {string}
   * @memberof CreateMatchListRequestDTO
   */
  patientId: string;
  /**
   * @type {number}
   * @memberof CreateMatchListRequestDTO
   */
  maxDistance?: number;
  /**
   * @type {SmartMatchAlgorithmVersionDTO}
   * @memberof CreateMatchListRequestDTO
   */
  algorithmVersion?: SmartMatchAlgorithmVersionDTO;
  /**
   * @type {boolean}
   * @memberof CreateMatchListRequestDTO
   */
  regenerateMatchList?: boolean;
  /**
   * @type {boolean}
   * @memberof CreateMatchListRequestDTO
   */
  isDirectMatch?: boolean;
}

/**
 * @export
 * @interface CreateMedicalProviderAndPracticeRequestDTO
 */
export interface CreateMedicalProviderAndPracticeRequestDTO {
  /**
   * @type {CreateMedicalProviderDTO}
   * @memberof CreateMedicalProviderAndPracticeRequestDTO
   */
  provider: CreateMedicalProviderDTO;
  /**
   * @type {CreatePracticeDTO}
   * @memberof CreateMedicalProviderAndPracticeRequestDTO
   */
  practice: CreatePracticeDTO;
}

/**
 * @export
 * @interface CreateMedicalProviderAndPracticeResponseDTO
 */
export interface CreateMedicalProviderAndPracticeResponseDTO {
  /**
   * @type {ProviderDTO}
   * @memberof CreateMedicalProviderAndPracticeResponseDTO
   */
  provider: ProviderDTO;
  /**
   * @type {PracticeDTO}
   * @memberof CreateMedicalProviderAndPracticeResponseDTO
   */
  practice: PracticeDTO;
  /**
   * @type {string}
   * @memberof CreateMedicalProviderAndPracticeResponseDTO
   */
  accountId: string;
}

/**
 * @export
 * @interface CreateMessageThreadRequestDTO
 */
export interface CreateMessageThreadRequestDTO {
  /**
   * @description patient that the thread is for
   * @type {string}
   * @memberof CreateMessageThreadRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface CreateMessageThreadResponseDTO
 */
export interface CreateMessageThreadResponseDTO {
  /**
   * @type {string}
   * @memberof CreateMessageThreadResponseDTO
   */
  threadId: string;
}

/**
 * @export
 * @interface CreatePatientAddressRequestDTO
 */
export interface CreatePatientAddressRequestDTO {
  /**
   * @type {string}
   * @memberof CreatePatientAddressRequestDTO
   */
  patientId: string;
  /**
   * @type {boolean}
   * @memberof CreatePatientAddressRequestDTO
   */
  isPrimaryAddressForSmartMatch: boolean;
  /**
   * @type {AddressTypeDTO}
   * @memberof CreatePatientAddressRequestDTO
   */
  addressType?: AddressTypeDTO;
  /**
   * @type {string}
   * @memberof CreatePatientAddressRequestDTO
   */
  googlePlaceId?: string;
  /**
   * @type {string}
   * @memberof CreatePatientAddressRequestDTO
   */
  city: string;
  /**
   * @type {string}
   * @memberof CreatePatientAddressRequestDTO
   */
  postalCode: string;
  /**
   * @type {StateDTO}
   * @memberof CreatePatientAddressRequestDTO
   */
  state: StateDTO;
  /**
   * @type {string}
   * @memberof CreatePatientAddressRequestDTO
   */
  streetAddress: string;
  /**
   * @type {string}
   * @memberof CreatePatientAddressRequestDTO
   */
  streetAddressLineTwo?: string;
}

/**
 * @export
 * @interface CreatePatientAddressResponseDTO
 */
export interface CreatePatientAddressResponseDTO {
  /**
   * @type {string}
   * @memberof CreatePatientAddressResponseDTO
   */
  addressId: string;
}

/**
 * @export
 * @interface CreatePatientAppointmentRecordRequestDTO
 */
export interface CreatePatientAppointmentRecordRequestDTO {
  /**
   * @type {string}
   * @memberof CreatePatientAppointmentRecordRequestDTO
   */
  patientId?: string;
  /**
   * @type {string}
   * @memberof CreatePatientAppointmentRecordRequestDTO
   */
  appointmentDate: string;
  /**
   * @type {string}
   * @memberof CreatePatientAppointmentRecordRequestDTO
   */
  referralId: string;
}

/**
 * @export
 * @interface CreatePatientRequestDTO
 */
export interface CreatePatientRequestDTO {
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof CreatePatientRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof CreatePatientRequestDTO
   */
  lastName: string;
  /**
   * @description Patient's date of birth (format yyyy-MM-DD)
   * @type {string}
   * @memberof CreatePatientRequestDTO
   */
  dateOfBirth: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof CreatePatientRequestDTO
   */
  gender?: GenderDTO;
  /**
   * @description Patient's email addresses
   * @type {Array<EmailDTO>}
   * @memberof CreatePatientRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @description Patient's phone numbers
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof CreatePatientRequestDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof CreatePatientRequestDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @description Neuroflow Patient ID
   * @type {string}
   * @memberof CreatePatientRequestDTO
   */
  patientId: string;
  /**
   * @type {ActivationChannelDTO}
   * @memberof CreatePatientRequestDTO
   */
  activationChannel: ActivationChannelDTO;
  /**
   * @type {string}
   * @memberof CreatePatientRequestDTO
   */
  invitationCode?: string;
  /**
   * @type {SupportedLocaleDTO}
   * @memberof CreatePatientRequestDTO
   */
  locale?: SupportedLocaleDTO;
}

/**
 * @description The core data required to create a Practice.
 * @export
 * @interface CreatePracticeDTO
 */
export interface CreatePracticeDTO {
  /**
   * @description Practice name
   * @type {string}
   * @memberof CreatePracticeDTO
   */
  name: string;
  /**
   * @description The National Provider Identifier associated with the Practice
   * @type {string}
   * @memberof CreatePracticeDTO
   */
  npi?: string;
  /**
   * @description Zero or more physical locations that this Practice has.
   * @type {Array<CreateLocationDTO>}
   * @memberof CreatePracticeDTO
   */
  locations?: Array<CreateLocationDTO>;
  /**
   * @type {PracticeSettingDTO}
   * @memberof CreatePracticeDTO
   */
  practiceSetting?: PracticeSettingDTO;
  /**
   * @type {PracticeTypeDTO}
   * @memberof CreatePracticeDTO
   */
  type?: PracticeTypeDTO;
  /**
   * @type {string}
   * @memberof CreatePracticeDTO
   */
  healthSystemId?: string;
  /**
   * @type {QuartetRegionDTO}
   * @memberof CreatePracticeDTO
   */
  quartetRegion?: QuartetRegionDTO;
  /**
   * @type {boolean}
   * @memberof CreatePracticeDTO
   */
  isTeleOnly?: boolean;
  /**
   * @type {boolean}
   * @memberof CreatePracticeDTO
   */
  isDirectSchedulingEnabled?: boolean;
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof CreatePracticeDTO
   */
  userAgreementVersions?: Array<UserAgreementVersionDTO>;
  /**
   * @type {string}
   * @memberof CreatePracticeDTO
   */
  userAgreementSignatory?: string;
  /**
   * @type {string}
   * @memberof CreatePracticeDTO
   */
  email?: string;
  /**
   * @type {Array<ServiceFormatDTO>}
   * @memberof CreatePracticeDTO
   */
  serviceFormats?: Array<ServiceFormatDTO>;
  /**
   * @type {Array<InsurancePlanCountyRestrictionDTO>}
   * @memberof CreatePracticeDTO
   */
  insurancePlanCountyRestriction?: Array<InsurancePlanCountyRestrictionDTO>;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof CreatePracticeDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
}

/**
 * @export
 * @interface CreatePracticePartnershipRuleDTO
 */
export interface CreatePracticePartnershipRuleDTO {
  /**
   * @type {Array<string>}
   * @memberof CreatePracticePartnershipRuleDTO
   */
  pcpPracticeIds: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CreatePracticePartnershipRuleDTO
   */
  bhpPracticeIds: Array<string>;
}

/**
 * @export
 * @interface CreatePracticePlaceholderRequestDTO
 */
export interface CreatePracticePlaceholderRequestDTO {
  /**
   * @type {string}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  healthSystemId?: string;
  /**
   * @type {Array<CreateLocationDTO>}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  locations?: Array<CreateLocationDTO>;
  /**
   * @type {string}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  npi?: string;
  /**
   * @type {QuartetRegionDTO}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  quartetRegion?: QuartetRegionDTO;
  /**
   * @type {AddressDTO}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  address?: AddressDTO;
  /**
   * @type {boolean}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  isTeleOnly?: boolean;
  /**
   * @type {boolean}
   * @memberof CreatePracticePlaceholderRequestDTO
   */
  isDirectSchedulingEnabled?: boolean;
}

/**
 * @export
 * @interface CreatePracticePlaceholderResponseDTO
 */
export interface CreatePracticePlaceholderResponseDTO {
  /**
   * @description The created practice
   * @type {PracticeDTO}
   * @memberof CreatePracticePlaceholderResponseDTO
   */
  practice?: PracticeDTO;
}

/**
 * @export
 * @interface CreatePreferentialMatchRuleRequestDTO
 */
export interface CreatePreferentialMatchRuleRequestDTO {
  /**
   * @type {string}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  description?: string;
  /**
   * @type {boolean}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  isActive?: boolean;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  needs: SupportedPatientNeedsDTO;
  /**
   * @type {CreateIntraHealthSystemRuleDTO}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  intraHealthSystem?: CreateIntraHealthSystemRuleDTO;
  /**
   * @type {CreateHealthSystemBhpPartnershipRuleDTO}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  healthSystemBhpPartnership?: CreateHealthSystemBhpPartnershipRuleDTO;
  /**
   * @type {CreatePracticePartnershipRuleDTO}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  practicePartnership?: CreatePracticePartnershipRuleDTO;
  /**
   * @type {CreateInsurancePlanHealthSystemPartnershipRuleDTO}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  insurancePlanHealthSystemPartnership?: CreateInsurancePlanHealthSystemPartnershipRuleDTO;
  /**
   * @type {CreateInsurancePlanBhpPracticePartnershipRuleDTO}
   * @memberof CreatePreferentialMatchRuleRequestDTO
   */
  insurancePlanBhpPracticePartnership?: CreateInsurancePlanBhpPracticePartnershipRuleDTO;
}

/**
 * @description The core data required to create a Provider of any type.
 * @export
 * @interface CreateProviderDTO
 */
export interface CreateProviderDTO {
  /**
   * @description The provider's first name.
   * @type {string}
   * @memberof CreateProviderDTO
   */
  firstName: string;
  /**
   * @description The provider's last name.
   * @type {string}
   * @memberof CreateProviderDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof CreateProviderDTO
   */
  suffix?: string;
  /**
   * @type {GenderDTO}
   * @memberof CreateProviderDTO
   */
  gender?: GenderDTO;
  /**
   * @type {ProviderTypeDTO}
   * @memberof CreateProviderDTO
   */
  type: ProviderTypeDTO;
  /**
   * @description The provider's National Provider Identifier number.
   * @type {string}
   * @memberof CreateProviderDTO
   */
  npi?: string;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof CreateProviderDTO
   */
  pcpPracticeTitle?: PcpPracticeTitleDTO;
  /**
   * @description A primary phone number at which the provider can be reached.
   * @type {string}
   * @memberof CreateProviderDTO
   */
  phoneNumber?: string;
  /**
   * @description The provider's primary email address.
   * @type {string}
   * @memberof CreateProviderDTO
   */
  emailAddress: string;
  /**
   * @description A fax number that the provider can receive documents on.
   * @type {string}
   * @memberof CreateProviderDTO
   */
  faxNumber?: string;
  /**
   * @type {Array<string>}
   * @memberof CreateProviderDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof CreateProviderDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof CreateProviderDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof CreateProviderDTO
   */
  userAgreementVersions?: Array<UserAgreementVersionDTO>;
}

/**
 * @export
 * @interface CreateQHAdminUserRequestDTO
 */
export interface CreateQHAdminUserRequestDTO {
  /**
   * @type {string}
   * @memberof CreateQHAdminUserRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof CreateQHAdminUserRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof CreateQHAdminUserRequestDTO
   */
  email: string;
}

/**
 * @export
 * @interface CreateQHAdminUserResponseDTO
 */
export interface CreateQHAdminUserResponseDTO {
  /**
   * @description The id associated with the new Admin
   * @type {string}
   * @memberof CreateQHAdminUserResponseDTO
   */
  id?: string;
}

/**
 * @export
 * @interface CreateReactiveReferralRequestDTO
 */
export interface CreateReactiveReferralRequestDTO {
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  address: AddressDTO;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @description Patient's date of birth
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  dateOfBirth: string;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof CreateReactiveReferralRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  gender: GenderDTO;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  lastName: string;
  /**
   * @description If known, the ID of the patient
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  patientId?: string;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  patientPreferences: PatientPreferencesDTO;
  /**
   * @description Patient's treatment consideration
   * @type {Array<TreatmentConsiderationDTO>}
   * @memberof CreateReactiveReferralRequestDTO
   */
  patientTreatmentConsideration?: Array<TreatmentConsiderationDTO>;
  /**
   * @description Patient's preferred language for matched BHP
   * @type {LanguageDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description The patient's preferred MHP gender
   * @type {GenderDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The patients preference towards receiving care via teleservices
   * @type {TeleservicesPreferenceDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @description Patient's phone numbers (must be exactly one where isPrimary = true)
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof CreateReactiveReferralRequestDTO
   */
  phoneNumbers: Array<PatientPhoneNumberDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof CreateReactiveReferralRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description The service type patient is requesting
   * @type {PatientServiceTypeDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  serviceType?: PatientServiceTypeDTO;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  preferredName?: string;
  /**
   * @description The id of the practice from which the patient is being referred
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  practiceId?: string;
  /**
   * @description The id of the pcp referring the patient
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  pcpId?: string;
  /**
   * @description The id of the plan case manager referring the patient
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  caseManagerId?: string;
  /**
   * @type {CreateReactiveReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  primaryInsurancePolicy: CreateReactiveReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @description Optionally, the patient's secondary insurance policy
   * @type {BaseInsurancePolicyDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  secondaryInsurancePolicy?: BaseInsurancePolicyDTO;
  /**
   * @description The referral reason from the pcp
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  referralReason?: string;
  /**
   * @description Patient's suffix, if any
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  suffix?: string;
  /**
   * @description Used for csv referrals, when we receive referrals over the weekend.
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  referralReceivedDate?: string;
  /**
   * @description referralId for external use
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  externalReferralId?: string;
  /**
   * @description Used for csv referrals
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  memberEpi?: string;
  /**
   * @description used for csv referrals
   * @type {string}
   * @memberof CreateReactiveReferralRequestDTO
   */
  externalReferringEmail?: string;
  /**
   * @description Used to determine which communications the patient will receive
   * @type {ReactiveWorkflowTypeDTO}
   * @memberof CreateReactiveReferralRequestDTO
   */
  reactiveWorkflowType?: ReactiveWorkflowTypeDTO;
  /**
   * @description used to determine if patient is participating in collaborative care
   * @type {boolean}
   * @memberof CreateReactiveReferralRequestDTO
   */
  collaborativeCarePatient?: boolean;
  /**
   * @description The patient's primary and additional concerns
   * @type {Array<PatientConcernDTO>}
   * @memberof CreateReactiveReferralRequestDTO
   */
  patientConcerns?: Array<PatientConcernDTO>;
}

/**
 * @description The patient's primary insurance policy
 * @export
 * @interface CreateReactiveReferralRequestPrimaryInsurancePolicyDTO
 */
export interface CreateReactiveReferralRequestPrimaryInsurancePolicyDTO {
  /**
   * @type {string}
   * @memberof CreateReactiveReferralRequestPrimaryInsurancePolicyDTO
   */
  insurancePlanId: string;
  /**
   * @type {string}
   * @memberof CreateReactiveReferralRequestPrimaryInsurancePolicyDTO
   */
  memberId?: string;
  /**
   * @type {string}
   * @memberof CreateReactiveReferralRequestPrimaryInsurancePolicyDTO
   */
  groupId?: string;
}

/**
 * @export
 * @interface CreateSecondPartyInsuranceMappingRequestDTO
 */
export interface CreateSecondPartyInsuranceMappingRequestDTO {
  /**
   * @type {string}
   * @memberof CreateSecondPartyInsuranceMappingRequestDTO
   */
  secondPartyPlan: string;
  /**
   * @type {string}
   * @memberof CreateSecondPartyInsuranceMappingRequestDTO
   */
  secondPartyCategory: string;
  /**
   * @type {string}
   * @memberof CreateSecondPartyInsuranceMappingRequestDTO
   */
  secondPartySubcategory?: string;
  /**
   * @type {string}
   * @memberof CreateSecondPartyInsuranceMappingRequestDTO
   */
  secondPartyCarrier?: string;
  /**
   * @type {CustomerNameDTO}
   * @memberof CreateSecondPartyInsuranceMappingRequestDTO
   */
  customerName: CustomerNameDTO;
  /**
   * @type {string}
   * @memberof CreateSecondPartyInsuranceMappingRequestDTO
   */
  insurancePlanId: string;
}

/**
 * @export
 * @interface CreateSelfReferralRequestDTO
 */
export interface CreateSelfReferralRequestDTO {
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  address: AddressDTO;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @description Patient's date of birth
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  dateOfBirth: string;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof CreateSelfReferralRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  gender: GenderDTO;
  /**
   * @description Sex at Birth
   * @type {SexAtBirthDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  sexAtBirth?: SexAtBirthDTO;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  lastName: string;
  /**
   * @description If known, the ID of the patient
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  patientId?: string;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  patientPreferences: PatientPreferencesDTO;
  /**
   * @description The patient's preferred service format
   * @type {TeleservicesPreferenceDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @description The patient's preferred MHP gender
   * @type {GenderDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The patient's preferred MHP language
   * @type {LanguageDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description Patient's phone numbers (must be exactly one where isPrimary = true)
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof CreateSelfReferralRequestDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @description The id of the practice from which the patient is being referred
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  practiceId: string;
  /**
   * @description The id of the pcp referring the patient
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  pcpId: string;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  preferredName?: string;
  /**
   * @type {CreateSelfReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  primaryInsurancePolicy: CreateSelfReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @description The referral reason from the pcp
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  referralReason: string;
  /**
   * @description If this is true, service path will be set to care nav. If this is null or false, it will go through the internal logic to decide which service path to use
   * @type {boolean}
   * @memberof CreateSelfReferralRequestDTO
   */
  referralRequiresManualReview?: boolean;
  /**
   * @description Patient's suffix, if any
   * @type {string}
   * @memberof CreateSelfReferralRequestDTO
   */
  suffix?: string;
  /**
   * @description If enabled, resolve for customer patient
   * @type {boolean}
   * @memberof CreateSelfReferralRequestDTO
   */
  isCustomerPatientResolutionEnabled?: boolean;
  /**
   * @description Indicates if the request is made from the pediatric referral form
   * @type {boolean}
   * @memberof CreateSelfReferralRequestDTO
   */
  isReferredYouth?: boolean;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof CreateSelfReferralRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description The service type patient is requesting
   * @type {PatientServiceTypeDTO}
   * @memberof CreateSelfReferralRequestDTO
   */
  serviceType?: PatientServiceTypeDTO;
  /**
   * @description The patient's primary and additional concerns
   * @type {Array<PatientConcernDTO>}
   * @memberof CreateSelfReferralRequestDTO
   */
  patientConcerns?: Array<PatientConcernDTO>;
}

/**
 * @description The patient's primary insurance policy
 * @export
 * @interface CreateSelfReferralRequestPrimaryInsurancePolicyDTO
 */
export interface CreateSelfReferralRequestPrimaryInsurancePolicyDTO {
  /**
   * @type {string}
   * @memberof CreateSelfReferralRequestPrimaryInsurancePolicyDTO
   */
  insurancePlanId: string;
  /**
   * @type {string}
   * @memberof CreateSelfReferralRequestPrimaryInsurancePolicyDTO
   */
  memberId?: string;
}

/**
 * @export
 * @interface CreateServicePathRequestDTO
 */
export interface CreateServicePathRequestDTO {
  /**
   * @description the ID of the patient
   * @type {string}
   * @memberof CreateServicePathRequestDTO
   */
  patientId: string;
  /**
   * @description Sex at Birth
   * @type {SexAtBirthDTO}
   * @memberof CreateServicePathRequestDTO
   */
  sexAtBirth?: SexAtBirthDTO;
}

/**
 * @export
 * @interface CreateSimpleProgressUpdateRequestDTO
 */
export interface CreateSimpleProgressUpdateRequestDTO {
  /**
   * @type {ProgressUpdateTypeDTO}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  progressUpdateType: ProgressUpdateTypeDTO;
  /**
   * @type {boolean}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  isUrgent: boolean;
  /**
   * @type {string}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  progressUpdateNote: string;
  /**
   * @type {string}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  providerId?: string;
  /**
   * @type {string}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  medication?: string;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof CreateSimpleProgressUpdateRequestDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
}

/**
 * @export
 * @interface CreateSimpleQuartetProgressUpdateRequestDTO
 */
export interface CreateSimpleQuartetProgressUpdateRequestDTO {
  /**
   * @type {string}
   * @memberof CreateSimpleQuartetProgressUpdateRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof CreateSimpleQuartetProgressUpdateRequestDTO
   */
  note: string;
  /**
   * @type {boolean}
   * @memberof CreateSimpleQuartetProgressUpdateRequestDTO
   */
  isUrgent: boolean;
}

/**
 * @export
 * @interface CreateStructuredUpdateRequestDTO
 */
export interface CreateStructuredUpdateRequestDTO {
  /**
   * @description Patient Id for the patient we're doing the structured update on.
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  patientId: string;
  /**
   * @description Provider Id of the provider doing the structured update.
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  providerId: string;
  /**
   * @description Overall progress enum
   * @type {ProgressQualifierDTO}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  overallProgress: ProgressQualifierDTO;
  /**
   * @description Recent progress enum
   * @type {ProgressQualifierDTO}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  recentProgress: ProgressQualifierDTO;
  /**
   * @description How engaged is the patient enum
   * @type {ClientEngagementLevelDTO}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  clientEngagementLevel?: ClientEngagementLevelDTO;
  /**
   * @description Results of standardized assessments tools (such as PHQ, GAD, Beck’s)
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messageAssessments?: string;
  /**
   * @description Client attendance
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messageAttendance?: string;
  /**
   * @description Medication-related changes or concerns
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messageMedication?: string;
  /**
   * @description Physical health concerns
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messagePhysicalHealth?: string;
  /**
   * @description The patient's prognosis
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messagePrognosis?: string;
  /**
   * @description New or worsening symptoms
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messageSymptomIncrease?: string;
  /**
   * @description Symptom reduction
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  messageSymptomReduction?: string;
  /**
   * @description Changes to the patient's treatment plan
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  treatmentPlan?: string;
  /**
   * @description Changes to the patient's treatment diagnosis
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  treatmentDiagnosis?: string;
  /**
   * @description Changes to the patient's treatment diagnosis
   * @type {string}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  treatmentMedication?: string;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof CreateStructuredUpdateRequestDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
}

/**
 * @export
 * @interface CreateVbcProgramRequestDTO
 */
export interface CreateVbcProgramRequestDTO {
  /**
   * @type {VbcProgramDTO}
   * @memberof CreateVbcProgramRequestDTO
   */
  vbcProgram?: VbcProgramDTO;
}

/**
 * @export
 * @interface CreateVbcProgramResponseDTO
 */
export interface CreateVbcProgramResponseDTO {
  /**
   * @type {string}
   * @memberof CreateVbcProgramResponseDTO
   */
  id: string;
}

/**
 * @export
 * @interface CreateYouthReferralRequestDTO
 */
export interface CreateYouthReferralRequestDTO {
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  address: AddressDTO;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @description Patient's date of birth
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  dateOfBirth: string;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof CreateYouthReferralRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  gender: GenderDTO;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  lastName: string;
  /**
   * @description If known, the ID of the patient
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  patientId?: string;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  patientPreferences: PatientPreferencesDTO;
  /**
   * @description Patient's treatment consideration
   * @type {Array<TreatmentConsiderationDTO>}
   * @memberof CreateYouthReferralRequestDTO
   */
  patientTreatmentConsideration?: Array<TreatmentConsiderationDTO>;
  /**
   * @description Patient's preferred language for matched BHP
   * @type {LanguageDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description The patient's preferred MHP gender
   * @type {GenderDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The patients preference towards receiving care via teleservices
   * @type {TeleservicesPreferenceDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof CreateYouthReferralRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description The service type patient is requesting
   * @type {PatientServiceTypeDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  serviceType?: PatientServiceTypeDTO;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  preferredName?: string;
  /**
   * @description The id of the practice from which the patient is being referred
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  practiceId?: string;
  /**
   * @description The id of the pcp referring the patient
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  pcpId?: string;
  /**
   * @description The id of the plan case manager referring the patient
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  caseManagerId?: string;
  /**
   * @type {CreateReactiveReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  primaryInsurancePolicy: CreateReactiveReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @description Optionally, the patient's secondary insurance policy
   * @type {BaseInsurancePolicyDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  secondaryInsurancePolicy?: BaseInsurancePolicyDTO;
  /**
   * @description The referral reason from the pcp
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  referralReason: string;
  /**
   * @description Patient's suffix, if any
   * @type {string}
   * @memberof CreateYouthReferralRequestDTO
   */
  suffix?: string;
  /**
   * @description Used to determine which communications the patient will receive
   * @type {ReactiveWorkflowTypeDTO}
   * @memberof CreateYouthReferralRequestDTO
   */
  reactiveWorkflowType?: ReactiveWorkflowTypeDTO;
  /**
   * @description used to determine if patient is participating in collaborative care
   * @type {boolean}
   * @memberof CreateYouthReferralRequestDTO
   */
  collaborativeCarePatient?: boolean;
  /**
   * @description The patient's primary and additional concerns
   * @type {Array<PatientConcernDTO>}
   * @memberof CreateYouthReferralRequestDTO
   */
  patientConcerns?: Array<PatientConcernDTO>;
}

/**
 * @export
 * @interface CrisisReferralDTO
 */
export interface CrisisReferralDTO {
  /**
   * @type {string}
   * @memberof CrisisReferralDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof CrisisReferralDTO
   */
  patientId: string;
  /**
   * @type {CrisisReferralTypeDTO}
   * @memberof CrisisReferralDTO
   */
  type: CrisisReferralTypeDTO;
  /**
   * @type {string}
   * @memberof CrisisReferralDTO
   */
  referredDate: string;
  /**
   * @type {CrisisReferralResolutionDTO}
   * @memberof CrisisReferralDTO
   */
  resolution?: CrisisReferralResolutionDTO;
  /**
   * @type {string}
   * @memberof CrisisReferralDTO
   */
  resolvedDate?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum CrisisReferralResolutionDTO {
  ReferredToEmergencyServices = 'Referred To Emergency Services',
  ReferredToEmergencyRoom = 'Referred To Emergency Room',
  ReferredToMobileCrisis = 'Referred To Mobile Crisis',
  ReferredToWalkInClinic = 'Referred To Walk In Clinic',
  ReferredToMentalHealthWalkInClinic = 'Referred To Mental Health Walk In Clinic',
  ReferredBackToQuartet = 'Referred Back To Quartet',
  Unreachable = 'Unreachable'
}

/**
 * @export
 * @enum {string}
 */
export enum CrisisReferralTypeDTO {
  WarmTransfer = 'Warm Transfer',
  PatientCompletedAssessment = 'Patient Completed Assessment'
}

/**
 * @export
 * @interface CurbsideDTO
 */
export interface CurbsideDTO {
  /**
   * @description The id of this curbside
   * @type {string}
   * @memberof CurbsideDTO
   */
  id?: string;
  /**
   * @description The id of this curbside's patient
   * @type {string}
   * @memberof CurbsideDTO
   */
  patientId?: string;
  /**
   * @description The id of the pcp requesting the curbside
   * @type {string}
   * @memberof CurbsideDTO
   */
  pcpId?: string;
  /**
   * @description The phone number of the pcp requesting the curbside
   * @type {string}
   * @memberof CurbsideDTO
   */
  pcpPhoneNumber?: string;
  /**
   * @description The pcps entered availability
   * @type {string}
   * @memberof CurbsideDTO
   */
  pcpAvailability?: string;
  /**
   * @description The reason for the curbside request
   * @type {string}
   * @memberof CurbsideDTO
   */
  reasonForConsult?: string;
  /**
   * @type {CurbsideStateDTO}
   * @memberof CurbsideDTO
   */
  state?: CurbsideStateDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum CurbsideStateDTO {
  Created = 'Created',
  Canceled = 'Canceled',
  Completed = 'Completed',
  InProgress = 'In Progress'
}

/**
 * @export
 * @enum {string}
 */
export enum CustomerNameDTO {
  HIGHMARK = 'HIGHMARK',
  PREMERA = 'PREMERA',
  PREMERAWA = 'PREMERA_WA',
  HORIZON = 'HORIZON',
  SUTTER = 'SUTTER',
  BCBSAZ = 'BCBS_AZ',
  BCBSMI = 'BCBS_MI',
  BCBSNC = 'BCBS_NC',
  CAMBIAWA = 'CAMBIA_WA',
  CENTENEIL = 'CENTENE_IL',
  CENTENELA = 'CENTENE_LA',
  INDEPENDENCE = 'INDEPENDENCE',
  OPTUM = 'OPTUM',
  QHTEST = 'QH_TEST',
  UNKNOWN = 'UNKNOWN'
}

/**
 * @export
 * @interface DeactivateBhpRequestDTO
 */
export interface DeactivateBhpRequestDTO {
  /**
   * @type {string}
   * @memberof DeactivateBhpRequestDTO
   */
  bhpId: string;
}

/**
 * @export
 * @interface DeactivateCareTeamBhpRequestDTO
 */
export interface DeactivateCareTeamBhpRequestDTO {
  /**
   * @type {string}
   * @memberof DeactivateCareTeamBhpRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof DeactivateCareTeamBhpRequestDTO
   */
  bhpId: string;
}

/**
 * @export
 * @interface DeactivateCaseManagerRequestDTO
 */
export interface DeactivateCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof DeactivateCaseManagerRequestDTO
   */
  caseManagerId: string;
}

/**
 * @export
 * @interface DeactivatePcpRequestDTO
 */
export interface DeactivatePcpRequestDTO {
  /**
   * @type {string}
   * @memberof DeactivatePcpRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof DeactivatePcpRequestDTO
   */
  practiceId?: string;
}

/**
 * @export
 * @interface DeactivateQHAdminUserRequestDTO
 */
export interface DeactivateQHAdminUserRequestDTO {
  /**
   * @description The id associated with the Admin to deactivate
   * @type {string}
   * @memberof DeactivateQHAdminUserRequestDTO
   */
  adminId: string;
}

/**
 * @export
 * @enum {string}
 */
export enum DeclineReasonDTO {
  AvailabilityClientAvailabilityDoesNotMatch = 'Availability Client Availability Does Not Match',
  AvailabilityProviderNotAvailable = 'Availability Provider Not Available',
  ClinicalClientNeedsDoNotMatch = 'Clinical Client Needs Do Not Match',
  ClinicalClientSeekingMedication = 'Clinical Client Seeking Medication',
  ClientSeekingMedicationOnly = 'Client Seeking Medication Only',
  DistanceClientNotWillingTravel = 'Distance Client Not Willing Travel',
  DistanceClientTooFar = 'Distance Client Too Far',
  InsuranceNotAccepted = 'Insurance Not Accepted',
  InsurancePlanIncorrect = 'Insurance Plan Incorrect',
  InsuranceCannotConfirm = 'Insurance Cannot Confirm',
  PatientAlreadyInCare = 'Patient Already In Care',
  PatientContactInfoIsIncorrect = 'Patient Contact Info Is Incorrect',
  PatientFinancialConstraints = 'Patient Financial Constraints',
  PatientInsuranceDidNotMatch = 'Patient Insurance Did Not Match',
  PatientIsNotInterested = 'Patient Is Not Interested',
  PatientIsNotReturningContact = 'Patient Is Not Returning Contact',
  PatientIsTooFarAway = 'Patient Is Too Far Away',
  PreferencesDifferentGender = 'Preferences Different Gender',
  PreferencesOther = 'Preferences Other',
  PreferencesTreatmentMethod = 'Preferences Treatment Method',
  Other = 'Other'
}

/**
 * @export
 * @interface DeclineReferralRequestDTO
 */
export interface DeclineReferralRequestDTO {
  /**
   * @description Care team invitation id
   * @type {string}
   * @memberof DeclineReferralRequestDTO
   */
  referralId: string;
  /**
   * @description Decline reason note
   * @type {string}
   * @memberof DeclineReferralRequestDTO
   */
  declineReasonNote?: string;
  /**
   * @description Reason the provider declined the referral
   * @type {DeclineReasonDTO}
   * @memberof DeclineReferralRequestDTO
   */
  declineReason: DeclineReasonDTO;
}

/**
 * @export
 * @interface DeleteItemsRequestDTO
 */
export interface DeleteItemsRequestDTO {
  /**
   * @type {Array<string>}
   * @memberof DeleteItemsRequestDTO
   */
  ids?: Array<string>;
}

/**
 * @export
 * @interface DeleteMessageRequestDTO
 */
export interface DeleteMessageRequestDTO {
  /**
   * @type {string}
   * @memberof DeleteMessageRequestDTO
   */
  messageId: string;
}

/**
 * @export
 * @interface DeletePatientAddressRequestDTO
 */
export interface DeletePatientAddressRequestDTO {
  /**
   * @type {string}
   * @memberof DeletePatientAddressRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof DeletePatientAddressRequestDTO
   */
  addressId: string;
}

/**
 * @export
 * @interface DeletePatientMatchListRequestDTO
 */
export interface DeletePatientMatchListRequestDTO {
  /**
   * @type {string}
   * @memberof DeletePatientMatchListRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface DeleteProgressUpdateRequestDTO
 */
export interface DeleteProgressUpdateRequestDTO {
  /**
   * @type {string}
   * @memberof DeleteProgressUpdateRequestDTO
   */
  progressUpdateId: string;
}

/**
 * @export
 * @interface DeleteRequestDTO
 */
export interface DeleteRequestDTO {
  /**
   * @type {string}
   * @memberof DeleteRequestDTO
   */
  id: string;
}

/**
 * @export
 * @enum {string}
 */
export enum DigitalOutreachTypeDTO {
  Priming = 'Priming',
  FollowUp = 'Follow-up',
  Decline = 'Decline',
  PendingProviderReachingOut = 'Pending Provider Reaching Out'
}

/**
 * @export
 * @interface DisableSmartMatchReferralsForPatientRequestDTO
 */
export interface DisableSmartMatchReferralsForPatientRequestDTO {
  /**
   * @description The ID of the patient for whom to disable Smart Match referrals
   * @type {string}
   * @memberof DisableSmartMatchReferralsForPatientRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface DismissRecommendationRequestDTO
 */
export interface DismissRecommendationRequestDTO {
  /**
   * @type {string}
   * @memberof DismissRecommendationRequestDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof DismissRecommendationRequestDTO
   */
  patientId: string;
  /**
   * @type {RecommendationDismissalReasonDTO}
   * @memberof DismissRecommendationRequestDTO
   */
  dismissalReason: RecommendationDismissalReasonDTO;
  /**
   * @description Only needed when Other is specified as dismissal reason
   * @type {string}
   * @memberof DismissRecommendationRequestDTO
   */
  dismissalReasonNote?: string;
}

/**
 * @export
 * @interface DisplayCareEventDTO
 */
export interface DisplayCareEventDTO {
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  id?: string;
  /**
   * @type {CareEventTypeDTO}
   * @memberof DisplayCareEventDTO
   */
  type?: CareEventTypeDTO;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  date?: string;
  /**
   * @type {boolean}
   * @memberof DisplayCareEventDTO
   */
  isUrgent?: boolean;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  patientId?: string;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  appointmentId?: string;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  appointmentDate?: string;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  progressUpdateId?: string;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  creatingProviderFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayCareEventDTO
   */
  creatingProviderLastName?: string;
  /**
   * @type {ContactOutcomeDTO}
   * @memberof DisplayCareEventDTO
   */
  contactOutcome?: ContactOutcomeDTO;
}

/**
 * @export
 * @interface DisplayCaseManagerDTO
 */
export interface DisplayCaseManagerDTO {
  /**
   * @type {string}
   * @memberof DisplayCaseManagerDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerDTO
   */
  suffix?: string;
}

/**
 * @export
 * @interface DisplayCaseManagerGroupDTO
 */
export interface DisplayCaseManagerGroupDTO {
  /**
   * @type {string}
   * @memberof DisplayCaseManagerGroupDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerGroupDTO
   */
  name?: string;
  /**
   * @type {AddressDTO}
   * @memberof DisplayCaseManagerGroupDTO
   */
  address?: AddressDTO;
}

/**
 * @export
 * @interface DisplayCaseManagerNotificationDTO
 */
export interface DisplayCaseManagerNotificationDTO {
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  notificationId: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  patientFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  patientLastName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  patientPreferredName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  patientDateOfBirth?: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  patientPhoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  caseManagerFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  caseManagerLastName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  bhpFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  bhpLastName?: string;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  careEventId: string;
  /**
   * @type {CareEventTypeDTO}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  careEventType: CareEventTypeDTO;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  appointmentDate?: string;
  /**
   * @type {boolean}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  isUrgent?: boolean;
  /**
   * @type {string}
   * @memberof DisplayCaseManagerNotificationDTO
   */
  date: string;
}

/**
 * @export
 * @interface DisplayCaseManagerNotificationsResponseDTO
 */
export interface DisplayCaseManagerNotificationsResponseDTO {
  /**
   * @type {Array<DisplayCaseManagerNotificationDTO>}
   * @memberof DisplayCaseManagerNotificationsResponseDTO
   */
  notifications: Array<DisplayCaseManagerNotificationDTO>;
}

/**
 * @export
 * @interface DisplayCaseManagersResponseDTO
 */
export interface DisplayCaseManagersResponseDTO {
  /**
   * @type {Array<DisplayCaseManagerDTO>}
   * @memberof DisplayCaseManagersResponseDTO
   */
  caseManagers: Array<DisplayCaseManagerDTO>;
}

/**
 * @export
 * @interface DisplayNotificationDTO
 */
export interface DisplayNotificationDTO {
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  notificationId: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  patientFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  patientLastName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  patientPreferredName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  patientDateOfBirth?: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof DisplayNotificationDTO
   */
  patientPhoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  pcpFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  pcpLastName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  bhpFirstName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  bhpLastName?: string;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  careEventId: string;
  /**
   * @type {CareEventTypeDTO}
   * @memberof DisplayNotificationDTO
   */
  careEventType: CareEventTypeDTO;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  appointmentDate?: string;
  /**
   * @type {boolean}
   * @memberof DisplayNotificationDTO
   */
  isUrgent?: boolean;
  /**
   * @type {string}
   * @memberof DisplayNotificationDTO
   */
  date: string;
}

/**
 * @export
 * @interface DisplayNotificationsResponseDTO
 */
export interface DisplayNotificationsResponseDTO {
  /**
   * @type {Array<DisplayNotificationDTO>}
   * @memberof DisplayNotificationsResponseDTO
   */
  notifications: Array<DisplayNotificationDTO>;
}

/**
 * @export
 * @interface DisplayPcpDTO
 */
export interface DisplayPcpDTO {
  /**
   * @type {string}
   * @memberof DisplayPcpDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof DisplayPcpDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof DisplayPcpDTO
   */
  lastName?: string;
  /**
   * @type {boolean}
   * @memberof DisplayPcpDTO
   */
  isHeadlessProvider: boolean;
  /**
   * @type {Array<DisplayPracticeDTO>}
   * @memberof DisplayPcpDTO
   */
  practices: Array<DisplayPracticeDTO>;
}

/**
 * @export
 * @interface DisplayPcpsResponseDTO
 */
export interface DisplayPcpsResponseDTO {
  /**
   * @type {Array<DisplayPcpDTO>}
   * @memberof DisplayPcpsResponseDTO
   */
  providers: Array<DisplayPcpDTO>;
}

/**
 * @export
 * @interface DisplayPracticeDTO
 */
export interface DisplayPracticeDTO {
  /**
   * @type {string}
   * @memberof DisplayPracticeDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof DisplayPracticeDTO
   */
  name?: string;
}

/**
 * @export
 * @interface DisplayPracticesResponseDTO
 */
export interface DisplayPracticesResponseDTO {
  /**
   * @type {Array<DisplayPracticeDTO>}
   * @memberof DisplayPracticesResponseDTO
   */
  practices: Array<DisplayPracticeDTO>;
}

/**
 * @export
 * @interface DisplayPrimaryCarePracticeDTO
 */
export interface DisplayPrimaryCarePracticeDTO {
  /**
   * @type {string}
   * @memberof DisplayPrimaryCarePracticeDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof DisplayPrimaryCarePracticeDTO
   */
  name: string;
  /**
   * @type {AddressDTO}
   * @memberof DisplayPrimaryCarePracticeDTO
   */
  address?: AddressDTO;
}

/**
 * @export
 * @interface DisplayProviderDTO
 */
export interface DisplayProviderDTO {
  /**
   * @type {string}
   * @memberof DisplayProviderDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof DisplayProviderDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof DisplayProviderDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof DisplayProviderDTO
   */
  suffix?: string;
  /**
   * @type {string}
   * @memberof DisplayProviderDTO
   */
  title?: string;
  /**
   * @type {string}
   * @memberof DisplayProviderDTO
   */
  phoneNumber?: string;
}

/**
 * @export
 * @interface DistanceDTO
 */
export interface DistanceDTO {
  /**
   * @type {number}
   * @memberof DistanceDTO
   */
  miles?: number;
  /**
   * @type {number}
   * @memberof DistanceDTO
   */
  minutes?: number;
  /**
   * @type {TransportationModeDTO}
   * @memberof DistanceDTO
   */
  transportationMode?: TransportationModeDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum EHRMessageTypeDTO {
  ActiveProgressUpdate = 'Active Progress Update',
  AssessmentCompleted = 'Assessment Completed',
  CCBTCreated = 'CCBT Created',
  CCBTCompleted = 'CCBT Completed',
  CrisisReferralCreated = 'Crisis Referral Created',
  CrisisReferralResolved = 'Crisis Referral Resolved',
  CurbsideInProgress = 'Curbside In Progress',
  InactiveProgressUpdate = 'Inactive Progress Update',
  InitialProgressUpdate = 'Initial Progress Update',
  AppointmentAttended = 'Appointment Attended',
  AppointmentCanceled = 'Appointment Canceled',
  AppointmentMissed = 'Appointment Missed',
  AppointmentRescheduled = 'Appointment Rescheduled',
  AppointmentScheduled = 'Appointment Scheduled',
  ProviderContactingPatient = 'Provider Contacting Patient',
  PatientDeclinedCare = 'Patient Declined Care',
  PatientUnreachable = 'Patient Unreachable',
  PatientDeferredCare = 'Patient Deferred Care',
  PatientReferredOutside = 'Patient Referred Outside',
  PatientAlreadyInCare = 'Patient Already In Care',
  QuartetDeclined = 'Quartet Declined'
}

/**
 * @export
 * @interface EditAdminRequestDTO
 */
export interface EditAdminRequestDTO {
  /**
   * @type {AdminDTO}
   * @memberof EditAdminRequestDTO
   */
  admin: AdminDTO;
}

/**
 * @export
 * @interface EditBhpRequestDTO
 */
export interface EditBhpRequestDTO {
  /**
   * @type {BhpDTO}
   * @memberof EditBhpRequestDTO
   */
  bhp: BhpDTO;
}

/**
 * @export
 * @interface EditCaseManagerGroupRequestDTO
 */
export interface EditCaseManagerGroupRequestDTO {
  /**
   * @type {string}
   * @memberof EditCaseManagerGroupRequestDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof EditCaseManagerGroupRequestDTO
   */
  name?: string;
  /**
   * @type {StateDTO}
   * @memberof EditCaseManagerGroupRequestDTO
   */
  state?: StateDTO;
}

/**
 * @export
 * @interface EditCaseManagerRequestDTO
 */
export interface EditCaseManagerRequestDTO {
  /**
   * @type {CaseManagerDTO}
   * @memberof EditCaseManagerRequestDTO
   */
  caseManager: CaseManagerDTO;
}

/**
 * @export
 * @interface EditInsurancePlanAliasRequestDTO
 */
export interface EditInsurancePlanAliasRequestDTO {
  /**
   * @type {InsurancePlanAliasDTO}
   * @memberof EditInsurancePlanAliasRequestDTO
   */
  insurancePlanAlias: InsurancePlanAliasDTO;
}

/**
 * @export
 * @interface EditInsurancePlanRequestDTO
 */
export interface EditInsurancePlanRequestDTO {
  /**
   * @type {InsurancePlanDTO}
   * @memberof EditInsurancePlanRequestDTO
   */
  insurancePlan: InsurancePlanDTO;
}

/**
 * @export
 * @interface EditMarketConfigurationRequestDTO
 */
export interface EditMarketConfigurationRequestDTO {
  /**
   * @type {MarketConfigurationDTO}
   * @memberof EditMarketConfigurationRequestDTO
   */
  marketConfiguration: MarketConfigurationDTO;
}

/**
 * @export
 * @interface EditMatchListRequestDTO
 */
export interface EditMatchListRequestDTO {
  /**
   * @type {string}
   * @memberof EditMatchListRequestDTO
   */
  patientId: string;
  /**
   * @type {EditMatchListRequestMatchListDTO}
   * @memberof EditMatchListRequestDTO
   */
  matchList: EditMatchListRequestMatchListDTO;
}

/**
 * @export
 * @interface EditMatchListRequestMatchListDTO
 */
export interface EditMatchListRequestMatchListDTO {
  /**
   * @type {Array<EditMatchListRequestPracticeMatchDTO>}
   * @memberof EditMatchListRequestMatchListDTO
   */
  practiceMatches: Array<EditMatchListRequestPracticeMatchDTO>;
}

/**
 * @export
 * @interface EditMatchListRequestPracticeMatchDTO
 */
export interface EditMatchListRequestPracticeMatchDTO {
  /**
   * @type {string}
   * @memberof EditMatchListRequestPracticeMatchDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof EditMatchListRequestPracticeMatchDTO
   */
  practiceId?: string;
  /**
   * @type {string}
   * @memberof EditMatchListRequestPracticeMatchDTO
   */
  closestLocationId?: string;
  /**
   * @type {DistanceDTO}
   * @memberof EditMatchListRequestPracticeMatchDTO
   */
  distance?: DistanceDTO;
  /**
   * @type {number}
   * @memberof EditMatchListRequestPracticeMatchDTO
   */
  score?: number;
  /**
   * @type {Array<string>}
   * @memberof EditMatchListRequestPracticeMatchDTO
   */
  newProviderIds: Array<string>;
}

/**
 * @export
 * @interface EditNoteOnCareEventRequestDTO
 */
export interface EditNoteOnCareEventRequestDTO {
  /**
   * @description The ID of the care event to edit
   * @type {string}
   * @memberof EditNoteOnCareEventRequestDTO
   */
  careEventId: string;
  /**
   * @description The edited note to put on the care event
   * @type {string}
   * @memberof EditNoteOnCareEventRequestDTO
   */
  note: string;
}

/**
 * @export
 * @interface EditPatientAddressesRequestDTO
 */
export interface EditPatientAddressesRequestDTO {
  /**
   * @type {string}
   * @memberof EditPatientAddressesRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<PatientAddressDTO>}
   * @memberof EditPatientAddressesRequestDTO
   */
  addresses: Array<PatientAddressDTO>;
}

/**
 * @export
 * @interface EditPcpAsAdminRequestDTO
 */
export interface EditPcpAsAdminRequestDTO {
  /**
   * @type {string}
   * @memberof EditPcpAsAdminRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof EditPcpAsAdminRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof EditPcpAsAdminRequestDTO
   */
  lastName: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof EditPcpAsAdminRequestDTO
   */
  phoneNumbers: Array<PhoneNumberDTO>;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof EditPcpAsAdminRequestDTO
   */
  pcpPracticeTitle: PcpPracticeTitleDTO;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof EditPcpAsAdminRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof EditPcpAsAdminRequestDTO
   */
  pcpProfilePermissions: ProviderProfilePermissionsDTO;
}

/**
 * @export
 * @interface EditPcpRequestDTO
 */
export interface EditPcpRequestDTO {
  /**
   * @type {string}
   * @memberof EditPcpRequestDTO
   */
  practiceId?: string;
  /**
   * @type {string}
   * @memberof EditPcpRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof EditPcpRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof EditPcpRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof EditPcpRequestDTO
   */
  npi?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof EditPcpRequestDTO
   */
  phoneNumbers: Array<PhoneNumberDTO>;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof EditPcpRequestDTO
   */
  pcpPracticeTitle: PcpPracticeTitleDTO;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof EditPcpRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof EditPcpRequestDTO
   */
  pcpProfilePermissions: ProviderProfilePermissionsDTO;
}

/**
 * @export
 * @interface EditProviderAsAdminRequestDTO
 */
export interface EditProviderAsAdminRequestDTO {
  /**
   * @type {ProviderDTO}
   * @memberof EditProviderAsAdminRequestDTO
   */
  provider: ProviderDTO;
  /**
   * @type {ProviderProfilePermissionsForAdminDTO}
   * @memberof EditProviderAsAdminRequestDTO
   */
  providerProfilePermissions?: ProviderProfilePermissionsForAdminDTO;
  /**
   * @type {ProviderDirectDetailsDTO}
   * @memberof EditProviderAsAdminRequestDTO
   */
  providerDirectDetails?: ProviderDirectDetailsDTO;
  /**
   * @type {ProviderClassificationDTO}
   * @memberof EditProviderAsAdminRequestDTO
   */
  classification?: ProviderClassificationDTO;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof EditProviderAsAdminRequestDTO
   */
  supportedPatientNeeds?: SupportedPatientNeedsDTO;
}

/**
 * @export
 * @interface EditSimpleProgressUpdateRequestDTO
 */
export interface EditSimpleProgressUpdateRequestDTO {
  /**
   * @type {string}
   * @memberof EditSimpleProgressUpdateRequestDTO
   */
  careEventId: string;
  /**
   * @type {string}
   * @memberof EditSimpleProgressUpdateRequestDTO
   */
  note: string;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof EditSimpleProgressUpdateRequestDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
}

/**
 * @export
 * @interface EditStructuredProgressUpdateRequestDTO
 */
export interface EditStructuredProgressUpdateRequestDTO {
  /**
   * @description care event associated with the progress update
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  careEventId?: string;
  /**
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  progressUpdateId: string;
  /**
   * @description Overall progress enum
   * @type {ProgressQualifierDTO}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  overallProgress: ProgressQualifierDTO;
  /**
   * @description Recent progress enum
   * @type {ProgressQualifierDTO}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  recentProgress: ProgressQualifierDTO;
  /**
   * @description How engaged is the patient enum
   * @type {ClientEngagementLevelDTO}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  clientEngagementLevel?: ClientEngagementLevelDTO;
  /**
   * @description Results of standardized assessments tools (such as PHQ, GAD, Beck’s)
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messageAssessments?: string;
  /**
   * @description Client attendance
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messageAttendance?: string;
  /**
   * @description Medication-related changes or concerns
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messageMedication?: string;
  /**
   * @description Physical health concerns
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messagePhysicalHealth?: string;
  /**
   * @description The patient's prognosis
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messagePrognosis?: string;
  /**
   * @description New or worsening symptoms
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messageSymptomIncrease?: string;
  /**
   * @description Symptom reduction
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  messageSymptomReduction?: string;
  /**
   * @description Changes to the patient's treatment plan
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  treatmentPlan?: string;
  /**
   * @description Changes to the patient's treatment diagnosis
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  treatmentDiagnosis?: string;
  /**
   * @description Changes to the patient's treatment diagnosis
   * @type {string}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  treatmentMedication?: string;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof EditStructuredProgressUpdateRequestDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
}

/**
 * @export
 * @interface EditVbcProgramRequestDTO
 */
export interface EditVbcProgramRequestDTO {
  /**
   * @type {string}
   * @memberof EditVbcProgramRequestDTO
   */
  id: string;
  /**
   * @type {VbcProgramDTO}
   * @memberof EditVbcProgramRequestDTO
   */
  vbcProgram: VbcProgramDTO;
}

/**
 * @export
 * @interface EhrAssessmentDataDTO
 */
export interface EhrAssessmentDataDTO {
  /**
   * @type {Array<ExternalAssessmentModuleDTO>}
   * @memberof EhrAssessmentDataDTO
   */
  modules?: Array<ExternalAssessmentModuleDTO>;
}

/**
 * @export
 * @enum {string}
 */
export enum EligibilityPartnerDTO {
  TELADOC = 'TELADOC'
}

/**
 * @export
 * @interface EmailDTO
 */
export interface EmailDTO {
  /**
   * @type {string}
   * @memberof EmailDTO
   */
  address?: string;
  /**
   * @type {boolean}
   * @memberof EmailDTO
   */
  isPrimary?: boolean;
  /**
   * @type {string}
   * @memberof EmailDTO
   */
  name?: string;
  /**
   * @type {boolean}
   * @memberof EmailDTO
   */
  verified?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum EmailStateDTO {
  SoftBounced = 'Soft Bounced',
  HardBounced = 'Hard Bounced',
  Failed = 'Failed',
  Sent = 'Sent',
  Invalid = 'Invalid',
  Queued = 'Queued',
  Created = 'Created',
  Unknown = 'Unknown'
}

/**
 * @export
 * @interface EmergencyContactDTO
 */
export interface EmergencyContactDTO {
  /**
   * @type {boolean}
   * @memberof EmergencyContactDTO
   */
  isPrimary: boolean;
  /**
   * @type {string}
   * @memberof EmergencyContactDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof EmergencyContactDTO
   */
  phoneNumber: string;
  /**
   * @type {RelationshipDTO}
   * @memberof EmergencyContactDTO
   */
  relationship: RelationshipDTO;
}

/**
 * @export
 * @interface EmrCurbsideDTO
 */
export interface EmrCurbsideDTO {
  /**
   * @type {string}
   * @memberof EmrCurbsideDTO
   */
  pcpAvailability: string;
  /**
   * @type {string}
   * @memberof EmrCurbsideDTO
   */
  pcpPhoneNumber: string;
  /**
   * @type {string}
   * @memberof EmrCurbsideDTO
   */
  reasonForConsult: string;
}

/**
 * @export
 * @interface EnableSmartMatchReferralsForPatientRequestDTO
 */
export interface EnableSmartMatchReferralsForPatientRequestDTO {
  /**
   * @description The ID of the patient for whom to enable smartmatch referrals
   * @type {string}
   * @memberof EnableSmartMatchReferralsForPatientRequestDTO
   */
  patientId: string;
  /**
   * @type {boolean}
   * @memberof EnableSmartMatchReferralsForPatientRequestDTO
   */
  isAutolaunched: boolean;
}

/**
 * @export
 * @interface EntityMetadataDTO
 */
export interface EntityMetadataDTO {
  /**
   * @type {string}
   * @memberof EntityMetadataDTO
   */
  createdAt?: string;
  /**
   * @type {string}
   * @memberof EntityMetadataDTO
   */
  updatedAt?: string;
  /**
   * @type {string}
   * @memberof EntityMetadataDTO
   */
  createdBy?: string;
  /**
   * @type {string}
   * @memberof EntityMetadataDTO
   */
  updatedBy?: string;
}

/**
 * @export
 * @interface ExternalAssessmentModuleDTO
 */
export interface ExternalAssessmentModuleDTO {
  /**
   * @type {string}
   * @memberof ExternalAssessmentModuleDTO
   */
  name: string;
  /**
   * @type {number}
   * @memberof ExternalAssessmentModuleDTO
   */
  rawScore: number;
  /**
   * @type {string}
   * @memberof ExternalAssessmentModuleDTO
   */
  scoreLabel?: string;
  /**
   * @type {boolean}
   * @memberof ExternalAssessmentModuleDTO
   */
  isUrgent?: boolean;
  /**
   * @type {boolean}
   * @memberof ExternalAssessmentModuleDTO
   */
  isPositive?: boolean;
  /**
   * @type {Array<ExternalAssessmentModuleQuestionDTO>}
   * @memberof ExternalAssessmentModuleDTO
   */
  questions: Array<ExternalAssessmentModuleQuestionDTO>;
}

/**
 * @export
 * @interface ExternalAssessmentModuleQuestionDTO
 */
export interface ExternalAssessmentModuleQuestionDTO {
  /**
   * @type {string}
   * @memberof ExternalAssessmentModuleQuestionDTO
   */
  question: string;
  /**
   * @type {string}
   * @memberof ExternalAssessmentModuleQuestionDTO
   */
  answer: string;
}

/**
 * @export
 * @interface ExternalReferralPatientDTO
 */
export interface ExternalReferralPatientDTO {
  /**
   * @type {AddressDTO}
   * @memberof ExternalReferralPatientDTO
   */
  address: AddressDTO;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof ExternalReferralPatientDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @type {ExternalPatientDemographicsDTO}
   * @memberof ExternalReferralPatientDTO
   */
  demographics: ExternalPatientDemographicsDTO;
  /**
   * @type {string}
   * @memberof ExternalReferralPatientDTO
   */
  emailAddress?: string;
  /**
   * @type {LanguageDTO}
   * @memberof ExternalReferralPatientDTO
   */
  languagePreference?: LanguageDTO;
  /**
   * @type {Array<CreateExternalReferralInsurancePolicyDTO>}
   * @memberof ExternalReferralPatientDTO
   */
  insurancePolicies?: Array<CreateExternalReferralInsurancePolicyDTO>;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof ExternalReferralPatientDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {PatientPreferencesDTO}
   * @memberof ExternalReferralPatientDTO
   */
  preferences: PatientPreferencesDTO;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof ExternalReferralPatientDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description used to determine if patient is participating in collaborative care
   * @type {boolean}
   * @memberof ExternalReferralPatientDTO
   */
  collaborativeCarePatient?: boolean;
}

/**
 * @export
 * @interface ExternalReferralPcpDTO
 */
export interface ExternalReferralPcpDTO {
  /**
   * @type {ExternalPcpDemographicsDTO}
   * @memberof ExternalReferralPcpDTO
   */
  demographics: ExternalPcpDemographicsDTO;
  /**
   * @type {string}
   * @memberof ExternalReferralPcpDTO
   */
  emailAddress?: string;
  /**
   * @type {string}
   * @memberof ExternalReferralPcpDTO
   */
  phoneNumber?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum FeatureInterestResponseDTO {
  Yes = 'Yes',
  No = 'No',
  NeedMoreInformation = 'Need More Information'
}

/**
 * @export
 * @enum {string}
 */
export enum FeatureTypeDTO {
  PatientInitiatedReferralFlow = 'Patient Initiated Referral Flow',
  DirectMatching = 'Direct Matching'
}

/**
 * @export
 * @enum {string}
 */
export enum FeatureUtilityResponseDTO {
  VeryUnhelpful = 'Very Unhelpful',
  Unhelpful = 'Unhelpful',
  Neutral = 'Neutral',
  Helpful = 'Helpful',
  VeryHelpful = 'Very Helpful'
}

/**
 * @export
 * @enum {string}
 */
export enum GenderDTO {
  Male = 'Male',
  Female = 'Female',
  Transgender = 'Transgender',
  TransgenderMale = 'Transgender Male',
  TransgenderFemale = 'Transgender Female',
  NonBinaryGenderNonconforming = 'Non Binary Gender Nonconforming',
  NotSpecified = 'Not Specified',
  Other = 'Other'
}

/**
 * @export
 * @interface GetAssessmentDetailsForPatientResponseDTO
 */
export interface GetAssessmentDetailsForPatientResponseDTO {
  /**
   * @type {Array<RequestedAssessmentDetailsDTO>}
   * @memberof GetAssessmentDetailsForPatientResponseDTO
   */
  requestedAssessmentDetails: Array<RequestedAssessmentDetailsDTO>;
  /**
   * @type {Array<CompletedAssessmentDetailsDTO>}
   * @memberof GetAssessmentDetailsForPatientResponseDTO
   */
  completedAssessmentDetails: Array<CompletedAssessmentDetailsDTO>;
}

/**
 * @export
 * @interface GetAssessmentResponseDTO
 */
export interface GetAssessmentResponseDTO {
  /**
   * @description The user entered assessment information and meta data
   * @type {AssessmentResultWithCompletingInfoDTO}
   * @memberof GetAssessmentResponseDTO
   */
  assessmentResult?: AssessmentResultWithCompletingInfoDTO;
}

/**
 * @export
 * @interface GetAssessmentResultResponseDTO
 */
export interface GetAssessmentResultResponseDTO {
  /**
   * @description The user entered assessment information and meta data
   * @type {AssessmentResultWithCompletingInfoDTO}
   * @memberof GetAssessmentResultResponseDTO
   */
  assessmentResult: AssessmentResultWithCompletingInfoDTO;
  /**
   * @description Assessment completed CareEvent
   * @type {CareEventDTO}
   * @memberof GetAssessmentResultResponseDTO
   */
  careEvent?: CareEventDTO;
  /**
   * @description Patient that took the assessment
   * @type {PatientDTO}
   * @memberof GetAssessmentResultResponseDTO
   */
  patient?: PatientDTO;
  /**
   * @description Obfuscated codeword for whether the Suicidality Question (Sq) threshold was reached.
   * @type {boolean}
   * @memberof GetAssessmentResultResponseDTO
   */
  isSqThresholdReached?: boolean;
  /**
   * @type {boolean}
   * @memberof GetAssessmentResultResponseDTO
   */
  isHighRiskAssessmentAcknowledged?: boolean;
  /**
   * @type {boolean}
   * @memberof GetAssessmentResultResponseDTO
   */
  isFirstAssessmentOfType?: boolean;
}

/**
 * @export
 * @interface GetAvailableAssessmentsResponseDTO
 */
export interface GetAvailableAssessmentsResponseDTO {
  /**
   * @type {Array<AssessmentInfoDTO>}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  assessmentInfo: Array<AssessmentInfoDTO>;
  /**
   * @type {string}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  patientFirstName?: string;
  /**
   * @type {string}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  patientLastName?: string;
  /**
   * @type {string}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  patientPreferredName?: string;
  /**
   * @type {string}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  patientDob?: string;
  /**
   * @type {string}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  patientEmail?: string;
  /**
   * @type {string}
   * @memberof GetAvailableAssessmentsResponseDTO
   */
  patientPhoneNumber?: string;
}

/**
 * @export
 * @interface GetBhpPatientsDashboardResponseDTO
 */
export interface GetBhpPatientsDashboardResponseDTO {
  /**
   * @type {PageDTO}
   * @memberof GetBhpPatientsDashboardResponseDTO
   */
  page: PageDTO;
  /**
   * @type {Array<BhpDashboardPatientDTO>}
   * @memberof GetBhpPatientsDashboardResponseDTO
   */
  patients: Array<BhpDashboardPatientDTO>;
  /**
   * @type {Array<BhpDashboardProviderDTO>}
   * @memberof GetBhpPatientsDashboardResponseDTO
   */
  providers: Array<BhpDashboardProviderDTO>;
  /**
   * @type {Array<BhpDashboardAppointmentDTO>}
   * @memberof GetBhpPatientsDashboardResponseDTO
   */
  appointments: Array<BhpDashboardAppointmentDTO>;
  /**
   * @type {Array<CareEventDTO>}
   * @memberof GetBhpPatientsDashboardResponseDTO
   */
  careEvents: Array<CareEventDTO>;
}

/**
 * @export
 * @interface GetCareTeamForPatientResponseDTO
 */
export interface GetCareTeamForPatientResponseDTO {
  /**
   * @type {PatientDTO}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  patient: PatientDTO;
  /**
   * @description The care team members associated with the patient
   * @type {Array<ProviderDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  careTeamMembers: Array<ProviderDTO>;
  /**
   * @description The case managers on this patient's care team
   * @type {Array<CaseManagerDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  careTeamCaseManagers?: Array<CaseManagerDTO>;
  /**
   * @description The case manager groups of the patient's careteam case managers
   * @type {Array<DisplayCaseManagerGroupDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  careTeamCaseManagerGroups?: Array<DisplayCaseManagerGroupDTO>;
  /**
   * @description The addresses of the care team members associated with the patient
   * @type {Array<LocationDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  careTeamMemberLocations?: Array<LocationDTO>;
  /**
   * @description The care team pcps associated with the patient
   * @type {Array<CareTeamPcpDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  careTeamPcps?: Array<CareTeamPcpDTO>;
  /**
   * @description The insurance plan information for this patient's policies
   * @type {Array<InsurancePlanDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  patientInsurancePlans?: Array<InsurancePlanDTO>;
  /**
   * @description The practices of the patient's careteam members
   * @type {Array<PracticeDTO>}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  practices?: Array<PracticeDTO>;
  /**
   * @type {LocationDTO}
   * @memberof GetCareTeamForPatientResponseDTO
   */
  closestMhpLocation?: LocationDTO;
}

/**
 * @export
 * @interface GetHealthSystemPatientsDashboardResponseDTO
 */
export interface GetHealthSystemPatientsDashboardResponseDTO {
  /**
   * @type {PageDTO}
   * @memberof GetHealthSystemPatientsDashboardResponseDTO
   */
  page: PageDTO;
  /**
   * @type {Array<HealthSystemDashboardPatientDTO>}
   * @memberof GetHealthSystemPatientsDashboardResponseDTO
   */
  patients: Array<HealthSystemDashboardPatientDTO>;
}

/**
 * @export
 * @interface GetHealthSystemsResponseDTO
 */
export interface GetHealthSystemsResponseDTO {
  /**
   * @type {Array<HealthSystemDTO>}
   * @memberof GetHealthSystemsResponseDTO
   */
  healthSystems: Array<HealthSystemDTO>;
}

/**
 * @export
 * @interface GetMarketConfigurationResponseDTO
 */
export interface GetMarketConfigurationResponseDTO {
  /**
   * @type {Array<MarketConfigurationDTO>}
   * @memberof GetMarketConfigurationResponseDTO
   */
  marketConfigurations: Array<MarketConfigurationDTO>;
}

/**
 * @export
 * @interface GetMatchPreferencesForPatientResponseDTO
 */
export interface GetMatchPreferencesForPatientResponseDTO {
  /**
   * @type {PatientSmartMatchPreferencesDTO}
   * @memberof GetMatchPreferencesForPatientResponseDTO
   */
  smartMatchPreferences?: PatientSmartMatchPreferencesDTO;
  /**
   * @type {Array<TimeOfDayDTO>}
   * @memberof GetMatchPreferencesForPatientResponseDTO
   */
  preferredContactTimes?: Array<TimeOfDayDTO>;
  /**
   * @type {Array<PatientAddressDTO>}
   * @memberof GetMatchPreferencesForPatientResponseDTO
   */
  addresses?: Array<PatientAddressDTO>;
}

/**
 * @export
 * @interface GetMatchedPracticeProfileResponseDTO
 */
export interface GetMatchedPracticeProfileResponseDTO {
  /**
   * @description The name of the practice with which the patient has been matched
   * @type {string}
   * @memberof GetMatchedPracticeProfileResponseDTO
   */
  practiceName?: string;
  /**
   * @description The id of the practice with which the patient has been matched
   * @type {string}
   * @memberof GetMatchedPracticeProfileResponseDTO
   */
  practiceId?: string;
  /**
   * @description Phone numbers for the practice with which the patient has been matched
   * @type {Array<PhoneNumberDTO>}
   * @memberof GetMatchedPracticeProfileResponseDTO
   */
  practicePhoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @description Providers at the practice who accept the patient's insurance and are suggested as BHPs for the patient
   * @type {Array<BhpDetailsForMatchedPracticeDTO>}
   * @memberof GetMatchedPracticeProfileResponseDTO
   */
  practiceProviders?: Array<BhpDetailsForMatchedPracticeDTO>;
}

/**
 * @export
 * @interface GetMessageThreadResponseDTO
 */
export interface GetMessageThreadResponseDTO {
  /**
   * @type {Array<MessageDTO>}
   * @memberof GetMessageThreadResponseDTO
   */
  messages: Array<MessageDTO>;
}

/**
 * @export
 * @interface GetMessageThreadSummariesResponseDTO
 */
export interface GetMessageThreadSummariesResponseDTO {
  /**
   * @type {Array<MessageThreadSummaryDTO>}
   * @memberof GetMessageThreadSummariesResponseDTO
   */
  threadSummaries: Array<MessageThreadSummaryDTO>;
}

/**
 * @export
 * @interface GetPatientContactsResponseDTO
 */
export interface GetPatientContactsResponseDTO {
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof GetPatientContactsResponseDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof GetPatientContactsResponseDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
}

/**
 * @export
 * @interface GetPatientDetailsForOpsResponseDTO
 */
export interface GetPatientDetailsForOpsResponseDTO {
  /**
   * @type {PatientDetailsForOpsDTO}
   * @memberof GetPatientDetailsForOpsResponseDTO
   */
  patient: PatientDetailsForOpsDTO;
  /**
   * @type {PatientActivationDetailsDTO}
   * @memberof GetPatientDetailsForOpsResponseDTO
   */
  patientActivationDetails: PatientActivationDetailsDTO;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof GetPatientDetailsForOpsResponseDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
  /**
   * @type {HealthSystemDTO}
   * @memberof GetPatientDetailsForOpsResponseDTO
   */
  referringHealthSystem?: HealthSystemDTO;
}

/**
 * @export
 * @interface GetPatientsByMrnsResponseDTO
 */
export interface GetPatientsByMrnsResponseDTO {
  /**
   * @type {Array<PatientWithExternalIdsDTO>}
   * @memberof GetPatientsByMrnsResponseDTO
   */
  patients?: Array<PatientWithExternalIdsDTO>;
}

/**
 * @export
 * @interface GetPcpByEmailResponseDTO
 */
export interface GetPcpByEmailResponseDTO {
  /**
   * @type {PcpDTO}
   * @memberof GetPcpByEmailResponseDTO
   */
  pcp: PcpDTO;
}

/**
 * @export
 * @interface GetPcpProfileAsAdminResponseDTO
 */
export interface GetPcpProfileAsAdminResponseDTO {
  /**
   * @type {PcpDTO}
   * @memberof GetPcpProfileAsAdminResponseDTO
   */
  pcp: PcpDTO;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof GetPcpProfileAsAdminResponseDTO
   */
  pcpProfilePermissions: ProviderProfilePermissionsDTO;
  /**
   * @type {Array<PcpPracticeMembershipDTO>}
   * @memberof GetPcpProfileAsAdminResponseDTO
   */
  pcpPracticeMemberships: Array<PcpPracticeMembershipDTO>;
  /**
   * @type {Array<DisplayPrimaryCarePracticeDTO>}
   * @memberof GetPcpProfileAsAdminResponseDTO
   */
  practices: Array<DisplayPrimaryCarePracticeDTO>;
}

/**
 * @export
 * @interface GetPcpProfileResponseDTO
 */
export interface GetPcpProfileResponseDTO {
  /**
   * @type {PcpDTO}
   * @memberof GetPcpProfileResponseDTO
   */
  pcp: PcpDTO;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof GetPcpProfileResponseDTO
   */
  pcpProfilePermissions: ProviderProfilePermissionsDTO;
}

/**
 * @export
 * @interface GetPracticeAndProviderDetailsForOpsResponseDTO
 */
export interface GetPracticeAndProviderDetailsForOpsResponseDTO {
  /**
   * @type {Array<PracticeDetailsForOpsDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsResponseDTO
   */
  practices: Array<PracticeDetailsForOpsDTO>;
  /**
   * @type {Array<ProviderDetailsWithPracticesForOpsDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsResponseDTO
   */
  providers: Array<ProviderDetailsWithPracticesForOpsDTO>;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsResponseDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
  /**
   * @type {Array<LocationForOpsDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsResponseDTO
   */
  locations: Array<LocationForOpsDTO>;
}

/**
 * @export
 * @interface GetPracticeProvidersByNpiResponseDTO
 */
export interface GetPracticeProvidersByNpiResponseDTO {
  /**
   * @type {Array<string>}
   * @memberof GetPracticeProvidersByNpiResponseDTO
   */
  providerIds?: Array<string>;
}

/**
 * @export
 * @interface GetPracticeTosResponseDTO
 */
export interface GetPracticeTosResponseDTO {
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof GetPracticeTosResponseDTO
   */
  signedUserAgreements?: Array<UserAgreementVersionDTO>;
}

/**
 * @export
 * @interface GetPreferentialMatchRuleResponseDTO
 */
export interface GetPreferentialMatchRuleResponseDTO {
  /**
   * @type {string}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  type: GetPreferentialMatchRuleResponseDTOTypeDTOEnum;
  /**
   * @type {boolean}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  isActive: boolean;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  conditionNeeds: SupportedPatientNeedsDTO;
  /**
   * @type {string}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  description?: string;
  /**
   * @type {Array<string>}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  sourceHealthSystemIds?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  sourcePcpPracticeIds?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  sourceInsurancePlanIds?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  targetHealthSystemIds?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof GetPreferentialMatchRuleResponseDTO
   */
  targetBhpPracticeIds?: Array<string>;
}

/**
 * @export
 * @enum {string}
 */
export enum GetPreferentialMatchRuleResponseDTOTypeDTOEnum {
  PRACTICEPARTNERSHIP = 'PRACTICE_PARTNERSHIP',
  INTRAHEALTHSYSTEM = 'INTRA_HEALTH_SYSTEM',
  HEALTHSYSTEMBHPPRACTICEPARTNERSHIP = 'HEALTH_SYSTEM_BHP_PRACTICE_PARTNERSHIP',
  INSURANCEPLANBHPPRACTICEPARTNERSHIP = 'INSURANCE_PLAN_BHP_PRACTICE_PARTNERSHIP',
  INSURANCEPLANHEALTHSYSTEMPARTNERSHIP = 'INSURANCE_PLAN_HEALTH_SYSTEM_PARTNERSHIP'
}

/**
 * @export
 * @interface GetPreferentialMatchRulesResponseDTO
 */
export interface GetPreferentialMatchRulesResponseDTO {
  /**
   * @type {Array<GetPreferentialMatchRuleResponseDTO>}
   * @memberof GetPreferentialMatchRulesResponseDTO
   */
  preferentialMatchRules: Array<GetPreferentialMatchRuleResponseDTO>;
}

/**
 * @export
 * @interface GetProviderNpisForInsurancePlanResponseDTO
 */
export interface GetProviderNpisForInsurancePlanResponseDTO {
  /**
   * @type {Array<string>}
   * @memberof GetProviderNpisForInsurancePlanResponseDTO
   */
  npis?: Array<string>;
}

/**
 * @export
 * @interface GetReferralMatchStatusForPatientResponseDTO
 */
export interface GetReferralMatchStatusForPatientResponseDTO {
  /**
   * @description True if patient requested a rematch
   * @type {boolean}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  hasRequestedRematch: boolean;
  /**
   * @type {string}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  rematchRequestId?: string;
  /**
   * @description Is the rematch requested an immediate request or a future date?
   * @type {boolean}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  isImmediateRematchRequest?: boolean;
  /**
   * @description Approximate date of when rematch will happen
   * @type {string}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  dateToRematch?: string;
  /**
   * @description Patient's referrals that have been accepted by a bhp
   * @type {Array<ReferralDTO>}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  acceptedReferrals?: Array<ReferralDTO>;
  /**
   * @description Reasons why a patient rejected their bhp
   * @type {Array<PatientReferralFeedbackDTO>}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  referralFeedback?: Array<PatientReferralFeedbackDTO>;
  /**
   * @description The bhps associated with the accepted referrals
   * @type {Array<BhpDetailsForPatientDTO>}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  bhpDetails?: Array<BhpDetailsForPatientDTO>;
  /**
   * @type {boolean}
   * @memberof GetReferralMatchStatusForPatientResponseDTO
   */
  hasCareOutcome?: boolean;
}

/**
 * @export
 * @interface GetUserDataResponseDTO
 */
export interface GetUserDataResponseDTO {
  /**
   * @type {string}
   * @memberof GetUserDataResponseDTO
   */
  accountId?: string;
  /**
   * @description If this user is a Provider or Case Manager, this is the id of their primary practice
   * @type {string}
   * @memberof GetUserDataResponseDTO
   */
  practiceId?: string;
  /**
   * @type {ProviderDTO}
   * @memberof GetUserDataResponseDTO
   */
  provider?: ProviderDTO;
  /**
   * @type {PcpDTO}
   * @memberof GetUserDataResponseDTO
   */
  pcp?: PcpDTO;
  /**
   * @type {PcpUserDataDTO}
   * @memberof GetUserDataResponseDTO
   */
  pcpV2?: PcpUserDataDTO;
  /**
   * @type {BhpDTO}
   * @memberof GetUserDataResponseDTO
   */
  bhp?: BhpDTO;
  /**
   * @type {PatientDTO}
   * @memberof GetUserDataResponseDTO
   */
  patient?: PatientDTO;
  /**
   * @type {CaseManagerUserDataDTO}
   * @memberof GetUserDataResponseDTO
   */
  caseManager?: CaseManagerUserDataDTO;
  /**
   * @type {AdminDTO}
   * @memberof GetUserDataResponseDTO
   */
  admin?: AdminDTO;
  /**
   * @type {ProviderProfilePermissionsResponseDTO}
   * @memberof GetUserDataResponseDTO
   */
  permissions?: ProviderProfilePermissionsResponseDTO;
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof GetUserDataResponseDTO
   */
  acceptedUserAgreementVersions: Array<UserAgreementVersionDTO>;
  /**
   * @type {Array<AudienceTypeDTO>}
   * @memberof GetUserDataResponseDTO
   */
  audiences?: Array<AudienceTypeDTO>;
  /**
   * @type {Array<UserRoleDTO>}
   * @memberof GetUserDataResponseDTO
   */
  userRoles: Array<UserRoleDTO>;
  /**
   * @type {Array<UserAuthorityDTO>}
   * @memberof GetUserDataResponseDTO
   */
  userAuthorities: Array<UserAuthorityDTO>;
}

/**
 * @export
 * @interface GetVbcInsurancePlansResponseDTO
 */
export interface GetVbcInsurancePlansResponseDTO {
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof GetVbcInsurancePlansResponseDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
}

/**
 * @export
 * @interface GetVbcPatientTasksResponseDTO
 */
export interface GetVbcPatientTasksResponseDTO {
  /**
   * @type {BhpPatientTimelineTaskBaseDTO}
   * @memberof GetVbcPatientTasksResponseDTO
   */
  initialProgressUpdateTask?: BhpPatientTimelineTaskBaseDTO;
  /**
   * @type {BhpPatientTimelineTaskBaseDTO}
   * @memberof GetVbcPatientTasksResponseDTO
   */
  baselineAssessmentTask?: BhpPatientTimelineTaskBaseDTO;
  /**
   * @type {BhpPatientTimelineTaskBaseDTO}
   * @memberof GetVbcPatientTasksResponseDTO
   */
  followUpProgressUpdateTask?: BhpPatientTimelineTaskBaseDTO;
  /**
   * @type {BhpPatientTimelineFollowUpAssessmentTaskDTO}
   * @memberof GetVbcPatientTasksResponseDTO
   */
  followUpAssessmentTask?: BhpPatientTimelineFollowUpAssessmentTaskDTO;
}

/**
 * @export
 * @interface GetVbcPatientsDashboardResponseDTO
 */
export interface GetVbcPatientsDashboardResponseDTO {
  /**
   * @type {PageDTO}
   * @memberof GetVbcPatientsDashboardResponseDTO
   */
  page: PageDTO;
  /**
   * @type {Array<VbcDashboardPatientDTO>}
   * @memberof GetVbcPatientsDashboardResponseDTO
   */
  patients: Array<VbcDashboardPatientDTO>;
  /**
   * @type {Array<BhpDashboardProviderDTO>}
   * @memberof GetVbcPatientsDashboardResponseDTO
   */
  providers: Array<BhpDashboardProviderDTO>;
}

/**
 * @export
 * @interface GetVbcProgramResponseDTO
 */
export interface GetVbcProgramResponseDTO {
  /**
   * @type {string}
   * @memberof GetVbcProgramResponseDTO
   */
  id: string;
  /**
   * @type {VbcProgramDTO}
   * @memberof GetVbcProgramResponseDTO
   */
  vbcProgram: VbcProgramDTO;
}

/**
 * @export
 * @interface GroupCaseManagerPermissionsWithMetadataResponseDTO
 */
export interface GroupCaseManagerPermissionsWithMetadataResponseDTO {
  /**
   * @type {Array<GroupCaseManagerPermissionsWithMetadataDTO>}
   * @memberof GroupCaseManagerPermissionsWithMetadataResponseDTO
   */
  permissions: Array<GroupCaseManagerPermissionsWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof GroupCaseManagerPermissionsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface GroupCaseManagerProfilePermissionsDTO
 */
export interface GroupCaseManagerProfilePermissionsDTO {
  /**
   * @type {boolean}
   * @memberof GroupCaseManagerProfilePermissionsDTO
   */
  canAdministerGroup?: boolean;
  /**
   * @type {boolean}
   * @memberof GroupCaseManagerProfilePermissionsDTO
   */
  canViewBehavioralHealthAssessmentsAndConsultNotes?: boolean;
  /**
   * @type {boolean}
   * @memberof GroupCaseManagerProfilePermissionsDTO
   */
  canViewPatientReferralProviderAndAppointmentDetails?: boolean;
}

/**
 * @export
 * @interface HealthSystemDTO
 */
export interface HealthSystemDTO {
  /**
   * @type {string}
   * @memberof HealthSystemDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof HealthSystemDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof HealthSystemDTO
   */
  parentId?: string;
  /**
   * @type {AddressDTO}
   * @memberof HealthSystemDTO
   */
  address?: AddressDTO;
}

/**
 * @export
 * @interface HealthSystemDashboardPatientDTO
 */
export interface HealthSystemDashboardPatientDTO {
  /**
   * @description The ID of the patient
   * @type {string}
   * @memberof HealthSystemDashboardPatientDTO
   */
  id?: string;
  /**
   * @description The first name of the patient
   * @type {string}
   * @memberof HealthSystemDashboardPatientDTO
   */
  firstName?: string;
  /**
   * @description The last name of the patient
   * @type {string}
   * @memberof HealthSystemDashboardPatientDTO
   */
  lastName?: string;
  /**
   * @description The preferred name of the patient
   * @type {string}
   * @memberof HealthSystemDashboardPatientDTO
   */
  preferredName?: string;
  /**
   * @description The date of birth of the patient
   * @type {string}
   * @memberof HealthSystemDashboardPatientDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof HealthSystemDashboardPatientDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {DisplayProviderDTO}
   * @memberof HealthSystemDashboardPatientDTO
   */
  provider?: DisplayProviderDTO;
  /**
   * @description The practices that the patient's provider belongs to
   * @type {Array<DisplayPracticeDTO>}
   * @memberof HealthSystemDashboardPatientDTO
   */
  practices?: Array<DisplayPracticeDTO>;
  /**
   * @description The latest care event for the patient
   * @type {DisplayCareEventDTO}
   * @memberof HealthSystemDashboardPatientDTO
   */
  latestCareEvent?: DisplayCareEventDTO;
}

/**
 * @export
 * @interface HealthSystemsWithMetadataResponseDTO
 */
export interface HealthSystemsWithMetadataResponseDTO {
  /**
   * @type {Array<HealthSystemWithMetadataDTO>}
   * @memberof HealthSystemsWithMetadataResponseDTO
   */
  healthSystems: Array<HealthSystemWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof HealthSystemsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum InScopeReasonDTO {
  PatientEntityDetected = 'Patient Entity Detected',
  PatientPresentInInnovatelEligibilityFile = 'Patient Present In Innovatel Eligibility File',
  ActivationChannel = 'Activation Channel',
  ExcludedPracticeBackfill = 'Excluded Practice Backfill',
  PreScopeCheckBackfill = 'Pre Scope Check Backfill'
}

/**
 * @export
 * @enum {string}
 */
export enum InactiveReasonDTO {
  CannotAffordCopay = 'Cannot Afford Copay',
  DischargedOther = 'Discharged Other',
  DischargedClientsChoice = 'Discharged Clients Choice',
  DischargedClientsHigherLevelOfCare = 'Discharged Clients Higher Level Of Care',
  DischargedGoalsAchieved = 'Discharged Goals Achieved',
  NotAttending = 'Not Attending',
  InsuranceIssues = 'Insurance Issues'
}

/**
 * @export
 * @enum {string}
 */
export enum InsightKeyDTO {
  Category = 'Category',
  EntrySource = 'Entry Source',
  EntrySourceType = 'Entry Source Type',
  EntryMedium = 'Entry Medium',
  EntryCampaign = 'Entry Campaign',
  IsAgeEligible = 'Is Age Eligible',
  IsMarketEligible = 'Is Market Eligible',
  IsInsuranceEligible = 'Is Insurance Eligible',
  MatchListId = 'Match List Id',
  MatchingType = 'Matching Type'
}

/**
 * @export
 * @enum {string}
 */
export enum InsightTypeDTO {
  Referral = 'Referral',
  MatchList = 'Match List'
}

/**
 * @export
 * @enum {string}
 */
export enum InsuranceCategoryDTO {
  Commercial = 'Commercial',
  DualEligible = 'Dual Eligible',
  DualHMOSNP = 'Dual HMO/SNP',
  EssentialPlan = 'Essential Plan',
  Federal = 'Federal',
  Medicaid = 'Medicaid',
  Medicare = 'Medicare',
  MedicareAdvantage = 'Medicare Advantage',
  MedicareSupplement = 'Medicare Supplement',
  Other = 'Other',
  OutOfNetwork = 'Out of Network',
  SelfPay = 'Self-Pay',
  Tricare = 'Tricare'
}

/**
 * @export
 * @interface InsurancePlanAliasDTO
 */
export interface InsurancePlanAliasDTO {
  /**
   * @type {string}
   * @memberof InsurancePlanAliasDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof InsurancePlanAliasDTO
   */
  insurancePlanId?: string;
  /**
   * @type {string}
   * @memberof InsurancePlanAliasDTO
   */
  healthSystemId?: string;
  /**
   * @type {string}
   * @memberof InsurancePlanAliasDTO
   */
  name?: string;
}

/**
 * @export
 * @interface InsurancePlanCountyRestrictionDTO
 */
export interface InsurancePlanCountyRestrictionDTO {
  /**
   * @type {string}
   * @memberof InsurancePlanCountyRestrictionDTO
   */
  insurancePlanId: string;
  /**
   * @type {Array<string>}
   * @memberof InsurancePlanCountyRestrictionDTO
   */
  counties?: Array<string>;
}

/**
 * @export
 * @interface InsurancePlanDTO
 */
export interface InsurancePlanDTO {
  /**
   * @type {string}
   * @memberof InsurancePlanDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof InsurancePlanDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof InsurancePlanDTO
   */
  carrier?: string;
  /**
   * @type {string}
   * @memberof InsurancePlanDTO
   */
  mbho?: string;
  /**
   * @type {InsuranceCategoryDTO}
   * @memberof InsurancePlanDTO
   */
  category?: InsuranceCategoryDTO;
  /**
   * @type {InsurancePlanTypeDTO}
   * @memberof InsurancePlanDTO
   */
  type?: InsurancePlanTypeDTO;
  /**
   * @type {StateDTO}
   * @memberof InsurancePlanDTO
   */
  state?: StateDTO;
  /**
   * @type {boolean}
   * @memberof InsurancePlanDTO
   */
  isActive?: boolean;
  /**
   * @type {boolean}
   * @memberof InsurancePlanDTO
   */
  isCountyRestricted?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum InsurancePlanTypeDTO {
  EPO = 'EPO',
  HMO = 'HMO',
  PHO = 'PHO',
  POS = 'POS',
  PPO = 'PPO'
}

/**
 * @export
 * @interface InsurancePlansDTO
 */
export interface InsurancePlansDTO {
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof InsurancePlansDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
}

/**
 * @export
 * @interface InsurancePolicyDTO
 */
export interface InsurancePolicyDTO {
  /**
   * @type {string}
   * @memberof InsurancePolicyDTO
   */
  insurancePlanId: string;
  /**
   * @type {string}
   * @memberof InsurancePolicyDTO
   */
  memberId?: string;
  /**
   * @type {string}
   * @memberof InsurancePolicyDTO
   */
  groupId?: string;
  /**
   * @type {CoordinationOfBenefitsOrderDTO}
   * @memberof InsurancePolicyDTO
   */
  order: CoordinationOfBenefitsOrderDTO;
  /**
   * @type {string}
   * @memberof InsurancePolicyDTO
   */
  enrollmentStart?: string;
  /**
   * @type {string}
   * @memberof InsurancePolicyDTO
   */
  enrollmentEnd?: string;
  /**
   * @type {boolean}
   * @memberof InsurancePolicyDTO
   */
  isEntityDetected?: boolean;
}

/**
 * @export
 * @interface InsurancePolicyDetailsDTO
 */
export interface InsurancePolicyDetailsDTO {
  /**
   * @type {CoordinationOfBenefitsOrderDTO}
   * @memberof InsurancePolicyDetailsDTO
   */
  order: CoordinationOfBenefitsOrderDTO;
  /**
   * @type {string}
   * @memberof InsurancePolicyDetailsDTO
   */
  insurancePlanId: string;
}

/**
 * @export
 * @interface InsurancesPlansResponseDTO
 */
export interface InsurancesPlansResponseDTO {
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof InsurancesPlansResponseDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
}

/**
 * @export
 * @interface InviteCaseManagerRequestDTO
 */
export interface InviteCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof InviteCaseManagerRequestDTO
   */
  username: string;
}

/**
 * @export
 * @enum {string}
 */
export enum LanguageDTO {
  NotSpecified = 'Not Specified',
  English = 'English',
  AmericanSignLanguage = 'American Sign Language',
  Arabic = 'Arabic',
  Cantonese = 'Cantonese',
  French = 'French',
  German = 'German',
  HaitianCreole = 'Haitian Creole',
  Hindi = 'Hindi',
  Italian = 'Italian',
  Japanese = 'Japanese',
  Korean = 'Korean',
  Mandarin = 'Mandarin',
  Polish = 'Polish',
  Portuguese = 'Portuguese',
  Other = 'Other',
  Russian = 'Russian',
  Serbian = 'Serbian',
  Spanish = 'Spanish',
  Tagalog = 'Tagalog',
  Vietnamese = 'Vietnamese'
}

/**
 * @export
 * @interface LicenseDTO
 */
export interface LicenseDTO {
  /**
   * @type {string}
   * @memberof LicenseDTO
   */
  licenseExpirationDate?: string;
  /**
   * @type {string}
   * @memberof LicenseDTO
   */
  licenseNumber?: string;
  /**
   * @type {StateDTO}
   * @memberof LicenseDTO
   */
  licenseState?: StateDTO;
}

/**
 * @export
 * @interface ListVbcProgramsResponseDTO
 */
export interface ListVbcProgramsResponseDTO {
  /**
   * @type {Array<ListVbcProgramsResponseItemDTO>}
   * @memberof ListVbcProgramsResponseDTO
   */
  vbcPrograms?: Array<ListVbcProgramsResponseItemDTO>;
}

/**
 * @export
 * @interface ListVbcProgramsResponseItemDTO
 */
export interface ListVbcProgramsResponseItemDTO {
  /**
   * @description The id of the VBC Program
   * @type {string}
   * @memberof ListVbcProgramsResponseItemDTO
   */
  id?: string;
  /**
   * @description The name of the VBC Program
   * @type {string}
   * @memberof ListVbcProgramsResponseItemDTO
   */
  name?: string;
  /**
   * @description A short description of the VBC Program
   * @type {string}
   * @memberof ListVbcProgramsResponseItemDTO
   */
  description?: string;
}

/**
 * @export
 * @interface LocationDTO
 */
export interface LocationDTO {
  /**
   * @type {AddressWithGeocodeDataDTO}
   * @memberof LocationDTO
   */
  address?: AddressWithGeocodeDataDTO;
  /**
   * @type {string}
   * @memberof LocationDTO
   */
  name?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof LocationDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {string}
   * @memberof LocationDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof LocationDTO
   */
  tin?: string;
  /**
   * @type {string}
   * @memberof LocationDTO
   */
  tinRemitAddress?: string;
}

/**
 * @export
 * @interface LocationForOpsDTO
 */
export interface LocationForOpsDTO {
  /**
   * @type {AddressWithGeocodeDataDTO}
   * @memberof LocationForOpsDTO
   */
  address?: AddressWithGeocodeDataDTO;
  /**
   * @type {string}
   * @memberof LocationForOpsDTO
   */
  name?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof LocationForOpsDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {string}
   * @memberof LocationForOpsDTO
   */
  id?: string;
}

/**
 * @export
 * @interface LocationResponseDTO
 */
export interface LocationResponseDTO {
  /**
   * @type {string}
   * @memberof LocationResponseDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof LocationResponseDTO
   */
  name?: string;
  /**
   * @type {AddressWithGeocodeDataDTO}
   * @memberof LocationResponseDTO
   */
  address?: AddressWithGeocodeDataDTO;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof LocationResponseDTO
   */
  phoneNumbers: Array<PhoneNumberDTO>;
}

/**
 * @export
 * @interface LocationsWithMetadataResponseDTO
 */
export interface LocationsWithMetadataResponseDTO {
  /**
   * @type {Array<LocationWithMetadataDTO>}
   * @memberof LocationsWithMetadataResponseDTO
   */
  locations: Array<LocationWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof LocationsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface LoginRequestDTO
 */
export interface LoginRequestDTO {
  /**
   * @description The email address associated with an account
   * @type {string}
   * @memberof LoginRequestDTO
   */
  emailAddress: string;
  /**
   * @description The password of an account
   * @type {string}
   * @memberof LoginRequestDTO
   */
  password: string;
  /**
   * @description A device-specific two-factor authentication code for this account
   * @type {string}
   * @memberof LoginRequestDTO
   */
  twoFactorAuthDeviceCode?: string;
  /**
   * @type {Array<UserRoleDTO>}
   * @memberof LoginRequestDTO
   */
  restrictUserRoles?: Array<UserRoleDTO>;
}

/**
 * @export
 * @interface LoginResponseDTO
 */
export interface LoginResponseDTO {
  /**
   * @description The email address associated with the new account
   * @type {string}
   * @memberof LoginResponseDTO
   */
  emailAddress: string;
  /**
   * @description The two-factor authentication methods that are available for this account.
   * @type {Array<TwoFactorAuthDetailsDTO>}
   * @memberof LoginResponseDTO
   */
  methods?: Array<TwoFactorAuthDetailsDTO>;
  /**
   * @description The id of the new account
   * @type {string}
   * @memberof LoginResponseDTO
   */
  id: string;
  /**
   * @description The result of the login action. This field will indicate whether the caller needs to follow up with additional calls to trigger two-factor authentication communication and verification.
   * @type {AuthenticationResultDTO}
   * @memberof LoginResponseDTO
   */
  result: AuthenticationResultDTO;
  /**
   * @type {GetUserDataResponseDTO}
   * @memberof LoginResponseDTO
   */
  userData?: GetUserDataResponseDTO;
}

/**
 * @export
 * @interface LogoutResponseDTO
 */
export interface LogoutResponseDTO {
  /**
   * @description The url a client should redirect to after a logout
   * @type {string}
   * @memberof LogoutResponseDTO
   */
  postLogoutUrl?: string;
}

/**
 * @export
 * @interface MarkAppointmentAttendanceRequestDTO
 */
export interface MarkAppointmentAttendanceRequestDTO {
  /**
   * @description The appointment to mark
   * @type {string}
   * @memberof MarkAppointmentAttendanceRequestDTO
   */
  appointmentId: string;
  /**
   * @description Additional note about the appointment
   * @type {string}
   * @memberof MarkAppointmentAttendanceRequestDTO
   */
  note?: string;
}

/**
 * @export
 * @interface MarkCurbsideCanceledRequestDTO
 */
export interface MarkCurbsideCanceledRequestDTO {
  /**
   * @type {string}
   * @memberof MarkCurbsideCanceledRequestDTO
   */
  curbsideId: string;
}

/**
 * @export
 * @interface MarkCurbsideCompletedRequestDTO
 */
export interface MarkCurbsideCompletedRequestDTO {
  /**
   * @type {string}
   * @memberof MarkCurbsideCompletedRequestDTO
   */
  curbsideId: string;
}

/**
 * @export
 * @interface MarkCurbsideInProgressRequestDTO
 */
export interface MarkCurbsideInProgressRequestDTO {
  /**
   * @type {string}
   * @memberof MarkCurbsideInProgressRequestDTO
   */
  curbsideId: string;
}

/**
 * @export
 * @interface MarkMessagesReadRequestDTO
 */
export interface MarkMessagesReadRequestDTO {
  /**
   * @type {Array<string>}
   * @memberof MarkMessagesReadRequestDTO
   */
  messageIds: Array<string>;
}

/**
 * @export
 * @interface MarkPatientAsTestRequestDTO
 */
export interface MarkPatientAsTestRequestDTO {
  /**
   * @type {string}
   * @memberof MarkPatientAsTestRequestDTO
   */
  patientId: string;
  /**
   * @description An optional date override used for backfilling
   * @type {string}
   * @memberof MarkPatientAsTestRequestDTO
   */
  dateOverride?: string;
}

/**
 * @export
 * @interface MarkPatientIntakeAsPendingRequestDTO
 */
export interface MarkPatientIntakeAsPendingRequestDTO {
  /**
   * @type {string}
   * @memberof MarkPatientIntakeAsPendingRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface MarkPatientOptsInRequestDTO
 */
export interface MarkPatientOptsInRequestDTO {
  /**
   * @type {string}
   * @memberof MarkPatientOptsInRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface MarkProviderAsDuplicateRequestDTO
 */
export interface MarkProviderAsDuplicateRequestDTO {
  /**
   * @type {string}
   * @memberof MarkProviderAsDuplicateRequestDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface MarkProviderAsTestRequestDTO
 */
export interface MarkProviderAsTestRequestDTO {
  /**
   * @type {string}
   * @memberof MarkProviderAsTestRequestDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface MarkRecommendedPatientsForFutureContactRequestDTO
 */
export interface MarkRecommendedPatientsForFutureContactRequestDTO {
  /**
   * @type {string}
   * @memberof MarkRecommendedPatientsForFutureContactRequestDTO
   */
  practiceId?: string;
  /**
   * @type {Array<string>}
   * @memberof MarkRecommendedPatientsForFutureContactRequestDTO
   */
  recommendationIds: Array<string>;
}

/**
 * @export
 * @interface MarketConfigurationDTO
 */
export interface MarketConfigurationDTO {
  /**
   * @type {StateDTO}
   * @memberof MarketConfigurationDTO
   */
  state: StateDTO;
  /**
   * @type {MarketConfigurationPediatricConfigurationDTO}
   * @memberof MarketConfigurationDTO
   */
  pediatricConfiguration?: MarketConfigurationPediatricConfigurationDTO;
}

/**
 * @export
 * @interface MarketConfigurationPediatricConfigurationDTO
 */
export interface MarketConfigurationPediatricConfigurationDTO {
  /**
   * @type {number}
   * @memberof MarketConfigurationPediatricConfigurationDTO
   */
  minAge: number;
  /**
   * @type {number}
   * @memberof MarketConfigurationPediatricConfigurationDTO
   */
  maxAge: number;
  /**
   * @type {boolean}
   * @memberof MarketConfigurationPediatricConfigurationDTO
   */
  isEnabled?: boolean;
  /**
   * @type {Array<ActivationChannelDTO>}
   * @memberof MarketConfigurationPediatricConfigurationDTO
   */
  activationChannels?: Array<ActivationChannelDTO>;
}

/**
 * @export
 * @interface MatchListResponseDTO
 */
export interface MatchListResponseDTO {
  /**
   * @type {MatchListResponseMatchListDTO}
   * @memberof MatchListResponseDTO
   */
  matchList: MatchListResponseMatchListDTO;
  /**
   * @type {Array<PracticeDetailsForOpsDTO>}
   * @memberof MatchListResponseDTO
   */
  practices: Array<PracticeDetailsForOpsDTO>;
  /**
   * @type {Array<ProviderDetailsForOpsDTO>}
   * @memberof MatchListResponseDTO
   */
  providers: Array<ProviderDetailsForOpsDTO>;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof MatchListResponseDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
  /**
   * @type {Array<LocationForOpsDTO>}
   * @memberof MatchListResponseDTO
   */
  locations: Array<LocationForOpsDTO>;
  /**
   * @type {Array<ReferralDTO>}
   * @memberof MatchListResponseDTO
   */
  referrals: Array<ReferralDTO>;
  /**
   * @type {Array<string>}
   * @memberof MatchListResponseDTO
   */
  excludedPreferences?: Array<string>;
}

/**
 * @export
 * @interface MatchListResponseMatchListDTO
 */
export interface MatchListResponseMatchListDTO {
  /**
   * @type {string}
   * @memberof MatchListResponseMatchListDTO
   */
  id?: string;
  /**
   * @type {Array<MatchListResponsePracticeMatchDTO>}
   * @memberof MatchListResponseMatchListDTO
   */
  practiceMatches: Array<MatchListResponsePracticeMatchDTO>;
  /**
   * @type {boolean}
   * @memberof MatchListResponseMatchListDTO
   */
  isReferable?: boolean;
  /**
   * @type {boolean}
   * @memberof MatchListResponseMatchListDTO
   */
  isAutolaunched?: boolean;
}

/**
 * @export
 * @interface MatchListResponsePracticeMatchDTO
 */
export interface MatchListResponsePracticeMatchDTO {
  /**
   * @type {string}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  practiceId: string;
  /**
   * @type {string}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  closestLocationId?: string;
  /**
   * @type {DistanceDTO}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  distance?: DistanceDTO;
  /**
   * @type {number}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  score?: number;
  /**
   * @type {boolean}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  isRecommendedForAutoLaunch?: boolean;
  /**
   * @type {string}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  preferentialMatchRuleId?: string;
  /**
   * @type {boolean}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  isBoosted?: boolean;
  /**
   * @type {number}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  speedToCarePenalty?: number;
  /**
   * @type {Array<MatchListResponseProviderMatchDTO>}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  providerMatches: Array<MatchListResponseProviderMatchDTO>;
  /**
   * @type {boolean}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  isConsumed?: boolean;
  /**
   * @type {Array<PracticeMatchConsumedReasonDTO>}
   * @memberof MatchListResponsePracticeMatchDTO
   */
  consumedReasons?: Array<PracticeMatchConsumedReasonDTO>;
}

/**
 * @export
 * @interface MatchListResponseProviderMatchDTO
 */
export interface MatchListResponseProviderMatchDTO {
  /**
   * @type {string}
   * @memberof MatchListResponseProviderMatchDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof MatchListResponseProviderMatchDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface MessageDTO
 */
export interface MessageDTO {
  /**
   * @type {string}
   * @memberof MessageDTO
   */
  id: string;
  /**
   * @type {SenderDTO}
   * @memberof MessageDTO
   */
  sender: SenderDTO;
  /**
   * @description If deletedAt is non-null, this property will be omitted
   * @type {string}
   * @memberof MessageDTO
   */
  body?: string;
  /**
   * @type {string}
   * @memberof MessageDTO
   */
  sentAt: string;
  /**
   * @type {Array<MessageReceiptDTO>}
   * @memberof MessageDTO
   */
  receipts: Array<MessageReceiptDTO>;
  /**
   * @type {string}
   * @memberof MessageDTO
   */
  deletedAt?: string;
}

/**
 * @export
 * @interface MessageReceiptDTO
 */
export interface MessageReceiptDTO {
  /**
   * @type {RecipientDTO}
   * @memberof MessageReceiptDTO
   */
  recipient: RecipientDTO;
  /**
   * @type {string}
   * @memberof MessageReceiptDTO
   */
  readAt: string;
}

/**
 * @export
 * @interface MessageThreadSummaryDTO
 */
export interface MessageThreadSummaryDTO {
  /**
   * @type {string}
   * @memberof MessageThreadSummaryDTO
   */
  id: string;
  /**
   * @type {number}
   * @memberof MessageThreadSummaryDTO
   */
  messagesCount: number;
  /**
   * @type {number}
   * @memberof MessageThreadSummaryDTO
   */
  unreadMessagesCount: number;
}

/**
 * @export
 * @interface MhpPracticeDTO
 */
export interface MhpPracticeDTO {
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  healthSystemId?: string;
  /**
   * @type {Array<LocationDTO>}
   * @memberof MhpPracticeDTO
   */
  locations?: Array<LocationDTO>;
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  npi?: string;
  /**
   * @type {PracticeTypeDTO}
   * @memberof MhpPracticeDTO
   */
  type?: PracticeTypeDTO;
  /**
   * @type {Array<string>}
   * @memberof MhpPracticeDTO
   */
  providers?: Array<string>;
  /**
   * @type {QuartetRegionDTO}
   * @memberof MhpPracticeDTO
   */
  quartetRegion?: QuartetRegionDTO;
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  creatingProviderId?: string;
  /**
   * @type {BhpPracticeSmartMatchPreferencesDTO}
   * @memberof MhpPracticeDTO
   */
  bhpPracticeSmartMatchPreferences?: BhpPracticeSmartMatchPreferencesDTO;
  /**
   * @type {number}
   * @memberof MhpPracticeDTO
   */
  referralVolumeTarget?: number;
  /**
   * @type {ReferralVolumePreferenceDTO}
   * @memberof MhpPracticeDTO
   */
  referralVolumePreference: ReferralVolumePreferenceDTO;
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  email?: string;
  /**
   * @type {Array<ServiceFormatDTO>}
   * @memberof MhpPracticeDTO
   */
  serviceFormats?: Array<ServiceFormatDTO>;
  /**
   * @type {Array<InsurancePlanCountyRestrictionDTO>}
   * @memberof MhpPracticeDTO
   */
  insurancePlanCountyRestriction?: Array<InsurancePlanCountyRestrictionDTO>;
  /**
   * @type {string}
   * @memberof MhpPracticeDTO
   */
  description?: string;
  /**
   * @type {boolean}
   * @memberof MhpPracticeDTO
   */
  isValueBasedPartner?: boolean;
  /**
   * @type {ValueBasedProgramPartnerDTO}
   * @memberof MhpPracticeDTO
   */
  valueBasedProgramPartner?: ValueBasedProgramPartnerDTO;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof MhpPracticeDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
}

/**
 * @export
 * @interface MyStrengthRequestDTO
 */
export interface MyStrengthRequestDTO {
  /**
   * @description the ID of the patient
   * @type {string}
   * @memberof MyStrengthRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface MyStrengthResponseDTO
 */
export interface MyStrengthResponseDTO {
  /**
   * @type {boolean}
   * @memberof MyStrengthResponseDTO
   */
  isEligible?: boolean;
  /**
   * @type {string}
   * @memberof MyStrengthResponseDTO
   */
  myStrengthUrl?: string;
}

/**
 * @export
 * @interface NotificationBaseDTO
 */
export interface NotificationBaseDTO {
  /**
   * @type {string}
   * @memberof NotificationBaseDTO
   */
  id?: string;
  /**
   * @type {CareEventDTO}
   * @memberof NotificationBaseDTO
   */
  careEvent: CareEventDTO;
  /**
   * @type {NotificationTypeDTO}
   * @memberof NotificationBaseDTO
   */
  type: NotificationTypeDTO;
  /**
   * @type {NotificationStateDTO}
   * @memberof NotificationBaseDTO
   */
  status: NotificationStateDTO;
  /**
   * @type {string}
   * @memberof NotificationBaseDTO
   */
  instant: string;
  /**
   * @type {boolean}
   * @memberof NotificationBaseDTO
   */
  isAcknowledged?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum NotificationStateDTO {
  Acknowledged = 'Acknowledged',
  Following = 'Following'
}

/**
 * @export
 * @enum {string}
 */
export enum NotificationTypeDTO {
  CaseManager = 'Case Manager',
  Provider = 'Provider'
}

/**
 * @export
 * @enum {string}
 */
export enum OutOfScopeTypeDTO {
  Reactive = 'Reactive',
  SelfReferral = 'Self Referral',
  NoMatches = 'No Matches',
  MatchesExhaustedOrReferralDeclined = 'Matches Exhausted or Referral Declined',
  NoProviderSelected = 'No Provider Selected'
}

/**
 * @export
 * @interface OutcomeEntryDTO
 */
export interface OutcomeEntryDTO {
  /**
   * @type {string}
   * @memberof OutcomeEntryDTO
   */
  question: string;
  /**
   * @type {string}
   * @memberof OutcomeEntryDTO
   */
  answer: string;
}

/**
 * @export
 * @interface PageDTO
 */
export interface PageDTO {
  /**
   * @description collection that paged
   * @type {string}
   * @memberof PageDTO
   */
  pagedCollection: string;
  /**
   * @description total number of items in a resultset
   * @type {number}
   * @memberof PageDTO
   */
  totalCount: number;
  /**
   * @description total number of pages in a resultset
   * @type {number}
   * @memberof PageDTO
   */
  totalPages: number;
  /**
   * @description size of page
   * @type {number}
   * @memberof PageDTO
   */
  size: number;
  /**
   * @description number of items present in this response
   * @type {number}
   * @memberof PageDTO
   */
  count: number;
  /**
   * @description current page, start from 1
   * @type {number}
   * @memberof PageDTO
   */
  currentPage: number;
}

/**
 * @export
 * @interface PatientActivationDetailsDTO
 */
export interface PatientActivationDetailsDTO {
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  date?: string;
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  reason?: string;
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  referrerId?: string;
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  referrerFirstName?: string;
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  referrerLastName?: string;
  /**
   * @type {ReferrerTypeDTO}
   * @memberof PatientActivationDetailsDTO
   */
  referrerType?: ReferrerTypeDTO;
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  practiceOrGroupId?: string;
  /**
   * @type {string}
   * @memberof PatientActivationDetailsDTO
   */
  practiceOrGroupName?: string;
}

/**
 * @export
 * @interface PatientAlternativeContactDTO
 */
export interface PatientAlternativeContactDTO {
  /**
   * @type {string}
   * @memberof PatientAlternativeContactDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof PatientAlternativeContactDTO
   */
  lastName: string;
  /**
   * @type {RelationshipDTO}
   * @memberof PatientAlternativeContactDTO
   */
  relationship: RelationshipDTO;
  /**
   * @type {string}
   * @memberof PatientAlternativeContactDTO
   */
  phoneNumber?: string;
  /**
   * @type {PatientContactPhoneNumberDTO}
   * @memberof PatientAlternativeContactDTO
   */
  contactPhoneNumber?: PatientContactPhoneNumberDTO;
  /**
   * @type {EmailDTO}
   * @memberof PatientAlternativeContactDTO
   */
  contactEmail?: EmailDTO;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof PatientAlternativeContactDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @type {string}
   * @memberof PatientAlternativeContactDTO
   */
  hipaaConsentExpiration?: string;
  /**
   * @type {PatientAlternativeContactTypeDTO}
   * @memberof PatientAlternativeContactDTO
   */
  contactType?: PatientAlternativeContactTypeDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientAlternativeContactTypeDTO {
  HIPAA = 'HIPAA',
  LegalGuardian = 'Legal Guardian',
  ConsentToCoordinate = 'Consent to Coordinate',
  Other = 'Other'
}

/**
 * @export
 * @enum {string}
 */
export enum PatientAppointmentFeedbackAnswerDTO {
  Bad = 'Bad',
  NotGood = 'Not Good',
  Average = 'Average',
  Good = 'Good',
  VeryGood = 'Very Good'
}

/**
 * @export
 * @interface PatientAppointmentFeedbackResponseDTO
 */
export interface PatientAppointmentFeedbackResponseDTO {
  /**
   * @type {string}
   * @memberof PatientAppointmentFeedbackResponseDTO
   */
  question?: string;
  /**
   * @type {PatientAppointmentFeedbackAnswerDTO}
   * @memberof PatientAppointmentFeedbackResponseDTO
   */
  answer?: PatientAppointmentFeedbackAnswerDTO;
}

/**
 * @export
 * @interface PatientBaseDTO
 */
export interface PatientBaseDTO {
  /**
   * @type {string}
   * @memberof PatientBaseDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof PatientBaseDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PatientBaseDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof PatientBaseDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof PatientBaseDTO
   */
  suffix?: string;
  /**
   * @type {string}
   * @memberof PatientBaseDTO
   */
  dateOfBirth?: string;
  /**
   * @type {GenderDTO}
   * @memberof PatientBaseDTO
   */
  gender?: GenderDTO;
}

/**
 * @export
 * @interface PatientConcernDTO
 */
export interface PatientConcernDTO {
  /**
   * @type {boolean}
   * @memberof PatientConcernDTO
   */
  isPrimary?: boolean;
  /**
   * @type {string}
   * @memberof PatientConcernDTO
   */
  concern: string;
}

/**
 * @export
 * @interface PatientConsentsToResearchRequestDTO
 */
export interface PatientConsentsToResearchRequestDTO {
  /**
   * @type {string}
   * @memberof PatientConsentsToResearchRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface PatientContactInfoRequestDTO
 */
export interface PatientContactInfoRequestDTO {
  /**
   * @type {string}
   * @memberof PatientContactInfoRequestDTO
   */
  id?: string;
  /**
   * @type {PatientContactInfoRequestStatusDTO}
   * @memberof PatientContactInfoRequestDTO
   */
  status?: PatientContactInfoRequestStatusDTO;
  /**
   * @type {boolean}
   * @memberof PatientContactInfoRequestDTO
   */
  didPhoneNumbersChange?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientContactInfoRequestDTO
   */
  didAlternateContactsChange?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientContactInfoRequestDTO
   */
  didSmsConsentChange?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientContactInfoRequestDTO
   */
  didEmailChange?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientContactInfoRequestStatusDTO {
  REQUESTED = 'REQUESTED',
  COMPLETED = 'COMPLETED'
}

/**
 * @export
 * @interface PatientDeclinesCareRequestDTO
 */
export interface PatientDeclinesCareRequestDTO {
  /**
   * @type {string}
   * @memberof PatientDeclinesCareRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface PatientDetailsForOpsDTO
 */
export interface PatientDetailsForOpsDTO {
  /**
   * @type {string}
   * @memberof PatientDetailsForOpsDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PatientDetailsForOpsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PatientDetailsForOpsDTO
   */
  lastName?: string;
  /**
   * @type {GenderDTO}
   * @memberof PatientDetailsForOpsDTO
   */
  gender?: GenderDTO;
  /**
   * @type {string}
   * @memberof PatientDetailsForOpsDTO
   */
  dateOfBirth?: string;
  /**
   * @type {PatientSegmentDTO}
   * @memberof PatientDetailsForOpsDTO
   */
  patientSegment?: PatientSegmentDTO;
  /**
   * @type {PatientNeedsDTO}
   * @memberof PatientDetailsForOpsDTO
   */
  patientNeeds?: PatientNeedsDTO;
  /**
   * @type {PatientSmartMatchPreferencesDTO}
   * @memberof PatientDetailsForOpsDTO
   */
  smartMatchPreferences?: PatientSmartMatchPreferencesDTO;
  /**
   * @type {AddressWithGeocodeDataDTO}
   * @memberof PatientDetailsForOpsDTO
   */
  address?: AddressWithGeocodeDataDTO;
  /**
   * @type {Array<InsurancePolicyDetailsDTO>}
   * @memberof PatientDetailsForOpsDTO
   */
  insurancePolicies: Array<InsurancePolicyDetailsDTO>;
}

/**
 * @export
 * @interface PatientDetectionForMhpRequestDTO
 */
export interface PatientDetectionForMhpRequestDTO {
  /**
   * @type {string}
   * @memberof PatientDetectionForMhpRequestDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PatientDetectionForMhpRequestDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof PatientDetectionForMhpRequestDTO
   */
  dateOfBirth?: string;
  /**
   * @type {string}
   * @memberof PatientDetectionForMhpRequestDTO
   */
  zipCode?: string;
}

/**
 * @export
 * @interface PatientDetectionForMhpResponseDTO
 */
export interface PatientDetectionForMhpResponseDTO {
  /**
   * @type {string}
   * @memberof PatientDetectionForMhpResponseDTO
   */
  patientId?: string;
}

/**
 * @export
 * @interface PatientEntityResolvedInsuranceDTO
 */
export interface PatientEntityResolvedInsuranceDTO {
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  score?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  customer?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insuranceCarrier?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insuranceCategory?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insuranceSubcategory?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insurancePlanType?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insurancePlanId?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insuranceMemberId?: string;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  insuranceGroupId?: string;
  /**
   * @type {boolean}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  inScope?: boolean;
  /**
   * @type {string}
   * @memberof PatientEntityResolvedInsuranceDTO
   */
  patientIntakeId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientExternalIdTypeDTO {
  MRN = 'MRN',
  EnterpriseID = 'Enterprise ID',
  SHEPTMRN = 'SHEPTMRN',
  QuartetHL7ID = 'Quartet HL7 ID',
  MemberEpi = 'Member Epi',
  ExternalReferringEmail = 'External Referring Email',
  ExternalReferralId = 'External Referral Id',
  ServicingProviderMRN = 'Servicing Provider MRN',
  NeuroflowPatientId = 'Neuroflow Patient Id'
}

/**
 * @export
 * @enum {string}
 */
export enum PatientFeatureTypeDTO {
  Ccbt = 'Ccbt',
  Mindfulness = 'Mindfulness',
  Therapy = 'Therapy',
  Goals = 'Goals',
  SymptomEducation = 'Symptom Education'
}

/**
 * @export
 * @interface PatientInsightsDTO
 */
export interface PatientInsightsDTO {
  /**
   * @description The total paid amount on all claims for which there is a BH indication on the diagnosis or drug.
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  bhPaid?: number;
  /**
   * @description The overall clinical needs score given to this insight. When given a list of insights for patient(s), the higher the score the more important these insights are and more important we get this patient care.
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  clinicalNeedScaleV1?: number;
  /**
   * @description The summary of all clinical needs.
   * @type {string}
   * @memberof PatientInsightsDTO
   */
  clinicalNeedV1Description?: string;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  cntBh?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  cntBhRx?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  cntBhp?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  cntBhpMed?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  erVisits?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  inpatientAdmissions?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  ipAdmits365d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  ipAdmits90d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  ipAdmitsBh365d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  ipAdmitsBh90d?: number;
  /**
   * @description Whether the member is flagged as having a BH condition based on 1 or more of the above flags.
   * @type {boolean}
   * @memberof PatientInsightsDTO
   */
  isBhAll?: boolean;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  opVisitErBhCnt365d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  opVisitErBhCnt90d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  opVisitErCnt365d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  opVisitErCnt90d?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  prescriptions?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  psychiatricErVisits?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  psychiatricInpatientAdmissions?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  psychiatricPrescriptions?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  psychiatricSpecialistVisits?: number;
  /**
   * @type {number}
   * @memberof PatientInsightsDTO
   */
  specialistVisits?: number;
  /**
   * @type {Array<string>}
   * @memberof PatientInsightsDTO
   */
  mentalHealthConditions?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof PatientInsightsDTO
   */
  moreConditions?: Array<string>;
  /**
   * @type {boolean}
   * @memberof PatientInsightsDTO
   */
  caUndertreated?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientInsightsDTO
   */
  caUndiagnosed?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientInsightsDTO
   */
  sudUndertreated?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientInsightsDTO
   */
  sudUndiagnosed?: boolean;
  /**
   * @description The rationale(s) attached to this insight, sorted in order of highest to least importance.
   * @type {Array<RationaleDTO>}
   * @memberof PatientInsightsDTO
   */
  rationales?: Array<RationaleDTO>;
}

/**
 * @export
 * @interface PatientIntakeDTO
 */
export interface PatientIntakeDTO {
  /**
   * @type {string}
   * @memberof PatientIntakeDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PatientIntakeDTO
   */
  patientId: string;
  /**
   * @description The referring PCP, if the intake was initiated by a PCP
   * @type {string}
   * @memberof PatientIntakeDTO
   */
  pcpId?: string;
  /**
   * @description The referring case manager, if the intake was initiated by a case manager
   * @type {string}
   * @memberof PatientIntakeDTO
   */
  caseManagerId?: string;
  /**
   * @description The PCP's practice when referring was initiated
   * @type {string}
   * @memberof PatientIntakeDTO
   */
  practiceId?: string;
  /**
   * @description If crisis is likely, according to DsInsights
   * @type {boolean}
   * @memberof PatientIntakeDTO
   */
  isCrisis: boolean;
  /**
   * @description likelihood patient is experiencing crisis, determined from referral note, by DsInsights
   * @type {number}
   * @memberof PatientIntakeDTO
   */
  crisisConfidence: number;
  /**
   * @description Triggers a dedicated Care Navigation workflow if true
   * @type {boolean}
   * @memberof PatientIntakeDTO
   */
  requiresCrisisAction: boolean;
  /**
   * @type {ActivationChannelDTO}
   * @memberof PatientIntakeDTO
   */
  channel: ActivationChannelDTO;
  /**
   * @type {PatientNeedsDTO}
   * @memberof PatientIntakeDTO
   */
  patientNeeds: PatientNeedsDTO;
  /**
   * @type {string}
   * @memberof PatientIntakeDTO
   */
  intakeReason?: string;
  /**
   * @type {ServicePathDTO}
   * @memberof PatientIntakeDTO
   */
  servicePath?: ServicePathDTO;
  /**
   * @type {ReactiveWorkflowTypeDTO}
   * @memberof PatientIntakeDTO
   */
  reactiveWorkflowType?: ReactiveWorkflowTypeDTO;
}

/**
 * @export
 * @interface PatientIntakeResponseDTO
 */
export interface PatientIntakeResponseDTO {
  /**
   * @type {PatientIntakeDTO}
   * @memberof PatientIntakeResponseDTO
   */
  patientIntake: PatientIntakeDTO;
  /**
   * @type {CareEventDTO}
   * @memberof PatientIntakeResponseDTO
   */
  careEvent?: CareEventDTO;
  /**
   * @type {string}
   * @memberof PatientIntakeResponseDTO
   */
  referringPracticeName?: string;
  /**
   * @type {string}
   * @memberof PatientIntakeResponseDTO
   */
  referringProviderName?: string;
  /**
   * @type {string}
   * @memberof PatientIntakeResponseDTO
   */
  referringProviderPhoneNumber?: string;
}

/**
 * @export
 * @interface PatientNeedsDTO
 */
export interface PatientNeedsDTO {
  /**
   * @type {boolean}
   * @memberof PatientNeedsDTO
   */
  includesSevere: boolean;
  /**
   * @type {boolean}
   * @memberof PatientNeedsDTO
   */
  includesSubstanceAbuse: boolean;
  /**
   * @type {boolean}
   * @memberof PatientNeedsDTO
   */
  includesMedication: boolean;
  /**
   * @type {boolean}
   * @memberof PatientNeedsDTO
   */
  includesGeneral?: boolean;
}

/**
 * @export
 * @interface PatientPreferencesDTO
 */
export interface PatientPreferencesDTO {
  /**
   * @type {ActivationChannelDTO}
   * @memberof PatientPreferencesDTO
   */
  activationChannel?: ActivationChannelDTO;
  /**
   * @type {Array<EmergencyContactDTO>}
   * @memberof PatientPreferencesDTO
   */
  emergencyContacts?: Array<EmergencyContactDTO>;
  /**
   * @type {PatientReferralChannelDTO}
   * @memberof PatientPreferencesDTO
   */
  patientReferralChannel?: PatientReferralChannelDTO;
  /**
   * @type {boolean}
   * @memberof PatientPreferencesDTO
   */
  optedInForResearch?: boolean;
  /**
   * @type {ResearchConsentDTO}
   * @memberof PatientPreferencesDTO
   */
  researchConsent?: ResearchConsentDTO;
  /**
   * @type {PatientSegmentDTO}
   * @memberof PatientPreferencesDTO
   */
  patientSegment?: PatientSegmentDTO;
  /**
   * @type {PatientNeedsDTO}
   * @memberof PatientPreferencesDTO
   */
  patientNeeds?: PatientNeedsDTO;
  /**
   * @type {boolean}
   * @memberof PatientPreferencesDTO
   */
  hasUnsureNeeds?: boolean;
  /**
   * @type {Array<TimeOfDayDTO>}
   * @memberof PatientPreferencesDTO
   */
  preferredContactTimes?: Array<TimeOfDayDTO>;
}

/**
 * @export
 * @interface PatientQuartetStatusDTO
 */
export interface PatientQuartetStatusDTO {
  /**
   * @type {string}
   * @memberof PatientQuartetStatusDTO
   */
  date?: string;
  /**
   * @type {PatientStatusInQuartetDTO}
   * @memberof PatientQuartetStatusDTO
   */
  state?: PatientStatusInQuartetDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientReferralChannelDTO {
  Doctor = 'Doctor',
  Other = 'Other',
  Employer = 'Employer'
}

/**
 * @export
 * @interface PatientReferralFeedbackDTO
 */
export interface PatientReferralFeedbackDTO {
  /**
   * @type {string}
   * @memberof PatientReferralFeedbackDTO
   */
  referralId: string;
  /**
   * @type {Array<PatientRejectBhpReasonDTO>}
   * @memberof PatientReferralFeedbackDTO
   */
  rejectBhpReasons: Array<PatientRejectBhpReasonDTO>;
  /**
   * @type {string}
   * @memberof PatientReferralFeedbackDTO
   */
  rejectBhpFreeTextReason?: string;
}

/**
 * @export
 * @interface PatientRegistersResponseDTO
 */
export interface PatientRegistersResponseDTO {
  /**
   * @type {number}
   * @memberof PatientRegistersResponseDTO
   */
  customerServiceCode?: number;
  /**
   * @type {boolean}
   * @memberof PatientRegistersResponseDTO
   */
  codeApplicable?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientRegistersResponseDTO
   */
  shouldRedirect?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientRegistersResponseDTO
   */
  newAccountCreated?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientRejectBhpReasonDTO {
  DistanceTooFar = 'Distance Too Far',
  InconvenientOfficeLocation = 'Inconvenient Office Location',
  BhpDoesNotMatchPreferences = 'Bhp Does Not Match Preferences',
  BhpPoorPersonalityMatch = 'Bhp Poor Personality Match',
  NotSpecified = 'Not Specified',
  Other = 'Other'
}

/**
 * @export
 * @interface PatientRematchRequestDTO
 */
export interface PatientRematchRequestDTO {
  /**
   * @type {string}
   * @memberof PatientRematchRequestDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PatientRematchRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof PatientRematchRequestDTO
   */
  rejectedReferralId: string;
  /**
   * @type {Array<PatientRematchRequestReasonDTO>}
   * @memberof PatientRematchRequestDTO
   */
  reasons: Array<PatientRematchRequestReasonDTO>;
  /**
   * @type {string}
   * @memberof PatientRematchRequestDTO
   */
  freeTextReason?: string;
  /**
   * @type {PatientRematchRequestStatusDTO}
   * @memberof PatientRematchRequestDTO
   */
  status: PatientRematchRequestStatusDTO;
  /**
   * @type {boolean}
   * @memberof PatientRematchRequestDTO
   */
  isImmediateRequest: boolean;
  /**
   * @type {string}
   * @memberof PatientRematchRequestDTO
   */
  dateToRematch: string;
  /**
   * @type {string}
   * @memberof PatientRematchRequestDTO
   */
  rematchedReferralId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientRematchRequestReasonDTO {
  DistanceTooFar = 'Distance Too Far',
  InconvenientOfficeLocation = 'Inconvenient Office Location',
  BhpDoesNotMatchPreferences = 'Bhp Does Not Match Preferences',
  BhpPoorPersonalityMatch = 'Bhp Poor Personality Match',
  Other = 'Other'
}

/**
 * @export
 * @enum {string}
 */
export enum PatientRematchRequestStatusDTO {
  Requested = 'Requested',
  Completed = 'Completed',
  Canceled = 'Canceled'
}

/**
 * @export
 * @interface PatientRequestsRematchRequestDTO
 */
export interface PatientRequestsRematchRequestDTO {
  /**
   * @type {string}
   * @memberof PatientRequestsRematchRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof PatientRequestsRematchRequestDTO
   */
  rejectedReferralId: string;
  /**
   * @description Reasons why the patient wants a different bhp
   * @type {Array<PatientRematchRequestReasonDTO>}
   * @memberof PatientRequestsRematchRequestDTO
   */
  reasons?: Array<PatientRematchRequestReasonDTO>;
  /**
   * @description An optional free-text field for when patient selects 'Other' as one of the rematch reasons
   * @type {string}
   * @memberof PatientRequestsRematchRequestDTO
   */
  freeTextReason?: string;
  /**
   * @description Whether to process the rematch immediately or at a future date
   * @type {boolean}
   * @memberof PatientRequestsRematchRequestDTO
   */
  isImmediateRequest: boolean;
  /**
   * @description Approximate date patient will be processed for rematching
   * @type {string}
   * @memberof PatientRequestsRematchRequestDTO
   */
  dateToRematch?: string;
}

/**
 * @export
 * @interface PatientScopeRequestDTO
 */
export interface PatientScopeRequestDTO {
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  lastName: string;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  preferredName?: string;
  /**
   * @description Patient's date of birth (format yyyy-MM-DD)
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  dateOfBirth: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof PatientScopeRequestDTO
   */
  gender?: GenderDTO;
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof PatientScopeRequestDTO
   */
  address: AddressDTO;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof PatientScopeRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @description Patient's phone numbers (must be exactly one where isPrimary = true)
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof PatientScopeRequestDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof PatientScopeRequestDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @description the ID of the patient
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  patientId?: string;
  /**
   * @type {boolean}
   * @memberof PatientScopeRequestDTO
   */
  isSeekingCareForSelf?: boolean;
  /**
   * @description The id of the practice from which the patient is being referred
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  practiceId?: string;
  /**
   * @description The id of the pcp referring the patient
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  pcpId?: string;
  /**
   * @description The id of the plan case manager referring the patient
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  caseManagerId?: string;
  /**
   * @type {ActivationChannelDTO}
   * @memberof PatientScopeRequestDTO
   */
  activationChannel?: ActivationChannelDTO;
  /**
   * @type {CreateReactiveReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof PatientScopeRequestDTO
   */
  primaryInsurancePolicy?: CreateReactiveReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @description Optionally, the patient's secondary insurance policy
   * @type {BaseInsurancePolicyDTO}
   * @memberof PatientScopeRequestDTO
   */
  secondaryInsurancePolicy?: BaseInsurancePolicyDTO;
  /**
   * @description Type of oos patient for custom comms
   * @type {OutOfScopeTypeDTO}
   * @memberof PatientScopeRequestDTO
   */
  outOfScopeType?: OutOfScopeTypeDTO;
  /**
   * @description Optional health system ID
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  healthSystemId?: string;
  /**
   * @description Optional Medium
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  medium?: string;
  /**
   * @description Optional Campaign
   * @type {string}
   * @memberof PatientScopeRequestDTO
   */
  campaign?: string;
}

/**
 * @export
 * @interface PatientScopeResponseDTO
 */
export interface PatientScopeResponseDTO {
  /**
   * @description The id of this patient
   * @type {string}
   * @memberof PatientScopeResponseDTO
   */
  patientId?: string;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isPatientInScope?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isAgeEligible?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isMarketConfiguration?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isEligibleForAffiliateResources?: boolean;
  /**
   * @type {string}
   * @memberof PatientScopeResponseDTO
   */
  patientGroupAge?: string;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isInsuranceEligible?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isHorizonNonAdultPatient?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientScopeResponseDTO
   */
  isNoInsuranceCarrier?: boolean;
  /**
   * @type {StateDTO}
   * @memberof PatientScopeResponseDTO
   */
  state?: StateDTO;
  /**
   * @type {PatientScopeResponsePrimaryInsurancePolicyDTO}
   * @memberof PatientScopeResponseDTO
   */
  primaryInsurancePolicy?: PatientScopeResponsePrimaryInsurancePolicyDTO;
  /**
   * @type {string}
   * @memberof PatientScopeResponseDTO
   */
  pcpId?: string;
  /**
   * @type {RedirectDTO}
   * @memberof PatientScopeResponseDTO
   */
  redirect?: RedirectDTO;
}

/**
 * @description The patient's primary insurance policy
 * @export
 * @interface PatientScopeResponsePrimaryInsurancePolicyDTO
 */
export interface PatientScopeResponsePrimaryInsurancePolicyDTO {
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  insurancePlanId?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  memberId?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  cardIds?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  carrier?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  category?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  groupId?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  plan?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  planType?: string;
  /**
   * @type {string}
   * @memberof PatientScopeResponsePrimaryInsurancePolicyDTO
   */
  subCategory?: string;
}

/**
 * @export
 * @interface PatientSecondPartyEventDTO
 */
export interface PatientSecondPartyEventDTO {
  /**
   * @type {string}
   * @memberof PatientSecondPartyEventDTO
   */
  dateFrom?: string;
  /**
   * @type {string}
   * @memberof PatientSecondPartyEventDTO
   */
  dateTo?: string;
  /**
   * @type {ClaimsEventTypeDTO}
   * @memberof PatientSecondPartyEventDTO
   */
  eventType?: ClaimsEventTypeDTO;
  /**
   * @type {string}
   * @memberof PatientSecondPartyEventDTO
   */
  primaryDiagnoses?: string;
  /**
   * @type {string}
   * @memberof PatientSecondPartyEventDTO
   */
  providerName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientSegmentDTO {
  One = 'One',
  Two = 'Two',
  Three = 'Three',
  Four = 'Four'
}

/**
 * @export
 * @enum {string}
 */
export enum PatientServiceTypeDTO {
  EvaluationDocumentation = 'Evaluation/Documentation',
  IndividualTalkTherapy = 'Individual/Talk Therapy',
  CouplesFamilyTherapy = 'Couples/Family Therapy',
  MedicationManagement = 'Medication Management',
  InpatientTreatment = 'Inpatient Treatment',
  OutpatientTreatment = 'Outpatient Treatment',
  MedicationAssistedTherapy = 'Medication Assisted Therapy',
  IntensiveOutpatientProgram = 'Intensive Outpatient Program'
}

/**
 * @export
 * @interface PatientSmartMatchPreferencesDTO
 */
export interface PatientSmartMatchPreferencesDTO {
  /**
   * @type {TransportationModeDTO}
   * @memberof PatientSmartMatchPreferencesDTO
   */
  travelPreference?: TransportationModeDTO;
  /**
   * @type {GenderDTO}
   * @memberof PatientSmartMatchPreferencesDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @type {LanguageDTO}
   * @memberof PatientSmartMatchPreferencesDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @type {TeleservicesPreferenceDTO}
   * @memberof PatientSmartMatchPreferencesDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @type {string}
   * @memberof PatientSmartMatchPreferencesDTO
   */
  preferredAppointmentTimes?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientStatusInQuartetDTO {
  AcceptedTOSVersion100 = 'Accepted TOS Version 1.0.0',
  ApprovedAsRecommendedPatient = 'Approved As Recommended Patient',
  AwaitingPracticeContact = 'Awaiting Practice Contact',
  ConnectedCareDeferred = 'Connected Care Deferred',
  DismissedByProvider = 'Dismissed By Provider',
  Duplicate = 'Duplicate',
  OptedIn = 'Opted In',
  PatientDeclinedExternallyInCare = 'Patient Declined - Externally In Care',
  PatientIntakeCompleted = 'Patient Intake Completed',
  PatientOutOfScope = 'Patient Out Of Scope',
  PatientPendingRegistration = 'Patient Pending Registration',
  PatientRejected = 'Patient Rejected',
  PatientUnreachable = 'Patient Unreachable',
  PendingOptIn = 'Pending Opt In',
  PendingPatientIntakeCompletion = 'Pending Patient Intake Completion',
  PendingSelfServiceProviderSelection = 'Pending Self Service Provider Selection',
  QuartetDeclined = 'Quartet Declined',
  ReferredIntoQuartet = 'Referred Into Quartet',
  ReferredOutside = 'Referred Outside',
  SelfServiceProviderSelected = 'Self Service Provider Selected',
  SubmittedForCurbsideConsult = 'Submitted For Curbside Consult',
  Test = 'Test'
}

/**
 * @export
 * @interface PatientSubmitAssessmentRequestDTO
 */
export interface PatientSubmitAssessmentRequestDTO {
  /**
   * @type {string}
   * @memberof PatientSubmitAssessmentRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof PatientSubmitAssessmentRequestDTO
   */
  assessmentId?: string;
  /**
   * @type {Array<AssessmentQuestionResponseDTO>}
   * @memberof PatientSubmitAssessmentRequestDTO
   */
  responses?: Array<AssessmentQuestionResponseDTO>;
  /**
   * @type {string}
   * @memberof PatientSubmitAssessmentRequestDTO
   */
  assessmentResultId?: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof PatientSubmitAssessmentRequestDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @type {Array<AssessmentModuleWithAnswersDTO>}
   * @memberof PatientSubmitAssessmentRequestDTO
   */
  assessmentModulesWithAnswers: Array<AssessmentModuleWithAnswersDTO>;
}

/**
 * @export
 * @interface PatientWithExternalIdsDTO
 */
export interface PatientWithExternalIdsDTO {
  /**
   * @type {PatientDTO}
   * @memberof PatientWithExternalIdsDTO
   */
  patient: PatientDTO;
  /**
   * @type {Array<PatientExternalIdDTO>}
   * @memberof PatientWithExternalIdsDTO
   */
  externalIds?: Array<PatientExternalIdDTO>;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof PatientWithExternalIdsDTO
   */
  insurancePlans?: Array<InsurancePlanDTO>;
}

/**
 * @export
 * @interface PatientWithInsurancePlansDTO
 */
export interface PatientWithInsurancePlansDTO {
  /**
   * @type {PatientDTO}
   * @memberof PatientWithInsurancePlansDTO
   */
  patient: PatientDTO;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof PatientWithInsurancePlansDTO
   */
  insurancePlans?: Array<InsurancePlanDTO>;
}

/**
 * @export
 * @interface PatientsByAccountDTO
 */
export interface PatientsByAccountDTO {
  /**
   * @type {Array<PatientDTO>}
   * @memberof PatientsByAccountDTO
   */
  patients: Array<PatientDTO>;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof PatientsByAccountDTO
   */
  insurancePlans?: Array<InsurancePlanDTO>;
}

/**
 * @export
 * @interface PatientsWithMetadataResponseDTO
 */
export interface PatientsWithMetadataResponseDTO {
  /**
   * @type {Array<PatientWithMetadataDTO>}
   * @memberof PatientsWithMetadataResponseDTO
   */
  patients: Array<PatientWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof PatientsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface PauseBhpAcceptedInsurancePlanRequestDTO
 */
export interface PauseBhpAcceptedInsurancePlanRequestDTO {
  /**
   * @type {string}
   * @memberof PauseBhpAcceptedInsurancePlanRequestDTO
   */
  bhpId: string;
  /**
   * @type {string}
   * @memberof PauseBhpAcceptedInsurancePlanRequestDTO
   */
  insurancePlanId: string;
  /**
   * @type {string}
   * @memberof PauseBhpAcceptedInsurancePlanRequestDTO
   */
  pauseUntilDate: string;
}

/**
 * @export
 * @interface PauseReferralsForPracticeRequestDTO
 */
export interface PauseReferralsForPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof PauseReferralsForPracticeRequestDTO
   */
  practiceId: string;
  /**
   * @type {string}
   * @memberof PauseReferralsForPracticeRequestDTO
   */
  pauseFromDate: string;
  /**
   * @type {string}
   * @memberof PauseReferralsForPracticeRequestDTO
   */
  pauseUntilDate: string;
}

/**
 * @export
 * @interface PauseReferralsRequestDTO
 */
export interface PauseReferralsRequestDTO {
  /**
   * @description The date at which this provider will stop receiving referrals
   * @type {string}
   * @memberof PauseReferralsRequestDTO
   */
  pauseUntilDate: string;
  /**
   * @description The ID of the provider who will stop receiving referrals
   * @type {string}
   * @memberof PauseReferralsRequestDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface PcpDTO
 */
export interface PcpDTO {
  /**
   * @type {Array<string>}
   * @memberof PcpDTO
   */
  associatedPractices?: Array<string>;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof PcpDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @type {string}
   * @memberof PcpDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof PcpDTO
   */
  emails: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof PcpDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PcpDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof PcpDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PcpDTO
   */
  npi?: string;
  /**
   * @type {boolean}
   * @memberof PcpDTO
   */
  isHeadlessProvider?: boolean;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof PcpDTO
   */
  practiceTitle: PcpPracticeTitleDTO;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof PcpDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {Array<ProviderStatusInQuartetDTO>}
   * @memberof PcpDTO
   */
  statusInQuartet: Array<ProviderStatusInQuartetDTO>;
  /**
   * @type {number}
   * @memberof PcpDTO
   */
  minimumReactiveReferralAge?: number;
  /**
   * @type {number}
   * @memberof PcpDTO
   */
  minimumCurbsideAge?: number;
}

/**
 * @export
 * @interface PcpDashboardResponseDTO
 */
export interface PcpDashboardResponseDTO {
  /**
   * @type {PageDTO}
   * @memberof PcpDashboardResponseDTO
   */
  page: PageDTO;
  /**
   * @type {Array<PcpDashboardResponsePatientDTO>}
   * @memberof PcpDashboardResponseDTO
   */
  patients: Array<PcpDashboardResponsePatientDTO>;
}

/**
 * @export
 * @interface PcpDashboardResponsePatientDTO
 */
export interface PcpDashboardResponsePatientDTO {
  /**
   * @type {string}
   * @memberof PcpDashboardResponsePatientDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof PcpDashboardResponsePatientDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PcpDashboardResponsePatientDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof PcpDashboardResponsePatientDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof PcpDashboardResponsePatientDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof PcpDashboardResponsePatientDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {DisplayProviderDTO}
   * @memberof PcpDashboardResponsePatientDTO
   */
  provider?: DisplayProviderDTO;
  /**
   * @type {DisplayCareEventDTO}
   * @memberof PcpDashboardResponsePatientDTO
   */
  latestCareEvent?: DisplayCareEventDTO;
}

/**
 * @export
 * @interface PcpForPracticeResponseDTO
 */
export interface PcpForPracticeResponseDTO {
  /**
   * @description All states for this provider in this practice.
   * @type {Array<ProviderStateDTO>}
   * @memberof PcpForPracticeResponseDTO
   */
  states?: Array<ProviderStateDTO>;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof PcpForPracticeResponseDTO
   */
  practiceTitle?: PcpPracticeTitleDTO;
  /**
   * @type {string}
   * @memberof PcpForPracticeResponseDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PcpForPracticeResponseDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof PcpForPracticeResponseDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof PcpForPracticeResponseDTO
   */
  primaryEmail?: string;
  /**
   * @type {string}
   * @memberof PcpForPracticeResponseDTO
   */
  primaryPhone?: string;
  /**
   * @type {string}
   * @memberof PcpForPracticeResponseDTO
   */
  npi?: string;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof PcpForPracticeResponseDTO
   */
  profilePermissions?: ProviderProfilePermissionsDTO;
  /**
   * @type {PrimaryCarePracticeMembershipStatusDTO}
   * @memberof PcpForPracticeResponseDTO
   */
  practiceMembershipStatus: PrimaryCarePracticeMembershipStatusDTO;
  /**
   * @type {Array<string>}
   * @memberof PcpForPracticeResponseDTO
   */
  practiceIds: Array<string>;
  /**
   * @type {boolean}
   * @memberof PcpForPracticeResponseDTO
   */
  isHeadlessProvider?: boolean;
  /**
   * @type {boolean}
   * @memberof PcpForPracticeResponseDTO
   */
  isAccountActive?: boolean;
}

/**
 * @export
 * @interface PcpPracticeMembershipDTO
 */
export interface PcpPracticeMembershipDTO {
  /**
   * @type {string}
   * @memberof PcpPracticeMembershipDTO
   */
  practiceId: string;
  /**
   * @type {boolean}
   * @memberof PcpPracticeMembershipDTO
   */
  isActive: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum PcpPracticeTitleDTO {
  PrimaryCarePhysician = 'Primary Care Physician',
  OfficeManager = 'Office Manager',
  CaseManager = 'Case Manager',
  SocialWorker = 'Social Worker',
  RegisteredNurse = 'Registered Nurse',
  LicensedPracticalNurse = 'Licensed Practical Nurse',
  NursePractitioner = 'Nurse Practitioner',
  PhysiciansAssistant = 'Physicians Assistant',
  MedicalAssistant = 'Medical Assistant',
  CareManager = 'Care Manager'
}

/**
 * @export
 * @interface PcpUserDataDTO
 */
export interface PcpUserDataDTO {
  /**
   * @type {string}
   * @memberof PcpUserDataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PcpUserDataDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PcpUserDataDTO
   */
  lastName?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof PcpUserDataDTO
   */
  emails: Array<EmailDTO>;
  /**
   * @type {Array<PcpUserDataPracticeDTO>}
   * @memberof PcpUserDataDTO
   */
  practices: Array<PcpUserDataPracticeDTO>;
}

/**
 * @export
 * @interface PcpUserDataPracticeDTO
 */
export interface PcpUserDataPracticeDTO {
  /**
   * @type {string}
   * @memberof PcpUserDataPracticeDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PcpUserDataPracticeDTO
   */
  name: string;
  /**
   * @type {AddressDTO}
   * @memberof PcpUserDataPracticeDTO
   */
  address: AddressDTO;
  /**
   * @type {number}
   * @memberof PcpUserDataPracticeDTO
   */
  minimumReactiveReferralAge: number;
  /**
   * @type {number}
   * @memberof PcpUserDataPracticeDTO
   */
  minimumCurbsideAge: number;
  /**
   * @type {number}
   * @memberof PcpUserDataPracticeDTO
   */
  minimumPediatricAge?: number;
  /**
   * @type {number}
   * @memberof PcpUserDataPracticeDTO
   */
  maximumPediatricAge?: number;
  /**
   * @type {string}
   * @memberof PcpUserDataPracticeDTO
   */
  healthSystemId?: string;
}

/**
 * @export
 * @interface PcpsForPracticeResponseDTO
 */
export interface PcpsForPracticeResponseDTO {
  /**
   * @description The collection of PCP's in a practice
   * @type {Array<PcpForPracticeResponseDTO>}
   * @memberof PcpsForPracticeResponseDTO
   */
  pcps: Array<PcpForPracticeResponseDTO>;
}

/**
 * @export
 * @interface PhoneNumberDTO
 */
export interface PhoneNumberDTO {
  /**
   * @type {boolean}
   * @memberof PhoneNumberDTO
   */
  isPrimary?: boolean;
  /**
   * @type {string}
   * @memberof PhoneNumberDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof PhoneNumberDTO
   */
  phoneNumber: string;
  /**
   * @type {PhoneNumberTypeDTO}
   * @memberof PhoneNumberDTO
   */
  type?: PhoneNumberTypeDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum PhoneNumberTypeDTO {
  Home = 'Home',
  Mobile = 'Mobile',
  Office = 'Office',
  Fax = 'Fax'
}

/**
 * @export
 * @interface PhoneTypeAndNumberDTO
 */
export interface PhoneTypeAndNumberDTO {
  /**
   * @type {PhoneNumberTypeDTO}
   * @memberof PhoneTypeAndNumberDTO
   */
  phoneNumberType: PhoneNumberTypeDTO;
  /**
   * @type {string}
   * @memberof PhoneTypeAndNumberDTO
   */
  phoneNumber: string;
  /**
   * @type {boolean}
   * @memberof PhoneTypeAndNumberDTO
   */
  isPrimary?: boolean;
}

/**
 * @export
 * @interface PostAssessmentReferralRequestDTO
 */
export interface PostAssessmentReferralRequestDTO {
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof PostAssessmentReferralRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof PostAssessmentReferralRequestDTO
   */
  patientPreferences: PatientPreferencesDTO;
  /**
   * @type {string}
   * @memberof PostAssessmentReferralRequestDTO
   */
  referralReason: string;
  /**
   * @description The service type patient is requesting
   * @type {PatientServiceTypeDTO}
   * @memberof PostAssessmentReferralRequestDTO
   */
  serviceType: PatientServiceTypeDTO;
  /**
   * @description The patient's primary and additional concerns
   * @type {Array<PatientConcernDTO>}
   * @memberof PostAssessmentReferralRequestDTO
   */
  patientConcerns: Array<PatientConcernDTO>;
}

/**
 * @export
 * @interface PracticeDTO
 */
export interface PracticeDTO {
  /**
   * @type {Array<string>}
   * @memberof PracticeDTO
   */
  caseManagers?: Array<string>;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  healthSystemId?: string;
  /**
   * @type {Array<LocationDTO>}
   * @memberof PracticeDTO
   */
  locations?: Array<LocationDTO>;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  npi?: string;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof PracticeDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
  /**
   * @type {PracticeSettingDTO}
   * @memberof PracticeDTO
   */
  practiceSetting?: PracticeSettingDTO;
  /**
   * @type {PracticeTypeDTO}
   * @memberof PracticeDTO
   */
  type?: PracticeTypeDTO;
  /**
   * @type {Array<string>}
   * @memberof PracticeDTO
   */
  providers?: Array<string>;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  id: string;
  /**
   * @type {QuartetRegionDTO}
   * @memberof PracticeDTO
   */
  quartetRegion?: QuartetRegionDTO;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  creatingProviderId?: string;
  /**
   * @type {BhpPracticeSmartMatchPreferencesDTO}
   * @memberof PracticeDTO
   */
  bhpPracticeSmartMatchPreferences?: BhpPracticeSmartMatchPreferencesDTO;
  /**
   * @type {boolean}
   * @memberof PracticeDTO
   */
  isTeleOnly?: boolean;
  /**
   * @type {boolean}
   * @memberof PracticeDTO
   */
  isDirectSchedulingEnabled?: boolean;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  email?: string;
  /**
   * @type {Array<ServiceFormatDTO>}
   * @memberof PracticeDTO
   */
  serviceFormats?: Array<ServiceFormatDTO>;
  /**
   * @type {Array<InsurancePlanCountyRestrictionDTO>}
   * @memberof PracticeDTO
   */
  insurancePlanCountyRestriction?: Array<InsurancePlanCountyRestrictionDTO>;
  /**
   * @type {string}
   * @memberof PracticeDTO
   */
  description?: string;
  /**
   * @type {boolean}
   * @memberof PracticeDTO
   */
  isValueBasedPartner?: boolean;
  /**
   * @type {ValueBasedProgramPartnerDTO}
   * @memberof PracticeDTO
   */
  valueBasedProgramPartner?: ValueBasedProgramPartnerDTO;
}

/**
 * @export
 * @interface PracticeDetailsForOpsDTO
 */
export interface PracticeDetailsForOpsDTO {
  /**
   * @type {string}
   * @memberof PracticeDetailsForOpsDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PracticeDetailsForOpsDTO
   */
  name?: string;
  /**
   * @type {Array<string>}
   * @memberof PracticeDetailsForOpsDTO
   */
  locationIds?: Array<string>;
  /**
   * @type {PracticeReferralStatisticsDTO}
   * @memberof PracticeDetailsForOpsDTO
   */
  referralStatistics?: PracticeReferralStatisticsDTO;
  /**
   * @type {string}
   * @memberof PracticeDetailsForOpsDTO
   */
  healthSystemId?: string;
  /**
   * @type {number}
   * @memberof PracticeDetailsForOpsDTO
   */
  referralVolumeTarget?: number;
  /**
   * @type {boolean}
   * @memberof PracticeDetailsForOpsDTO
   */
  isTeleOnly?: boolean;
  /**
   * @type {boolean}
   * @memberof PracticeDetailsForOpsDTO
   */
  isDirectSchedulingEnabled?: boolean;
  /**
   * @type {string}
   * @memberof PracticeDetailsForOpsDTO
   */
  description?: string;
}

/**
 * @export
 * @interface PracticeMatchConsumedReasonDTO
 */
export interface PracticeMatchConsumedReasonDTO {
  /**
   * @type {string}
   * @memberof PracticeMatchConsumedReasonDTO
   */
  providerMatchId?: string;
  /**
   * @type {PracticeMatchConsumedReasonTypeDTO}
   * @memberof PracticeMatchConsumedReasonDTO
   */
  reason: PracticeMatchConsumedReasonTypeDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum PracticeMatchConsumedReasonTypeDTO {
  ProviderCanReceiveReferralsFalse = 'Provider Can Receive Referrals False',
  ProviderHasNotCompletedRegistration = 'Provider Has Not Completed Registration',
  ProviderInactive = 'Provider Inactive',
  ProviderInsuranceNotAccepted = 'Provider Insurance Not Accepted',
  ProviderInsurancePaused = 'Provider Insurance Paused',
  ProviderNotBhp = 'Provider Not Bhp',
  ProviderNotQHVerified = 'Provider Not QH Verified',
  ProviderReferralsPaused = 'Provider Referrals Paused',
  PracticeMissingAdmin = 'Practice Missing Admin',
  ReferralCreated = 'Referral Created'
}

/**
 * @export
 * @interface PracticeNameWithLocationsDTO
 */
export interface PracticeNameWithLocationsDTO {
  /**
   * @type {string}
   * @memberof PracticeNameWithLocationsDTO
   */
  name?: string;
  /**
   * @type {Array<LocationDTO>}
   * @memberof PracticeNameWithLocationsDTO
   */
  locations?: Array<LocationDTO>;
}

/**
 * @export
 * @interface PracticeReferralStatisticsDTO
 */
export interface PracticeReferralStatisticsDTO {
  /**
   * @description Practice referral statistics for the last 14 days
   * @type {ReferralAcceptedStatisticsDTO}
   * @memberof PracticeReferralStatisticsDTO
   */
  shortStats: ReferralAcceptedStatisticsDTO;
  /**
   * @description Practice referral statistics for the last 30 days
   * @type {ReferralAcceptedStatisticsDTO}
   * @memberof PracticeReferralStatisticsDTO
   */
  longStats: ReferralAcceptedStatisticsDTO;
}

/**
 * @export
 * @interface PracticeRequestDTO
 */
export interface PracticeRequestDTO {
  /**
   * @type {string}
   * @memberof PracticeRequestDTO
   */
  healthSystemId?: string;
  /**
   * @type {Array<LocationDTO>}
   * @memberof PracticeRequestDTO
   */
  locations?: Array<LocationDTO>;
  /**
   * @type {string}
   * @memberof PracticeRequestDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof PracticeRequestDTO
   */
  npi?: string;
  /**
   * @type {boolean}
   * @memberof PracticeRequestDTO
   */
  isTeleOnly?: boolean;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof PracticeRequestDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {PracticeTypeDTO}
   * @memberof PracticeRequestDTO
   */
  type?: PracticeTypeDTO;
  /**
   * @type {string}
   * @memberof PracticeRequestDTO
   */
  id: string;
  /**
   * @type {QuartetRegionDTO}
   * @memberof PracticeRequestDTO
   */
  quartetRegion?: QuartetRegionDTO;
  /**
   * @type {BhpPracticeSmartMatchPreferencesDTO}
   * @memberof PracticeRequestDTO
   */
  bhpPracticeSmartMatchPreferences?: BhpPracticeSmartMatchPreferencesDTO;
  /**
   * @type {boolean}
   * @memberof PracticeRequestDTO
   */
  isDirectSchedulingEnabled?: boolean;
  /**
   * @type {string}
   * @memberof PracticeRequestDTO
   */
  email?: string;
  /**
   * @type {Array<ServiceFormatDTO>}
   * @memberof PracticeRequestDTO
   */
  serviceFormats?: Array<ServiceFormatDTO>;
  /**
   * @type {Array<InsurancePlanCountyRestrictionDTO>}
   * @memberof PracticeRequestDTO
   */
  insurancePlanCountyRestriction?: Array<InsurancePlanCountyRestrictionDTO>;
  /**
   * @type {string}
   * @memberof PracticeRequestDTO
   */
  description?: string;
  /**
   * @type {boolean}
   * @memberof PracticeRequestDTO
   */
  isValueBasedPartner?: boolean;
  /**
   * @type {ValueBasedProgramPartnerDTO}
   * @memberof PracticeRequestDTO
   */
  valueBasedProgramPartner?: ValueBasedProgramPartnerDTO;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof PracticeRequestDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
}

/**
 * @export
 * @enum {string}
 */
export enum PracticeSettingDTO {
  PrivatePractice = 'Private Practice',
  ClinicSUF = 'Clinic SUF',
  ClinicMUF = 'Clinic MUF',
  ClinicSMIF = 'Clinic SMIF',
  ClinicGF = 'Clinic GF'
}

/**
 * @export
 * @enum {string}
 */
export enum PracticeTypeDTO {
  PCPPractice = 'PCP Practice',
  BHPGroupPractice = 'BHP Group Practice',
  BHPIndividualPractice = 'BHP Individual Practice'
}

/**
 * @export
 * @interface PracticesWithMetadataResponseDTO
 */
export interface PracticesWithMetadataResponseDTO {
  /**
   * @type {Array<PracticeWithMetadataDTO>}
   * @memberof PracticesWithMetadataResponseDTO
   */
  practices: Array<PracticeWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof PracticesWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @description The data required to create a pre-registered Provider (PCP)
 * @export
 * @interface PreRegisteredProviderRequestDTO
 */
export interface PreRegisteredProviderRequestDTO {
  /**
   * @description The provider's first name.
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  firstName: string;
  /**
   * @description The provider's last name.
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  suffix?: string;
  /**
   * @type {GenderDTO}
   * @memberof PreRegisteredProviderRequestDTO
   */
  gender?: GenderDTO;
  /**
   * @type {ProviderTypeDTO}
   * @memberof PreRegisteredProviderRequestDTO
   */
  type: ProviderTypeDTO;
  /**
   * @description The provider's National Provider Identifier number.
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  npi?: string;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof PreRegisteredProviderRequestDTO
   */
  pcpPracticeTitle: PcpPracticeTitleDTO;
  /**
   * @description A primary phone number at which the provider can be reached.
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  phoneNumber: string;
  /**
   * @description The provider's primary email address.
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  emailAddress?: string;
  /**
   * @description A fax number that the provider can receive documents on.
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  faxNumber?: string;
  /**
   * @type {Array<string>}
   * @memberof PreRegisteredProviderRequestDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {string}
   * @memberof PreRegisteredProviderRequestDTO
   */
  practiceId: string;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof PreRegisteredProviderRequestDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
}

/**
 * @export
 * @interface PrimaryCarePracticeMembershipDTO
 */
export interface PrimaryCarePracticeMembershipDTO {
  /**
   * @type {string}
   * @memberof PrimaryCarePracticeMembershipDTO
   */
  practiceId?: string;
  /**
   * @type {boolean}
   * @memberof PrimaryCarePracticeMembershipDTO
   */
  isActive?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum PrimaryCarePracticeMembershipStateDTO {
  Active = 'Active',
  Inactive = 'Inactive'
}

/**
 * @export
 * @interface PrimaryCarePracticeMembershipStatusDTO
 */
export interface PrimaryCarePracticeMembershipStatusDTO {
  /**
   * @type {string}
   * @memberof PrimaryCarePracticeMembershipStatusDTO
   */
  date: string;
  /**
   * @type {PrimaryCarePracticeMembershipStateDTO}
   * @memberof PrimaryCarePracticeMembershipStatusDTO
   */
  state: PrimaryCarePracticeMembershipStateDTO;
}

/**
 * @export
 * @interface ProcessPatientIntakeAndMatchRequestDTO
 */
export interface ProcessPatientIntakeAndMatchRequestDTO {
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  firstName: string;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  lastName: string;
  /**
   * @description Patient's suffix, if any
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  suffix?: string;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  preferredName?: string;
  /**
   * @description Patient's date of birth
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  dateOfBirth: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  gender: GenderDTO;
  /**
   * @description Neuroflow Patient ID
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  patientId: string;
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  address: AddressDTO;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @description Patient's phone numbers (must be exactly one where isPrimary = true)
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @type {CreateSelfReferralRequestPrimaryInsurancePolicyDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  primaryInsurancePolicy: CreateSelfReferralRequestPrimaryInsurancePolicyDTO;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  patientPreferences: PatientPreferencesDTO;
  /**
   * @description The patient's preferred service format
   * @type {TeleservicesPreferenceDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @description The patient's preferred MHP gender
   * @type {GenderDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The patient's preferred MHP language
   * @type {LanguageDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  referralReason: string;
  /**
   * @description The service type patient is requesting
   * @type {PatientServiceTypeDTO}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  serviceType: PatientServiceTypeDTO;
  /**
   * @description The patient's primary and additional concerns
   * @type {Array<PatientConcernDTO>}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  patientConcerns: Array<PatientConcernDTO>;
  /**
   * @description The edited note to put on the care event
   * @type {string}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  careEventNote?: string;
  /**
   * @type {boolean}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  isDirectMatch?: boolean;
  /**
   * @type {boolean}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  collaborativeCarePatient?: boolean;
  /**
   * @type {boolean}
   * @memberof ProcessPatientIntakeAndMatchRequestDTO
   */
  urgentAssessmentResults?: boolean;
}

/**
 * @export
 * @interface ProcessPatientIntakeAndMatchResponseDTO
 */
export interface ProcessPatientIntakeAndMatchResponseDTO {
  /**
   * @type {MatchListResponseDTO}
   * @memberof ProcessPatientIntakeAndMatchResponseDTO
   */
  matchListResult?: MatchListResponseDTO;
  /**
   * @type {ServicePathDTO}
   * @memberof ProcessPatientIntakeAndMatchResponseDTO
   */
  servicePath?: ServicePathDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ProgressQualifierDTO {
  SignificantProgress = 'Significant Progress',
  MinimalProgress = 'Minimal Progress',
  Regression = 'Regression',
  NoChange = 'No Change',
  SomeProgress = 'Some Progress'
}

/**
 * @export
 * @enum {string}
 */
export enum ProgressUpdateCollaborationTypeDTO {
  Yes = 'Yes',
  No = 'No',
  NoConsent = 'No Consent'
}

/**
 * @export
 * @interface ProgressUpdateDTO
 */
export interface ProgressUpdateDTO {
  /**
   * @type {ClientEngagementLevelDTO}
   * @memberof ProgressUpdateDTO
   */
  clientEngagementLevel?: ClientEngagementLevelDTO;
  /**
   * @type {InactiveReasonDTO}
   * @memberof ProgressUpdateDTO
   */
  inactiveReason?: InactiveReasonDTO;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messageAssessments?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messageAttendance?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messageMedication?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messagePhysicalHealth?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messagePrognosis?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messageSimpleProgressNote?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messageSymptomIncrease?: string;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  messageSymptomReduction?: string;
  /**
   * @type {number}
   * @memberof ProgressUpdateDTO
   */
  numberOfAppointments?: number;
  /**
   * @type {ProgressQualifierDTO}
   * @memberof ProgressUpdateDTO
   */
  overallProgress?: ProgressQualifierDTO;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  id: string;
  /**
   * @type {ProgressQualifierDTO}
   * @memberof ProgressUpdateDTO
   */
  recentProgress?: ProgressQualifierDTO;
  /**
   * @type {StatusInCareDTO}
   * @memberof ProgressUpdateDTO
   */
  statusInCare?: StatusInCareDTO;
  /**
   * @type {TreatmentPlanDTO}
   * @memberof ProgressUpdateDTO
   */
  treatmentPlan?: TreatmentPlanDTO;
  /**
   * @type {ProgressUpdateTypeDTO}
   * @memberof ProgressUpdateDTO
   */
  type: ProgressUpdateTypeDTO;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof ProgressUpdateDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
  /**
   * @type {string}
   * @memberof ProgressUpdateDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface ProgressUpdateResponseDTO
 */
export interface ProgressUpdateResponseDTO {
  /**
   * @type {ProgressUpdateDTO}
   * @memberof ProgressUpdateResponseDTO
   */
  progressUpdate: ProgressUpdateDTO;
  /**
   * @type {CareEventDTO}
   * @memberof ProgressUpdateResponseDTO
   */
  careEvent: CareEventDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ProgressUpdateTypeDTO {
  BHPInitialUpdate = 'BHP Initial Update',
  BHPLegacyUpdate = 'BHP Legacy Update',
  BHPStructuredUpdate = 'BHP Structured Update',
  PCPUpdate = 'PCP Update',
  CaseManagerUpdate = 'Case Manager Update',
  QuartetUpdate = 'Quartet Update',
  MatchedWithBHPFollowup = 'Matched With BHP Followup'
}

/**
 * @export
 * @interface ProgressUpdatesResponseDTO
 */
export interface ProgressUpdatesResponseDTO {
  /**
   * @type {Array<ProgressUpdateDTO>}
   * @memberof ProgressUpdatesResponseDTO
   */
  progressUpdates: Array<ProgressUpdateDTO>;
  /**
   * @type {PageDTO}
   * @memberof ProgressUpdatesResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ProviderClassificationDTO {
  A = 'A',
  B = 'B',
  C = 'C',
  E = 'E',
  F = 'F',
  G = 'G'
}

/**
 * @export
 * @interface ProviderDTO
 */
export interface ProviderDTO {
  /**
   * @type {Array<string>}
   * @memberof ProviderDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof ProviderDTO
   */
  associatedPractices?: Array<string>;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof ProviderDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof ProviderDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof ProviderDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  firstName?: string;
  /**
   * @type {GenderDTO}
   * @memberof ProviderDTO
   */
  gender?: GenderDTO;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof ProviderDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  lastName?: string;
  /**
   * @type {LicenseDTO}
   * @memberof ProviderDTO
   */
  license?: LicenseDTO;
  /**
   * @type {Array<LicenseDTO>}
   * @memberof ProviderDTO
   */
  licenses?: Array<LicenseDTO>;
  /**
   * @type {Array<string>}
   * @memberof ProviderDTO
   */
  locations?: Array<string>;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  npi?: string;
  /**
   * @type {number}
   * @memberof ProviderDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {number}
   * @memberof ProviderDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof ProviderDTO
   */
  pcpPracticeTitle?: PcpPracticeTitleDTO;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof ProviderDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof ProviderDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<ProviderStatusInQuartetDTO>}
   * @memberof ProviderDTO
   */
  providerStatusInQuartet?: Array<ProviderStatusInQuartetDTO>;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  id?: string;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof ProviderDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  suffix?: string;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof ProviderDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {boolean}
   * @memberof ProviderDTO
   */
  isQHVerified?: boolean;
  /**
   * @description flag to determine if this provider is allowed to receive referrals
   * @type {boolean}
   * @memberof ProviderDTO
   */
  canReceiveReferrals?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderDTO
   */
  isUsingSupervisorsNpi?: boolean;
  /**
   * @type {ProviderTypeDTO}
   * @memberof ProviderDTO
   */
  type?: ProviderTypeDTO;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof ProviderDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
  /**
   * @type {RaceEthnicityDTO}
   * @memberof ProviderDTO
   */
  raceEthnicity?: RaceEthnicityDTO;
  /**
   * @type {string}
   * @memberof ProviderDTO
   */
  tin?: string;
}

/**
 * @export
 * @interface ProviderDetailsForOpsDTO
 */
export interface ProviderDetailsForOpsDTO {
  /**
   * @type {string}
   * @memberof ProviderDetailsForOpsDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof ProviderDetailsForOpsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ProviderDetailsForOpsDTO
   */
  lastName?: string;
  /**
   * @type {GenderDTO}
   * @memberof ProviderDetailsForOpsDTO
   */
  gender?: GenderDTO;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof ProviderDetailsForOpsDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof ProviderDetailsForOpsDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof ProviderDetailsForOpsDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof ProviderDetailsForOpsDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof ProviderDetailsForOpsDTO
   */
  supportedPatientNeeds?: SupportedPatientNeedsDTO;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof ProviderDetailsForOpsDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {Array<string>}
   * @memberof ProviderDetailsForOpsDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {Array<AcceptedInsurancePlanDTO>}
   * @memberof ProviderDetailsForOpsDTO
   */
  acceptedInsurancePlans?: Array<AcceptedInsurancePlanDTO>;
  /**
   * @type {number}
   * @memberof ProviderDetailsForOpsDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {number}
   * @memberof ProviderDetailsForOpsDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {Array<string>}
   * @memberof ProviderDetailsForOpsDTO
   */
  locationIds?: Array<string>;
  /**
   * @type {boolean}
   * @memberof ProviderDetailsForOpsDTO
   */
  canReceiveReferrals?: boolean;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof ProviderDetailsForOpsDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
}

/**
 * @export
 * @interface ProviderDirectDetailsDTO
 */
export interface ProviderDirectDetailsDTO {
  /**
   * @description The provider's Direct email address, if available.
   * @type {string}
   * @memberof ProviderDirectDetailsDTO
   */
  providerDirectAddress: string;
  /**
   * @description The provider's health system for this direct address. This must be an existing healthSystemId.
   * @type {string}
   * @memberof ProviderDirectDetailsDTO
   */
  providerHealthSystemId: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ProviderExternalIdTypeDTO {
  UserLogin = 'User Login',
  DirectEmailAddress = 'Direct Email Address',
  EnterpriseId = 'Enterprise Id',
  SHSER = 'SHSER',
  LocationId = 'Location Id'
}

/**
 * @export
 * @interface ProviderMatchAcceptedInsurancePlanDTO
 */
export interface ProviderMatchAcceptedInsurancePlanDTO {
  /**
   * @type {string}
   * @memberof ProviderMatchAcceptedInsurancePlanDTO
   */
  insurancePlanId: string;
  /**
   * @type {boolean}
   * @memberof ProviderMatchAcceptedInsurancePlanDTO
   */
  isActive: boolean;
  /**
   * @type {string}
   * @memberof ProviderMatchAcceptedInsurancePlanDTO
   */
  insurancePlanName: string;
}

/**
 * @export
 * @interface ProviderMatchDetailsDTO
 */
export interface ProviderMatchDetailsDTO {
  /**
   * @type {string}
   * @memberof ProviderMatchDetailsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ProviderMatchDetailsDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof ProviderMatchDetailsDTO
   */
  id?: string;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof ProviderMatchDetailsDTO
   */
  bhProviderType?: BhProviderTypeDTO;
}

/**
 * @export
 * @interface ProviderNPIValidationResponseDTO
 */
export interface ProviderNPIValidationResponseDTO {
  /**
   * @type {string}
   * @memberof ProviderNPIValidationResponseDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ProviderNPIValidationResponseDTO
   */
  middleName?: string;
  /**
   * @type {string}
   * @memberof ProviderNPIValidationResponseDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof ProviderNPIValidationResponseDTO
   */
  npi?: string;
  /**
   * @type {string}
   * @memberof ProviderNPIValidationResponseDTO
   */
  id?: string;
}

/**
 * @export
 * @interface ProviderNameDTO
 */
export interface ProviderNameDTO {
  /**
   * @type {string}
   * @memberof ProviderNameDTO
   */
  providerFirstName?: string;
  /**
   * @type {string}
   * @memberof ProviderNameDTO
   */
  providerLastName?: string;
}

/**
 * @export
 * @interface ProviderProfilePermissionsDTO
 */
export interface ProviderProfilePermissionsDTO {
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsDTO
   */
  canAdministerPractice?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsDTO
   */
  canViewBehavioralHealthAssessmentsAndConsultNotes?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsDTO
   */
  canSubmitPatient?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsDTO
   */
  canViewPatientReferralProviderAndAppointmentDetails?: boolean;
}

/**
 * @export
 * @interface ProviderProfilePermissionsForAdminDTO
 */
export interface ProviderProfilePermissionsForAdminDTO {
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminDTO
   */
  canViewBehavioralHealthData?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminDTO
   */
  canSubmitPatient?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminDTO
   */
  canViewReferralDetails?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminDTO
   */
  canViewRecommendedPatients?: boolean;
}

/**
 * @export
 * @interface ProviderProfilePermissionsForAdminWithMetadataResponseDTO
 */
export interface ProviderProfilePermissionsForAdminWithMetadataResponseDTO {
  /**
   * @type {Array<ProviderProfilePermissionsForAdminWithMetadataDTO>}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataResponseDTO
   */
  permissions: Array<ProviderProfilePermissionsForAdminWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @interface ProviderProfilePermissionsResponseDTO
 */
export interface ProviderProfilePermissionsResponseDTO {
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsResponseDTO
   */
  canAdministerPractice: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsResponseDTO
   */
  canViewBehavioralHealthAssessmentsAndConsultNotes: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsResponseDTO
   */
  canSubmitPatient: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsResponseDTO
   */
  canViewPatientReferralProviderAndAppointmentDetails: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsResponseDTO
   */
  canViewRecommendedPatients: boolean;
}

/**
 * @export
 * @interface ProviderResponseDTO
 */
export interface ProviderResponseDTO {
  /**
   * @type {ProviderDTO}
   * @memberof ProviderResponseDTO
   */
  provider: ProviderDTO;
  /**
   * @type {Array<BhPracticeRoleDTO>}
   * @memberof ProviderResponseDTO
   */
  bhPracticeRoles?: Array<BhPracticeRoleDTO>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof ProviderResponseDTO
   */
  providerPreferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {ProviderProfilePermissionsDTO}
   * @memberof ProviderResponseDTO
   */
  providerProfilePermissions?: ProviderProfilePermissionsDTO;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof ProviderResponseDTO
   */
  supportedPatientNeeds?: SupportedPatientNeedsDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ProviderStateDTO {
  AcceptedTOSVersion100 = 'Accepted TOS Version 1.0.0',
  AcceptedTOSVersion101 = 'Accepted TOS Version 1.0.1',
  AcceptedInvitationToPractice = 'Accepted Invitation To Practice',
  PreRegistered = 'Pre-registered',
  CompletedRegistration = 'Completed Registration',
  Test = 'Test',
  Duplicate = 'Duplicate',
  Deactivated = 'Deactivated'
}

/**
 * @export
 * @interface ProviderStatusInQuartetDTO
 */
export interface ProviderStatusInQuartetDTO {
  /**
   * @type {string}
   * @memberof ProviderStatusInQuartetDTO
   */
  date?: string;
  /**
   * @type {ProviderStateDTO}
   * @memberof ProviderStatusInQuartetDTO
   */
  state?: ProviderStateDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ProviderTypeDTO {
  BHP = 'BHP',
  PCP = 'PCP',
  BHADMIN = 'BH_ADMIN'
}

/**
 * @export
 * @interface ProviderViewsListOfActivePatientsResponseDTO
 */
export interface ProviderViewsListOfActivePatientsResponseDTO {
  /**
   * @type {Array<ProviderViewsListOfActivePatientsResponsePatientsDTO>}
   * @memberof ProviderViewsListOfActivePatientsResponseDTO
   */
  patients: Array<ProviderViewsListOfActivePatientsResponsePatientsDTO>;
}

/**
 * @export
 * @interface ProviderViewsListOfActivePatientsResponsePatientDTO
 */
export interface ProviderViewsListOfActivePatientsResponsePatientDTO {
  /**
   * @description The ID of this patient
   * @type {string}
   * @memberof ProviderViewsListOfActivePatientsResponsePatientDTO
   */
  id?: string;
  /**
   * @description The first name of this patient
   * @type {string}
   * @memberof ProviderViewsListOfActivePatientsResponsePatientDTO
   */
  firstName?: string;
  /**
   * @description The last name of this patient
   * @type {string}
   * @memberof ProviderViewsListOfActivePatientsResponsePatientDTO
   */
  lastName?: string;
}

/**
 * @export
 * @interface ProviderViewsListOfActivePatientsResponsePatientsDTO
 */
export interface ProviderViewsListOfActivePatientsResponsePatientsDTO {
  /**
   * @type {ProviderViewsListOfActivePatientsResponsePatientDTO}
   * @memberof ProviderViewsListOfActivePatientsResponsePatientsDTO
   */
  patient?: ProviderViewsListOfActivePatientsResponsePatientDTO;
  /**
   * @description The names of each active BHP on the patient's care team
   * @type {Array<ProviderViewsListOfActivePatientsResponseProvidersDTO>}
   * @memberof ProviderViewsListOfActivePatientsResponsePatientsDTO
   */
  providers?: Array<ProviderViewsListOfActivePatientsResponseProvidersDTO>;
  /**
   * @description The most recent care event for this patient
   * @type {CareEventDTO}
   * @memberof ProviderViewsListOfActivePatientsResponsePatientsDTO
   */
  mostRecentCareEvent?: CareEventDTO;
}

/**
 * @export
 * @interface ProviderViewsListOfActivePatientsResponseProvidersDTO
 */
export interface ProviderViewsListOfActivePatientsResponseProvidersDTO {
  /**
   * @description The ID of this provider
   * @type {string}
   * @memberof ProviderViewsListOfActivePatientsResponseProvidersDTO
   */
  id?: string;
  /**
   * @description The first name of this provider
   * @type {string}
   * @memberof ProviderViewsListOfActivePatientsResponseProvidersDTO
   */
  firstName?: string;
  /**
   * @description The last name of this provider
   * @type {string}
   * @memberof ProviderViewsListOfActivePatientsResponseProvidersDTO
   */
  lastName?: string;
}

/**
 * @export
 * @interface ProviderViewsListOfInactivePatientsResponseDTO
 */
export interface ProviderViewsListOfInactivePatientsResponseDTO {
  /**
   * @type {Array<ProviderViewsListOfInactivePatientsResponsePatientsDTO>}
   * @memberof ProviderViewsListOfInactivePatientsResponseDTO
   */
  patients: Array<ProviderViewsListOfInactivePatientsResponsePatientsDTO>;
}

/**
 * @export
 * @interface ProviderViewsListOfInactivePatientsResponsePatientDTO
 */
export interface ProviderViewsListOfInactivePatientsResponsePatientDTO {
  /**
   * @description The first name of this patient
   * @type {string}
   * @memberof ProviderViewsListOfInactivePatientsResponsePatientDTO
   */
  firstName?: string;
  /**
   * @description The last name of this patient
   * @type {string}
   * @memberof ProviderViewsListOfInactivePatientsResponsePatientDTO
   */
  lastName?: string;
}

/**
 * @export
 * @interface ProviderViewsListOfInactivePatientsResponsePatientsDTO
 */
export interface ProviderViewsListOfInactivePatientsResponsePatientsDTO {
  /**
   * @type {ProviderViewsListOfInactivePatientsResponsePatientDTO}
   * @memberof ProviderViewsListOfInactivePatientsResponsePatientsDTO
   */
  patient?: ProviderViewsListOfInactivePatientsResponsePatientDTO;
  /**
   * @description The names of each inactive BHP on the patient's care team
   * @type {Array<ProviderViewsListOfInactivePatientsResponseProvidersDTO>}
   * @memberof ProviderViewsListOfInactivePatientsResponsePatientsDTO
   */
  providers?: Array<ProviderViewsListOfInactivePatientsResponseProvidersDTO>;
  /**
   * @description The most recent care event for this patient
   * @type {CareEventDTO}
   * @memberof ProviderViewsListOfInactivePatientsResponsePatientsDTO
   */
  mostRecentCareEvent?: CareEventDTO;
}

/**
 * @export
 * @interface ProviderViewsListOfInactivePatientsResponseProvidersDTO
 */
export interface ProviderViewsListOfInactivePatientsResponseProvidersDTO {
  /**
   * @description The first name of this provider
   * @type {string}
   * @memberof ProviderViewsListOfInactivePatientsResponseProvidersDTO
   */
  firstName?: string;
  /**
   * @description The last name of this provider
   * @type {string}
   * @memberof ProviderViewsListOfInactivePatientsResponseProvidersDTO
   */
  lastName?: string;
}

/**
 * @export
 * @interface ProviderViewsPatientTimelineResponseDTO
 */
export interface ProviderViewsPatientTimelineResponseDTO {
  /**
   * @description The details of the patient to be viewed
   * @type {PatientDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  patient: PatientDTO;
  /**
   * @description All of the patient's insurance plans
   * @type {Array<InsurancePlanDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  patientInsurancePlans: Array<InsurancePlanDTO>;
  /**
   * @description Patient's latest assessment
   * @type {GetAssessmentResponseDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  assessment?: GetAssessmentResponseDTO;
  /**
   * @description Latest care event associated with the assessment result
   * @type {CareEventDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  careEvent?: CareEventDTO;
  /**
   * @description Patient's latest treatment plan
   * @type {TreatmentPlanDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  treatmentPlan?: TreatmentPlanDTO;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  treatmentSetting?: AppointmentSettingDTO;
  /**
   * @description The appointment location relevant to the viewing provider
   * @type {LocationDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  treatmentLocation?: LocationDTO;
  /**
   * @description The care team for this patient
   * @type {CareTeamDTO}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  careTeam: CareTeamDTO;
  /**
   * @description The providers on this patient's care team
   * @type {Array<ProviderDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  providers: Array<ProviderDTO>;
  /**
   * @description The case managers on this patient's care team
   * @type {Array<TimelineResponseCaseManagerDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  caseManagers: Array<TimelineResponseCaseManagerDTO>;
  /**
   * @description The practices for the providers on this patient's care team
   * @type {Array<PracticeDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  practices: Array<PracticeDTO>;
  /**
   * @description The groups for the case managers on this patient's care team
   * @type {Array<DisplayCaseManagerGroupDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  caseManagerGroups: Array<DisplayCaseManagerGroupDTO>;
  /**
   * @description The care team members for the current provider's practices
   * @type {Array<CareTeamMemberDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  myPracticeCareTeamMembers?: Array<CareTeamMemberDTO>;
  /**
   * @description The care team case managers for the current case manager's group
   * @type {Array<CaseManagerDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  myGroupCaseManagers?: Array<CaseManagerDTO>;
  /**
   * @description The providers in my practice that I can assign the patient to
   * @type {Array<ProviderDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  myPracticeProviders?: Array<ProviderDTO>;
  /**
   * @type {boolean}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  hasAssessment: boolean;
  /**
   * @description The patient's external IDs
   * @type {Array<PatientExternalIdDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  externalIds?: Array<PatientExternalIdDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  alternativeContacts: Array<PatientAlternativeContactDTO>;
  /**
   * @type {string}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  preferredAppointmentTimes?: string;
  /**
   * @type {boolean}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderViewsPatientTimelineResponseDTO
   */
  isCenteneVbcPatient?: boolean;
}

/**
 * @export
 * @interface ProviderViewsReferralsResponseDTO
 */
export interface ProviderViewsReferralsResponseDTO {
  /**
   * @description Info about the referral list pagination
   * @type {PageDTO}
   * @memberof ProviderViewsReferralsResponseDTO
   */
  page?: PageDTO;
  /**
   * @description list of referred patients
   * @type {Array<ProviderViewsReferralsResponseReferralsDTO>}
   * @memberof ProviderViewsReferralsResponseDTO
   */
  referrals?: Array<ProviderViewsReferralsResponseReferralsDTO>;
}

/**
 * @export
 * @interface ProviderViewsReferralsResponseReferralsDTO
 */
export interface ProviderViewsReferralsResponseReferralsDTO {
  /**
   * @description The patient's full name
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  patientName?: string;
  /**
   * @description The patient's preferred first name
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  patientPreferredName?: string;
  /**
   * @description The assigned to provider's id
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  assignedToProviderId?: string;
  /**
   * @description The assigned to provider's full name
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  assignedToName?: string;
  /**
   * @description Date the referral was received on
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  receivedOn?: string;
  /**
   * @description Date the referral was accepted on
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  acceptedDate?: string;
  /**
   * @description Date the referral will expire
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  expirationDate?: string;
  /**
   * @description Referencing referral of the referral
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  referralId?: string;
  /**
   * @description Latest care event associated with the referral
   * @type {CareEventDTO}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  latestCareEvent?: CareEventDTO;
  /**
   * @description Human readable description of the referral status
   * @type {string}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  referralStatus?: string;
  /**
   * @type {boolean}
   * @memberof ProviderViewsReferralsResponseReferralsDTO
   */
  collaborativeCarePatient?: boolean;
}

/**
 * @export
 * @interface ProvidersWithMetadataResponseDTO
 */
export interface ProvidersWithMetadataResponseDTO {
  /**
   * @type {Array<ProviderWithMetadataDTO>}
   * @memberof ProvidersWithMetadataResponseDTO
   */
  providers: Array<ProviderWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof ProvidersWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum QuartetRegionDTO {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
  QuartetTest = 'QuartetTest'
}

/**
 * @export
 * @enum {string}
 */
export enum RaceEthnicityDTO {
  White = 'White',
  BlackOrAfricanAmerican = 'Black or African American',
  AmericanIndianOrAlaskaNative = 'American Indian or Alaska Native',
  Asian = 'Asian',
  ChineseChineseAmerican = 'Chinese/Chinese-American',
  Filipino = 'Filipino',
  JapaneseJapaneseAmerican = 'Japanese/Japanese-American',
  Korean = 'Korean',
  Vietnamese = 'Vietnamese',
  NativeHawaiianOrOtherPacificIslander = 'Native Hawaiian or Other Pacific Islander',
  MexicanMexicanAmerican = 'Mexican/Mexican-American',
  HispanicOrLatino = 'Hispanic or Latino',
  Arab = 'Arab',
  OtherRace = 'Other Race',
  AssyrianChaldean = 'Assyrian/Chaldean',
  OtherAsian = 'Other Asian',
  Multiracial = 'Multiracial',
  NotDisclosed = 'Not Disclosed',
  PreferNotToSay = 'Prefer Not to Say',
  Unknown = 'Unknown'
}

/**
 * @description Explanations associated to the PatientInsight
 * @export
 * @interface RationaleDTO
 */
export interface RationaleDTO {
  /**
   * @type {string}
   * @memberof RationaleDTO
   */
  reasoning: string;
  /**
   * @type {RationaleTypeDTO}
   * @memberof RationaleDTO
   */
  rationaleType: RationaleTypeDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum RationaleTypeDTO {
  Insight = 'Insight',
  Recommendation = 'Recommendation'
}

/**
 * @export
 * @interface ReactivateBhpRequestDTO
 */
export interface ReactivateBhpRequestDTO {
  /**
   * @type {string}
   * @memberof ReactivateBhpRequestDTO
   */
  bhpId: string;
}

/**
 * @export
 * @interface ReactivateCareTeamBhpRequestDTO
 */
export interface ReactivateCareTeamBhpRequestDTO {
  /**
   * @type {string}
   * @memberof ReactivateCareTeamBhpRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof ReactivateCareTeamBhpRequestDTO
   */
  bhpId: string;
}

/**
 * @export
 * @interface ReactivateCaseManagerRequestDTO
 */
export interface ReactivateCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof ReactivateCaseManagerRequestDTO
   */
  caseManagerId: string;
}

/**
 * @export
 * @interface ReactivatePatientRequestDTO
 */
export interface ReactivatePatientRequestDTO {
  /**
   * @type {string}
   * @memberof ReactivatePatientRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface ReactivatePcpRequestDTO
 */
export interface ReactivatePcpRequestDTO {
  /**
   * @type {string}
   * @memberof ReactivatePcpRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof ReactivatePcpRequestDTO
   */
  practiceId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ReactiveWorkflowTypeDTO {
  UpgradedWithDigitalConsent20 = 'Upgraded with Digital Consent 2.0',
  UpgradedWithoutDigitalConsent20 = 'Upgraded without Digital Consent 2.0',
  Upgraded10 = 'Upgraded 1.0',
  NonUpgraded10 = 'Non-upgraded 1.0',
  NonUpgraded20 = 'Non-upgraded 2.0'
}

/**
 * @export
 * @interface ReassignPatientRequestDTO
 */
export interface ReassignPatientRequestDTO {
  /**
   * @description Id of the provider originally assigned to this patient
   * @type {string}
   * @memberof ReassignPatientRequestDTO
   */
  oldProviderId: string;
  /**
   * @description Id of the provider this patient should be assigned to
   * @type {string}
   * @memberof ReassignPatientRequestDTO
   */
  newProviderId: string;
  /**
   * @description Id of the practice the provider intends the patient to be assigned to
   * @type {string}
   * @memberof ReassignPatientRequestDTO
   */
  newPracticeId?: string;
  /**
   * @description Id for the patient meant to be reassigned
   * @type {string}
   * @memberof ReassignPatientRequestDTO
   */
  patientId: string;
  /**
   * @type {CareTeamRoleDTO}
   * @memberof ReassignPatientRequestDTO
   */
  role: CareTeamRoleDTO;
}

/**
 * @export
 * @interface ReassignPatientResponseDTO
 */
export interface ReassignPatientResponseDTO {
  /**
   * @description Join and left care events
   * @type {Array<CareEventDTO>}
   * @memberof ReassignPatientResponseDTO
   */
  careEvents?: Array<CareEventDTO>;
  /**
   * @type {ReassignPatientResponseNewProviderDTO}
   * @memberof ReassignPatientResponseDTO
   */
  newProvider?: ReassignPatientResponseNewProviderDTO;
}

/**
 * @export
 * @interface ReassignPatientResponseNewProviderDTO
 */
export interface ReassignPatientResponseNewProviderDTO {
  /**
   * @type {string}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  accountId?: string;
  /**
   * @type {string}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  lastName?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {PracticeNameWithLocationsDTO}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  practice?: PracticeNameWithLocationsDTO;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  pcpPracticeTitle?: PcpPracticeTitleDTO;
  /**
   * @type {CareTeamRoleDTO}
   * @memberof ReassignPatientResponseNewProviderDTO
   */
  role?: CareTeamRoleDTO;
}

/**
 * @export
 * @interface ReassignPatientToCaseManagerRequestDTO
 */
export interface ReassignPatientToCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof ReassignPatientToCaseManagerRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof ReassignPatientToCaseManagerRequestDTO
   */
  oldCaseManagerId: string;
  /**
   * @type {string}
   * @memberof ReassignPatientToCaseManagerRequestDTO
   */
  newCaseManagerId: string;
}

/**
 * @export
 * @interface ReassignPatientToCaseManagerResponseDTO
 */
export interface ReassignPatientToCaseManagerResponseDTO {
  /**
   * @type {AssignedCaseManagerDTO}
   * @memberof ReassignPatientToCaseManagerResponseDTO
   */
  newCaseManager?: AssignedCaseManagerDTO;
}

/**
 * @export
 * @interface ReassignPatientToPracticeRequestDTO
 */
export interface ReassignPatientToPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof ReassignPatientToPracticeRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof ReassignPatientToPracticeRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof ReassignPatientToPracticeRequestDTO
   */
  practiceId: string;
}

/**
 * @export
 * @interface ReassignReferralRequestDTO
 */
export interface ReassignReferralRequestDTO {
  /**
   * @type {string}
   * @memberof ReassignReferralRequestDTO
   */
  newProviderId: string;
  /**
   * @type {string}
   * @memberof ReassignReferralRequestDTO
   */
  referralId: string;
}

/**
 * @export
 * @interface RecipientDTO
 */
export interface RecipientDTO {
  /**
   * @description One of adminId or patientId is required, but not both
   * @type {string}
   * @memberof RecipientDTO
   */
  adminId?: string;
  /**
   * @description See comment for adminId
   * @type {string}
   * @memberof RecipientDTO
   */
  patientId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RecommendationDismissalReasonDTO {
  AlreadyInCareWithAMentalHealthProvider = 'Already in care with a mental health provider',
  PracticeWillManageMentalHealthCare = 'Practice will manage mental health care',
  HealthConditionTooSevere = 'Health condition too severe',
  PatientNotInterested = 'Patient not interested',
  NoLongerAPatientOfThisPractice = 'No longer a patient of this practice',
  DoesNotNeedMentalHealthCare = 'Does not need mental health care',
  Deceased = 'Deceased',
  Other = 'Other'
}

/**
 * @export
 * @interface RecommendedPatientDetailsResponseDTO
 */
export interface RecommendedPatientDetailsResponseDTO {
  /**
   * @type {string}
   * @memberof RecommendedPatientDetailsResponseDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientDetailsResponseDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientDetailsResponseDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientDetailsResponseDTO
   */
  dateOfBirth?: string;
  /**
   * @description The list of insights derived for this patient
   * @type {PatientInsightsDTO}
   * @memberof RecommendedPatientDetailsResponseDTO
   */
  patientInsights?: PatientInsightsDTO;
  /**
   * @type {Array<PatientSecondPartyEventDTO>}
   * @memberof RecommendedPatientDetailsResponseDTO
   */
  claimsEvents?: Array<PatientSecondPartyEventDTO>;
}

/**
 * @export
 * @interface RecommendedPatientsRequestDTO
 */
export interface RecommendedPatientsRequestDTO {
  /**
   * @type {Array<string>}
   * @memberof RecommendedPatientsRequestDTO
   */
  providerIds?: Array<string>;
  /**
   * @type {string}
   * @memberof RecommendedPatientsRequestDTO
   */
  practiceId?: string;
  /**
   * @type {Array<string>}
   * @memberof RecommendedPatientsRequestDTO
   */
  practiceIds?: Array<string>;
}

/**
 * @description retrieve the list of recommended patients
 * @export
 * @interface RecommendedPatientsResponseDTO
 */
export interface RecommendedPatientsResponseDTO {
  /**
   * @description the list (one or more) of providers with recommended patients
   * @type {Array<RecommendedPatientsResponseProvidersDTO>}
   * @memberof RecommendedPatientsResponseDTO
   */
  providers?: Array<RecommendedPatientsResponseProvidersDTO>;
}

/**
 * @export
 * @interface RecommendedPatientsResponsePatientsDTO
 */
export interface RecommendedPatientsResponsePatientsDTO {
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  recommendationId?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  dateOfBirth?: string;
  /**
   * @description The list of insights derived for this patient
   * @type {PatientInsightsDTO}
   * @memberof RecommendedPatientsResponsePatientsDTO
   */
  patientInsights?: PatientInsightsDTO;
}

/**
 * @export
 * @interface RecommendedPatientsResponseProvidersDTO
 */
export interface RecommendedPatientsResponseProvidersDTO {
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponseProvidersDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponseProvidersDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof RecommendedPatientsResponseProvidersDTO
   */
  lastName?: string;
  /**
   * @description list of recommended patients associated with given provider, sorted by their clinical needs score (descending)
   * @type {Array<RecommendedPatientsResponsePatientsDTO>}
   * @memberof RecommendedPatientsResponseProvidersDTO
   */
  patients?: Array<RecommendedPatientsResponsePatientsDTO>;
}

/**
 * @export
 * @interface RedirectDTO
 */
export interface RedirectDTO {
  /**
   * @type {ActionTypeDTO}
   * @memberof RedirectDTO
   */
  action?: ActionTypeDTO;
  /**
   * @type {TargetTypeDTO}
   * @memberof RedirectDTO
   */
  target?: TargetTypeDTO;
}

/**
 * @export
 * @interface ReferralAcceptedStatisticsDTO
 */
export interface ReferralAcceptedStatisticsDTO {
  /**
   * @type {number}
   * @memberof ReferralAcceptedStatisticsDTO
   */
  createdCount: number;
  /**
   * @type {number}
   * @memberof ReferralAcceptedStatisticsDTO
   */
  acceptedCount: number;
}

/**
 * @export
 * @interface ReferralDTO
 */
export interface ReferralDTO {
  /**
   * @type {DeclineReasonDTO}
   * @memberof ReferralDTO
   */
  declineReason?: DeclineReasonDTO;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  declineReasonNote?: string;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  referralExpirationDate?: string;
  /**
   * @type {ReferralStateDTO}
   * @memberof ReferralDTO
   */
  referralState: ReferralStateDTO;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  referredDate?: string;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  referralAcceptDate?: string;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  referralDeclineDate?: string;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof ReferralDTO
   */
  id: string;
}

/**
 * @export
 * @interface ReferralDetailDTO
 */
export interface ReferralDetailDTO {
  /**
   * @type {ProviderDTO}
   * @memberof ReferralDetailDTO
   */
  provider: ProviderDTO;
  /**
   * @type {PatientDTO}
   * @memberof ReferralDetailDTO
   */
  patient: PatientDTO;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof ReferralDetailDTO
   */
  patientInsurancePlans: Array<InsurancePlanDTO>;
  /**
   * @type {PatientSmartMatchPreferencesDTO}
   * @memberof ReferralDetailDTO
   */
  patientSmartMatchPreferences?: PatientSmartMatchPreferencesDTO;
  /**
   * @type {Array<ProviderMatchDetailsDTO>}
   * @memberof ReferralDetailDTO
   */
  providerMatches?: Array<ProviderMatchDetailsDTO>;
  /**
   * @type {LocationDTO}
   * @memberof ReferralDetailDTO
   */
  closestLocation?: LocationDTO;
  /**
   * @type {ReferralDTO}
   * @memberof ReferralDetailDTO
   */
  referral: ReferralDTO;
  /**
   * @type {ReferringProviderDTO}
   * @memberof ReferralDetailDTO
   */
  referringProvider?: ReferringProviderDTO;
  /**
   * @type {ReferringCaseManagerDTO}
   * @memberof ReferralDetailDTO
   */
  referringCaseManager?: ReferringCaseManagerDTO;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof ReferralDetailDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
}

/**
 * @export
 * @interface ReferralRequestResponseDTO
 */
export interface ReferralRequestResponseDTO {
  /**
   * @description The updated referral
   * @type {ReferralDTO}
   * @memberof ReferralRequestResponseDTO
   */
  referral?: ReferralDTO;
  /**
   * @description The care event
   * @type {CareEventDTO}
   * @memberof ReferralRequestResponseDTO
   */
  careEvent?: CareEventDTO;
}

/**
 * Referral state
 * @export
 * @enum {string}
 */
export enum ReferralStateDTO {
  AppointmentScheduled = 'Appointment Scheduled',
  DeclinedProviderUnresponsive = 'Declined Provider Unresponsive',
  DeclinedQHToIntervene = 'Declined QH To Intervene',
  Inactive = 'Inactive',
  PatientRejected = 'Patient Rejected',
  PatientSelfDeclined = 'Patient Self Declined',
  PatientUnresponsive = 'Patient Unresponsive',
  PendingProviderReachingOut = 'Pending Provider Reaching Out',
  PendingProviderResponse = 'Pending Provider Response',
  QuartetManualDecline = 'Quartet Manual Decline',
  ReferredOutside = 'Referred Outside'
}

/**
 * @export
 * @enum {string}
 */
export enum ReferralVolumePreferenceDTO {
  NoPreference = 'No Preference',
  LimitSet = 'Limit Set',
  NoLimit = 'No Limit'
}

/**
 * @export
 * @interface ReferralsWithMetadataResponseDTO
 */
export interface ReferralsWithMetadataResponseDTO {
  /**
   * @type {Array<ReferralWithMetadataDTO>}
   * @memberof ReferralsWithMetadataResponseDTO
   */
  referrals: Array<ReferralWithMetadataDTO>;
  /**
   * @type {PageDTO}
   * @memberof ReferralsWithMetadataResponseDTO
   */
  page: PageDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ReferrerTypeDTO {
  Provider = 'Provider',
  CaseManager = 'Case Manager'
}

/**
 * @export
 * @interface ReferringCaseManagerDTO
 */
export interface ReferringCaseManagerDTO {
  /**
   * @description The case manager's id
   * @type {string}
   * @memberof ReferringCaseManagerDTO
   */
  id: string;
  /**
   * @description The case manager's first name
   * @type {string}
   * @memberof ReferringCaseManagerDTO
   */
  firstName: string;
  /**
   * @description The case manager's last name
   * @type {string}
   * @memberof ReferringCaseManagerDTO
   */
  lastName: string;
  /**
   * @description The name of the group originating the referral
   * @type {string}
   * @memberof ReferringCaseManagerDTO
   */
  groupName: string;
  /**
   * @description A contact number for the referring case manager
   * @type {string}
   * @memberof ReferringCaseManagerDTO
   */
  phoneNumber: string;
  /**
   * @description The case manager's status
   * @type {boolean}
   * @memberof ReferringCaseManagerDTO
   */
  isActive: boolean;
}

/**
 * @export
 * @interface ReferringProviderDTO
 */
export interface ReferringProviderDTO {
  /**
   * @description The provider's id
   * @type {string}
   * @memberof ReferringProviderDTO
   */
  id: string;
  /**
   * @description The provider's first name
   * @type {string}
   * @memberof ReferringProviderDTO
   */
  firstName: string;
  /**
   * @description The provider's last name
   * @type {string}
   * @memberof ReferringProviderDTO
   */
  lastName: string;
  /**
   * @description The name of the practice originating the referral
   * @type {string}
   * @memberof ReferringProviderDTO
   */
  practiceName: string;
  /**
   * @description A contact number for the referring provider
   * @type {string}
   * @memberof ReferringProviderDTO
   */
  phoneNumber: string;
  /**
   * @description The provider's status
   * @type {boolean}
   * @memberof ReferringProviderDTO
   */
  isActive: boolean;
}

/**
 * @export
 * @interface RegisterCaseManagerRequestDTO
 */
export interface RegisterCaseManagerRequestDTO {
  /**
   * @type {string}
   * @memberof RegisterCaseManagerRequestDTO
   */
  username: string;
  /**
   * @type {string}
   * @memberof RegisterCaseManagerRequestDTO
   */
  token: string;
  /**
   * @type {string}
   * @memberof RegisterCaseManagerRequestDTO
   */
  password: string;
}

/**
 * @export
 * @interface RegisterPreRegisteredProviderRequestDTO
 */
export interface RegisterPreRegisteredProviderRequestDTO {
  /**
   * @type {string}
   * @memberof RegisterPreRegisteredProviderRequestDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof RegisterPreRegisteredProviderRequestDTO
   */
  emailAddress: string;
}

/**
 * @export
 * @interface RegisterRequestDTO
 */
export interface RegisterRequestDTO {
  /**
   * @description The email address associated with an account
   * @type {string}
   * @memberof RegisterRequestDTO
   */
  emailAddress: string;
  /**
   * @description The password of an account
   * @type {string}
   * @memberof RegisterRequestDTO
   */
  password: string;
}

/**
 * @export
 * @interface RegisterResponseDTO
 */
export interface RegisterResponseDTO {
  /**
   * @description The email address associated with an account
   * @type {string}
   * @memberof RegisterResponseDTO
   */
  emailAddress: string;
  /**
   * @description The id associated with the new account
   * @type {string}
   * @memberof RegisterResponseDTO
   */
  id: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RelationshipDTO {
  Parent = 'Parent',
  Spouse = 'Spouse',
  Other = 'Other',
  Friend = 'Friend',
  Child = 'Child',
  Relative = 'Relative'
}

/**
 * @export
 * @interface RemoveEmailStatusesRequestDTO
 */
export interface RemoveEmailStatusesRequestDTO {
  /**
   * @description Email Status - State to find and remove
   * @type {EmailStateDTO}
   * @memberof RemoveEmailStatusesRequestDTO
   */
  status: EmailStateDTO;
  /**
   * @description Provider email address
   * @type {string}
   * @memberof RemoveEmailStatusesRequestDTO
   */
  recipientEmailAddress: string;
  /**
   * @description The number of past days to check for email awaiting dispatch and attempt to resend them
   * @type {number}
   * @memberof RemoveEmailStatusesRequestDTO
   */
  daysToResendEmails?: number;
}

/**
 * @export
 * @interface RemovePracticeLocationRequestDTO
 */
export interface RemovePracticeLocationRequestDTO {
  /**
   * @type {string}
   * @memberof RemovePracticeLocationRequestDTO
   */
  practiceId: string;
  /**
   * @type {string}
   * @memberof RemovePracticeLocationRequestDTO
   */
  locationIdToRemove: string;
  /**
   * @type {string}
   * @memberof RemovePracticeLocationRequestDTO
   */
  futureAppointmentLocationId: string;
}

/**
 * @export
 * @interface ReplayEhrMessageEventDTO
 */
export interface ReplayEhrMessageEventDTO {
  /**
   * @type {string}
   * @memberof ReplayEhrMessageEventDTO
   */
  careEventId: string;
}

/**
 * @export
 * @interface RequestAssessmentRequestDTO
 */
export interface RequestAssessmentRequestDTO {
  /**
   * @type {string}
   * @memberof RequestAssessmentRequestDTO
   */
  patientId: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof RequestAssessmentRequestDTO
   */
  assessmentType: AssessmentTypeDTO;
}

/**
 * @export
 * @interface RequestResetPasswordRequestDTO
 */
export interface RequestResetPasswordRequestDTO {
  /**
   * @description The email address of the account request to reset their password
   * @type {string}
   * @memberof RequestResetPasswordRequestDTO
   */
  emailAddress: string;
  /**
   * @description URI where user can initiate reset password request on the frontend
   * @type {string}
   * @memberof RequestResetPasswordRequestDTO
   */
  passwordResetUri: string;
}

/**
 * @export
 * @interface RequestSmartMatchAutoLaunchRequestDTO
 */
export interface RequestSmartMatchAutoLaunchRequestDTO {
  /**
   * @description The ID of the patient for whom to enable smartmatch referrals
   * @type {string}
   * @memberof RequestSmartMatchAutoLaunchRequestDTO
   */
  patientId: string;
  /**
   * @description As this is an asynchronous operation, the result of the auto-launch request will be POSTed to this URL as JSON.
   * @type {string}
   * @memberof RequestSmartMatchAutoLaunchRequestDTO
   */
  callbackUrl: string;
  /**
   * @description The maximum amount of seconds to try this request before failing with a timeout
   * @type {number}
   * @memberof RequestSmartMatchAutoLaunchRequestDTO
   */
  timeout: number;
}

/**
 * @export
 * @interface RequestedAssessmentDetailsDTO
 */
export interface RequestedAssessmentDetailsDTO {
  /**
   * @type {AssessmentTypeDTO}
   * @memberof RequestedAssessmentDetailsDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @type {string}
   * @memberof RequestedAssessmentDetailsDTO
   */
  assessmentResultId: string;
  /**
   * @type {string}
   * @memberof RequestedAssessmentDetailsDTO
   */
  requestedAt: string;
  /**
   * @type {string}
   * @memberof RequestedAssessmentDetailsDTO
   */
  requestingProviderFirstName?: string;
  /**
   * @type {string}
   * @memberof RequestedAssessmentDetailsDTO
   */
  requestingProviderLastName?: string;
}

/**
 * @export
 * @interface RescheduleAppointmentRequestDTO
 */
export interface RescheduleAppointmentRequestDTO {
  /**
   * @description Appointment ID to reschedule
   * @type {string}
   * @memberof RescheduleAppointmentRequestDTO
   */
  appointmentId: string;
  /**
   * @description New appointment start date and time
   * @type {string}
   * @memberof RescheduleAppointmentRequestDTO
   */
  startDateTime: string;
  /**
   * @description New provider ID of rescheduled appointment
   * @type {string}
   * @memberof RescheduleAppointmentRequestDTO
   */
  providerId?: string;
  /**
   * @description Location ID of rescheduled appointment
   * @type {string}
   * @memberof RescheduleAppointmentRequestDTO
   */
  locationId?: string;
  /**
   * @description A note for the reschedule care event
   * @type {string}
   * @memberof RescheduleAppointmentRequestDTO
   */
  note?: string;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof RescheduleAppointmentRequestDTO
   */
  setting?: AppointmentSettingDTO;
}

/**
 * @export
 * @interface RescheduleAppointmentResponseDTO
 */
export interface RescheduleAppointmentResponseDTO {
  /**
   * @description The reschedule appointment care event
   * @type {CareEventDTO}
   * @memberof RescheduleAppointmentResponseDTO
   */
  careEvent: CareEventDTO;
  /**
   * @description The rescheduled appointment
   * @type {AppointmentDTO}
   * @memberof RescheduleAppointmentResponseDTO
   */
  appointment: AppointmentDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ResearchConsentDTO {
  OptedIn = 'Opted In',
  OptedOut = 'Opted Out',
  HasNotResponded = 'Has Not Responded'
}

/**
 * @export
 * @interface ResendNewProviderEmailDTO
 */
export interface ResendNewProviderEmailDTO {
  /**
   * @description New provider's id
   * @type {string}
   * @memberof ResendNewProviderEmailDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface ResolveCrisisReferralRequestDTO
 */
export interface ResolveCrisisReferralRequestDTO {
  /**
   * @type {string}
   * @memberof ResolveCrisisReferralRequestDTO
   */
  crisisReferralId: string;
  /**
   * @type {CrisisReferralResolutionDTO}
   * @memberof ResolveCrisisReferralRequestDTO
   */
  resolution: CrisisReferralResolutionDTO;
}

/**
 * @export
 * @interface ResolvePatientForDigitalIntakeRequestDTO
 */
export interface ResolvePatientForDigitalIntakeRequestDTO {
  /**
   * @description A registration code ID to resolve the patient
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeRequestDTO
   */
  codeId: string;
  /**
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeRequestDTO
   */
  dateOfBirth: string;
}

/**
 * @export
 * @interface ResolvePatientForDigitalIntakeResponseDTO
 */
export interface ResolvePatientForDigitalIntakeResponseDTO {
  /**
   * @description If known, the ID of the patient
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  patientId?: string;
  /**
   * @description Patient's first name
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  firstName?: string;
  /**
   * @description Patient's last name
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  lastName?: string;
  /**
   * @description Patient's preferred name, if any
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  preferredName?: string;
  /**
   * @description Patient's gender
   * @type {GenderDTO}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  gender?: GenderDTO;
  /**
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  dateOfBirth?: string;
  /**
   * @description Address of the patient
   * @type {AddressDTO}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  address?: AddressDTO;
  /**
   * @type {Array<InsurancePolicyDTO>}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  insurancePolicies?: Array<InsurancePolicyDTO>;
  /**
   * @description Communication preferences for the patient
   * @type {CommunicationPreferencesDTO}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  communicationPreferences?: CommunicationPreferencesDTO;
  /**
   * @description Patient's phone numbers (must be exactly one where isPrimary = true)
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description Patient's preferences
   * @type {PatientPreferencesDTO}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  patientPreferences?: PatientPreferencesDTO;
  /**
   * @description Patient's treatment consideration
   * @type {Array<TreatmentConsiderationDTO>}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  patientTreatmentConsideration?: Array<TreatmentConsiderationDTO>;
  /**
   * @description Patient's preferred language for matched BHP
   * @type {LanguageDTO}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description The patients preference towards receiving care via teleservices
   * @type {TeleservicesPreferenceDTO}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @type {boolean}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  isPatientInScope?: boolean;
  /**
   * @type {string}
   * @memberof ResolvePatientForDigitalIntakeResponseDTO
   */
  referrerState?: string;
}

/**
 * @export
 * @interface ResolvePatientForRegistrationDTO
 */
export interface ResolvePatientForRegistrationDTO {
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  emailAddress: string;
  /**
   * @type {PatientReferralChannelDTO}
   * @memberof ResolvePatientForRegistrationDTO
   */
  referralChannel?: PatientReferralChannelDTO;
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  dateOfBirth: string;
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  postalCode: string;
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  phoneNumber?: string;
  /**
   * @type {string}
   * @memberof ResolvePatientForRegistrationDTO
   */
  patientId?: string;
}

/**
 * @export
 * @interface ResolvePatientForRegistrationRequestDTO
 */
export interface ResolvePatientForRegistrationRequestDTO {
  /**
   * @type {ResolvePatientForRegistrationDTO}
   * @memberof ResolvePatientForRegistrationRequestDTO
   */
  patient: ResolvePatientForRegistrationDTO;
}

/**
 * @export
 * @interface ResolvePatientForRegistrationResponseDTO
 */
export interface ResolvePatientForRegistrationResponseDTO {
  /**
   * @description friendly error code for end-users
   * @type {number}
   * @memberof ResolvePatientForRegistrationResponseDTO
   */
  customerServiceCode?: number;
  /**
   * @description obfuscated email address to assist user
   * @type {string}
   * @memberof ResolvePatientForRegistrationResponseDTO
   */
  email?: string;
  /**
   * @description id of patient, if entity match returned a single result
   * @type {string}
   * @memberof ResolvePatientForRegistrationResponseDTO
   */
  patientId?: string;
  /**
   * @type {boolean}
   * @memberof ResolvePatientForRegistrationResponseDTO
   */
  isYouthReferral?: boolean;
}

/**
 * @export
 * @interface ResolvePatientRequestDTO
 */
export interface ResolvePatientRequestDTO {
  /**
   * @description A registration code ID to resolve the patient
   * @type {string}
   * @memberof ResolvePatientRequestDTO
   */
  codeId: string;
  /**
   * @type {string}
   * @memberof ResolvePatientRequestDTO
   */
  dateOfBirth: string;
  /**
   * @type {string}
   * @memberof ResolvePatientRequestDTO
   */
  emailAddress: string;
  /**
   * @type {string}
   * @memberof ResolvePatientRequestDTO
   */
  phoneNumber?: string;
}

/**
 * @export
 * @interface ResolveReferralRequestDTO
 */
export interface ResolveReferralRequestDTO {
  /**
   * @type {string}
   * @memberof ResolveReferralRequestDTO
   */
  insuranceMemberId: string;
  /**
   * @type {string}
   * @memberof ResolveReferralRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof ResolveReferralRequestDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof ResolveReferralRequestDTO
   */
  dateOfBirth: string;
  /**
   * @type {string}
   * @memberof ResolveReferralRequestDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface ResolveReferralResponseDTO
 */
export interface ResolveReferralResponseDTO {
  /**
   * @type {string}
   * @memberof ResolveReferralResponseDTO
   */
  referralId: string;
}

/**
 * @export
 * @interface ResumeBhpAcceptedInsurancePlanRequestDTO
 */
export interface ResumeBhpAcceptedInsurancePlanRequestDTO {
  /**
   * @type {string}
   * @memberof ResumeBhpAcceptedInsurancePlanRequestDTO
   */
  bhpId: string;
  /**
   * @type {string}
   * @memberof ResumeBhpAcceptedInsurancePlanRequestDTO
   */
  insurancePlanId: string;
}

/**
 * @export
 * @interface ResumeReferralsForPracticeRequestDTO
 */
export interface ResumeReferralsForPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof ResumeReferralsForPracticeRequestDTO
   */
  practiceId: string;
}

/**
 * @export
 * @interface ResumeReferralsRequestDTO
 */
export interface ResumeReferralsRequestDTO {
  /**
   * @description The ID of the provider who will start receiving referrals
   * @type {string}
   * @memberof ResumeReferralsRequestDTO
   */
  providerId: string;
}

/**
 * @export
 * @interface RubricDTO
 */
export interface RubricDTO {
  /**
   * @description After applying the scoring function, this is the number you get for module
   * @type {number}
   * @memberof RubricDTO
   */
  total: number;
  /**
   * @description Textual summary of this total
   * @type {string}
   * @memberof RubricDTO
   */
  label: string;
}

/**
 * @export
 * @interface ScheduleAppointmentRequestDTO
 */
export interface ScheduleAppointmentRequestDTO {
  /**
   * @description Date and time for the new appointment
   * @type {string}
   * @memberof ScheduleAppointmentRequestDTO
   */
  appointmentDateTime: string;
  /**
   * @description Location id for the new appointment
   * @type {string}
   * @memberof ScheduleAppointmentRequestDTO
   */
  locationId?: string;
  /**
   * @description Provider id for the new appointment
   * @type {string}
   * @memberof ScheduleAppointmentRequestDTO
   */
  providerId: string;
  /**
   * @description Additional notes for the care event
   * @type {string}
   * @memberof ScheduleAppointmentRequestDTO
   */
  notes?: string;
  /**
   * @type {string}
   * @memberof ScheduleAppointmentRequestDTO
   */
  patientId?: string;
  /**
   * @description The existing Referral id, if this appointment marks a provider joining a careteam
   * @type {string}
   * @memberof ScheduleAppointmentRequestDTO
   */
  referralId?: string;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof ScheduleAppointmentRequestDTO
   */
  setting?: AppointmentSettingDTO;
}

/**
 * @export
 * @interface ScheduleAppointmentResponseDTO
 */
export interface ScheduleAppointmentResponseDTO {
  /**
   * @description The newly scheduled appointment
   * @type {AppointmentDTO}
   * @memberof ScheduleAppointmentResponseDTO
   */
  appointment: AppointmentDTO;
  /**
   * @type {Array<CareEventDTO>}
   * @memberof ScheduleAppointmentResponseDTO
   */
  careEvents: Array<CareEventDTO>;
  /**
   * @type {ReferralDTO}
   * @memberof ScheduleAppointmentResponseDTO
   */
  referral?: ReferralDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ScoreLabelDTO {
  BORDERLINE = 'BORDERLINE',
  DETECTED = 'DETECTED',
  EQUIVOCAL = 'EQUIVOCAL',
  EXCELLENT = 'EXCELLENT',
  FAIR = 'FAIR',
  GOOD = 'GOOD',
  HIGH = 'HIGH',
  HIGHPROBABILITY = 'HIGH-PROBABILITY',
  LESSLIKELY = 'LESS-LIKELY',
  LOW = 'LOW',
  LOWPROBABILITY = 'LOW-PROBABILITY',
  MILD = 'MILD',
  MINIMAL = 'MINIMAL',
  MODERATE = 'MODERATE',
  MODERATELYSEVERE = 'MODERATELY-SEVERE',
  NOLABEL = 'NO LABEL',
  NONEREPORTED = 'NONE-REPORTED',
  NONSIGNIFICANT = 'NON-SIGNIFICANT',
  NOTPRESENT = 'NOT-PRESENT',
  POOR = 'POOR',
  PRESENTANDMODERATE = 'PRESENT-AND-MODERATE',
  PRESENTANDSEVERE = 'PRESENT-AND-SEVERE',
  PRESENTBUTMILD = 'PRESENT-BUT-MILD',
  PROBABLE = 'PROBABLE',
  SEVERE = 'SEVERE',
  SIGNIFICANT = 'SIGNIFICANT',
  VERYGOOD = 'VERY-GOOD'
}

/**
 * @export
 * @enum {string}
 */
export enum ScoringFunctionDTO {
  Sum = 'Sum',
  Mean = 'Mean',
  Max = 'Max'
}

/**
 * @description list of screened recommended patients with completed assessments, patient rejected (aka patient declined), and patient unresponsive statuses
 * @export
 * @interface ScreenedRecommendedPatientListResponseDTO
 */
export interface ScreenedRecommendedPatientListResponseDTO {
  /**
   * @description the list (one or more) of providers with recommended patients
   * @type {Array<ScreenedRecommendedPatientListResponseProvidersDTO>}
   * @memberof ScreenedRecommendedPatientListResponseDTO
   */
  providers?: Array<ScreenedRecommendedPatientListResponseProvidersDTO>;
}

/**
 * @export
 * @interface ScreenedRecommendedPatientListResponsePatientsDTO
 */
export interface ScreenedRecommendedPatientListResponsePatientsDTO {
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  recommendationId?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  dateOfBirth?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  assessmentCompletedDate?: string;
  /**
   * @type {AssessmentResultWithCompletingInfoDTO}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  assessmentResult?: AssessmentResultWithCompletingInfoDTO;
  /**
   * @type {PatientQuartetStatusDTO}
   * @memberof ScreenedRecommendedPatientListResponsePatientsDTO
   */
  patientStatus?: PatientQuartetStatusDTO;
}

/**
 * @export
 * @interface ScreenedRecommendedPatientListResponseProvidersDTO
 */
export interface ScreenedRecommendedPatientListResponseProvidersDTO {
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponseProvidersDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponseProvidersDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ScreenedRecommendedPatientListResponseProvidersDTO
   */
  lastName?: string;
  /**
   * @description list of screened recommended patients with completed assessments, patient rejected (patient declined), and patient unresponsive statuses
   * @type {Array<ScreenedRecommendedPatientListResponsePatientsDTO>}
   * @memberof ScreenedRecommendedPatientListResponseProvidersDTO
   */
  patients?: Array<ScreenedRecommendedPatientListResponsePatientsDTO>;
}

/**
 * @export
 * @interface SelfReferralResponseDTO
 */
export interface SelfReferralResponseDTO {
  /**
   * @description Patient id
   * @type {string}
   * @memberof SelfReferralResponseDTO
   */
  patientId?: string;
  /**
   * @description True if customer is resolved by patient detection
   * @type {boolean}
   * @memberof SelfReferralResponseDTO
   */
  isCustomerPatient: boolean;
}

/**
 * @export
 * @interface SendDigitalOutreachRequestDTO
 */
export interface SendDigitalOutreachRequestDTO {
  /**
   * @type {string}
   * @memberof SendDigitalOutreachRequestDTO
   */
  patientId: string;
  /**
   * @description Salesforce activation case ID
   * @type {string}
   * @memberof SendDigitalOutreachRequestDTO
   */
  externalCaseId: string;
  /**
   * @type {DigitalOutreachTypeDTO}
   * @memberof SendDigitalOutreachRequestDTO
   */
  outreachType: DigitalOutreachTypeDTO;
}

/**
 * @export
 * @interface SendEmailRequestDTO
 */
export interface SendEmailRequestDTO {
  /**
   * @type {string}
   * @memberof SendEmailRequestDTO
   */
  templateName: string;
  /**
   * @type {string}
   * @memberof SendEmailRequestDTO
   */
  email: string;
  /**
   * @type {string}
   * @memberof SendEmailRequestDTO
   */
  subject?: string;
  /**
   * @type {{ [key: string]: string; }}
   * @memberof SendEmailRequestDTO
   */
  templateVariables: { [key: string]: string };
}

/**
 * @export
 * @interface SendMessageRequestDTO
 */
export interface SendMessageRequestDTO {
  /**
   * @description thread that the message belongs to
   * @type {string}
   * @memberof SendMessageRequestDTO
   */
  threadId: string;
  /**
   * @type {string}
   * @memberof SendMessageRequestDTO
   */
  body: string;
}

/**
 * @export
 * @interface SendMessageResponseDTO
 */
export interface SendMessageResponseDTO {
  /**
   * @type {string}
   * @memberof SendMessageResponseDTO
   */
  messageId?: string;
}

/**
 * @export
 * @interface SendSMSAndEmailResponseDTO
 */
export interface SendSMSAndEmailResponseDTO {}

/**
 * @export
 * @interface SendSmsRequestDTO
 */
export interface SendSmsRequestDTO {
  /**
   * @type {string}
   * @memberof SendSmsRequestDTO
   */
  phoneNumber: string;
  /**
   * @type {string}
   * @memberof SendSmsRequestDTO
   */
  message: string;
}

/**
 * @export
 * @interface SendSmsToPatientRequestDTO
 */
export interface SendSmsToPatientRequestDTO {
  /**
   * @type {string}
   * @memberof SendSmsToPatientRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof SendSmsToPatientRequestDTO
   */
  message: string;
}

/**
 * @export
 * @interface SenderDTO
 */
export interface SenderDTO {
  /**
   * @description One of adminId or patientId is required, but not both
   * @type {string}
   * @memberof SenderDTO
   */
  adminId?: string;
  /**
   * @description See comment for adminId
   * @type {string}
   * @memberof SenderDTO
   */
  patientId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ServiceFormatDTO {
  InPerson = 'In-person',
  Tele = 'Tele'
}

/**
 * @export
 * @enum {string}
 */
export enum ServicePathDTO {
  SelfService = 'Self Service',
  CareNav = 'Care Nav'
}

/**
 * @export
 * @interface ServicePathResponseDTO
 */
export interface ServicePathResponseDTO {
  /**
   * @type {ServicePathDTO}
   * @memberof ServicePathResponseDTO
   */
  servicePath?: ServicePathDTO;
}

/**
 * @export
 * @interface SetMhpReferralVolumeRequestDTO
 */
export interface SetMhpReferralVolumeRequestDTO {
  /**
   * @type {string}
   * @memberof SetMhpReferralVolumeRequestDTO
   */
  practiceId: string;
  /**
   * @type {number}
   * @memberof SetMhpReferralVolumeRequestDTO
   */
  referralVolumeTarget?: number;
  /**
   * @type {ReferralVolumePreferenceDTO}
   * @memberof SetMhpReferralVolumeRequestDTO
   */
  referralVolumePreference: ReferralVolumePreferenceDTO;
}

/**
 * @export
 * @interface SetPatientAdditionalPreferencesRequestDTO
 */
export interface SetPatientAdditionalPreferencesRequestDTO {
  /**
   * @description The ID of the patient attempting to update their additional preferences
   * @type {string}
   * @memberof SetPatientAdditionalPreferencesRequestDTO
   */
  patientId: string;
  /**
   * @description The value of their preferred BHP gender
   * @type {GenderDTO}
   * @memberof SetPatientAdditionalPreferencesRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The value of their preferred BHP language
   * @type {LanguageDTO}
   * @memberof SetPatientAdditionalPreferencesRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description The free text describing patient availability
   * @type {string}
   * @memberof SetPatientAdditionalPreferencesRequestDTO
   */
  preferredAppointmentTime?: string;
}

/**
 * @export
 * @interface SetPatientContactTimesPreferenceRequestDTO
 */
export interface SetPatientContactTimesPreferenceRequestDTO {
  /**
   * @description The ID of the patient attempting to update their preferred contact time
   * @type {string}
   * @memberof SetPatientContactTimesPreferenceRequestDTO
   */
  patientId: string;
  /**
   * @description Array of values identified as preferred time to contact patient
   * @type {Array<TimeOfDayDTO>}
   * @memberof SetPatientContactTimesPreferenceRequestDTO
   */
  preferredContactTimes: Array<TimeOfDayDTO>;
}

/**
 * @export
 * @interface SetPatientEmergencyContactsRequestDTO
 */
export interface SetPatientEmergencyContactsRequestDTO {
  /**
   * @type {string}
   * @memberof SetPatientEmergencyContactsRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<EmergencyContactDTO>}
   * @memberof SetPatientEmergencyContactsRequestDTO
   */
  emergencyContacts: Array<EmergencyContactDTO>;
}

/**
 * @export
 * @interface SetPatientPhoneNumbersRequestDTO
 */
export interface SetPatientPhoneNumbersRequestDTO {
  /**
   * @type {string}
   * @memberof SetPatientPhoneNumbersRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof SetPatientPhoneNumbersRequestDTO
   */
  phoneNumbers: Array<PatientPhoneNumberDTO>;
}

/**
 * @export
 * @interface SetPatientSmartMatchPreferencesRequestDTO
 */
export interface SetPatientSmartMatchPreferencesRequestDTO {
  /**
   * @description The ID of the patient attempting to update their smart match preferences
   * @type {string}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<PatientAddressDTO>}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  addresses: Array<PatientAddressDTO>;
  /**
   * @description Array of values identified as preferred time to contact patient
   * @type {Array<TimeOfDayDTO>}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  preferredContactTimes: Array<TimeOfDayDTO>;
  /**
   * @description The preferred mode of transit that a patient would use to get to an appointment
   * @type {TransportationModeDTO}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  travelPreference: TransportationModeDTO;
  /**
   * @description The patients preference towards receiving care via teleservices
   * @type {TeleservicesPreferenceDTO}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  teleservicesPreference?: TeleservicesPreferenceDTO;
  /**
   * @description The value of their preferred BHP gender
   * @type {GenderDTO}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  bhpGenderPreference?: GenderDTO;
  /**
   * @description The value of their preferred BHP language
   * @type {LanguageDTO}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  bhpLanguagePreference?: LanguageDTO;
  /**
   * @description The free text describing patient availability
   * @type {string}
   * @memberof SetPatientSmartMatchPreferencesRequestDTO
   */
  preferredAppointmentTime?: string;
}

/**
 * @export
 * @interface SetPatientTeleservicesPreferenceRequestDTO
 */
export interface SetPatientTeleservicesPreferenceRequestDTO {
  /**
   * @description The ID of the patient whose teleservices preference should be updated
   * @type {string}
   * @memberof SetPatientTeleservicesPreferenceRequestDTO
   */
  patientId: string;
  /**
   * @description Preference of using teleservices setting for the patient
   * @type {TeleservicesPreferenceDTO}
   * @memberof SetPatientTeleservicesPreferenceRequestDTO
   */
  teleservicesPreference: TeleservicesPreferenceDTO;
}

/**
 * @export
 * @interface SetPatientTravelPreferenceRequestDTO
 */
export interface SetPatientTravelPreferenceRequestDTO {
  /**
   * @description The ID of the patient attempting to update their preferred transporation mode
   * @type {string}
   * @memberof SetPatientTravelPreferenceRequestDTO
   */
  patientId: string;
  /**
   * @description The preferred mode of transit that a patient would use to get to an appointment
   * @type {TransportationModeDTO}
   * @memberof SetPatientTravelPreferenceRequestDTO
   */
  travelPreference: TransportationModeDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum SexAtBirthDTO {
  Male = 'Male',
  Female = 'Female',
  Intersex = 'Intersex',
  NotSpecified = 'Not Specified'
}

/**
 * @export
 * @interface SignupProviderResponseDTO
 */
export interface SignupProviderResponseDTO {
  /**
   * @description The email address associated with an account
   * @type {string}
   * @memberof SignupProviderResponseDTO
   */
  emailAddress: string;
  /**
   * @description The id of the new provider
   * @type {string}
   * @memberof SignupProviderResponseDTO
   */
  providerId: string;
}

/**
 * @export
 * @enum {string}
 */
export enum SmartMatchAlgorithmVersionDTO {
  V2 = 'V2',
  V3 = 'V3'
}

/**
 * @export
 * @enum {string}
 */
export enum SourceTypeDTO {
  HealthSystem = 'Health System',
  Practice = 'Practice'
}

/**
 * @export
 * @interface StartCcbtProgramRequestDTO
 */
export interface StartCcbtProgramRequestDTO {
  /**
   * @type {string}
   * @memberof StartCcbtProgramRequestDTO
   */
  patientId: string;
  /**
   * @type {CcbtProgramVendorDTO}
   * @memberof StartCcbtProgramRequestDTO
   */
  vendor: CcbtProgramVendorDTO;
  /**
   * @type {CcbtProgramTypeDTO}
   * @memberof StartCcbtProgramRequestDTO
   */
  programType: CcbtProgramTypeDTO;
  /**
   * @type {CcbtProgramAssessmentTypeDTO}
   * @memberof StartCcbtProgramRequestDTO
   */
  assessmentType: CcbtProgramAssessmentTypeDTO;
  /**
   * @type {string}
   * @memberof StartCcbtProgramRequestDTO
   */
  registrationDate: string;
  /**
   * @type {number}
   * @memberof StartCcbtProgramRequestDTO
   */
  initialScore: number;
  /**
   * @type {string}
   * @memberof StartCcbtProgramRequestDTO
   */
  externalId?: string;
}

/**
 * @export
 * @interface StartCcbtProgramResponseDTO
 */
export interface StartCcbtProgramResponseDTO {
  /**
   * @type {string}
   * @memberof StartCcbtProgramResponseDTO
   */
  ccbtProgramId: string;
}

/**
 * @export
 * @enum {string}
 */
export enum StateDTO {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY'
}

/**
 * @export
 * @enum {string}
 */
export enum StatusInCareDTO {
  Inactive = 'Inactive',
  InTreatment = 'In Treatment'
}

/**
 * @export
 * @interface SubmitAppointmentCanceledReasonRequestDTO
 */
export interface SubmitAppointmentCanceledReasonRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitAppointmentCanceledReasonRequestDTO
   */
  appointmentId: string;
  /**
   * @type {string}
   * @memberof SubmitAppointmentCanceledReasonRequestDTO
   */
  referralId: string;
  /**
   * @type {AppointmentCanceledReasonDTO}
   * @memberof SubmitAppointmentCanceledReasonRequestDTO
   */
  appointmentCanceledReason: AppointmentCanceledReasonDTO;
  /**
   * @description An optional free-text field for when patient selects 'Other' as one of the cancellation reasons
   * @type {string}
   * @memberof SubmitAppointmentCanceledReasonRequestDTO
   */
  freeTextCanceledReason?: string;
}

/**
 * @export
 * @interface SubmitAppointmentMissedReasonRequestDTO
 */
export interface SubmitAppointmentMissedReasonRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitAppointmentMissedReasonRequestDTO
   */
  appointmentId: string;
  /**
   * @type {string}
   * @memberof SubmitAppointmentMissedReasonRequestDTO
   */
  referralId: string;
  /**
   * @type {AppointmentMissedReasonDTO}
   * @memberof SubmitAppointmentMissedReasonRequestDTO
   */
  appointmentMissedReason: AppointmentMissedReasonDTO;
}

/**
 * @export
 * @interface SubmitAssessmentRequestDTO
 */
export interface SubmitAssessmentRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitAssessmentRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof SubmitAssessmentRequestDTO
   */
  completedAt?: string;
  /**
   * @type {string}
   * @memberof SubmitAssessmentRequestDTO
   */
  administeredByBhpId?: string;
  /**
   * @type {string}
   * @memberof SubmitAssessmentRequestDTO
   */
  assessmentId?: string;
  /**
   * @type {Array<AssessmentQuestionResponseDTO>}
   * @memberof SubmitAssessmentRequestDTO
   */
  responses?: Array<AssessmentQuestionResponseDTO>;
  /**
   * @type {string}
   * @memberof SubmitAssessmentRequestDTO
   */
  assessmentResultId?: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof SubmitAssessmentRequestDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @type {Array<AssessmentModuleWithAnswersDTO>}
   * @memberof SubmitAssessmentRequestDTO
   */
  assessmentModulesWithAnswers: Array<AssessmentModuleWithAnswersDTO>;
}

/**
 * @export
 * @interface SubmitAssessmentResponseDTO
 */
export interface SubmitAssessmentResponseDTO {
  /**
   * @type {AssessmentResultWithCompletingInfoDTO}
   * @memberof SubmitAssessmentResponseDTO
   */
  assessmentResult?: AssessmentResultWithCompletingInfoDTO;
  /**
   * @description Obfuscated codeword for whether the Suicidality Question (Sq) threshold was reached.
   * @type {boolean}
   * @memberof SubmitAssessmentResponseDTO
   */
  isSqThresholdReached?: boolean;
}

/**
 * @export
 * @interface SubmitCareOutcomeRequestDTO
 */
export interface SubmitCareOutcomeRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitCareOutcomeRequestDTO
   */
  referralId: string;
  /**
   * @type {Array<OutcomeEntryDTO>}
   * @memberof SubmitCareOutcomeRequestDTO
   */
  outcomeEntries: Array<OutcomeEntryDTO>;
}

/**
 * @export
 * @interface SubmitInitialProgressUpdateRequestDTO
 */
export interface SubmitInitialProgressUpdateRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  bhpId: string;
  /**
   * @type {string}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  treatmentPlan?: string;
  /**
   * @type {string}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  treatmentDiagnosis?: string;
  /**
   * @type {boolean}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  isUrgent: boolean;
  /**
   * @type {string}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  note?: string;
  /**
   * @type {string}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  date?: string;
  /**
   * @type {ProgressUpdateCollaborationTypeDTO}
   * @memberof SubmitInitialProgressUpdateRequestDTO
   */
  collaborationType?: ProgressUpdateCollaborationTypeDTO;
}

/**
 * @export
 * @interface SubmitPatientAppointmentFeedbackRequestDTO
 */
export interface SubmitPatientAppointmentFeedbackRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitPatientAppointmentFeedbackRequestDTO
   */
  appointmentId: string;
  /**
   * @type {string}
   * @memberof SubmitPatientAppointmentFeedbackRequestDTO
   */
  referralId: string;
  /**
   * @type {Array<PatientAppointmentFeedbackResponseDTO>}
   * @memberof SubmitPatientAppointmentFeedbackRequestDTO
   */
  patientAppointmentFeedbackResponses: Array<PatientAppointmentFeedbackResponseDTO>;
}

/**
 * @export
 * @interface SubmitPatientFeatureInterestRequestDTO
 */
export interface SubmitPatientFeatureInterestRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitPatientFeatureInterestRequestDTO
   */
  patientId: string;
  /**
   * @type {PatientFeatureTypeDTO}
   * @memberof SubmitPatientFeatureInterestRequestDTO
   */
  featureType: PatientFeatureTypeDTO;
  /**
   * @type {FeatureInterestResponseDTO}
   * @memberof SubmitPatientFeatureInterestRequestDTO
   */
  featureInterest?: FeatureInterestResponseDTO;
  /**
   * @type {FeatureUtilityResponseDTO}
   * @memberof SubmitPatientFeatureInterestRequestDTO
   */
  featureUtility?: FeatureUtilityResponseDTO;
  /**
   * @type {string}
   * @memberof SubmitPatientFeatureInterestRequestDTO
   */
  featureFreeTextFeedback?: string;
}

/**
 * @export
 * @interface SubmitPatientGoalRequestDTO
 */
export interface SubmitPatientGoalRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitPatientGoalRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof SubmitPatientGoalRequestDTO
   */
  goal: string;
  /**
   * @type {string}
   * @memberof SubmitPatientGoalRequestDTO
   */
  stepToAchieve?: string;
}

/**
 * @export
 * @interface SubmitPatientRejectBhpReasonsRequestDTO
 */
export interface SubmitPatientRejectBhpReasonsRequestDTO {
  /**
   * @type {string}
   * @memberof SubmitPatientRejectBhpReasonsRequestDTO
   */
  referralId: string;
  /**
   * @type {string}
   * @memberof SubmitPatientRejectBhpReasonsRequestDTO
   */
  rejectBhpFreeTextReason?: string;
  /**
   * @type {Array<PatientRejectBhpReasonDTO>}
   * @memberof SubmitPatientRejectBhpReasonsRequestDTO
   */
  rejectBhpReasons: Array<PatientRejectBhpReasonDTO>;
}

/**
 * @export
 * @enum {string}
 */
export enum SupportedLocaleDTO {
  EnUS = 'en_US',
  EsUS = 'es_US'
}

/**
 * @export
 * @interface SupportedPatientNeedsDTO
 */
export interface SupportedPatientNeedsDTO {
  /**
   * @type {boolean}
   * @memberof SupportedPatientNeedsDTO
   */
  includesSevere: boolean;
  /**
   * @type {boolean}
   * @memberof SupportedPatientNeedsDTO
   */
  includesSubstanceAbuse: boolean;
  /**
   * @type {boolean}
   * @memberof SupportedPatientNeedsDTO
   */
  includesMedication: boolean;
  /**
   * @type {boolean}
   * @memberof SupportedPatientNeedsDTO
   */
  includesGeneral: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum TargetTypeDTO {
  CompleteDigitalIntake = 'Complete Digital Intake',
  ViewMatchList = 'View Match List',
  PatientApp = 'Patient App'
}

/**
 * @export
 * @enum {string}
 */
export enum TeleservicesPreferenceDTO {
  TeleOnly = 'Tele only',
  InPersonOnly = 'In-person only',
  TeleAndInPerson = 'Tele and in-person',
  NoPreference = 'No preference'
}

/**
 * @export
 * @enum {string}
 */
export enum TimeOfDayDTO {
  Morning = 'Morning',
  EarlyAfternoon = 'Early Afternoon',
  LateAfternoon = 'Late Afternoon'
}

/**
 * @export
 * @enum {string}
 */
export enum TimeUnitDTO {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months'
}

/**
 * @export
 * @interface TimelineResponseCaseManagerDTO
 */
export interface TimelineResponseCaseManagerDTO {
  /**
   * @type {string}
   * @memberof TimelineResponseCaseManagerDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof TimelineResponseCaseManagerDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof TimelineResponseCaseManagerDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof TimelineResponseCaseManagerDTO
   */
  suffix?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof TimelineResponseCaseManagerDTO
   */
  phoneNumbers: Array<PhoneNumberDTO>;
  /**
   * @type {Array<CaseManagerStatusInQuartetDTO>}
   * @memberof TimelineResponseCaseManagerDTO
   */
  statusInQuartet: Array<CaseManagerStatusInQuartetDTO>;
  /**
   * @type {Array<string>}
   * @memberof TimelineResponseCaseManagerDTO
   */
  groupIds: Array<string>;
}

/**
 * @export
 * @enum {string}
 */
export enum TokenStatusDTO {
  Valid = 'Valid',
  Invalid = 'Invalid',
  Expired = 'Expired'
}

/**
 * @export
 * @enum {string}
 */
export enum TransportationModeDTO {
  Walking = 'Walking',
  Bicycle = 'Bicycle',
  PublicTransit = 'Public Transit',
  Automobile = 'Automobile'
}

/**
 * @export
 * @enum {string}
 */
export enum TreatmentApproachDTO {
  Hypnotherapy = 'Hypnotherapy',
  OnlineScheduling = 'Online Scheduling',
  Depth = 'Depth',
  Couples = 'Couples',
  Somatic = 'Somatic',
  MindBody = 'Mind Body',
  Eclectic = 'Eclectic',
  Psychoanalytic = 'Psychoanalytic',
  Imago = 'Imago',
  Family = 'Family',
  ForensicPsychology = 'Forensic Psychology',
  Existential = 'Existential',
  PlayTherapy = 'Play Therapy',
  SandPlay = 'Sand Play',
  TraumaFocused = 'Trauma Focused',
  AttachmentBased = 'Attachment Based',
  Humanistic = 'Humanistic',
  Narrative = 'Narrative',
  Group = 'Group',
  Integrative = 'Integrative',
  EMDR = 'EMDR',
  Intervention = 'Intervention',
  Dialectical = 'Dialectical',
  Interpersonal = 'Interpersonal',
  CognitiveBehavioralTherapy = 'Cognitive Behavioral Therapy',
  EmotionallyFocused = 'Emotionally Focused',
  FamilySystems = 'Family Systems',
  SolutionFocusedBrief = 'Solution Focused Brief',
  MindfulnessBased = 'Mindfulness Based',
  ArtTherapy = 'Art Therapy',
  Gestalt = 'Gestalt',
  Relational = 'Relational',
  PsychologicalTestingAndEvaluation = 'Psychological Testing And Evaluation',
  GottmanMethod = 'Gottman Method',
  Neurofeedback = 'Neurofeedback',
  Psychodynamic = 'Psychodynamic',
  Coaching = 'Coaching',
  NeuroLinguistic = 'Neuro Linguistic',
  Mobile = 'Mobile',
  ExpressiveArts = 'Expressive Arts',
  FamilyMarital = 'Family Marital',
  Music = 'Music',
  MotivationalInterviewing = 'Motivational Interviewing',
  Jungian = 'Jungian',
  Transpersonal = 'Transpersonal',
  InHome = 'In Home',
  Holistic = 'Holistic',
  BariatricAssessment = 'Bariatric Assessment',
  CaregiverSupport = 'Caregiver Support',
  InpatientTreatment = 'Inpatient Treatment',
  IntensiveOutpatientProgram = 'Intensive Outpatient Program',
  MedicationAssistedTreatment = 'Medication Assisted Treatment',
  OpioidTreatment = 'Opioid Treatment',
  OutpatientTreatment = 'Outpatient Treatment',
  AcceptanceAndCommitment = 'Acceptance and Commitment',
  Biofeedback = 'Biofeedback',
  Brainspotting = 'Brainspotting',
  ExposureTherapy = 'Exposure Therapy',
  FaithBasedCounseling = 'Faith Based Counseling',
  InternalFamilySystems = 'Internal Family Systems',
  ParentChildInteraction = 'Parent Child Interaction',
  PersonCentered = 'Person Centered'
}

/**
 * @export
 * @enum {string}
 */
export enum TreatmentConsiderationDTO {
  Diagnosis = 'Diagnosis',
  Medication = 'Medication',
  Testing = 'Testing',
  Individual = 'Individual',
  Family = 'Family',
  StartMedication = 'Start Medication',
  CurrentMedication = 'Current Medication',
  DrugMedication = 'Drug Medication',
  Other = 'Other'
}

/**
 * @export
 * @interface TreatmentPlanDTO
 */
export interface TreatmentPlanDTO {
  /**
   * @type {string}
   * @memberof TreatmentPlanDTO
   */
  diagnosis?: string;
  /**
   * @type {string}
   * @memberof TreatmentPlanDTO
   */
  medication?: string;
  /**
   * @type {string}
   * @memberof TreatmentPlanDTO
   */
  plan?: string;
}

/**
 * @export
 * @interface TwoFactorAuthDetailsDTO
 */
export interface TwoFactorAuthDetailsDTO {
  /**
   * @description The method of communication the user selected to receive their two factor authentication request
   * @type {TwoFactorAuthMethodDTO}
   * @memberof TwoFactorAuthDetailsDTO
   */
  method: TwoFactorAuthMethodDTO;
  /**
   * @description The masked communication channel (e.g. email address or telephone number) which will be used for MFA on this account
   * @type {string}
   * @memberof TwoFactorAuthDetailsDTO
   */
  maskedMfaChannel: string;
}

/**
 * The method of communication the user selected to receive their two factor authentication request
 * @export
 * @enum {string}
 */
export enum TwoFactorAuthMethodDTO {
  Email = 'Email',
  SMS = 'SMS'
}

/**
 * @export
 * @interface TwoFactorAuthRequestDTO
 */
export interface TwoFactorAuthRequestDTO {
  /**
   * @type {TwoFactorAuthMethodDTO}
   * @memberof TwoFactorAuthRequestDTO
   */
  twoFactorAuthMethod: TwoFactorAuthMethodDTO;
}

/**
 * @export
 * @interface UnlockUserAccountRequestDTO
 */
export interface UnlockUserAccountRequestDTO {
  /**
   * @type {string}
   * @memberof UnlockUserAccountRequestDTO
   */
  username: string;
}

/**
 * @export
 * @interface UpdateCaseManagerProfileRequestDTO
 */
export interface UpdateCaseManagerProfileRequestDTO {
  /**
   * @type {string}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  caseManagerId: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  lastName: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  phoneNumbers: Array<PhoneNumberDTO>;
  /**
   * @type {CommunicationPreferencesDTO}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  communicationPreferences: CommunicationPreferencesDTO;
  /**
   * @type {GroupCaseManagerProfilePermissionsDTO}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  profilePermissions: GroupCaseManagerProfilePermissionsDTO;
  /**
   * @type {Array<string>}
   * @memberof UpdateCaseManagerProfileRequestDTO
   */
  groupIds?: Array<string>;
}

/**
 * @export
 * @interface UpdateHealthSystemAddressRequestDTO
 */
export interface UpdateHealthSystemAddressRequestDTO {
  /**
   * @type {string}
   * @memberof UpdateHealthSystemAddressRequestDTO
   */
  healthSystemId: string;
  /**
   * @type {AddressDTO}
   * @memberof UpdateHealthSystemAddressRequestDTO
   */
  address?: AddressDTO;
}

/**
 * @export
 * @interface UpdatePasswordRequestDTO
 */
export interface UpdatePasswordRequestDTO {
  /**
   * @description The email address of the account wishing to reset its password
   * @type {string}
   * @memberof UpdatePasswordRequestDTO
   */
  emailAddress: string;
  /**
   * @description The new password for this account
   * @type {string}
   * @memberof UpdatePasswordRequestDTO
   */
  newPassword: string;
  /**
   * @description The provided on a reset password request
   * @type {string}
   * @memberof UpdatePasswordRequestDTO
   */
  passwordResetToken: string;
}

/**
 * @export
 * @interface UpdatePatientAddressesRequestDTO
 */
export interface UpdatePatientAddressesRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePatientAddressesRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<PatientAddressDTO>}
   * @memberof UpdatePatientAddressesRequestDTO
   */
  addresses: Array<PatientAddressDTO>;
}

/**
 * @export
 * @interface UpdatePatientAlternativeContactsRequestDTO
 */
export interface UpdatePatientAlternativeContactsRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePatientAlternativeContactsRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof UpdatePatientAlternativeContactsRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
}

/**
 * @export
 * @interface UpdatePatientContactInfoRequestDTO
 */
export interface UpdatePatientContactInfoRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePatientContactInfoRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof UpdatePatientContactInfoRequestDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof UpdatePatientContactInfoRequestDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @description Patient's email addresses (must be exactly one where isPrimary = true)
   * @type {Array<EmailDTO>}
   * @memberof UpdatePatientContactInfoRequestDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {boolean}
   * @memberof UpdatePatientContactInfoRequestDTO
   */
  smsConsent?: boolean;
}

/**
 * @export
 * @interface UpdatePatientInsurancePoliciesRequestDTO
 */
export interface UpdatePatientInsurancePoliciesRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePatientInsurancePoliciesRequestDTO
   */
  patientId: string;
  /**
   * @type {Array<InsurancePolicyDTO>}
   * @memberof UpdatePatientInsurancePoliciesRequestDTO
   */
  insurancePolicies: Array<InsurancePolicyDTO>;
}

/**
 * @export
 * @interface UpdatePatientProfileRequestDTO
 */
export interface UpdatePatientProfileRequestDTO {
  /**
   * @type {PatientDTO}
   * @memberof UpdatePatientProfileRequestDTO
   */
  patient: PatientDTO;
}

/**
 * @export
 * @interface UpdatePatientRematchRequestRequestDTO
 */
export interface UpdatePatientRematchRequestRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePatientRematchRequestRequestDTO
   */
  patientRematchRequestId: string;
  /**
   * @description Reasons why the patient wants a different bhp
   * @type {Array<PatientRematchRequestReasonDTO>}
   * @memberof UpdatePatientRematchRequestRequestDTO
   */
  reasons?: Array<PatientRematchRequestReasonDTO>;
  /**
   * @description An optional free-text field for when patient selects 'Other' as one of the rematch reasons
   * @type {string}
   * @memberof UpdatePatientRematchRequestRequestDTO
   */
  freeTextReason?: string;
  /**
   * @description Whether to process the rematch immediately or at a future date
   * @type {boolean}
   * @memberof UpdatePatientRematchRequestRequestDTO
   */
  isImmediateRequest: boolean;
  /**
   * @description Approximate date patient will be processed for rematching
   * @type {string}
   * @memberof UpdatePatientRematchRequestRequestDTO
   */
  dateToRematch?: string;
}

/**
 * @export
 * @interface UpdatePatientUserInformationRequestDTO
 */
export interface UpdatePatientUserInformationRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  preferredName?: string;
  /**
   * @type {SupportedLocaleDTO}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  locale?: SupportedLocaleDTO;
  /**
   * @type {GenderDTO}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  gender?: GenderDTO;
  /**
   * @type {boolean}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  smsConsent?: boolean;
  /**
   * @type {boolean}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  emailConsent?: boolean;
  /**
   * @type {ResearchConsentDTO}
   * @memberof UpdatePatientUserInformationRequestDTO
   */
  researchConsent?: ResearchConsentDTO;
}

/**
 * @export
 * @interface UpdatePcpPracticeMembershipsRequestDTO
 */
export interface UpdatePcpPracticeMembershipsRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePcpPracticeMembershipsRequestDTO
   */
  pcpId: string;
  /**
   * @type {Array<PcpPracticeMembershipDTO>}
   * @memberof UpdatePcpPracticeMembershipsRequestDTO
   */
  memberships: Array<PcpPracticeMembershipDTO>;
}

/**
 * @export
 * @interface UpdatePcpPracticeRequestDTO
 */
export interface UpdatePcpPracticeRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePcpPracticeRequestDTO
   */
  pcpId: string;
  /**
   * @type {string}
   * @memberof UpdatePcpPracticeRequestDTO
   */
  toPracticeId: string;
  /**
   * @type {string}
   * @memberof UpdatePcpPracticeRequestDTO
   */
  fromPracticeId: string;
}

/**
 * @export
 * @interface UpdatePracticeMembershipsRequestDTO
 */
export interface UpdatePracticeMembershipsRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePracticeMembershipsRequestDTO
   */
  caseManagerId: string;
  /**
   * @type {Array<string>}
   * @memberof UpdatePracticeMembershipsRequestDTO
   */
  practiceIds: Array<string>;
}

/**
 * @export
 * @interface UpdatePreferentialMatchRuleRequestDTO
 */
export interface UpdatePreferentialMatchRuleRequestDTO {
  /**
   * @type {string}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  description?: string;
  /**
   * @type {boolean}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  isActive?: boolean;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  needs: SupportedPatientNeedsDTO;
  /**
   * @type {CreateIntraHealthSystemRuleDTO}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  intraHealthSystem?: CreateIntraHealthSystemRuleDTO;
  /**
   * @type {CreateHealthSystemBhpPartnershipRuleDTO}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  healthSystemBhpPartnership?: CreateHealthSystemBhpPartnershipRuleDTO;
  /**
   * @type {CreatePracticePartnershipRuleDTO}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  practicePartnership?: CreatePracticePartnershipRuleDTO;
  /**
   * @type {CreateInsurancePlanHealthSystemPartnershipRuleDTO}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  insurancePlanHealthSystemPartnership?: CreateInsurancePlanHealthSystemPartnershipRuleDTO;
  /**
   * @type {CreateInsurancePlanBhpPracticePartnershipRuleDTO}
   * @memberof UpdatePreferentialMatchRuleRequestDTO
   */
  insurancePlanBhpPracticePartnership?: CreateInsurancePlanBhpPracticePartnershipRuleDTO;
}

/**
 * @description Core data describing a Provider of any type.
 * @export
 * @interface UpdateProviderDTO
 */
export interface UpdateProviderDTO {
  /**
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  id: string;
  /**
   * @description The provider's first name.
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  firstName?: string;
  /**
   * @description The provider's last name.
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  suffix?: string;
  /**
   * @type {GenderDTO}
   * @memberof UpdateProviderDTO
   */
  gender?: GenderDTO;
  /**
   * @type {ProviderTypeDTO}
   * @memberof UpdateProviderDTO
   */
  type?: ProviderTypeDTO;
  /**
   * @description The provider's National Provider Identifier number.
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  npi?: string;
  /**
   * @description A primary phone number at which the provider can be reached.
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  phoneNumber?: string;
  /**
   * @description A fax number that the provider can receive documents on.
   * @type {string}
   * @memberof UpdateProviderDTO
   */
  faxNumber?: string;
  /**
   * @type {Array<string>}
   * @memberof UpdateProviderDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof UpdateProviderDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof UpdateProviderDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof UpdateProviderDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {number}
   * @memberof UpdateProviderDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {number}
   * @memberof UpdateProviderDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof UpdateProviderDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
}

/**
 * @export
 * @interface UpdateReconciledProvidersRequestDTO
 */
export interface UpdateReconciledProvidersRequestDTO {
  /**
   * @type {string}
   * @memberof UpdateReconciledProvidersRequestDTO
   */
  insurancePlanId?: string;
  /**
   * @type {Array<string>}
   * @memberof UpdateReconciledProvidersRequestDTO
   */
  verifiedProviderNpis?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof UpdateReconciledProvidersRequestDTO
   */
  unverifiedProviderNpis?: Array<string>;
}

/**
 * @export
 * @interface UpdateReferralStateRequestDTO
 */
export interface UpdateReferralStateRequestDTO {
  /**
   * @type {string}
   * @memberof UpdateReferralStateRequestDTO
   */
  referralId: string;
  /**
   * @type {ReferralStateDTO}
   * @memberof UpdateReferralStateRequestDTO
   */
  referralState: ReferralStateDTO;
  /**
   * @type {string}
   * @memberof UpdateReferralStateRequestDTO
   */
  referralDeclineReasonNote?: string;
}

/**
 * @export
 * @interface UpdateReferralStateResponseDTO
 */
export interface UpdateReferralStateResponseDTO {
  /**
   * @type {ReferralWithMetadataDTO}
   * @memberof UpdateReferralStateResponseDTO
   */
  referral: ReferralWithMetadataDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum UserAgreementVersionDTO {
  TermsOfService20171221 = 'Terms Of Service 2017-12-21',
  PrivacyPolicy20171221 = 'Privacy Policy 2017-12-21',
  SoftwareServicesAndLicenseAgreement20171221 = 'Software Services And License Agreement 2017-12-21',
  MhpSoftwareServicesAndLicenseAgreement20200526 = 'Mhp Software Services And License Agreement 2020-05-26',
  PcpSoftwareServicesAndLicenseAgreement20200526 = 'Pcp Software Services And License Agreement 2020-05-26',
  PcpSoftwareServicesAndLicenseAgreement20260731 = 'Pcp Software Services And License Agreement 2026-07-31',
  MhpSoftwareServicesAndLicenseAgreement20260810 = 'Mhp Software Services and License Agreement 2026-08-10'
}

/**
 * @export
 * @enum {string}
 */
export enum UserAuthorityDTO {
  SubmitReferral = 'Submit Referral',
  SubmitCurbside = 'Submit Curbside',
  ViewBHData = 'View BH Data',
  ViewPatientTimeline = 'View Patient Timeline',
  AdministratePCPPractice = 'Administrate PCP Practice',
  AdministrateCMGroup = 'Administrate CM Group'
}

/**
 * @export
 * @enum {string}
 */
export enum UserRoleDTO {
  CaseManager = 'Case Manager',
  IndividualCaseManager = 'Individual Case Manager',
  GroupCaseManager = 'Group Case Manager',
  GroupAdminCaseManager = 'Group Admin Case Manager',
  MHP = 'MHP',
  Patient = 'Patient',
  PCP = 'PCP',
  QuartetAdmin = 'Quartet Admin'
}

/**
 * @export
 * @interface ValidateTokenRequestDTO
 */
export interface ValidateTokenRequestDTO {
  /**
   * @description Token for validation
   * @type {string}
   * @memberof ValidateTokenRequestDTO
   */
  token: string;
  /**
   * @description Neuroflow patient id
   * @type {string}
   * @memberof ValidateTokenRequestDTO
   */
  patientId: string;
}

/**
 * @export
 * @interface ValidateTokenResponseDTO
 */
export interface ValidateTokenResponseDTO {
  /**
   * @type {TokenStatusDTO}
   * @memberof ValidateTokenResponseDTO
   */
  status: TokenStatusDTO;
}

/**
 * @export
 * @enum {string}
 */
export enum ValueBasedProgramPartnerDTO {
  Centene = 'Centene'
}

/**
 * @export
 * @interface VbcDashboardPatientDTO
 */
export interface VbcDashboardPatientDTO {
  /**
   * @type {string}
   * @memberof VbcDashboardPatientDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof VbcDashboardPatientDTO
   */
  mrn?: string;
  /**
   * @type {string}
   * @memberof VbcDashboardPatientDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof VbcDashboardPatientDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof VbcDashboardPatientDTO
   */
  preferredName?: string;
  /**
   * @type {Array<string>}
   * @memberof VbcDashboardPatientDTO
   */
  providerIds: Array<string>;
  /**
   * @type {string}
   * @memberof VbcDashboardPatientDTO
   */
  createdAt?: string;
}

/**
 * @export
 * @interface VbcProgramAssessmentBonusesDTO
 */
export interface VbcProgramAssessmentBonusesDTO {
  /**
   * @type {AssessmentTypeDTO}
   * @memberof VbcProgramAssessmentBonusesDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @description The bonus value (in US$) for partial improvement (see assessmentImprovementCriteria for criteria to qualify for this bonus)
   * @type {number}
   * @memberof VbcProgramAssessmentBonusesDTO
   */
  partialBonus: number;
  /**
   * @description The bonus value (in US$) for full improvement (see assessmentImprovementCriteria for criteria to qualify for this bonus)
   * @type {number}
   * @memberof VbcProgramAssessmentBonusesDTO
   */
  fullBonus: number;
  /**
   * @description The bonus value (in US$) assessment maintenance (see assessmentMaintenanceCriteria for criteria to qualify for this bonus)
   * @type {number}
   * @memberof VbcProgramAssessmentBonusesDTO
   */
  maintenanceBonus: number;
}

/**
 * @export
 * @interface VbcProgramAssessmentImprovementCriteriaDTO
 */
export interface VbcProgramAssessmentImprovementCriteriaDTO {
  /**
   * @type {AssessmentTypeDTO}
   * @memberof VbcProgramAssessmentImprovementCriteriaDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @description The baseline assessment score that needs to be met for an improvement bonus to be paid
   * @type {number}
   * @memberof VbcProgramAssessmentImprovementCriteriaDTO
   */
  minBaselineScore?: number;
  /**
   * @description The percentage the assessment result should change from the baseline (for eg -0.25)
   * @type {number}
   * @memberof VbcProgramAssessmentImprovementCriteriaDTO
   */
  partialImprovementPercentage?: number;
  /**
   * @description The percentage the assessment result should change from the baseline (for eg -0.50)
   * @type {number}
   * @memberof VbcProgramAssessmentImprovementCriteriaDTO
   */
  fullImprovementPercentage?: number;
  /**
   * @description The fixed value the assessment result should change from the baseline (for eg -5)
   * @type {number}
   * @memberof VbcProgramAssessmentImprovementCriteriaDTO
   */
  partialImprovementValue?: number;
  /**
   * @description The fixed value the assessment result should change from the baseline (for eg -10)
   * @type {number}
   * @memberof VbcProgramAssessmentImprovementCriteriaDTO
   */
  fullImprovementValue?: number;
}

/**
 * @export
 * @interface VbcProgramAssessmentMaintenanceCriteriaDTO
 */
export interface VbcProgramAssessmentMaintenanceCriteriaDTO {
  /**
   * @type {AssessmentTypeDTO}
   * @memberof VbcProgramAssessmentMaintenanceCriteriaDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @description The threshold (in percentage) of the baseline assessment result to qualify for this bonus (for eg -0.5)
   * @type {number}
   * @memberof VbcProgramAssessmentMaintenanceCriteriaDTO
   */
  thresholdPercentage?: number;
  /**
   * @description The threshold (in value) of the baseline assessment result to qualify for this bonus (for eg -10)
   * @type {number}
   * @memberof VbcProgramAssessmentMaintenanceCriteriaDTO
   */
  thresholdValue?: number;
  /**
   * @description The maximum frequency this assessment can be paid out per patient. If 'maximumFrequencyWindowValue' and 'maximumFrequencyWindowUnit' values are set then this resets after the window. If 'maximumFrequencyWindowValue' and 'maximumFrequencyWindowUnit' is null then it does not reset once it has been reached.
   * @type {number}
   * @memberof VbcProgramAssessmentMaintenanceCriteriaDTO
   */
  maximumFrequency?: number;
  /**
   * @description The period the maximumFrequency limit applies per patient (the unit value is specified in the maximumFrequencyWindowUnit column). After the window expires the 'maximumFrequency' amount resets. If this value is null, then the 'maximumFrequency' value applies to patient with no reset period
   * @type {number}
   * @memberof VbcProgramAssessmentMaintenanceCriteriaDTO
   */
  maximumFrequencyWindowValue?: number;
  /**
   * @description The unit that the maximum_frequency_window_value represents. Can be DAYS, WEEKS or MONTHS
   * @type {TimeUnitDTO}
   * @memberof VbcProgramAssessmentMaintenanceCriteriaDTO
   */
  maximumFrequencyWindowUnit?: TimeUnitDTO;
}

/**
 * @export
 * @interface VbcProgramBonusAmountsDTO
 */
export interface VbcProgramBonusAmountsDTO {
  /**
   * @description The risk group these bonuses apply to.
   * @type {number}
   * @memberof VbcProgramBonusAmountsDTO
   */
  riskGroup: number;
  /**
   * @description The amount paid (US$) for completing the treatment initiation criteria
   * @type {number}
   * @memberof VbcProgramBonusAmountsDTO
   */
  treatmentInitiation: number;
  /**
   * @description The amount paid (US$) for achieving 'speed to care' criteria for a quartet referral
   * @type {number}
   * @memberof VbcProgramBonusAmountsDTO
   */
  speedToCare: number;
  /**
   * @description The amount paid (US$) for meeting 'community tenure' criteria
   * @type {number}
   * @memberof VbcProgramBonusAmountsDTO
   */
  communityTenure: number;
  /**
   * @description The amount paid (US$) for meeting the outpatient criteria
   * @type {number}
   * @memberof VbcProgramBonusAmountsDTO
   */
  outpatientFollowup: number;
  /**
   * @description The amount paid (US$) for each assessment that qualifies for the startup bonus
   * @type {number}
   * @memberof VbcProgramBonusAmountsDTO
   */
  assessmentStartupBonus: number;
}

/**
 * @export
 * @interface VbcProgramDTO
 */
export interface VbcProgramDTO {
  /**
   * @description The name of the VBC Program
   * @type {string}
   * @memberof VbcProgramDTO
   */
  name: string;
  /**
   * @description A short description of the VBC Program
   * @type {string}
   * @memberof VbcProgramDTO
   */
  description: string;
  /**
   * @description The prefix value to look up this customers claims data in ablative
   * @type {string}
   * @memberof VbcProgramDTO
   */
  claimSource?: string;
  /**
   * @description The markets (insurances) that are eligible for a program. If the insurance plan has a \"minimum age\" eligibility for patients, then it should be set here
   * @type {Array<VbcProgramMarketsDTO>}
   * @memberof VbcProgramDTO
   */
  markets: Array<VbcProgramMarketsDTO>;
  /**
   * @type {VbcProgramStartupAssessmentBonusDTO}
   * @memberof VbcProgramDTO
   */
  startupAssessmentBonus: VbcProgramStartupAssessmentBonusDTO;
  /**
   * @description The assessment bonus values for assessments beyond the baseline assessments.
   * @type {Array<VbcProgramAssessmentBonusesDTO>}
   * @memberof VbcProgramDTO
   */
  assessmentBonuses: Array<VbcProgramAssessmentBonusesDTO>;
  /**
   * @description The maintenance bonus criteria for assessments in this VBC program.
   * @type {Array<VbcProgramAssessmentMaintenanceCriteriaDTO>}
   * @memberof VbcProgramDTO
   */
  assessmentMaintenanceCriteria: Array<VbcProgramAssessmentMaintenanceCriteriaDTO>;
  /**
   * @description The conditions that need to be met for an improvement bonus to be paid for an assessment. The improvement values are expressed either as a '%' of the baseline, or values relative to the baseline.
   * @type {Array<VbcProgramAssessmentImprovementCriteriaDTO>}
   * @memberof VbcProgramDTO
   */
  assessmentImprovementCriteria: Array<VbcProgramAssessmentImprovementCriteriaDTO>;
  /**
   * @description The maximum amount that can be paid per patient, per bonus type annually.
   * @type {Array<VbcProgramMaxBonusAmountsDTO>}
   * @memberof VbcProgramDTO
   */
  maxBonusAmounts: Array<VbcProgramMaxBonusAmountsDTO>;
  /**
   * @description The US$ amount for generic bonus amounts per risk group
   * @type {Array<VbcProgramBonusAmountsDTO>}
   * @memberof VbcProgramDTO
   */
  bonusAmounts: Array<VbcProgramBonusAmountsDTO>;
  /**
   * @type {VbcProgramTreatmentInitiationCriteriaDTO}
   * @memberof VbcProgramDTO
   */
  treatmentInitiationCriteria: VbcProgramTreatmentInitiationCriteriaDTO;
}

/**
 * @export
 * @interface VbcProgramIncludedCategoriesDTO
 */
export interface VbcProgramIncludedCategoriesDTO {
  /**
   * @description The insurance category that is eligible for this market
   * @type {string}
   * @memberof VbcProgramIncludedCategoriesDTO
   */
  category?: string;
  /**
   * @description The subcategories to exclude from eligibility for this category
   * @type {Array<string>}
   * @memberof VbcProgramIncludedCategoriesDTO
   */
  excludedSubcategories?: Array<string>;
}

/**
 * @export
 * @interface VbcProgramMarketsDTO
 */
export interface VbcProgramMarketsDTO {
  /**
   * @description The state of this market
   * @type {string}
   * @memberof VbcProgramMarketsDTO
   */
  state: string;
  /**
   * @description The health plan name of this market
   * @type {string}
   * @memberof VbcProgramMarketsDTO
   */
  healthPlanName: string;
  /**
   * @description The 'id' of the health plan for the insurance customer (For example this is referred to as DIM for centene)
   * @type {string}
   * @memberof VbcProgramMarketsDTO
   */
  planIdentifier: string;
  /**
   * @description The minimum age for patients to be eligible for this insurance in this program (if null then there is no min age)
   * @type {number}
   * @memberof VbcProgramMarketsDTO
   */
  minAge?: number;
  /**
   * @description Does this market require a treatment plan for treatment initiation to be met
   * @type {boolean}
   * @memberof VbcProgramMarketsDTO
   */
  requiresTreatmentPlan?: boolean;
  /**
   * @description The practices that are participating in a program. Reports will be generated for each of these practices.
   * @type {Array<VbcProgramPracticesDTO>}
   * @memberof VbcProgramMarketsDTO
   */
  practices?: Array<VbcProgramPracticesDTO>;
  /**
   * @description The insurance categories that should be used to identify eligible patients for this program market, and any excluded subcategories from this category
   * @type {Array<VbcProgramIncludedCategoriesDTO>}
   * @memberof VbcProgramMarketsDTO
   */
  includedCategories?: Array<VbcProgramIncludedCategoriesDTO>;
}

/**
 * @export
 * @interface VbcProgramMaxBonusAmountsDTO
 */
export interface VbcProgramMaxBonusAmountsDTO {
  /**
   * @description The patient risk group these maximums apply to
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  riskGroup: number;
  /**
   * @description The maximum amount (in US$) that can be paid in treatment initiation bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  treatmentInitiation: number;
  /**
   * @description The maximum amount (in US$) that can be paid in 'speed to care' bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  speedToCare: number;
  /**
   * @description The maximum amount (in US$) that can be paid in 'assessment maintenance' bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  assessmentMaintenance: number;
  /**
   * @description The maximum amount (in US$) that can be paid in 'assessment improvement' bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  assessmentImprovement: number;
  /**
   * @description The maximum amount (in US$) that can be paid in 'community tenure' bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  communityTenure: number;
  /**
   * @description The maximum amount (in US$) that can be paid in 'outpatient followup' bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  outpatientFollowup: number;
  /**
   * @description The maximum amount (in US$) that can be paid in in 'total' bonuses per patient (annually)
   * @type {number}
   * @memberof VbcProgramMaxBonusAmountsDTO
   */
  total: number;
}

/**
 * @export
 * @interface VbcProgramPracticesDTO
 */
export interface VbcProgramPracticesDTO {
  /**
   * @description The tax id number of the practice that is participating in this VBC program. Bonuses will be calculated for this practice using the criteria and bonus parameters for this VBC program.
   * @type {string}
   * @memberof VbcProgramPracticesDTO
   */
  taxIdNumber: string;
  /**
   * @description The name of the practice (This is used to display a user friendly title in the reports)
   * @type {string}
   * @memberof VbcProgramPracticesDTO
   */
  practiceName: string;
  /**
   * @description The date that the practice is considered live in a VBC program. Claims data from this date will be used for bonus/eligibility calculation.
   * @type {string}
   * @memberof VbcProgramPracticesDTO
   */
  goLiveDate: string;
  /**
   * @description The date that the practice will get their first VBC report
   * @type {string}
   * @memberof VbcProgramPracticesDTO
   */
  firstReportDate: string;
  /**
   * @description The date that the practice will get their last VBC report
   * @type {string}
   * @memberof VbcProgramPracticesDTO
   */
  lastReportDate?: string;
  /**
   * @description The atacama practice ids that correspond to this program market practice's tax id number
   * @type {Array<string>}
   * @memberof VbcProgramPracticesDTO
   */
  atacamaPracticeIds?: Array<string>;
}

/**
 * @description The criteria, limits and bonus amounts for the startup assessment bonuses of the VBC program. These bonuses are paid for subsequent assessments taken after the baseline assessment.
 * @export
 * @interface VbcProgramStartupAssessmentBonusDTO
 */
export interface VbcProgramStartupAssessmentBonusDTO {
  /**
   * @description The bonus amount (in US$) paid for each startup assessment
   * @type {number}
   * @memberof VbcProgramStartupAssessmentBonusDTO
   */
  bonusPerAssessment: number;
}

/**
 * @export
 * @interface VbcProgramTreatmentInitiationCriteriaDTO
 */
export interface VbcProgramTreatmentInitiationCriteriaDTO {
  /**
   * @description The period of time (weeks) that the treatment initiation should occur within
   * @type {number}
   * @memberof VbcProgramTreatmentInitiationCriteriaDTO
   */
  treatmentInitiationPeriodWeeks: number;
  /**
   * @description The min number of visits that must be met within the (treatment_initiation_period_days)
   * @type {number}
   * @memberof VbcProgramTreatmentInitiationCriteriaDTO
   */
  minVisits: number;
  /**
   * @description If a treatment plan is required to to meet the treatment initiation
   * @type {boolean}
   * @memberof VbcProgramTreatmentInitiationCriteriaDTO
   */
  requiresTreatmentPlan: boolean;
  /**
   * @description If set, an alternative to 'treatment_initiation_period_days' as long as the 'min_prescriptions' has been met
   * @type {number}
   * @memberof VbcProgramTreatmentInitiationCriteriaDTO
   */
  minVisitsWithPrescriptions: number;
  /**
   * @description The min prescriptions to be filled for 'min_visit_with_prescription' to apply
   * @type {number}
   * @memberof VbcProgramTreatmentInitiationCriteriaDTO
   */
  minPrescriptions: number;
  /**
   * @description The number of days that are required for a 'speed to care' bonus to be paid
   * @type {number}
   * @memberof VbcProgramTreatmentInitiationCriteriaDTO
   */
  speedToCareDays: number;
}

/**
 * @export
 * @interface VerifyTwoFactorAuthRequestDTO
 */
export interface VerifyTwoFactorAuthRequestDTO {
  /**
   * @description The two-factor authentication code
   * @type {string}
   * @memberof VerifyTwoFactorAuthRequestDTO
   */
  authCode: string;
  /**
   * @description If true, generate a new device code for this account
   * @type {boolean}
   * @memberof VerifyTwoFactorAuthRequestDTO
   */
  shouldGenerateDeviceCode?: boolean;
}

/**
 * @export
 * @interface VerifyTwoFactorAuthResponseDTO
 */
export interface VerifyTwoFactorAuthResponseDTO {
  /**
   * @description A new device code for this device, if requested
   * @type {string}
   * @memberof VerifyTwoFactorAuthResponseDTO
   */
  deviceCode?: string;
  /**
   * @type {GetUserDataResponseDTO}
   * @memberof VerifyTwoFactorAuthResponseDTO
   */
  userData: GetUserDataResponseDTO;
}

/**
 * @export
 * @interface AcceptedInsurancePlanResponseDTO
 */
export interface AcceptedInsurancePlanResponseDTO {
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanResponseDTO
   */
  insurancePlanId: string;
  /**
   * @type {boolean}
   * @memberof AcceptedInsurancePlanResponseDTO
   */
  isActive: boolean;
  /**
   * @type {boolean}
   * @memberof AcceptedInsurancePlanResponseDTO
   */
  isTeleSupported?: boolean;
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanResponseDTO
   */
  pauseFromDate?: string;
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanResponseDTO
   */
  pauseUntilDate?: string;
  /**
   * @type {string}
   * @memberof AcceptedInsurancePlanResponseDTO
   */
  name?: string;
}

/**
 * @export
 * @interface AddressWithGeocodeDataDTO
 */
export interface AddressWithGeocodeDataDTO {
  /**
   * @type {string}
   * @memberof AddressWithGeocodeDataDTO
   */
  city?: string;
  /**
   * @type {string}
   * @memberof AddressWithGeocodeDataDTO
   */
  postalCode?: string;
  /**
   * @type {StateDTO}
   * @memberof AddressWithGeocodeDataDTO
   */
  state?: StateDTO;
  /**
   * @type {string}
   * @memberof AddressWithGeocodeDataDTO
   */
  streetAddress?: string;
  /**
   * @type {string}
   * @memberof AddressWithGeocodeDataDTO
   */
  streetAddressLineTwo?: string;
  /**
   * @type {number}
   * @memberof AddressWithGeocodeDataDTO
   */
  latitude?: number;
  /**
   * @type {number}
   * @memberof AddressWithGeocodeDataDTO
   */
  longitude?: number;
  /**
   * @type {string}
   * @memberof AddressWithGeocodeDataDTO
   */
  county?: string;
}

/**
 * @export
 * @interface AppointmentNeedingUpdateDTO
 */
export interface AppointmentNeedingUpdateDTO {
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof AppointmentNeedingUpdateDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof AppointmentNeedingUpdateDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  appointmentId: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  appointmentDate: string;
  /**
   * @type {string}
   * @memberof AppointmentNeedingUpdateDTO
   */
  appointmentLocationId?: string;
  /**
   * @type {AppointmentStatusDTO}
   * @memberof AppointmentNeedingUpdateDTO
   */
  appointmentStatus: AppointmentStatusDTO;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof AppointmentNeedingUpdateDTO
   */
  appointmentSetting: AppointmentSettingDTO;
}

/**
 * @export
 * @interface AssessmentResultWithCompletingInfoDTO
 */
export interface AssessmentResultWithCompletingInfoDTO {
  /**
   * @description Indicates whether or not the patient consented to this assessment
   * @type {boolean}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  hasConsented: boolean;
  /**
   * @type {string}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  id: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @description Id of the patient who took this assessment
   * @type {string}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  patientId: string;
  /**
   * @description results from each module in the assessment
   * @type {Array<AssessmentModuleResultV2DTO>}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  moduleResultsV2: Array<AssessmentModuleResultV2DTO>;
  /**
   * @description State of this result set
   * @type {AssessmentStateDTO}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  state: AssessmentStateDTO;
  /**
   * @description Indicates if the results require urgent attention for patient
   * @type {boolean}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  isUrgent?: boolean;
  /**
   * @description Assessments that are scored positive are presented to PCP users
   * @type {boolean}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  isPositive?: boolean;
  /**
   * @description Type of user who completed the assessment
   * @type {AssessmentCompletingUserTypeDTO}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  completingUserType?: AssessmentCompletingUserTypeDTO;
  /**
   * @description Full name of user who completed the assessment
   * @type {string}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  completingFullName?: string;
  /**
   * @description Practice with which the provider that administered this assessment is affiliated (if applicable)
   * @type {string}
   * @memberof AssessmentResultWithCompletingInfoDTO
   */
  completingUserPracticeName?: string;
}

/**
 * @export
 * @interface BhpPatientTimelineFollowUpAssessmentTaskDTO
 */
export interface BhpPatientTimelineFollowUpAssessmentTaskDTO {
  /**
   * @type {string}
   * @memberof BhpPatientTimelineFollowUpAssessmentTaskDTO
   */
  dueDate?: string;
  /**
   * @type {string}
   * @memberof BhpPatientTimelineFollowUpAssessmentTaskDTO
   */
  completionDate?: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof BhpPatientTimelineFollowUpAssessmentTaskDTO
   */
  assessmentType?: AssessmentTypeDTO;
}

/**
 * @export
 * @interface CareEventExternalIdDTO
 */
export interface CareEventExternalIdDTO {
  /**
   * @type {string}
   * @memberof CareEventExternalIdDTO
   */
  externalId?: string;
  /**
   * @type {string}
   * @memberof CareEventExternalIdDTO
   */
  healthSystemId?: string;
  /**
   * @type {CareEventExternalIdTypeDTO}
   * @memberof CareEventExternalIdDTO
   */
  idType?: CareEventExternalIdTypeDTO;
}

/**
 * @export
 * @interface CareEventWithMetadataDTO
 */
export interface CareEventWithMetadataDTO {
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  appointmentId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  assessmentResultId?: string;
  /**
   * @type {ContactOutcomeDTO}
   * @memberof CareEventWithMetadataDTO
   */
  contactOutcome?: ContactOutcomeDTO;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  creatingProviderId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  creatingCaseManagerId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  creatingAdminId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  creatingPatientId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  curbsideId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  date: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  followupDate?: string;
  /**
   * @type {boolean}
   * @memberof CareEventWithMetadataDTO
   */
  isUrgent: boolean;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  note?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  progressUpdateId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  providerId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  caseManagerId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  id: string;
  /**
   * @type {CareEventTypeDTO}
   * @memberof CareEventWithMetadataDTO
   */
  type: CareEventTypeDTO;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  careTeamId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  referralId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  crisisReferralId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  patientRematchRequestId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  patientContactInfoRequestId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  patientIntakeId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  appointmentDateTime?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  appointmentLocationId?: string;
  /**
   * @type {boolean}
   * @memberof CareEventWithMetadataDTO
   */
  assessmentHighRiskResponse?: boolean;
  /**
   * @type {boolean}
   * @memberof CareEventWithMetadataDTO
   */
  assessmentIsPositive?: boolean;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  assessmentName?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  creatingPracticeId?: string;
  /**
   * @type {string}
   * @memberof CareEventWithMetadataDTO
   */
  externalCaseId?: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof CareEventWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
  /**
   * @type {PatientDTO}
   * @memberof CareEventWithMetadataDTO
   */
  patient?: PatientDTO;
  /**
   * @type {PatientIntakeDTO}
   * @memberof CareEventWithMetadataDTO
   */
  patientIntake?: PatientIntakeDTO;
  /**
   * @type {PatientPreferencesDTO}
   * @memberof CareEventWithMetadataDTO
   */
  patientPreferences?: PatientPreferencesDTO;
  /**
   * @type {PatientServiceTypeDTO}
   * @memberof CareEventWithMetadataDTO
   */
  patientServiceType?: PatientServiceTypeDTO;
  /**
   * @type {Array<PatientConcernDTO>}
   * @memberof CareEventWithMetadataDTO
   */
  patientConcerns?: Array<PatientConcernDTO>;
  /**
   * @type {ProgressUpdateDTO}
   * @memberof CareEventWithMetadataDTO
   */
  progressUpdate?: ProgressUpdateDTO;
  /**
   * @type {CrisisReferralWithTrackingIdDTO}
   * @memberof CareEventWithMetadataDTO
   */
  crisisReferral?: CrisisReferralWithTrackingIdDTO;
  /**
   * @type {CurbsideDTO}
   * @memberof CareEventWithMetadataDTO
   */
  curbside?: CurbsideDTO;
  /**
   * @type {PatientRematchRequestDTO}
   * @memberof CareEventWithMetadataDTO
   */
  patientRematchRequest?: PatientRematchRequestDTO;
}

/**
 * @export
 * @interface CareTeamWithMetadataDTO
 */
export interface CareTeamWithMetadataDTO {
  /**
   * @type {Array<CareTeamMemberDTO>}
   * @memberof CareTeamWithMetadataDTO
   */
  careTeamMembers?: Array<CareTeamMemberDTO>;
  /**
   * @type {Array<CareTeamCaseManagerDTO>}
   * @memberof CareTeamWithMetadataDTO
   */
  caseManagers?: Array<CareTeamCaseManagerDTO>;
  /**
   * @type {Array<CareTeamPcpDTO>}
   * @memberof CareTeamWithMetadataDTO
   */
  pcps?: Array<CareTeamPcpDTO>;
  /**
   * @type {string}
   * @memberof CareTeamWithMetadataDTO
   */
  patientId?: string;
  /**
   * @type {string}
   * @memberof CareTeamWithMetadataDTO
   */
  id: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof CareTeamWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
}

/**
 * @export
 * @interface CaseManagerWithMetadataDTO
 */
export interface CaseManagerWithMetadataDTO {
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof CaseManagerWithMetadataDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerWithMetadataDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof CaseManagerWithMetadataDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerWithMetadataDTO
   */
  firstName?: string;
  /**
   * @type {GenderDTO}
   * @memberof CaseManagerWithMetadataDTO
   */
  gender?: GenderDTO;
  /**
   * @type {string}
   * @memberof CaseManagerWithMetadataDTO
   */
  lastName?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof CaseManagerWithMetadataDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {Array<string>}
   * @memberof CaseManagerWithMetadataDTO
   */
  practices?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof CaseManagerWithMetadataDTO
   */
  groupIds: Array<string>;
  /**
   * @type {string}
   * @memberof CaseManagerWithMetadataDTO
   */
  id: string;
  /**
   * @type {Array<CaseManagerStatusInQuartetDTO>}
   * @memberof CaseManagerWithMetadataDTO
   */
  statusInQuartet?: Array<CaseManagerStatusInQuartetDTO>;
  /**
   * @type {string}
   * @memberof CaseManagerWithMetadataDTO
   */
  suffix?: string;
  /**
   * @type {ProviderProfilePermissionsForAdminDTO}
   * @memberof CaseManagerWithMetadataDTO
   */
  caseManagerProfilePermissions?: ProviderProfilePermissionsForAdminDTO;
  /**
   * @type {EntityMetadataDTO}
   * @memberof CaseManagerWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
  /**
   * @type {Array<string>}
   * @memberof CaseManagerWithMetadataDTO
   */
  healthSystemIds: Array<string>;
}

/**
 * @description The data required to create a Medical Provider.
 * @export
 * @interface CreateMedicalProviderDTO
 */
export interface CreateMedicalProviderDTO {
  /**
   * @description The provider's first name.
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  firstName: string;
  /**
   * @description The provider's last name.
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  suffix?: string;
  /**
   * @type {GenderDTO}
   * @memberof CreateMedicalProviderDTO
   */
  gender?: GenderDTO;
  /**
   * @type {ProviderTypeDTO}
   * @memberof CreateMedicalProviderDTO
   */
  type: ProviderTypeDTO;
  /**
   * @description The provider's National Provider Identifier number.
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  npi?: string;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof CreateMedicalProviderDTO
   */
  pcpPracticeTitle?: PcpPracticeTitleDTO;
  /**
   * @description A primary phone number at which the provider can be reached.
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  phoneNumber?: string;
  /**
   * @description The provider's primary email address.
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  emailAddress: string;
  /**
   * @description A fax number that the provider can receive documents on.
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  faxNumber?: string;
  /**
   * @type {Array<string>}
   * @memberof CreateMedicalProviderDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof CreateMedicalProviderDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof CreateMedicalProviderDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {Array<UserAgreementVersionDTO>}
   * @memberof CreateMedicalProviderDTO
   */
  userAgreementVersions?: Array<UserAgreementVersionDTO>;
  /**
   * @type {string}
   * @memberof CreateMedicalProviderDTO
   */
  password?: string;
}

/**
 * @export
 * @interface CrisisReferralWithTrackingIdDTO
 */
export interface CrisisReferralWithTrackingIdDTO {
  /**
   * @type {string}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  patientId: string;
  /**
   * @type {CrisisReferralTypeDTO}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  type: CrisisReferralTypeDTO;
  /**
   * @type {string}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  referredDate: string;
  /**
   * @type {CrisisReferralResolutionDTO}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  resolution?: CrisisReferralResolutionDTO;
  /**
   * @type {string}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  resolvedDate?: string;
  /**
   * @type {string}
   * @memberof CrisisReferralWithTrackingIdDTO
   */
  trackingId: string;
}

/**
 * @export
 * @interface ExternalPatientDemographicsDTO
 */
export interface ExternalPatientDemographicsDTO {
  /**
   * @type {Array<string>}
   * @memberof ExternalPatientDemographicsDTO
   */
  insuranceMemberIds?: Array<string>;
  /**
   * @type {string}
   * @memberof ExternalPatientDemographicsDTO
   */
  firstName: string;
  /**
   * @type {string}
   * @memberof ExternalPatientDemographicsDTO
   */
  lastName: string;
  /**
   * @type {string}
   * @memberof ExternalPatientDemographicsDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof ExternalPatientDemographicsDTO
   */
  dateOfBirth: string;
  /**
   * @type {Array<string>}
   * @memberof ExternalPatientDemographicsDTO
   */
  zipCodes: Array<string>;
  /**
   * @type {string}
   * @memberof ExternalPatientDemographicsDTO
   */
  primaryPhoneNumber?: string;
  /**
   * @type {string}
   * @memberof ExternalPatientDemographicsDTO
   */
  primaryEmail?: string;
  /**
   * @type {PatientExternalIdDTO}
   * @memberof ExternalPatientDemographicsDTO
   */
  externalId?: PatientExternalIdDTO;
  /**
   * @type {GenderDTO}
   * @memberof ExternalPatientDemographicsDTO
   */
  gender?: GenderDTO;
}

/**
 * @export
 * @interface ExternalPcpDemographicsDTO
 */
export interface ExternalPcpDemographicsDTO {
  /**
   * @type {string}
   * @memberof ExternalPcpDemographicsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ExternalPcpDemographicsDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof ExternalPcpDemographicsDTO
   */
  dateOfBirth?: string;
  /**
   * @type {string}
   * @memberof ExternalPcpDemographicsDTO
   */
  npi?: string;
  /**
   * @type {ProviderExternalIdDTO}
   * @memberof ExternalPcpDemographicsDTO
   */
  externalId?: ProviderExternalIdDTO;
}

/**
 * @export
 * @interface GetPracticeAndProviderDetailsForOpsPageResponseDTO
 */
export interface GetPracticeAndProviderDetailsForOpsPageResponseDTO {
  /**
   * @type {Array<PracticeDetailsForOpsDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsPageResponseDTO
   */
  practices: Array<PracticeDetailsForOpsDTO>;
  /**
   * @type {Array<ProviderDetailsWithPracticesForOpsDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsPageResponseDTO
   */
  providers: Array<ProviderDetailsWithPracticesForOpsDTO>;
  /**
   * @type {Array<InsurancePlanDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsPageResponseDTO
   */
  insurancePlans: Array<InsurancePlanDTO>;
  /**
   * @type {Array<LocationForOpsDTO>}
   * @memberof GetPracticeAndProviderDetailsForOpsPageResponseDTO
   */
  locations: Array<LocationForOpsDTO>;
  /**
   * @type {PageDTO}
   * @memberof GetPracticeAndProviderDetailsForOpsPageResponseDTO
   */
  page?: PageDTO;
}

/**
 * @export
 * @interface GroupCaseManagerPermissionsWithMetadataDTO
 */
export interface GroupCaseManagerPermissionsWithMetadataDTO {
  /**
   * @type {boolean}
   * @memberof GroupCaseManagerPermissionsWithMetadataDTO
   */
  canAdministerGroup?: boolean;
  /**
   * @type {boolean}
   * @memberof GroupCaseManagerPermissionsWithMetadataDTO
   */
  canViewBehavioralHealthAssessmentsAndConsultNotes?: boolean;
  /**
   * @type {boolean}
   * @memberof GroupCaseManagerPermissionsWithMetadataDTO
   */
  canViewPatientReferralProviderAndAppointmentDetails?: boolean;
  /**
   * @description ID of the provider or case manager on the account
   * @type {string}
   * @memberof GroupCaseManagerPermissionsWithMetadataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof GroupCaseManagerPermissionsWithMetadataDTO
   */
  lastName?: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof GroupCaseManagerPermissionsWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
}

/**
 * @export
 * @interface HealthSystemWithMetadataDTO
 */
export interface HealthSystemWithMetadataDTO {
  /**
   * @type {string}
   * @memberof HealthSystemWithMetadataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof HealthSystemWithMetadataDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof HealthSystemWithMetadataDTO
   */
  parentId?: string;
  /**
   * @type {AddressDTO}
   * @memberof HealthSystemWithMetadataDTO
   */
  address?: AddressDTO;
  /**
   * @type {EntityMetadataDTO}
   * @memberof HealthSystemWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
}

/**
 * @export
 * @interface HighRiskAssessmentDTO
 */
export interface HighRiskAssessmentDTO {
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof HighRiskAssessmentDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof HighRiskAssessmentDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  assessmentResultId?: string;
  /**
   * @type {string}
   * @memberof HighRiskAssessmentDTO
   */
  dateCompleted?: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof HighRiskAssessmentDTO
   */
  assessmentType: AssessmentTypeDTO;
}

/**
 * @export
 * @interface LocationWithMetadataDTO
 */
export interface LocationWithMetadataDTO {
  /**
   * @type {AddressWithGeocodeDataDTO}
   * @memberof LocationWithMetadataDTO
   */
  address?: AddressWithGeocodeDataDTO;
  /**
   * @type {string}
   * @memberof LocationWithMetadataDTO
   */
  name?: string;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof LocationWithMetadataDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {string}
   * @memberof LocationWithMetadataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof LocationWithMetadataDTO
   */
  tin?: string;
  /**
   * @type {string}
   * @memberof LocationWithMetadataDTO
   */
  tinRemitAddress?: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof LocationWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
}

/**
 * @export
 * @interface NotificationForTimelineDTO
 */
export interface NotificationForTimelineDTO {
  /**
   * @type {string}
   * @memberof NotificationForTimelineDTO
   */
  id?: string;
  /**
   * @type {CareEventDTO}
   * @memberof NotificationForTimelineDTO
   */
  careEvent: CareEventDTO;
  /**
   * @type {NotificationTypeDTO}
   * @memberof NotificationForTimelineDTO
   */
  type: NotificationTypeDTO;
  /**
   * @type {NotificationStateDTO}
   * @memberof NotificationForTimelineDTO
   */
  status: NotificationStateDTO;
  /**
   * @type {string}
   * @memberof NotificationForTimelineDTO
   */
  instant: string;
  /**
   * @type {boolean}
   * @memberof NotificationForTimelineDTO
   */
  isAcknowledged?: boolean;
  /**
   * @description The provider that the notification is intended for
   * @type {ProviderDTO}
   * @memberof NotificationForTimelineDTO
   */
  provider?: ProviderDTO;
  /**
   * @description The provider that acknowledged the notification (if it is of type Provider and has been acknowledged)
   * @type {ProviderDTO}
   * @memberof NotificationForTimelineDTO
   */
  acknowledgingProvider?: ProviderDTO;
  /**
   * @description The case manager that the notification is intended for
   * @type {CaseManagerDTO}
   * @memberof NotificationForTimelineDTO
   */
  caseManager?: CaseManagerDTO;
  /**
   * @description The case manager that acknowledged the notification (if it is of type Case Manager and has been acknowledged)
   * @type {CaseManagerDTO}
   * @memberof NotificationForTimelineDTO
   */
  acknowledgingCaseManager?: CaseManagerDTO;
}

/**
 * @export
 * @interface PatientAddressDTO
 */
export interface PatientAddressDTO {
  /**
   * @type {string}
   * @memberof PatientAddressDTO
   */
  city?: string;
  /**
   * @type {string}
   * @memberof PatientAddressDTO
   */
  postalCode?: string;
  /**
   * @type {StateDTO}
   * @memberof PatientAddressDTO
   */
  state?: StateDTO;
  /**
   * @type {string}
   * @memberof PatientAddressDTO
   */
  streetAddress?: string;
  /**
   * @type {string}
   * @memberof PatientAddressDTO
   */
  streetAddressLineTwo?: string;
  /**
   * @type {string}
   * @memberof PatientAddressDTO
   */
  id?: string;
  /**
   * @type {AddressTypeDTO}
   * @memberof PatientAddressDTO
   */
  type?: AddressTypeDTO;
  /**
   * @type {boolean}
   * @memberof PatientAddressDTO
   */
  isPrimaryAddressForSmartMatch: boolean;
  /**
   * @type {string}
   * @memberof PatientAddressDTO
   */
  googlePlaceId?: string;
}

/**
 * @export
 * @interface PatientContactPhoneNumberDTO
 */
export interface PatientContactPhoneNumberDTO {
  /**
   * @type {boolean}
   * @memberof PatientContactPhoneNumberDTO
   */
  isPrimary?: boolean;
  /**
   * @type {string}
   * @memberof PatientContactPhoneNumberDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof PatientContactPhoneNumberDTO
   */
  phoneNumber: string;
  /**
   * @type {PhoneNumberTypeDTO}
   * @memberof PatientContactPhoneNumberDTO
   */
  type?: PhoneNumberTypeDTO;
  /**
   * @type {boolean}
   * @memberof PatientContactPhoneNumberDTO
   */
  canLeaveVoicemail?: boolean;
}

/**
 * @export
 * @interface PatientDTO
 */
export interface PatientDTO {
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  id?: string;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  suffix?: string;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  dateOfBirth?: string;
  /**
   * @type {GenderDTO}
   * @memberof PatientDTO
   */
  gender?: GenderDTO;
  /**
   * @type {AddressDTO}
   * @memberof PatientDTO
   */
  address?: AddressDTO;
  /**
   * @type {Array<PatientAddressDTO>}
   * @memberof PatientDTO
   */
  addresses?: Array<PatientAddressDTO>;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof PatientDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {Array<PatientQuartetStatusDTO>}
   * @memberof PatientDTO
   */
  patientQuartetStatuses?: Array<PatientQuartetStatusDTO>;
  /**
   * @type {Array<EmailDTO>}
   * @memberof PatientDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {Array<InsurancePolicyDTO>}
   * @memberof PatientDTO
   */
  insurancePolicies?: Array<InsurancePolicyDTO>;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof PatientDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {PatientPreferencesDTO}
   * @memberof PatientDTO
   */
  preferences?: PatientPreferencesDTO;
  /**
   * @type {SupportedLocaleDTO}
   * @memberof PatientDTO
   */
  locale?: SupportedLocaleDTO;
  /**
   * @type {PatientSmartMatchPreferencesDTO}
   * @memberof PatientDTO
   */
  smartMatchPreferences?: PatientSmartMatchPreferencesDTO;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  careNavigatorId?: string;
  /**
   * @type {boolean}
   * @memberof PatientDTO
   */
  isReferredYouth?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientDTO
   */
  inScope?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientDTO
   */
  collaborativeCarePatient?: boolean;
  /**
   * @type {string}
   * @memberof PatientDTO
   */
  inScopeReason?: string;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof PatientDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
  /**
   * @type {PatientServiceTypeDTO}
   * @memberof PatientDTO
   */
  serviceType?: PatientServiceTypeDTO;
  /**
   * @type {Array<PatientConcernDTO>}
   * @memberof PatientDTO
   */
  concerns?: Array<PatientConcernDTO>;
}

/**
 * @export
 * @interface PatientExternalIdDTO
 */
export interface PatientExternalIdDTO {
  /**
   * @type {string}
   * @memberof PatientExternalIdDTO
   */
  externalId?: string;
  /**
   * @type {string}
   * @memberof PatientExternalIdDTO
   */
  healthSystemId?: string;
  /**
   * @type {PatientExternalIdTypeDTO}
   * @memberof PatientExternalIdDTO
   */
  idType?: PatientExternalIdTypeDTO;
}

/**
 * @export
 * @interface PatientNeedingUpdateDTO
 */
export interface PatientNeedingUpdateDTO {
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof PatientNeedingUpdateDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof PatientNeedingUpdateDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  dateOfLastUpdate: string;
  /**
   * @type {string}
   * @memberof PatientNeedingUpdateDTO
   */
  dueDate?: string;
  /**
   * @type {CareEventTypeDTO}
   * @memberof PatientNeedingUpdateDTO
   */
  typeOfLastUpdate: CareEventTypeDTO;
}

/**
 * @export
 * @interface PatientPhoneNumberDTO
 */
export interface PatientPhoneNumberDTO {
  /**
   * @type {boolean}
   * @memberof PatientPhoneNumberDTO
   */
  isPrimary?: boolean;
  /**
   * @type {string}
   * @memberof PatientPhoneNumberDTO
   */
  name?: string;
  /**
   * @type {string}
   * @memberof PatientPhoneNumberDTO
   */
  phoneNumber: string;
  /**
   * @type {PhoneNumberTypeDTO}
   * @memberof PatientPhoneNumberDTO
   */
  type?: PhoneNumberTypeDTO;
  /**
   * @type {boolean}
   * @memberof PatientPhoneNumberDTO
   */
  canLeaveVoicemail?: boolean;
}

/**
 * @export
 * @interface PendingReferralDTO
 */
export interface PendingReferralDTO {
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof PendingReferralDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof PendingReferralDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  referralId: string;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  referralExpirationDate: string;
  /**
   * @type {InsuranceCategoryDTO}
   * @memberof PendingReferralDTO
   */
  patientInsuranceCategory: InsuranceCategoryDTO;
  /**
   * @type {StateDTO}
   * @memberof PendingReferralDTO
   */
  patientInsuranceState: StateDTO;
  /**
   * @type {string}
   * @memberof PendingReferralDTO
   */
  patientInsuranceCarrier: string;
  /**
   * @type {boolean}
   * @memberof PendingReferralDTO
   */
  collaborativeCarePatient?: boolean;
}

/**
 * @export
 * @interface PracticeWithMetadataDTO
 */
export interface PracticeWithMetadataDTO {
  /**
   * @type {Array<string>}
   * @memberof PracticeWithMetadataDTO
   */
  caseManagers?: Array<string>;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  healthSystemId?: string;
  /**
   * @type {Array<LocationDTO>}
   * @memberof PracticeWithMetadataDTO
   */
  locations?: Array<LocationDTO>;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  name: string;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  npi?: string;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof PracticeWithMetadataDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
  /**
   * @type {PracticeSettingDTO}
   * @memberof PracticeWithMetadataDTO
   */
  practiceSetting?: PracticeSettingDTO;
  /**
   * @type {PracticeTypeDTO}
   * @memberof PracticeWithMetadataDTO
   */
  type?: PracticeTypeDTO;
  /**
   * @type {Array<string>}
   * @memberof PracticeWithMetadataDTO
   */
  providers?: Array<string>;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  id: string;
  /**
   * @type {QuartetRegionDTO}
   * @memberof PracticeWithMetadataDTO
   */
  quartetRegion?: QuartetRegionDTO;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  creatingProviderId?: string;
  /**
   * @type {BhpPracticeSmartMatchPreferencesDTO}
   * @memberof PracticeWithMetadataDTO
   */
  bhpPracticeSmartMatchPreferences?: BhpPracticeSmartMatchPreferencesDTO;
  /**
   * @type {boolean}
   * @memberof PracticeWithMetadataDTO
   */
  isTeleOnly?: boolean;
  /**
   * @type {boolean}
   * @memberof PracticeWithMetadataDTO
   */
  isDirectSchedulingEnabled?: boolean;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  email?: string;
  /**
   * @type {Array<ServiceFormatDTO>}
   * @memberof PracticeWithMetadataDTO
   */
  serviceFormats?: Array<ServiceFormatDTO>;
  /**
   * @type {Array<InsurancePlanCountyRestrictionDTO>}
   * @memberof PracticeWithMetadataDTO
   */
  insurancePlanCountyRestriction?: Array<InsurancePlanCountyRestrictionDTO>;
  /**
   * @type {string}
   * @memberof PracticeWithMetadataDTO
   */
  description?: string;
  /**
   * @type {boolean}
   * @memberof PracticeWithMetadataDTO
   */
  isValueBasedPartner?: boolean;
  /**
   * @type {ValueBasedProgramPartnerDTO}
   * @memberof PracticeWithMetadataDTO
   */
  valueBasedProgramPartner?: ValueBasedProgramPartnerDTO;
  /**
   * @type {EntityMetadataDTO}
   * @memberof PracticeWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
  /**
   * @type {number}
   * @memberof PracticeWithMetadataDTO
   */
  referralVolumeTarget?: number;
  /**
   * @type {ReferralVolumePreferenceDTO}
   * @memberof PracticeWithMetadataDTO
   */
  referralVolumePreference?: ReferralVolumePreferenceDTO;
}

/**
 * @export
 * @interface ProviderDetailsWithPracticesForOpsDTO
 */
export interface ProviderDetailsWithPracticesForOpsDTO {
  /**
   * @type {string}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  lastName?: string;
  /**
   * @type {GenderDTO}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  gender?: GenderDTO;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  supportedPatientNeeds?: SupportedPatientNeedsDTO;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {Array<string>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {Array<AcceptedInsurancePlanDTO>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  acceptedInsurancePlans?: Array<AcceptedInsurancePlanDTO>;
  /**
   * @type {number}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {number}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {Array<string>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  locationIds?: Array<string>;
  /**
   * @type {boolean}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  canReceiveReferrals?: boolean;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
  /**
   * @type {Array<string>}
   * @memberof ProviderDetailsWithPracticesForOpsDTO
   */
  practiceIds: Array<string>;
}

/**
 * @export
 * @interface ProviderExternalIdDTO
 */
export interface ProviderExternalIdDTO {
  /**
   * @type {string}
   * @memberof ProviderExternalIdDTO
   */
  externalId?: string;
  /**
   * @type {string}
   * @memberof ProviderExternalIdDTO
   */
  healthSystemId?: string;
  /**
   * @type {ProviderExternalIdTypeDTO}
   * @memberof ProviderExternalIdDTO
   */
  idType?: ProviderExternalIdTypeDTO;
}

/**
 * @export
 * @interface ProviderProfilePermissionsForAdminWithMetadataDTO
 */
export interface ProviderProfilePermissionsForAdminWithMetadataDTO {
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  canViewBehavioralHealthData?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  canSubmitPatient?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  canViewReferralDetails?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  canViewRecommendedPatients?: boolean;
  /**
   * @description ID of the provider or case manager on the account
   * @type {string}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  lastName?: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof ProviderProfilePermissionsForAdminWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
}

/**
 * @export
 * @interface ProviderWithMetadataDTO
 */
export interface ProviderWithMetadataDTO {
  /**
   * @type {Array<string>}
   * @memberof ProviderWithMetadataDTO
   */
  acceptedInsurancePlanIds?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof ProviderWithMetadataDTO
   */
  associatedPractices?: Array<string>;
  /**
   * @type {BhProviderTypeDTO}
   * @memberof ProviderWithMetadataDTO
   */
  bhProviderType?: BhProviderTypeDTO;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  dateOfBirth?: string;
  /**
   * @type {Array<EmailDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  firstName?: string;
  /**
   * @type {GenderDTO}
   * @memberof ProviderWithMetadataDTO
   */
  gender?: GenderDTO;
  /**
   * @type {Array<LanguageDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  languages?: Array<LanguageDTO>;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  lastName?: string;
  /**
   * @type {LicenseDTO}
   * @memberof ProviderWithMetadataDTO
   */
  license?: LicenseDTO;
  /**
   * @type {Array<LicenseDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  licenses?: Array<LicenseDTO>;
  /**
   * @type {Array<string>}
   * @memberof ProviderWithMetadataDTO
   */
  locations?: Array<string>;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  npi?: string;
  /**
   * @type {number}
   * @memberof ProviderWithMetadataDTO
   */
  patientMaximumAge?: number;
  /**
   * @type {number}
   * @memberof ProviderWithMetadataDTO
   */
  patientMinimumAge?: number;
  /**
   * @type {PcpPracticeTitleDTO}
   * @memberof ProviderWithMetadataDTO
   */
  pcpPracticeTitle?: PcpPracticeTitleDTO;
  /**
   * @type {Array<PhoneNumberDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  phoneNumbers?: Array<PhoneNumberDTO>;
  /**
   * @type {BhpSmartMatchPreferencesDTO}
   * @memberof ProviderWithMetadataDTO
   */
  preferences?: BhpSmartMatchPreferencesDTO;
  /**
   * @type {Array<ProviderStatusInQuartetDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  providerStatusInQuartet?: Array<ProviderStatusInQuartetDTO>;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  id: string;
  /**
   * @type {Array<ConditionDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  specialties?: Array<ConditionDTO>;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  suffix?: string;
  /**
   * @type {Array<TreatmentApproachDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  treatmentApproaches?: Array<TreatmentApproachDTO>;
  /**
   * @type {boolean}
   * @memberof ProviderWithMetadataDTO
   */
  isQHVerified?: boolean;
  /**
   * @description flag to determine if this provider is allowed to receive referrals
   * @type {boolean}
   * @memberof ProviderWithMetadataDTO
   */
  canReceiveReferrals?: boolean;
  /**
   * @type {boolean}
   * @memberof ProviderWithMetadataDTO
   */
  isUsingSupervisorsNpi?: boolean;
  /**
   * @type {ProviderTypeDTO}
   * @memberof ProviderWithMetadataDTO
   */
  type?: ProviderTypeDTO;
  /**
   * @type {BhpTeleSettingsDTO}
   * @memberof ProviderWithMetadataDTO
   */
  teleSettings?: BhpTeleSettingsDTO;
  /**
   * @type {RaceEthnicityDTO}
   * @memberof ProviderWithMetadataDTO
   */
  raceEthnicity?: RaceEthnicityDTO;
  /**
   * @type {string}
   * @memberof ProviderWithMetadataDTO
   */
  tin?: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof ProviderWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
  /**
   * @type {Array<ProviderExternalIdDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  providerExternalIds?: Array<ProviderExternalIdDTO>;
  /**
   * @type {ProviderClassificationDTO}
   * @memberof ProviderWithMetadataDTO
   */
  classification?: ProviderClassificationDTO;
  /**
   * @type {SupportedPatientNeedsDTO}
   * @memberof ProviderWithMetadataDTO
   */
  supportedPatientNeeds?: SupportedPatientNeedsDTO;
  /**
   * @type {Array<AcceptedInsurancePlanResponseDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  acceptedInsurancePlans?: Array<AcceptedInsurancePlanResponseDTO>;
  /**
   * @type {Array<PrimaryCarePracticeMembershipDTO>}
   * @memberof ProviderWithMetadataDTO
   */
  primaryCarePracticeMemberships?: Array<PrimaryCarePracticeMembershipDTO>;
}

/**
 * @export
 * @interface ReferralNeedingContactDTO
 */
export interface ReferralNeedingContactDTO {
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof ReferralNeedingContactDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof ReferralNeedingContactDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  referralId: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  dateOfReferralAccepted?: string;
  /**
   * @type {string}
   * @memberof ReferralNeedingContactDTO
   */
  dateOfLastContactLog?: string;
}

/**
 * @export
 * @interface ReferralWithMetadataDTO
 */
export interface ReferralWithMetadataDTO {
  /**
   * @type {DeclineReasonDTO}
   * @memberof ReferralWithMetadataDTO
   */
  declineReason?: DeclineReasonDTO;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  declineReasonNote?: string;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  referralExpirationDate?: string;
  /**
   * @type {ReferralStateDTO}
   * @memberof ReferralWithMetadataDTO
   */
  referralState: ReferralStateDTO;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  referredDate?: string;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  referralAcceptDate?: string;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  referralDeclineDate?: string;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof ReferralWithMetadataDTO
   */
  id: string;
  /**
   * @type {EntityMetadataDTO}
   * @memberof ReferralWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
}

/**
 * @export
 * @interface ReschedulePastAppointmentRequestDTO
 */
export interface ReschedulePastAppointmentRequestDTO {
  /**
   * @description Appointment ID to reschedule
   * @type {string}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  appointmentId: string;
  /**
   * @description New appointment start date and time
   * @type {string}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  startDateTime: string;
  /**
   * @description New provider ID of rescheduled appointment
   * @type {string}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  providerId?: string;
  /**
   * @description Location ID of rescheduled appointment
   * @type {string}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  locationId?: string;
  /**
   * @description A note for the reschedule care event
   * @type {string}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  note?: string;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  setting?: AppointmentSettingDTO;
  /**
   * @type {AppointmentStatusDTO}
   * @memberof ReschedulePastAppointmentRequestDTO
   */
  appointmentStatus: AppointmentStatusDTO;
}

/**
 * @export
 * @interface SchedulePastAppointmentRequestDTO
 */
export interface SchedulePastAppointmentRequestDTO {
  /**
   * @description Date and time for the new appointment
   * @type {string}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  appointmentDateTime: string;
  /**
   * @description Location id for the new appointment
   * @type {string}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  locationId?: string;
  /**
   * @description Provider id for the new appointment
   * @type {string}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  providerId: string;
  /**
   * @description Additional notes for the care event
   * @type {string}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  notes?: string;
  /**
   * @type {string}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  patientId?: string;
  /**
   * @description The existing Referral id, if this appointment marks a provider joining a careteam
   * @type {string}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  referralId?: string;
  /**
   * @type {AppointmentSettingDTO}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  setting?: AppointmentSettingDTO;
  /**
   * @type {AppointmentStatusDTO}
   * @memberof SchedulePastAppointmentRequestDTO
   */
  appointmentStatus?: AppointmentStatusDTO;
}

/**
 * @export
 * @interface VbcBaselineAssessmentDTO
 */
export interface VbcBaselineAssessmentDTO {
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof VbcBaselineAssessmentDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof VbcBaselineAssessmentDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof VbcBaselineAssessmentDTO
   */
  dueDate: string;
}

/**
 * @export
 * @interface VbcFollowupAssessmentDTO
 */
export interface VbcFollowupAssessmentDTO {
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientId: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientFirstName: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientLastName: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientPreferredName?: string;
  /**
   * @type {GenderDTO}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientGender?: GenderDTO;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientDob?: string;
  /**
   * @type {boolean}
   * @memberof VbcFollowupAssessmentDTO
   */
  isBcncVbcPatient?: boolean;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  providerId: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  providerFirstName: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  providerLastName: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  dueDate: string;
  /**
   * @type {AssessmentTypeDTO}
   * @memberof VbcFollowupAssessmentDTO
   */
  assessmentType: AssessmentTypeDTO;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientPhoneNumber?: string;
  /**
   * @type {string}
   * @memberof VbcFollowupAssessmentDTO
   */
  patientEmailAddress?: string;
}

/**
 * @export
 * @interface PatientAddressWithGeocodeDataDTO
 */
export interface PatientAddressWithGeocodeDataDTO {
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  city?: string;
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  postalCode?: string;
  /**
   * @type {StateDTO}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  state?: StateDTO;
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  streetAddress?: string;
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  streetAddressLineTwo?: string;
  /**
   * @type {number}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  latitude?: number;
  /**
   * @type {number}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  longitude?: number;
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  county?: string;
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  id?: string;
  /**
   * @type {AddressTypeDTO}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  type?: AddressTypeDTO;
  /**
   * @type {boolean}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  isPrimaryAddressForSmartMatch?: boolean;
  /**
   * @type {string}
   * @memberof PatientAddressWithGeocodeDataDTO
   */
  googlePlaceId?: string;
}

/**
 * @export
 * @interface PatientWithMetadataDTO
 */
export interface PatientWithMetadataDTO {
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  id: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  firstName?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  lastName?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  preferredName?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  suffix?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  dateOfBirth?: string;
  /**
   * @type {GenderDTO}
   * @memberof PatientWithMetadataDTO
   */
  gender?: GenderDTO;
  /**
   * @type {AddressDTO}
   * @memberof PatientWithMetadataDTO
   */
  address?: AddressDTO;
  /**
   * @type {Array<PatientAddressWithGeocodeDataDTO>}
   * @memberof PatientWithMetadataDTO
   */
  addresses?: Array<PatientAddressWithGeocodeDataDTO>;
  /**
   * @type {Array<CommunicationPreferenceDTO>}
   * @memberof PatientWithMetadataDTO
   */
  communicationPreferences?: Array<CommunicationPreferenceDTO>;
  /**
   * @type {Array<PatientQuartetStatusDTO>}
   * @memberof PatientWithMetadataDTO
   */
  patientQuartetStatuses?: Array<PatientQuartetStatusDTO>;
  /**
   * @type {Array<EmailDTO>}
   * @memberof PatientWithMetadataDTO
   */
  emails?: Array<EmailDTO>;
  /**
   * @type {Array<InsurancePolicyDTO>}
   * @memberof PatientWithMetadataDTO
   */
  insurancePolicies?: Array<InsurancePolicyDTO>;
  /**
   * @type {Array<PatientPhoneNumberDTO>}
   * @memberof PatientWithMetadataDTO
   */
  phoneNumbers?: Array<PatientPhoneNumberDTO>;
  /**
   * @type {PatientPreferencesDTO}
   * @memberof PatientWithMetadataDTO
   */
  preferences?: PatientPreferencesDTO;
  /**
   * @type {SupportedLocaleDTO}
   * @memberof PatientWithMetadataDTO
   */
  locale?: SupportedLocaleDTO;
  /**
   * @type {PatientSmartMatchPreferencesDTO}
   * @memberof PatientWithMetadataDTO
   */
  smartMatchPreferences?: PatientSmartMatchPreferencesDTO;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  careNavigatorId?: string;
  /**
   * @type {boolean}
   * @memberof PatientWithMetadataDTO
   */
  isReferredYouth?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientWithMetadataDTO
   */
  inScope?: boolean;
  /**
   * @type {boolean}
   * @memberof PatientWithMetadataDTO
   */
  collaborativeCarePatient?: boolean;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  inScopeReason?: string;
  /**
   * @type {Array<EligibilityPartnerDTO>}
   * @memberof PatientWithMetadataDTO
   */
  eligibilityPartners?: Array<EligibilityPartnerDTO>;
  /**
   * @type {PatientServiceTypeDTO}
   * @memberof PatientWithMetadataDTO
   */
  serviceType?: PatientServiceTypeDTO;
  /**
   * @type {Array<PatientConcernDTO>}
   * @memberof PatientWithMetadataDTO
   */
  concerns?: Array<PatientConcernDTO>;
  /**
   * @type {AccountStateDTO}
   * @memberof PatientWithMetadataDTO
   */
  accountState?: AccountStateDTO;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  referringProviderId?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  referringCaseManagerId?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  referringPracticeId?: string;
  /**
   * @type {string}
   * @memberof PatientWithMetadataDTO
   */
  registrationCode?: string;
  /**
   * @type {Array<PatientExternalIdDTO>}
   * @memberof PatientWithMetadataDTO
   */
  externalIds?: Array<PatientExternalIdDTO>;
  /**
   * @type {Array<PatientAlternativeContactDTO>}
   * @memberof PatientWithMetadataDTO
   */
  alternativeContacts?: Array<PatientAlternativeContactDTO>;
  /**
   * @type {EntityMetadataDTO}
   * @memberof PatientWithMetadataDTO
   */
  metadata: EntityMetadataDTO;
  /**
   * @type {boolean}
   * @memberof PatientWithMetadataDTO
   */
  isPendingOptIn?: boolean;
}
